import Xt, { useState as fa, useEffect as Da, useId as nh, useRef as Yo, createElement as T1, Component as S1, forwardRef as x1, createContext as E1, useImperativeHandle as w1, useCallback as Ls } from "react";
import qg from "react-dom";
function nm(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var rg = { exports: {} }, Lf = {};
var Zy;
function A1() {
  if (Zy) return Lf;
  Zy = 1;
  var a = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function f(v, y, p) {
    var w = null;
    if (p !== void 0 && (w = "" + p), y.key !== void 0 && (w = "" + y.key), "key" in y) {
      p = {};
      for (var _ in y)
        _ !== "key" && (p[_] = y[_]);
    } else p = y;
    return y = p.ref, {
      $$typeof: a,
      type: v,
      key: w,
      ref: y !== void 0 ? y : null,
      props: p
    };
  }
  return Lf.Fragment = o, Lf.jsx = f, Lf.jsxs = f, Lf;
}
var Vy;
function _1() {
  return Vy || (Vy = 1, rg.exports = A1()), rg.exports;
}
var A = _1(), ug = { exports: {} }, cg, Qy;
function O1() {
  if (Qy) return cg;
  Qy = 1;
  var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return cg = a, cg;
}
var og, Py;
function C1() {
  if (Py) return og;
  Py = 1;
  var a = /* @__PURE__ */ O1();
  function o() {
  }
  function f() {
  }
  return f.resetWarningCache = o, og = function() {
    function v(w, _, C, z, B, I) {
      if (I !== a) {
        var F = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw F.name = "Invariant Violation", F;
      }
    }
    v.isRequired = v;
    function y() {
      return v;
    }
    var p = {
      array: v,
      bigint: v,
      bool: v,
      func: v,
      number: v,
      object: v,
      string: v,
      symbol: v,
      any: v,
      arrayOf: y,
      element: v,
      elementType: v,
      instanceOf: y,
      node: v,
      objectOf: y,
      oneOf: y,
      oneOfType: y,
      shape: y,
      exact: y,
      checkPropTypes: f,
      resetWarningCache: o
    };
    return p.PropTypes = p, p;
  }, og;
}
var Wy;
function R1() {
  return Wy || (Wy = 1, ug.exports = /* @__PURE__ */ C1()()), ug.exports;
}
var N1 = /* @__PURE__ */ R1();
const E = /* @__PURE__ */ nm(N1), M1 = () => {
  const [a, o] = fa(null), [f, v] = fa(!1), [y, p] = fa(null), [w, _] = fa("");
  return Da(() => {
    if (!w) return;
    (() => {
      p(null), v(!0);
      try {
        fetch(w).then((z) => z.json()).then((z) => {
          o(z), v(!1);
        }).catch((z) => {
          p(z), v(!1);
        });
      } catch (z) {
        p(z);
      }
    })();
  }, [w]), [{ data: a, loading: f, error: y }, _];
};
function z1(a) {
  const [o, f] = fa(!1);
  return Da(() => {
    const v = window.matchMedia(a);
    v.matches !== o && f(v.matches);
    const y = () => {
      f(v.matches);
    };
    return v.addEventListener("change", y), () => v.removeEventListener("change", y);
  }, [o, a]), o;
}
const Jy = (a, o, f) => a ? o : f, Fd = (a) => (a || []).join(" ");
function Ky(a, o) {
  (o == null || o > a.length) && (o = a.length);
  for (var f = 0, v = Array(o); f < o; f++) v[f] = a[f];
  return v;
}
function D1(a) {
  if (Array.isArray(a)) return a;
}
function L1(a, o) {
  var f = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (f != null) {
    var v, y, p, w, _ = [], C = !0, z = !1;
    try {
      if (p = (f = f.call(a)).next, o !== 0) for (; !(C = (v = p.call(f)).done) && (_.push(v.value), _.length !== o); C = !0) ;
    } catch (B) {
      z = !0, y = B;
    } finally {
      try {
        if (!C && f.return != null && (w = f.return(), Object(w) !== w)) return;
      } finally {
        if (z) throw y;
      }
    }
    return _;
  }
}
function k1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H1(a, o) {
  return D1(a) || L1(a, o) || B1(a, o) || k1();
}
function B1(a, o) {
  if (a) {
    if (typeof a == "string") return Ky(a, o);
    var f = {}.toString.call(a).slice(8, -1);
    return f === "Object" && a.constructor && (f = a.constructor.name), f === "Map" || f === "Set" ? Array.from(a) : f === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(f) ? Ky(a, o) : void 0;
  }
}
const lm = Object.entries, jy = Object.setPrototypeOf, U1 = Object.isFrozen, F1 = Object.getPrototypeOf, Y1 = Object.getOwnPropertyDescriptor;
let da = Object.freeze, ha = Object.seal, Ds = Object.create, am = typeof Reflect < "u" && Reflect, Cg = am.apply, Rg = am.construct;
da || (da = function(o) {
  return o;
});
ha || (ha = function(o) {
  return o;
});
Cg || (Cg = function(o, f) {
  for (var v = arguments.length, y = new Array(v > 2 ? v - 2 : 0), p = 2; p < v; p++)
    y[p - 2] = arguments[p];
  return o.apply(f, y);
});
Rg || (Rg = function(o) {
  for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
    v[y - 1] = arguments[y];
  return new o(...v);
});
const kf = pl(Array.prototype.forEach), G1 = pl(Array.prototype.lastIndexOf), qy = pl(Array.prototype.pop), Ms = pl(Array.prototype.push), X1 = pl(Array.prototype.splice), ro = Array.isArray, Gf = pl(String.prototype.toLowerCase), sg = pl(String.prototype.toString), $y = pl(String.prototype.match), Hf = pl(String.prototype.replace), eb = pl(String.prototype.indexOf), I1 = pl(String.prototype.trim), Z1 = pl(Number.prototype.toString), V1 = pl(Boolean.prototype.toString), tb = typeof BigInt > "u" ? null : pl(BigInt.prototype.toString), nb = typeof Symbol > "u" ? null : pl(Symbol.prototype.toString), Ql = pl(Object.prototype.hasOwnProperty), Bf = pl(Object.prototype.toString), oa = pl(RegExp.prototype.test), Do = Q1(TypeError);
function pl(a) {
  return function(o) {
    o instanceof RegExp && (o.lastIndex = 0);
    for (var f = arguments.length, v = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
      v[y - 1] = arguments[y];
    return Cg(a, o, v);
  };
}
function Q1(a) {
  return function() {
    for (var o = arguments.length, f = new Array(o), v = 0; v < o; v++)
      f[v] = arguments[v];
    return Rg(a, f);
  };
}
function Nt(a, o) {
  let f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Gf;
  if (jy && jy(a, null), !ro(o))
    return a;
  let v = o.length;
  for (; v--; ) {
    let y = o[v];
    if (typeof y == "string") {
      const p = f(y);
      p !== y && (U1(o) || (o[v] = p), y = p);
    }
    a[y] = !0;
  }
  return a;
}
function P1(a) {
  for (let o = 0; o < a.length; o++)
    Ql(a, o) || (a[o] = null);
  return a;
}
function za(a) {
  const o = Ds(null);
  for (const v of lm(a)) {
    var f = H1(v, 2);
    const y = f[0], p = f[1];
    Ql(a, y) && (ro(p) ? o[y] = P1(p) : p && typeof p == "object" && p.constructor === Object ? o[y] = za(p) : o[y] = p);
  }
  return o;
}
function W1(a) {
  switch (typeof a) {
    case "string":
      return a;
    case "number":
      return Z1(a);
    case "boolean":
      return V1(a);
    case "bigint":
      return tb ? tb(a) : "0";
    case "symbol":
      return nb ? nb(a) : "Symbol()";
    case "undefined":
      return Bf(a);
    case "function":
    case "object": {
      if (a === null)
        return Bf(a);
      const o = a, f = du(o, "toString");
      if (typeof f == "function") {
        const v = f(o);
        return typeof v == "string" ? v : Bf(v);
      }
      return Bf(a);
    }
    default:
      return Bf(a);
  }
}
function du(a, o) {
  for (; a !== null; ) {
    const v = Y1(a, o);
    if (v) {
      if (v.get)
        return pl(v.get);
      if (typeof v.value == "function")
        return pl(v.value);
    }
    a = F1(a);
  }
  function f() {
    return null;
  }
  return f;
}
function J1(a) {
  try {
    return oa(a, ""), !0;
  } catch {
    return !1;
  }
}
const lb = da(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), fg = da(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), dg = da(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), K1 = da(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), hg = da(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), j1 = da(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ab = da(["#text"]), ib = da(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), gg = da(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), rb = da(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), zd = da(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), q1 = ha(/{{[\w\W]*|^[\w\W]*}}/g), $1 = ha(/<%[\w\W]*|^[\w\W]*%>/g), ep = ha(/\${[\w\W]*/g), tp = ha(/^data-[\-\w.\u00B7-\uFFFF]+$/), np = ha(/^aria-[\-\w]+$/), ub = ha(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), lp = ha(/^(?:\w+script|data):/i), ap = ha(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ip = ha(/^html$/i), rp = ha(/^[a-z][.\w]*(-[.\w]+)+$/i), cb = ha(/<[/\w!]/g), up = ha(/<[/\w]/g), cp = ha(/<\/no(script|embed|frames)/i), op = ha(/\/>/i), fu = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, sp = function() {
  return typeof window > "u" ? null : window;
}, fp = function(o, f) {
  if (typeof o != "object" || typeof o.createPolicy != "function")
    return null;
  let v = null;
  const y = "data-tt-policy-suffix";
  f && f.hasAttribute(y) && (v = f.getAttribute(y));
  const p = "dompurify" + (v ? "#" + v : "");
  try {
    return o.createPolicy(p, {
      createHTML(w) {
        return w;
      },
      createScriptURL(w) {
        return w;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + p + " could not be created."), null;
  }
}, ob = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, ao = function(o, f, v, y) {
  return Ql(o, f) && ro(o[f]) ? Nt(y.base ? za(y.base) : {}, o[f], y.transform) : v;
};
function im() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : sp();
  const o = (be) => im(be);
  if (o.version = "3.4.11", o.removed = [], !a || !a.document || a.document.nodeType !== fu.document || !a.Element)
    return o.isSupported = !1, o;
  let f = a.document;
  const v = f, y = v.currentScript;
  a.DocumentFragment;
  const p = a.HTMLTemplateElement, w = a.Node, _ = a.Element, C = a.NodeFilter, z = a.NamedNodeMap;
  z === void 0 && (a.NamedNodeMap || a.MozNamedAttrMap), a.HTMLFormElement;
  const B = a.DOMParser, I = a.trustedTypes, F = _.prototype, ce = du(F, "cloneNode"), ae = du(F, "remove"), $ = du(F, "nextSibling"), he = du(F, "childNodes"), ge = du(F, "parentNode"), de = du(F, "shadowRoot"), De = du(F, "attributes"), Re = w && w.prototype ? du(w.prototype, "nodeType") : null, ye = w && w.prototype ? du(w.prototype, "nodeName") : null;
  if (typeof p == "function") {
    const be = f.createElement("template");
    be.content && be.content.ownerDocument && (f = be.content.ownerDocument);
  }
  let xe, we = "", Me, He = !1, Ot = 0;
  const wt = function() {
    if (Ot > 0)
      throw Do('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, At = function(D) {
    wt(), Ot++;
    try {
      return xe.createHTML(D);
    } finally {
      Ot--;
    }
  }, Ae = function(D) {
    wt(), Ot++;
    try {
      return xe.createScriptURL(D);
    } finally {
      Ot--;
    }
  }, Xe = function() {
    return He || (Me = fp(I, y), He = !0), Me;
  }, it = f, U = it.implementation, P = it.createNodeIterator, Se = it.createDocumentFragment, et = it.getElementsByTagName, ue = v.importNode;
  let Q = ob();
  o.isSupported = typeof lm == "function" && typeof ge == "function" && U && U.createHTMLDocument !== void 0;
  const ct = q1, tt = $1, _e = ep, Ne = tp, It = np, en = lp, Pl = ap, kl = rp;
  let Xn = ub, $e = null;
  const Ci = Nt({}, [...lb, ...fg, ...dg, ...hg, ...ab]);
  let Ce = null;
  const cr = Nt({}, [...ib, ...gg, ...rb, ...zd]);
  let vt = Object.seal(Ds(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ka = null, Ta = null;
  const jn = Object.seal(Ds(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let pn = !0, Ri = !0, ul = !1, In = !0, cl = !1, Ni = !0, Ue = !1, qn = !1, Lr = null, Mi = null, tn = !1, Ha = !1, ui = !1, Sa = !1, or = !0, Wl = !1;
  const Zn = "user-content-";
  let Sl = !0, Cn = !1, Ba = {}, ft = null;
  const Tn = Nt({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let ci = null;
  const Hl = Nt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ua = null;
  const Jl = Nt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Kl = "http://www.w3.org/1998/Math/MathML", Rn = "http://www.w3.org/2000/svg", jl = "http://www.w3.org/1999/xhtml";
  let Fa = jl, sr = !1, Ya = null;
  const fr = Nt({}, [Kl, Rn, jl], sg), oi = da(["mi", "mo", "mn", "ms", "mtext"]);
  let fn = Nt({}, oi);
  const ol = da(["annotation-xml"]);
  let zt = Nt({}, ol);
  const zi = Nt({}, ["title", "style", "font", "a", "script"]);
  let Nn = null;
  const Zt = ["application/xhtml+xml", "text/html"], xa = "text/html";
  let nt = null, on = null;
  const si = f.createElement("form"), Ga = function(D) {
    return D instanceof RegExp || D instanceof Function;
  }, kr = function() {
    let D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (on && on === D)
      return;
    (!D || typeof D != "object") && (D = {}), D = za(D), Nn = // eslint-disable-next-line unicorn/prefer-includes
    Zt.indexOf(D.PARSER_MEDIA_TYPE) === -1 ? xa : D.PARSER_MEDIA_TYPE, nt = Nn === "application/xhtml+xml" ? sg : Gf, $e = ao(D, "ALLOWED_TAGS", Ci, {
      transform: nt
    }), Ce = ao(D, "ALLOWED_ATTR", cr, {
      transform: nt
    }), Ya = ao(D, "ALLOWED_NAMESPACES", fr, {
      transform: sg
    }), Ua = ao(D, "ADD_URI_SAFE_ATTR", Jl, {
      transform: nt,
      base: Jl
    }), ci = ao(D, "ADD_DATA_URI_TAGS", Hl, {
      transform: nt,
      base: Hl
    }), ft = ao(D, "FORBID_CONTENTS", Tn, {
      transform: nt
    }), ka = ao(D, "FORBID_TAGS", za({}), {
      transform: nt
    }), Ta = ao(D, "FORBID_ATTR", za({}), {
      transform: nt
    }), Ba = Ql(D, "USE_PROFILES") ? D.USE_PROFILES && typeof D.USE_PROFILES == "object" ? za(D.USE_PROFILES) : D.USE_PROFILES : !1, pn = D.ALLOW_ARIA_ATTR !== !1, Ri = D.ALLOW_DATA_ATTR !== !1, ul = D.ALLOW_UNKNOWN_PROTOCOLS || !1, In = D.ALLOW_SELF_CLOSE_IN_ATTR !== !1, cl = D.SAFE_FOR_TEMPLATES || !1, Ni = D.SAFE_FOR_XML !== !1, Ue = D.WHOLE_DOCUMENT || !1, Ha = D.RETURN_DOM || !1, ui = D.RETURN_DOM_FRAGMENT || !1, Sa = D.RETURN_TRUSTED_TYPE || !1, tn = D.FORCE_BODY || !1, or = D.SANITIZE_DOM !== !1, Wl = D.SANITIZE_NAMED_PROPS || !1, Sl = D.KEEP_CONTENT !== !1, Cn = D.IN_PLACE || !1, Xn = J1(D.ALLOWED_URI_REGEXP) ? D.ALLOWED_URI_REGEXP : ub, Fa = typeof D.NAMESPACE == "string" ? D.NAMESPACE : jl, fn = Ql(D, "MATHML_TEXT_INTEGRATION_POINTS") && D.MATHML_TEXT_INTEGRATION_POINTS && typeof D.MATHML_TEXT_INTEGRATION_POINTS == "object" ? za(D.MATHML_TEXT_INTEGRATION_POINTS) : Nt({}, oi), zt = Ql(D, "HTML_INTEGRATION_POINTS") && D.HTML_INTEGRATION_POINTS && typeof D.HTML_INTEGRATION_POINTS == "object" ? za(D.HTML_INTEGRATION_POINTS) : Nt({}, ol);
    const W = Ql(D, "CUSTOM_ELEMENT_HANDLING") && D.CUSTOM_ELEMENT_HANDLING && typeof D.CUSTOM_ELEMENT_HANDLING == "object" ? za(D.CUSTOM_ELEMENT_HANDLING) : Ds(null);
    if (vt = Ds(null), Ql(W, "tagNameCheck") && Ga(W.tagNameCheck) && (vt.tagNameCheck = W.tagNameCheck), Ql(W, "attributeNameCheck") && Ga(W.attributeNameCheck) && (vt.attributeNameCheck = W.attributeNameCheck), Ql(W, "allowCustomizedBuiltInElements") && typeof W.allowCustomizedBuiltInElements == "boolean" && (vt.allowCustomizedBuiltInElements = W.allowCustomizedBuiltInElements), ha(vt), cl && (Ri = !1), ui && (Ha = !0), Ba && ($e = Nt({}, ab), Ce = Ds(null), Ba.html === !0 && (Nt($e, lb), Nt(Ce, ib)), Ba.svg === !0 && (Nt($e, fg), Nt(Ce, gg), Nt(Ce, zd)), Ba.svgFilters === !0 && (Nt($e, dg), Nt(Ce, gg), Nt(Ce, zd)), Ba.mathMl === !0 && (Nt($e, hg), Nt(Ce, rb), Nt(Ce, zd))), jn.tagCheck = null, jn.attributeCheck = null, Ql(D, "ADD_TAGS") && (typeof D.ADD_TAGS == "function" ? jn.tagCheck = D.ADD_TAGS : ro(D.ADD_TAGS) && ($e === Ci && ($e = za($e)), Nt($e, D.ADD_TAGS, nt))), Ql(D, "ADD_ATTR") && (typeof D.ADD_ATTR == "function" ? jn.attributeCheck = D.ADD_ATTR : ro(D.ADD_ATTR) && (Ce === cr && (Ce = za(Ce)), Nt(Ce, D.ADD_ATTR, nt))), Ql(D, "ADD_URI_SAFE_ATTR") && ro(D.ADD_URI_SAFE_ATTR) && Nt(Ua, D.ADD_URI_SAFE_ATTR, nt), Ql(D, "FORBID_CONTENTS") && ro(D.FORBID_CONTENTS) && (ft === Tn && (ft = za(ft)), Nt(ft, D.FORBID_CONTENTS, nt)), Ql(D, "ADD_FORBID_CONTENTS") && ro(D.ADD_FORBID_CONTENTS) && (ft === Tn && (ft = za(ft)), Nt(ft, D.ADD_FORBID_CONTENTS, nt)), Sl && ($e["#text"] = !0), Ue && Nt($e, ["html", "head", "body"]), $e.table && (Nt($e, ["tbody"]), delete ka.tbody), D.TRUSTED_TYPES_POLICY) {
      if (typeof D.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Do('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof D.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Do('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const me = xe;
      xe = D.TRUSTED_TYPES_POLICY;
      try {
        we = At("");
      } catch (Ee) {
        throw xe = me, Ee;
      }
    } else D.TRUSTED_TYPES_POLICY === null ? (xe = void 0, we = "") : (xe === void 0 && (xe = Xe()), xe && typeof we == "string" && (we = At("")));
    da && da(D), on = D;
  }, St = Nt({}, [...fg, ...dg, ...K1]), Dt = Nt({}, [...hg, ...j1]), Ea = function(D, W, me) {
    return W.namespaceURI === jl ? D === "svg" : W.namespaceURI === Kl ? D === "svg" && (me === "annotation-xml" || fn[me]) : !!St[D];
  }, $n = function(D, W, me) {
    return W.namespaceURI === jl ? D === "math" : W.namespaceURI === Rn ? D === "math" && zt[me] : !!Dt[D];
  }, Di = function(D, W, me) {
    return W.namespaceURI === Rn && !zt[me] || W.namespaceURI === Kl && !fn[me] ? !1 : !Dt[D] && (zi[D] || !St[D]);
  }, Xa = function(D) {
    let W = ge(D);
    (!W || !W.tagName) && (W = {
      namespaceURI: Fa,
      tagName: "template"
    });
    const me = Gf(D.tagName), Ee = Gf(W.tagName);
    return Ya[D.namespaceURI] ? D.namespaceURI === Rn ? Ea(me, W, Ee) : D.namespaceURI === Kl ? $n(me, W, Ee) : D.namespaceURI === jl ? Di(me, W, Ee) : !!(Nn === "application/xhtml+xml" && Ya[D.namespaceURI]) : !1;
  }, xl = function(D) {
    Ms(o.removed, {
      element: D
    });
    try {
      ge(D).removeChild(D);
    } catch {
      if (ae(D), !ge(D))
        throw Do("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, Ia = function(D) {
    const W = he(D);
    if (W) {
      const Ee = [];
      kf(W, (We) => {
        Ms(Ee, We);
      }), kf(Ee, (We) => {
        try {
          ae(We);
        } catch {
        }
      });
    }
    const me = De(D);
    if (me)
      for (let Ee = me.length - 1; Ee >= 0; --Ee) {
        const We = me[Ee], ot = We && We.name;
        if (typeof ot == "string")
          try {
            D.removeAttribute(ot);
          } catch {
          }
      }
  }, Vt = function(D, W) {
    try {
      Ms(o.removed, {
        attribute: W.getAttributeNode(D),
        from: W
      });
    } catch {
      Ms(o.removed, {
        attribute: null,
        from: W
      });
    }
    if (W.removeAttribute(D), D === "is")
      if (Ha || ui)
        try {
          xl(W);
        } catch {
        }
      else
        try {
          W.setAttribute(D, "");
        } catch {
        }
  }, Li = function(D) {
    const W = De(D);
    if (W)
      for (let me = W.length - 1; me >= 0; --me) {
        const Ee = W[me], We = Ee && Ee.name;
        if (!(typeof We != "string" || Ce[nt(We)]))
          try {
            D.removeAttribute(We);
          } catch {
          }
      }
  }, dn = function(D) {
    const W = [D];
    for (; W.length > 0; ) {
      const me = W.pop();
      (Re ? Re(me) : me.nodeType) === fu.element && Li(me);
      const We = he(me);
      if (We)
        for (let ot = We.length - 1; ot >= 0; --ot)
          W.push(We[ot]);
    }
  }, ql = function(D) {
    let W = null, me = null;
    if (tn)
      D = "<remove></remove>" + D;
    else {
      const ot = $y(D, /^[\r\n\t ]+/);
      me = ot && ot[0];
    }
    Nn === "application/xhtml+xml" && Fa === jl && (D = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + D + "</body></html>");
    const Ee = xe ? At(D) : D;
    if (Fa === jl)
      try {
        W = new B().parseFromString(Ee, Nn);
      } catch {
      }
    if (!W || !W.documentElement) {
      W = U.createDocument(Fa, "template", null);
      try {
        W.documentElement.innerHTML = sr ? we : Ee;
      } catch {
      }
    }
    const We = W.body || W.documentElement;
    return D && me && We.insertBefore(f.createTextNode(me), We.childNodes[0] || null), Fa === jl ? et.call(W, Ue ? "html" : "body")[0] : Ue ? W.documentElement : We;
  }, ga = function(D) {
    return P.call(
      D.ownerDocument || D,
      D,
      // eslint-disable-next-line no-bitwise
      C.SHOW_ELEMENT | C.SHOW_COMMENT | C.SHOW_TEXT | C.SHOW_PROCESSING_INSTRUCTION | C.SHOW_CDATA_SECTION,
      null
    );
  }, $l = function(D) {
    return D = Hf(D, ct, " "), D = Hf(D, tt, " "), D = Hf(D, _e, " "), D;
  }, fi = function(D) {
    var W;
    D.normalize();
    const me = P.call(
      D.ownerDocument || D,
      D,
      // eslint-disable-next-line no-bitwise
      C.SHOW_TEXT | C.SHOW_COMMENT | C.SHOW_CDATA_SECTION | C.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let Ee = me.nextNode();
    for (; Ee; )
      Ee.data = $l(Ee.data), Ee = me.nextNode();
    const We = (W = D.querySelectorAll) === null || W === void 0 ? void 0 : W.call(D, "template");
    We && kf(We, (ot) => {
      ki(ot.content) && fi(ot.content);
    });
  }, dr = function(D) {
    const W = ye ? ye(D) : null;
    return typeof W != "string" || nt(W) !== "form" ? !1 : typeof D.nodeName != "string" || typeof D.textContent != "string" || typeof D.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    D.attributes !== De(D) || typeof D.removeAttribute != "function" || typeof D.setAttribute != "function" || typeof D.namespaceURI != "string" || typeof D.insertBefore != "function" || typeof D.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    D.nodeType !== Re(D) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    D.childNodes !== he(D);
  }, ki = function(D) {
    if (!Re || typeof D != "object" || D === null)
      return !1;
    try {
      return Re(D) === fu.documentFragment;
    } catch {
      return !1;
    }
  }, El = function(D) {
    if (!Re || typeof D != "object" || D === null)
      return !1;
    try {
      return typeof Re(D) == "number";
    } catch {
      return !1;
    }
  };
  function el(be, D, W) {
    be.length !== 0 && kf(be, (me) => {
      me.call(o, D, W, on);
    });
  }
  const Bl = function(D, W) {
    return !!(Ni && D.hasChildNodes() && !El(D.firstElementChild) && oa(cb, D.textContent) && oa(cb, D.innerHTML) || Ni && D.namespaceURI === jl && W === "style" && El(D.firstElementChild) || D.nodeType === fu.processingInstruction || Ni && D.nodeType === fu.comment && oa(up, D.data));
  }, Sn = function(D, W) {
    if (!ka[W] && nn(W) && (vt.tagNameCheck instanceof RegExp && oa(vt.tagNameCheck, W) || vt.tagNameCheck instanceof Function && vt.tagNameCheck(W)))
      return !1;
    if (Sl && !ft[W]) {
      const me = ge(D), Ee = he(D);
      if (Ee && me) {
        const We = Ee.length;
        for (let ot = We - 1; ot >= 0; --ot) {
          const xn = Cn ? Ee[ot] : ce(Ee[ot], !0);
          me.insertBefore(xn, $(D));
        }
      }
    }
    return xl(D), !0;
  }, hr = function(D) {
    if (el(Q.beforeSanitizeElements, D, null), dr(D))
      return xl(D), !0;
    const W = nt(ye ? ye(D) : D.nodeName);
    if (el(Q.uponSanitizeElement, D, {
      tagName: W,
      allowedTags: $e
    }), Bl(D, W))
      return xl(D), !0;
    if (ka[W] || !(jn.tagCheck instanceof Function && jn.tagCheck(W)) && !$e[W])
      return Sn(D, W);
    if ((Re ? Re(D) : D.nodeType) === fu.element && !Xa(D) || (W === "noscript" || W === "noembed" || W === "noframes") && oa(cp, D.innerHTML))
      return xl(D), !0;
    if (cl && D.nodeType === fu.text) {
      const Ee = $l(D.textContent);
      D.textContent !== Ee && (Ms(o.removed, {
        element: D.cloneNode()
      }), D.textContent = Ee);
    }
    return el(Q.afterSanitizeElements, D, null), !1;
  }, lc = function(D, W, me) {
    if (Ta[W] || or && (W === "id" || W === "name") && (me in f || me in si))
      return !1;
    const Ee = Ce[W] || jn.attributeCheck instanceof Function && jn.attributeCheck(W, D);
    if (!(Ri && oa(Ne, W))) {
      if (!(pn && oa(It, W))) {
        if (Ee) {
          if (!Ua[W]) {
            if (!oa(Xn, Hf(me, Pl, ""))) {
              if (!((W === "src" || W === "xlink:href" || W === "href") && D !== "script" && eb(me, "data:") === 0 && ci[D])) {
                if (!(ul && !oa(en, Hf(me, Pl, "")))) {
                  if (me)
                    return !1;
                }
              }
            }
          }
        } else if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(nn(D) && (vt.tagNameCheck instanceof RegExp && oa(vt.tagNameCheck, D) || vt.tagNameCheck instanceof Function && vt.tagNameCheck(D)) && (vt.attributeNameCheck instanceof RegExp && oa(vt.attributeNameCheck, W) || vt.attributeNameCheck instanceof Function && vt.attributeNameCheck(W, D)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          W === "is" && vt.allowCustomizedBuiltInElements && (vt.tagNameCheck instanceof RegExp && oa(vt.tagNameCheck, me) || vt.tagNameCheck instanceof Function && vt.tagNameCheck(me)))
        ) return !1;
      }
    }
    return !0;
  }, di = Nt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), nn = function(D) {
    return !di[Gf(D)] && oa(kl, D);
  }, va = function(D, W, me, Ee) {
    if (xe && typeof I == "object" && typeof I.getAttributeType == "function" && !me)
      switch (I.getAttributeType(D, W)) {
        case "TrustedHTML":
          return At(Ee);
        case "TrustedScriptURL":
          return Ae(Ee);
      }
    return Ee;
  }, Hr = function(D, W, me, Ee) {
    try {
      me ? D.setAttributeNS(me, W, Ee) : D.setAttribute(W, Ee), dr(D) ? xl(D) : qy(o.removed);
    } catch {
      Vt(W, D);
    }
  }, tl = function(D) {
    el(Q.beforeSanitizeAttributes, D, null);
    const W = D.attributes;
    if (!W || dr(D))
      return;
    const me = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Ce,
      forceKeepAttr: void 0
    };
    let Ee = W.length;
    const We = nt(D.nodeName);
    for (; Ee--; ) {
      const ot = W[Ee], xn = ot.name, ln = ot.namespaceURI, Ht = ot.value, Wt = nt(xn), Bi = Ht;
      let Bt = xn === "value" ? Bi : I1(Bi);
      if (me.attrName = Wt, me.attrValue = Bt, me.keepAttr = !0, me.forceKeepAttr = void 0, el(Q.uponSanitizeAttribute, D, me), Bt = me.attrValue, Wl && (Wt === "id" || Wt === "name") && eb(Bt, Zn) !== 0 && (Vt(xn, D), Bt = Zn + Bt), Ni && oa(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Bt)) {
        Vt(xn, D);
        continue;
      }
      if (Wt === "attributename" && $y(Bt, "href")) {
        Vt(xn, D);
        continue;
      }
      if (!me.forceKeepAttr) {
        if (!me.keepAttr) {
          Vt(xn, D);
          continue;
        }
        if (!In && oa(op, Bt)) {
          Vt(xn, D);
          continue;
        }
        if (cl && (Bt = $l(Bt)), !lc(We, Wt, Bt)) {
          Vt(xn, D);
          continue;
        }
        Bt = va(We, Wt, ln, Bt), Bt !== Bi && Hr(D, xn, ln, Bt);
      }
    }
    el(Q.afterSanitizeAttributes, D, null);
  }, wl = function(D) {
    let W = null;
    const me = ga(D);
    for (el(Q.beforeSanitizeShadowDOM, D, null); W = me.nextNode(); )
      if (el(Q.uponSanitizeShadowNode, W, null), hr(W), tl(W), ki(W.content) && wl(W.content), (Re ? Re(W) : W.nodeType) === fu.element) {
        const We = de(W);
        ki(We) && (Hi(We), wl(We));
      }
    el(Q.afterSanitizeShadowDOM, D, null);
  }, Hi = function(D) {
    const W = [{
      node: D,
      shadow: null
    }];
    for (; W.length > 0; ) {
      const me = W.pop();
      if (me.shadow) {
        wl(me.shadow);
        continue;
      }
      const Ee = me.node, ot = (Re ? Re(Ee) : Ee.nodeType) === fu.element, xn = he(Ee);
      if (xn)
        for (let ln = xn.length - 1; ln >= 0; --ln)
          W.push({
            node: xn[ln],
            shadow: null
          });
      if (ot) {
        const ln = ye ? ye(Ee) : null;
        if (typeof ln == "string" && nt(ln) === "template") {
          const Ht = Ee.content;
          ki(Ht) && W.push({
            node: Ht,
            shadow: null
          });
        }
      }
      if (ot) {
        const ln = de(Ee);
        ki(ln) && W.push({
          node: null,
          shadow: ln
        }, {
          node: ln,
          shadow: null
        });
      }
    }
  };
  return o.sanitize = function(be) {
    let D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, W = null, me = null, Ee = null, We = null;
    if (sr = !be, sr && (be = "<!-->"), typeof be != "string" && !El(be) && (be = W1(be), typeof be != "string"))
      throw Do("dirty is not a string, aborting");
    if (!o.isSupported)
      return be;
    qn ? ($e = Lr, Ce = Mi) : kr(D), (Q.uponSanitizeElement.length > 0 || Q.uponSanitizeAttribute.length > 0) && ($e = za($e)), Q.uponSanitizeAttribute.length > 0 && (Ce = za(Ce)), o.removed = [];
    const ot = Cn && typeof be != "string" && El(be);
    if (ot) {
      const Ht = ye ? ye(be) : be.nodeName;
      if (typeof Ht == "string") {
        const Wt = nt(Ht);
        if (!$e[Wt] || ka[Wt])
          throw Do("root node is forbidden and cannot be sanitized in-place");
      }
      if (dr(be))
        throw Do("root node is clobbered and cannot be sanitized in-place");
      try {
        Hi(be);
      } catch (Wt) {
        throw Ia(be), Wt;
      }
    } else if (El(be))
      W = ql("<!---->"), me = W.ownerDocument.importNode(be, !0), me.nodeType === fu.element && me.nodeName === "BODY" || me.nodeName === "HTML" ? W = me : W.appendChild(me), Hi(me);
    else {
      if (!Ha && !cl && !Ue && // eslint-disable-next-line unicorn/prefer-includes
      be.indexOf("<") === -1)
        return xe && Sa ? At(be) : be;
      if (W = ql(be), !W)
        return Ha ? null : Sa ? we : "";
    }
    W && tn && xl(W.firstChild);
    const xn = ga(ot ? be : W);
    try {
      for (; Ee = xn.nextNode(); )
        hr(Ee), tl(Ee), ki(Ee.content) && wl(Ee.content);
    } catch (Ht) {
      throw ot && Ia(be), Ht;
    }
    if (ot)
      return kf(o.removed, (Ht) => {
        Ht.element && dn(Ht.element);
      }), cl && fi(be), be;
    if (Ha) {
      if (cl && fi(W), ui)
        for (We = Se.call(W.ownerDocument); W.firstChild; )
          We.appendChild(W.firstChild);
      else
        We = W;
      return (Ce.shadowroot || Ce.shadowrootmode) && (We = ue.call(v, We, !0)), We;
    }
    let ln = Ue ? W.outerHTML : W.innerHTML;
    return Ue && $e["!doctype"] && W.ownerDocument && W.ownerDocument.doctype && W.ownerDocument.doctype.name && oa(ip, W.ownerDocument.doctype.name) && (ln = "<!DOCTYPE " + W.ownerDocument.doctype.name + `>
` + ln), cl && (ln = $l(ln)), xe && Sa ? At(ln) : ln;
  }, o.setConfig = function() {
    let be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    kr(be), qn = !0, Lr = $e, Mi = Ce;
  }, o.clearConfig = function() {
    on = null, qn = !1, Lr = null, Mi = null, xe = Me, we = "";
  }, o.isValidAttribute = function(be, D, W) {
    on || kr({});
    const me = nt(be), Ee = nt(D);
    return lc(me, Ee, W);
  }, o.addHook = function(be, D) {
    typeof D == "function" && Ql(Q, be) && Ms(Q[be], D);
  }, o.removeHook = function(be, D) {
    if (Ql(Q, be)) {
      if (D !== void 0) {
        const W = G1(Q[be], D);
        return W === -1 ? void 0 : X1(Q[be], W, 1)[0];
      }
      return qy(Q[be]);
    }
  }, o.removeHooks = function(be) {
    Ql(Q, be) && (Q[be] = []);
  }, o.removeAllHooks = function() {
    Q = ob();
  }, o;
}
var sb = im();
let Dd = null;
function dp() {
  return Dd || (typeof window < "u" ? Dd = sb(window) : Dd = sb), Dd;
}
function hp(a) {
  const o = a ? document.querySelector(a) : document;
  return o ? o.querySelector(
    'button, [href], input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
  ) : null;
}
const La = (a) => ({ __html: dp().sanitize(a) }), fb = (a, o, f) => {
  let v = a;
  const y = [];
  for (; v < o; )
    v > 0 && v <= f && y.push(v), v += 1;
  return y;
};
let vg = !1;
const Ng = (a, o) => {
  vg || (vg = !0, setTimeout(() => {
    a(), vg = !1;
  }, o));
};
let db;
const Mg = (a, o) => {
  window.clearTimeout(db), db = window.setTimeout(a, o);
};
function gp(a) {
  if (a && typeof a.getBoundingClientRect == "function") {
    const { bottom: o, top: f } = a.getBoundingClientRect(), { offsetTop: v } = a;
    if (f < 0 && o > 0) {
      const y = a.style;
      a.style = `${y};transition: height 0s !important; overflow:hidden; height:${o}px!important;max-height:${o}px!important`, window.scrollTo({ behavior: "instant", top: v }), setTimeout(() => {
        a.style = y, window.scrollTo({
          behavior: "smooth",
          top: a.offsetTop - o / 2
        });
      }, 50);
    }
  }
}
E.shape({
  event: E.string,
  action: E.string,
  name: E.string,
  region: E.string,
  section: E.string,
  component: E.string,
  type: E.string,
  text: E.string
});
const rm = ({
  event: a = "",
  action: o = "",
  name: f = "",
  type: v = "",
  section: y = "",
  text: p = "",
  region: w = "",
  component: _ = ""
}) => {
  const { dataLayer: C } = window, z = {
    event: a.toLowerCase(),
    action: o.toLowerCase(),
    name: f.toLowerCase(),
    type: v.toLowerCase(),
    region: w.toLowerCase(),
    section: y.toLowerCase(),
    text: p.toLowerCase(),
    component: _.toLowerCase()
  };
  C && C.push(z);
}, Wf = ({ children: a }) => /* @__PURE__ */ A.jsx(A.Fragment, { children: a });
Wf.propTypes = {
  children: E.oneOfType([
    E.arrayOf(E.node),
    E.node,
    E.string
  ])
};
var yg = { exports: {} };
var hb;
function vp() {
  return hb || (hb = 1, (function(a) {
    (function() {
      var o = {}.hasOwnProperty;
      function f() {
        for (var p = "", w = 0; w < arguments.length; w++) {
          var _ = arguments[w];
          _ && (p = y(p, v(_)));
        }
        return p;
      }
      function v(p) {
        if (typeof p == "string" || typeof p == "number")
          return p;
        if (typeof p != "object")
          return "";
        if (Array.isArray(p))
          return f.apply(null, p);
        if (p.toString !== Object.prototype.toString && !p.toString.toString().includes("[native code]"))
          return p.toString();
        var w = "";
        for (var _ in p)
          o.call(p, _) && p[_] && (w = y(w, _));
        return w;
      }
      function y(p, w) {
        return w ? p ? p + " " + w : p + w : p;
      }
      a.exports ? (f.default = f, a.exports = f) : window.classNames = f;
    })();
  })(yg)), yg.exports;
}
var yp = vp();
const Mt = /* @__PURE__ */ nm(yp);
({
  ...Wf.propTypes
});
const um = ({ children: a, className: o = "container", ...f }) => /* @__PURE__ */ A.jsx("div", { className: o, ...f, children: /* @__PURE__ */ A.jsx("div", { className: "row", children: a }) });
um.propTypes = {
  children: Wf.propTypes.children
};
({
  ...um.propTypes
});
Wf.propTypes.children, E.oneOf(["0", "3", "4", "6", "8", "9", "12"]);
Wf.propTypes.children;
const bp = E.shape({
  url: E.string,
  altText: E.string,
  cssClass: E.arrayOf(E.string),
  size: E.oneOf(["small", "medium", "large"])
}), bg = E.shape({
  text: E.string,
  maxWidth: E.string,
  cssClass: E.arrayOf(E.string),
  highlightColor: E.oneOf(["gold", "black"])
}), cm = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  content: E.shape({
    icon: E.arrayOf(E.string),
    header: E.string,
    body: E.string
  })
}), $g = E.shape({
  text: E.string,
  name: E.string,
  event: E.string,
  action: E.string,
  type: E.string,
  region: E.string,
  section: E.string,
  component: E.string
});
var Lo = {}, Uf = {};
var gb;
function mp() {
  if (gb) return Uf;
  gb = 1;
  var a = Xt, o = qg;
  function f(r) {
    var c = "https://react.dev/errors/" + r;
    if (1 < arguments.length) {
      c += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var g = 2; g < arguments.length; g++)
        c += "&args[]=" + encodeURIComponent(arguments[g]);
    }
    return "Minified React error #" + r + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var v = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), _ = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), z = Symbol.for("react.context"), B = Symbol.for("react.forward_ref"), I = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), $ = Symbol.for("react.scope"), he = Symbol.for("react.activity"), ge = Symbol.for("react.legacy_hidden"), de = Symbol.for("react.memo_cache_sentinel"), De = Symbol.for("react.view_transition"), Re = Symbol.iterator;
  function ye(r) {
    return r === null || typeof r != "object" ? null : (r = Re && r[Re] || r["@@iterator"], typeof r == "function" ? r : null);
  }
  var xe = Array.isArray;
  function we(r, c) {
    var g = r.length & 3, m = r.length - g, x = c;
    for (c = 0; c < m; ) {
      var N = r.charCodeAt(c) & 255 | (r.charCodeAt(++c) & 255) << 8 | (r.charCodeAt(++c) & 255) << 16 | (r.charCodeAt(++c) & 255) << 24;
      ++c, N = 3432918353 * (N & 65535) + ((3432918353 * (N >>> 16) & 65535) << 16) & 4294967295, N = N << 15 | N >>> 17, N = 461845907 * (N & 65535) + ((461845907 * (N >>> 16) & 65535) << 16) & 4294967295, x ^= N, x = x << 13 | x >>> 19, x = 5 * (x & 65535) + ((5 * (x >>> 16) & 65535) << 16) & 4294967295, x = (x & 65535) + 27492 + (((x >>> 16) + 58964 & 65535) << 16);
    }
    switch (N = 0, g) {
      case 3:
        N ^= (r.charCodeAt(c + 2) & 255) << 16;
      case 2:
        N ^= (r.charCodeAt(c + 1) & 255) << 8;
      case 1:
        N ^= r.charCodeAt(c) & 255, N = 3432918353 * (N & 65535) + ((3432918353 * (N >>> 16) & 65535) << 16) & 4294967295, N = N << 15 | N >>> 17, x ^= 461845907 * (N & 65535) + ((461845907 * (N >>> 16) & 65535) << 16) & 4294967295;
    }
    return x ^= r.length, x ^= x >>> 16, x = 2246822507 * (x & 65535) + ((2246822507 * (x >>> 16) & 65535) << 16) & 4294967295, x ^= x >>> 13, x = 3266489909 * (x & 65535) + ((3266489909 * (x >>> 16) & 65535) << 16) & 4294967295, (x ^ x >>> 16) >>> 0;
  }
  var Me = Object.assign, He = Object.prototype.hasOwnProperty, Ot = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), wt = {}, At = {};
  function Ae(r) {
    return He.call(At, r) ? !0 : He.call(wt, r) ? !1 : Ot.test(r) ? At[r] = !0 : (wt[r] = !0, !1);
  }
  var Xe = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), it = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), U = /["'&<>]/;
  function P(r) {
    if (typeof r == "boolean" || typeof r == "number" || typeof r == "bigint")
      return "" + r;
    r = "" + r;
    var c = U.exec(r);
    if (c) {
      var g = "", m, x = 0;
      for (m = c.index; m < r.length; m++) {
        switch (r.charCodeAt(m)) {
          case 34:
            c = "&quot;";
            break;
          case 38:
            c = "&amp;";
            break;
          case 39:
            c = "&#x27;";
            break;
          case 60:
            c = "&lt;";
            break;
          case 62:
            c = "&gt;";
            break;
          default:
            continue;
        }
        x !== m && (g += r.slice(x, m)), x = m + 1, g += c;
      }
      r = x !== m ? g + r.slice(x, m) : g;
    }
    return r;
  }
  var Se = /([A-Z])/g, et = /^ms-/, ue = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Q(r) {
    return ue.test("" + r) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : r;
  }
  var ct = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, tt = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, _e = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Ne = tt.d;
  tt.d = {
    f: Ne.f,
    r: Ne.r,
    D: Ea,
    C: $n,
    L: Di,
    m: Xa,
    X: Ia,
    S: xl,
    M: Vt
  };
  var It = [], en = null, Pl = /(<\/|<)(s)(cript)/gi;
  function kl(r, c, g, m) {
    return "" + c + (g === "s" ? "\\u0073" : "\\u0053") + m;
  }
  function Xn(r, c, g, m, x) {
    return {
      idPrefix: r === void 0 ? "" : r,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: g,
      bootstrapScripts: m,
      bootstrapModules: x,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function $e(r, c, g, m) {
    return {
      insertionMode: r,
      selectedValue: c,
      tagScope: g,
      viewTransition: m
    };
  }
  function Ci(r, c, g) {
    var m = r.tagScope & -25;
    switch (c) {
      case "noscript":
        return $e(2, null, m | 1, null);
      case "select":
        return $e(
          2,
          g.value != null ? g.value : g.defaultValue,
          m,
          null
        );
      case "svg":
        return $e(4, null, m, null);
      case "picture":
        return $e(2, null, m | 2, null);
      case "math":
        return $e(5, null, m, null);
      case "foreignObject":
        return $e(2, null, m, null);
      case "table":
        return $e(6, null, m, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return $e(7, null, m, null);
      case "colgroup":
        return $e(9, null, m, null);
      case "tr":
        return $e(8, null, m, null);
      case "head":
        if (2 > r.insertionMode)
          return $e(3, null, m, null);
        break;
      case "html":
        if (r.insertionMode === 0)
          return $e(1, null, m, null);
    }
    return 6 <= r.insertionMode || 2 > r.insertionMode ? $e(2, null, m, null) : r.tagScope !== m ? $e(
      r.insertionMode,
      r.selectedValue,
      m,
      null
    ) : r;
  }
  function Ce(r) {
    return r === null ? null : {
      update: r.update,
      enter: "none",
      exit: "none",
      share: r.update,
      name: r.autoName,
      autoName: r.autoName,
      nameIdx: 0
    };
  }
  function cr(r, c) {
    return c.tagScope & 32 && (r.instructions |= 128), $e(
      c.insertionMode,
      c.selectedValue,
      c.tagScope | 12,
      Ce(c.viewTransition)
    );
  }
  function vt(r, c) {
    r = Ce(c.viewTransition);
    var g = c.tagScope | 16;
    return r !== null && r.share !== "none" && (g |= 64), $e(
      c.insertionMode,
      c.selectedValue,
      g,
      r
    );
  }
  var ka = /* @__PURE__ */ new Map();
  function Ta(r, c) {
    if (typeof c != "object") throw Error(f(62));
    var g = !0, m;
    for (m in c)
      if (He.call(c, m)) {
        var x = c[m];
        if (x != null && typeof x != "boolean" && x !== "") {
          if (m.indexOf("--") === 0) {
            var N = P(m);
            x = P(("" + x).trim());
          } else
            N = ka.get(m), N === void 0 && (N = P(
              m.replace(Se, "-$1").toLowerCase().replace(et, "-ms-")
            ), ka.set(m, N)), x = typeof x == "number" ? x === 0 || Xe.has(m) ? "" + x : x + "px" : P(("" + x).trim());
          g ? (g = !1, r.push(' style="', N, ":", x)) : r.push(";", N, ":", x);
        }
      }
    g || r.push('"');
  }
  function jn(r, c, g) {
    g && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '=""');
  }
  function pn(r, c, g) {
    typeof g != "function" && typeof g != "symbol" && typeof g != "boolean" && r.push(" ", c, '="', P(g), '"');
  }
  var Ri = P(
    "javascript:throw new Error('React form unexpectedly submitted.')"
  );
  function ul(r, c) {
    this.push('<input type="hidden"'), In(r), pn(this, "name", c), pn(this, "value", r), this.push("/>");
  }
  function In(r) {
    if (typeof r != "string") throw Error(f(480));
  }
  function cl(r, c) {
    if (typeof c.$$FORM_ACTION == "function") {
      var g = r.nextFormID++;
      r = r.idPrefix + g;
      try {
        var m = c.$$FORM_ACTION(r);
        if (m) {
          var x = m.data;
          x != null && x.forEach(In);
        }
        return m;
      } catch (N) {
        if (typeof N == "object" && N !== null && typeof N.then == "function")
          throw N;
      }
    }
    return null;
  }
  function Ni(r, c, g, m, x, N, L, ee) {
    var Y = null;
    if (typeof m == "function") {
      var te = cl(c, m);
      te !== null ? (ee = te.name, m = te.action || "", x = te.encType, N = te.method, L = te.target, Y = te.data) : (r.push(" ", "formAction", '="', Ri, '"'), L = N = x = m = ee = null, Mi(c, g));
    }
    return ee != null && Ue(r, "name", ee), m != null && Ue(r, "formAction", m), x != null && Ue(r, "formEncType", x), N != null && Ue(r, "formMethod", N), L != null && Ue(r, "formTarget", L), Y;
  }
  function Ue(r, c, g) {
    switch (c) {
      case "className":
        pn(r, "class", g);
        break;
      case "tabIndex":
        pn(r, "tabindex", g);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        pn(r, c, g);
        break;
      case "style":
        Ta(r, g);
        break;
      case "src":
      case "href":
        if (g === "") break;
      case "action":
      case "formAction":
        if (g == null || typeof g == "function" || typeof g == "symbol" || typeof g == "boolean")
          break;
        g = Q("" + g), r.push(" ", c, '="', P(g), '"');
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        jn(r, c.toLowerCase(), g);
        break;
      case "xlinkHref":
        if (typeof g == "function" || typeof g == "symbol" || typeof g == "boolean")
          break;
        g = Q("" + g), r.push(" ", "xlink:href", '="', P(g), '"');
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '="', P(g), '"');
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        g && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '=""');
        break;
      case "capture":
      case "download":
        g === !0 ? r.push(" ", c, '=""') : g !== !1 && typeof g != "function" && typeof g != "symbol" && r.push(" ", c, '="', P(g), '"');
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof g != "function" && typeof g != "symbol" && !isNaN(g) && 1 <= g && r.push(" ", c, '="', P(g), '"');
        break;
      case "rowSpan":
      case "start":
        typeof g == "function" || typeof g == "symbol" || isNaN(g) || r.push(" ", c, '="', P(g), '"');
        break;
      case "xlinkActuate":
        pn(r, "xlink:actuate", g);
        break;
      case "xlinkArcrole":
        pn(r, "xlink:arcrole", g);
        break;
      case "xlinkRole":
        pn(r, "xlink:role", g);
        break;
      case "xlinkShow":
        pn(r, "xlink:show", g);
        break;
      case "xlinkTitle":
        pn(r, "xlink:title", g);
        break;
      case "xlinkType":
        pn(r, "xlink:type", g);
        break;
      case "xmlBase":
        pn(r, "xml:base", g);
        break;
      case "xmlLang":
        pn(r, "xml:lang", g);
        break;
      case "xmlSpace":
        pn(r, "xml:space", g);
        break;
      default:
        if ((!(2 < c.length) || c[0] !== "o" && c[0] !== "O" || c[1] !== "n" && c[1] !== "N") && (c = it.get(c) || c, Ae(c))) {
          switch (typeof g) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var m = c.toLowerCase().slice(0, 5);
              if (m !== "data-" && m !== "aria-") return;
          }
          r.push(" ", c, '="', P(g), '"');
        }
    }
  }
  function qn(r, c, g) {
    if (c != null) {
      if (g != null) throw Error(f(60));
      if (typeof c != "object" || !("__html" in c))
        throw Error(f(61));
      c = c.__html, c != null && r.push("" + c);
    }
  }
  function Lr(r) {
    var c = "";
    return a.Children.forEach(r, function(g) {
      g != null && (c += g);
    }), c;
  }
  function Mi(r, c) {
    if ((r.instructions & 16) === 0) {
      r.instructions |= 16;
      var g = c.preamble, m = c.bootstrapChunks;
      (g.htmlChunks || g.headChunks) && m.length === 0 ? (m.push(c.startInlineScript), Ga(m, r), m.push(
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      )) : m.unshift(
        c.startInlineScript,
        ">",
        `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`,
        "<\/script>"
      );
    }
  }
  function tn(r, c) {
    r.push(ft("link"));
    for (var g in c)
      if (He.call(c, g)) {
        var m = c[g];
        if (m != null)
          switch (g) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, "link"));
            default:
              Ue(r, g, m);
          }
      }
    return r.push("/>"), null;
  }
  var Ha = /(<\/|<)(s)(tyle)/gi;
  function ui(r, c, g, m) {
    return "" + c + (g === "s" ? "\\73 " : "\\53 ") + m;
  }
  function Sa(r, c, g) {
    r.push(ft(g));
    for (var m in c)
      if (He.call(c, m)) {
        var x = c[m];
        if (x != null)
          switch (m) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, g));
            default:
              Ue(r, m, x);
          }
      }
    return r.push("/>"), null;
  }
  function or(r, c) {
    r.push(ft("title"));
    var g = null, m = null, x;
    for (x in c)
      if (He.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ue(r, x, N);
          }
      }
    return r.push(">"), c = Array.isArray(g) ? 2 > g.length ? g[0] : null : g, typeof c != "function" && typeof c != "symbol" && c !== null && c !== void 0 && r.push(P("" + c)), qn(r, m, g), r.push(Hl("title")), null;
  }
  function Wl(r, c) {
    r.push(ft("script"));
    var g = null, m = null, x;
    for (x in c)
      if (He.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ue(r, x, N);
          }
      }
    return r.push(">"), qn(r, m, g), typeof g == "string" && r.push(("" + g).replace(Pl, kl)), r.push(Hl("script")), null;
  }
  function Zn(r, c, g) {
    r.push(ft(g));
    var m = g = null, x;
    for (x in c)
      if (He.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ue(r, x, N);
          }
      }
    return r.push(">"), qn(r, m, g), g;
  }
  function Sl(r, c, g) {
    r.push(ft(g));
    var m = g = null, x;
    for (x in c)
      if (He.call(c, x)) {
        var N = c[x];
        if (N != null)
          switch (x) {
            case "children":
              g = N;
              break;
            case "dangerouslySetInnerHTML":
              m = N;
              break;
            default:
              Ue(r, x, N);
          }
      }
    return r.push(">"), qn(r, m, g), typeof g == "string" ? (r.push(P(g)), null) : g;
  }
  var Cn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Ba = /* @__PURE__ */ new Map();
  function ft(r) {
    var c = Ba.get(r);
    if (c === void 0) {
      if (!Cn.test(r))
        throw Error(f(65, r));
      c = "<" + r, Ba.set(r, c);
    }
    return c;
  }
  function Tn(r, c, g, m, x, N, L, ee, Y) {
    switch (c) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        r.push(ft("a"));
        var te = null, se = null, ie;
        for (ie in g)
          if (He.call(g, ie)) {
            var ve = g[ie];
            if (ve != null)
              switch (ie) {
                case "children":
                  te = ve;
                  break;
                case "dangerouslySetInnerHTML":
                  se = ve;
                  break;
                case "href":
                  ve === "" ? pn(r, "href", "") : Ue(r, ie, ve);
                  break;
                default:
                  Ue(r, ie, ve);
              }
          }
        if (r.push(">"), qn(r, se, te), typeof te == "string") {
          r.push(P(te));
          var Be = null;
        } else Be = te;
        return Be;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        r.push(ft("select"));
        var Ie = null, Ze = null, je;
        for (je in g)
          if (He.call(g, je)) {
            var Qe = g[je];
            if (Qe != null)
              switch (je) {
                case "children":
                  Ie = Qe;
                  break;
                case "dangerouslySetInnerHTML":
                  Ze = Qe;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  Ue(
                    r,
                    je,
                    Qe
                  );
              }
          }
        return r.push(">"), qn(r, Ze, Ie), Ie;
      case "option":
        var qe = ee.selectedValue;
        r.push(ft("option"));
        var Qt = null, Lt = null, ht = null, gt = null, lt;
        for (lt in g)
          if (He.call(g, lt)) {
            var Fl = g[lt];
            if (Fl != null)
              switch (lt) {
                case "children":
                  Qt = Fl;
                  break;
                case "selected":
                  ht = Fl;
                  break;
                case "dangerouslySetInnerHTML":
                  gt = Fl;
                  break;
                case "value":
                  Lt = Fl;
                default:
                  Ue(
                    r,
                    lt,
                    Fl
                  );
              }
          }
        if (qe != null) {
          var Pe = Lt !== null ? "" + Lt : Lr(Qt);
          if (xe(qe)) {
            for (var Al = 0; Al < qe.length; Al++)
              if ("" + qe[Al] === Pe) {
                r.push(' selected=""');
                break;
              }
          } else
            "" + qe === Pe && r.push(' selected=""');
        } else ht && r.push(' selected=""');
        return r.push(">"), qn(r, gt, Qt), Qt;
      case "textarea":
        r.push(ft("textarea"));
        var rt = null, En = null, gn = null, Rt;
        for (Rt in g)
          if (He.call(g, Rt)) {
            var nl = g[Rt];
            if (nl != null)
              switch (Rt) {
                case "children":
                  gn = nl;
                  break;
                case "value":
                  rt = nl;
                  break;
                case "defaultValue":
                  En = nl;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(f(91));
                default:
                  Ue(
                    r,
                    Rt,
                    nl
                  );
              }
          }
        if (rt === null && En !== null && (rt = En), r.push(">"), gn != null) {
          if (rt != null) throw Error(f(92));
          if (xe(gn)) {
            if (1 < gn.length)
              throw Error(f(93));
            rt = "" + gn[0];
          }
          rt = "" + gn;
        }
        return typeof rt == "string" && rt[0] === `
` && r.push(`
`), rt !== null && r.push(P("" + rt)), null;
      case "input":
        r.push(ft("input"));
        var $i = null, _l = null, Zr = null, ll = null, wn = null, al = null, Yl = null, Ol = null, Mn = null, Hn;
        for (Hn in g)
          if (He.call(g, Hn)) {
            var Jt = g[Hn];
            if (Jt != null)
              switch (Hn) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "input"));
                case "name":
                  $i = Jt;
                  break;
                case "formAction":
                  _l = Jt;
                  break;
                case "formEncType":
                  Zr = Jt;
                  break;
                case "formMethod":
                  ll = Jt;
                  break;
                case "formTarget":
                  wn = Jt;
                  break;
                case "defaultChecked":
                  Mn = Jt;
                  break;
                case "defaultValue":
                  Yl = Jt;
                  break;
                case "checked":
                  Ol = Jt;
                  break;
                case "value":
                  al = Jt;
                  break;
                default:
                  Ue(
                    r,
                    Hn,
                    Jt
                  );
              }
          }
        var fl = Ni(
          r,
          m,
          x,
          _l,
          Zr,
          ll,
          wn,
          $i
        );
        return Ol !== null ? jn(r, "checked", Ol) : Mn !== null && jn(r, "checked", Mn), al !== null ? Ue(r, "value", al) : Yl !== null && Ue(r, "value", Yl), r.push("/>"), fl != null && fl.forEach(ul, r), null;
      case "button":
        r.push(ft("button"));
        var Gl = null, _a = null, Sc = null, xc = null, _u = null, Vr = null, Qn = null, _t;
        for (_t in g)
          if (He.call(g, _t)) {
            var Je = g[_t];
            if (Je != null)
              switch (_t) {
                case "children":
                  Gl = Je;
                  break;
                case "dangerouslySetInnerHTML":
                  _a = Je;
                  break;
                case "name":
                  Sc = Je;
                  break;
                case "formAction":
                  xc = Je;
                  break;
                case "formEncType":
                  _u = Je;
                  break;
                case "formMethod":
                  Vr = Je;
                  break;
                case "formTarget":
                  Qn = Je;
                  break;
                default:
                  Ue(
                    r,
                    _t,
                    Je
                  );
              }
          }
        var Xl = Ni(
          r,
          m,
          x,
          xc,
          _u,
          Vr,
          Qn,
          Sc
        );
        if (r.push(">"), Xl != null && Xl.forEach(ul, r), qn(r, _a, Gl), typeof Gl == "string") {
          r.push(P(Gl));
          var Cl = null;
        } else Cl = Gl;
        return Cl;
      case "form":
        r.push(ft("form"));
        var Wa = null, Ja = null, ea = null, Qr = null, Oa = null, ma = null, Tr;
        for (Tr in g)
          if (He.call(g, Tr)) {
            var ta = g[Tr];
            if (ta != null)
              switch (Tr) {
                case "children":
                  Wa = ta;
                  break;
                case "dangerouslySetInnerHTML":
                  Ja = ta;
                  break;
                case "action":
                  ea = ta;
                  break;
                case "encType":
                  Qr = ta;
                  break;
                case "method":
                  Oa = ta;
                  break;
                case "target":
                  ma = ta;
                  break;
                default:
                  Ue(
                    r,
                    Tr,
                    ta
                  );
              }
          }
        var Ou = null, Kt = null;
        if (typeof ea == "function") {
          var dl = cl(
            m,
            ea
          );
          dl !== null ? (ea = dl.action || "", Qr = dl.encType, Oa = dl.method, ma = dl.target, Ou = dl.data, Kt = dl.name) : (r.push(
            " ",
            "action",
            '="',
            Ri,
            '"'
          ), ma = Oa = Qr = ea = null, Mi(m, x));
        }
        if (ea != null && Ue(r, "action", ea), Qr != null && Ue(r, "encType", Qr), Oa != null && Ue(r, "method", Oa), ma != null && Ue(r, "target", ma), r.push(">"), Kt !== null && (r.push('<input type="hidden"'), pn(r, "name", Kt), r.push("/>"), Ou != null && Ou.forEach(ul, r)), qn(r, Ja, Wa), typeof Wa == "string") {
          r.push(P(Wa));
          var na = null;
        } else na = Wa;
        return na;
      case "menuitem":
        r.push(ft("menuitem"));
        for (var hl in g)
          if (He.call(g, hl)) {
            var Pr = g[hl];
            if (Pr != null)
              switch (hl) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(400));
                default:
                  Ue(
                    r,
                    hl,
                    Pr
                  );
              }
          }
        return r.push(">"), null;
      case "object":
        r.push(ft("object"));
        var Il = null, la = null, Ka;
        for (Ka in g)
          if (He.call(g, Ka)) {
            var Pn = g[Ka];
            if (Pn != null)
              switch (Ka) {
                case "children":
                  Il = Pn;
                  break;
                case "dangerouslySetInnerHTML":
                  la = Pn;
                  break;
                case "data":
                  var yt = Q("" + Pn);
                  if (yt === "") break;
                  r.push(
                    " ",
                    "data",
                    '="',
                    P(yt),
                    '"'
                  );
                  break;
                default:
                  Ue(
                    r,
                    Ka,
                    Pn
                  );
              }
          }
        if (r.push(">"), qn(r, la, Il), typeof Il == "string") {
          r.push(P(Il));
          var pi = null;
        } else pi = Il;
        return pi;
      case "title":
        var il = ee.tagScope & 1, So = ee.tagScope & 4;
        if (ee.insertionMode === 4 || il || g.itemProp != null)
          var Cu = or(
            r,
            g
          );
        else
          So ? Cu = null : (or(x.hoistableChunks, g), Cu = void 0);
        return Cu;
      case "link":
        var Ru = ee.tagScope & 1, An = ee.tagScope & 4, Ec = g.rel, aa = g.href, Ca = g.precedence;
        if (ee.insertionMode === 4 || Ru || g.itemProp != null || typeof Ec != "string" || typeof aa != "string" || aa === "") {
          tn(r, g);
          var ja = null;
        } else if (g.rel === "stylesheet")
          if (typeof Ca != "string" || g.disabled != null || g.onLoad || g.onError)
            ja = tn(
              r,
              g
            );
          else {
            var vn = x.styles.get(Ca), Ra = m.styleResources.hasOwnProperty(aa) ? m.styleResources[aa] : void 0;
            if (Ra !== null) {
              m.styleResources[aa] = null, vn || (vn = {
                precedence: P(Ca),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, x.styles.set(Ca, vn));
              var Wr = {
                state: 0,
                props: Me({}, g, {
                  "data-precedence": g.precedence,
                  precedence: null
                })
              };
              if (Ra) {
                Ra.length === 2 && Li(Wr.props, Ra);
                var Nu = x.preloads.stylesheets.get(aa);
                Nu && 0 < Nu.length ? Nu.length = 0 : Wr.state = 1;
              }
              vn.sheets.set(aa, Wr), L && L.stylesheets.add(Wr);
            } else if (vn) {
              var wc = vn.sheets.get(aa);
              wc && L && L.stylesheets.add(wc);
            }
            Y && r.push("<!-- -->"), ja = null;
          }
        else
          g.onLoad || g.onError ? ja = tn(
            r,
            g
          ) : (Y && r.push("<!-- -->"), ja = An ? null : tn(x.hoistableChunks, g));
        return ja;
      case "script":
        var Ac = ee.tagScope & 1, qa = g.async;
        if (typeof g.src != "string" || !g.src || !qa || typeof qa == "function" || typeof qa == "symbol" || g.onLoad || g.onError || ee.insertionMode === 4 || Ac || g.itemProp != null)
          var Mu = Wl(
            r,
            g
          );
        else {
          var an = g.src;
          if (g.type === "module")
            var zu = m.moduleScriptResources, Na = x.preloads.moduleScripts;
          else
            zu = m.scriptResources, Na = x.preloads.scripts;
          var er = zu.hasOwnProperty(an) ? zu[an] : void 0;
          if (er !== null) {
            zu[an] = null;
            var tr = g;
            if (er) {
              er.length === 2 && (tr = Me({}, g), Li(tr, er));
              var Sr = Na.get(an);
              Sr && (Sr.length = 0);
            }
            var Jr = [];
            x.scripts.add(Jr), Wl(Jr, tr);
          }
          Y && r.push("<!-- -->"), Mu = null;
        }
        return Mu;
      case "style":
        var Kr = ee.tagScope & 1, Rl = g.precedence, Bn = g.href, _c = g.nonce;
        if (ee.insertionMode === 4 || Kr || g.itemProp != null || typeof Rl != "string" || typeof Bn != "string" || Bn === "") {
          r.push(ft("style"));
          var Ti = null, nr = null, ia;
          for (ia in g)
            if (He.call(g, ia)) {
              var $a = g[ia];
              if ($a != null)
                switch (ia) {
                  case "children":
                    Ti = $a;
                    break;
                  case "dangerouslySetInnerHTML":
                    nr = $a;
                    break;
                  default:
                    Ue(
                      r,
                      ia,
                      $a
                    );
                }
            }
          r.push(">");
          var ra = Array.isArray(Ti) ? 2 > Ti.length ? Ti[0] : null : Ti;
          typeof ra != "function" && typeof ra != "symbol" && ra !== null && ra !== void 0 && r.push(("" + ra).replace(Ha, ui)), qn(r, nr, Ti), r.push(Hl("style"));
          var Si = null;
        } else {
          var ei = x.styles.get(Rl);
          if ((m.styleResources.hasOwnProperty(Bn) ? m.styleResources[Bn] : void 0) !== null) {
            m.styleResources[Bn] = null, ei || (ei = {
              precedence: P(Rl),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, x.styles.set(Rl, ei));
            var xi = x.nonce.style;
            if (!xi || xi === _c) {
              ei.hrefs.push(P(Bn));
              var Oc = ei.rules, gl = null, xr = null, Ei;
              for (Ei in g)
                if (He.call(g, Ei)) {
                  var vl = g[Ei];
                  if (vl != null)
                    switch (Ei) {
                      case "children":
                        gl = vl;
                        break;
                      case "dangerouslySetInnerHTML":
                        xr = vl;
                    }
                }
              var Nl = Array.isArray(gl) ? 2 > gl.length ? gl[0] : null : gl;
              typeof Nl != "function" && typeof Nl != "symbol" && Nl !== null && Nl !== void 0 && Oc.push(
                ("" + Nl).replace(Ha, ui)
              ), qn(Oc, xr, gl);
            }
          }
          ei && L && L.styles.add(ei), Y && r.push("<!-- -->"), Si = void 0;
        }
        return Si;
      case "meta":
        var yl = ee.tagScope & 1, jr = ee.tagScope & 4;
        if (ee.insertionMode === 4 || yl || g.itemProp != null)
          var Du = Sa(
            r,
            g,
            "meta"
          );
        else
          Y && r.push("<!-- -->"), Du = jr ? null : typeof g.charSet == "string" ? Sa(x.charsetChunks, g, "meta") : g.name === "viewport" ? Sa(x.viewportChunks, g, "meta") : Sa(x.hoistableChunks, g, "meta");
        return Du;
      case "listing":
      case "pre":
        r.push(ft(c));
        var ti = null, i = null, u;
        for (u in g)
          if (He.call(g, u)) {
            var h = g[u];
            if (h != null)
              switch (u) {
                case "children":
                  ti = h;
                  break;
                case "dangerouslySetInnerHTML":
                  i = h;
                  break;
                default:
                  Ue(
                    r,
                    u,
                    h
                  );
              }
          }
        if (r.push(">"), i != null) {
          if (ti != null) throw Error(f(60));
          if (typeof i != "object" || !("__html" in i))
            throw Error(f(61));
          var b = i.__html;
          b != null && (typeof b == "string" && 0 < b.length && b[0] === `
` ? r.push(`
`, b) : r.push("" + b));
        }
        return typeof ti == "string" && ti[0] === `
` && r.push(`
`), ti;
      case "img":
        var T = ee.tagScope & 3, O = g.src, M = g.srcSet;
        if (!(g.loading === "lazy" || !O && !M || typeof O != "string" && O != null || typeof M != "string" && M != null || g.fetchPriority === "low" || T) && (typeof O != "string" || O[4] !== ":" || O[0] !== "d" && O[0] !== "D" || O[1] !== "a" && O[1] !== "A" || O[2] !== "t" && O[2] !== "T" || O[3] !== "a" && O[3] !== "A") && (typeof M != "string" || M[4] !== ":" || M[0] !== "d" && M[0] !== "D" || M[1] !== "a" && M[1] !== "A" || M[2] !== "t" && M[2] !== "T" || M[3] !== "a" && M[3] !== "A")) {
          L !== null && ee.tagScope & 64 && (L.suspenseyImages = !0);
          var Z = typeof g.sizes == "string" ? g.sizes : void 0, k = M ? M + `
` + (Z || "") : O, X = x.preloads.images, J = X.get(k);
          if (J)
            (g.fetchPriority === "high" || 10 > x.highImagePreloads.size) && (X.delete(k), x.highImagePreloads.add(J));
          else if (!m.imageResources.hasOwnProperty(k)) {
            m.imageResources[k] = It;
            var ne = g.crossOrigin, pe = typeof ne == "string" ? ne === "use-credentials" ? ne : "" : void 0, Te = x.headers, Ve;
            Te && 0 < Te.remainingCapacity && typeof g.srcSet != "string" && (g.fetchPriority === "high" || 500 > Te.highImagePreloads.length) && (Ve = dn(O, "image", {
              imageSrcSet: g.srcSet,
              imageSizes: g.sizes,
              crossOrigin: pe,
              integrity: g.integrity,
              nonce: g.nonce,
              type: g.type,
              fetchPriority: g.fetchPriority,
              referrerPolicy: g.refererPolicy
            }), 0 <= (Te.remainingCapacity -= Ve.length + 2)) ? (x.resets.image[k] = It, Te.highImagePreloads && (Te.highImagePreloads += ", "), Te.highImagePreloads += Ve) : (J = [], tn(J, {
              rel: "preload",
              as: "image",
              href: M ? void 0 : O,
              imageSrcSet: M,
              imageSizes: Z,
              crossOrigin: pe,
              integrity: g.integrity,
              type: g.type,
              fetchPriority: g.fetchPriority,
              referrerPolicy: g.referrerPolicy
            }), g.fetchPriority === "high" || 10 > x.highImagePreloads.size ? x.highImagePreloads.add(J) : (x.bulkPreloads.add(J), X.set(k, J)));
          }
        }
        return Sa(r, g, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return Sa(r, g, c);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > ee.insertionMode) {
          var Le = N || x.preamble;
          if (Le.headChunks)
            throw Error(f(545, "`<head>`"));
          N !== null && r.push("<!--head-->"), Le.headChunks = [];
          var at = Zn(
            Le.headChunks,
            g,
            "head"
          );
        } else
          at = Sl(
            r,
            g,
            "head"
          );
        return at;
      case "body":
        if (2 > ee.insertionMode) {
          var bt = N || x.preamble;
          if (bt.bodyChunks)
            throw Error(f(545, "`<body>`"));
          N !== null && r.push("<!--body-->"), bt.bodyChunks = [];
          var Oe = Zn(
            bt.bodyChunks,
            g,
            "body"
          );
        } else
          Oe = Sl(
            r,
            g,
            "body"
          );
        return Oe;
      case "html":
        if (ee.insertionMode === 0) {
          var Ke = N || x.preamble;
          if (Ke.htmlChunks)
            throw Error(f(545, "`<html>`"));
          N !== null && r.push("<!--html-->"), Ke.htmlChunks = [""];
          var mt = Zn(
            Ke.htmlChunks,
            g,
            "html"
          );
        } else
          mt = Sl(
            r,
            g,
            "html"
          );
        return mt;
      default:
        if (c.indexOf("-") !== -1) {
          r.push(ft(c));
          var Ml = null, Ye = null, yn;
          for (yn in g)
            if (He.call(g, yn)) {
              var jt = g[yn];
              if (jt != null) {
                var Un = yn;
                switch (yn) {
                  case "children":
                    Ml = jt;
                    break;
                  case "dangerouslySetInnerHTML":
                    Ye = jt;
                    break;
                  case "style":
                    Ta(r, jt);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    Un = "class";
                  default:
                    if (Ae(yn) && typeof jt != "function" && typeof jt != "symbol" && jt !== !1) {
                      if (jt === !0) jt = "";
                      else if (typeof jt == "object") continue;
                      r.push(
                        " ",
                        Un,
                        '="',
                        P(jt),
                        '"'
                      );
                    }
                }
              }
            }
          return r.push(">"), qn(r, Ye, Ml), Ml;
        }
    }
    return Sl(r, g, c);
  }
  var ci = /* @__PURE__ */ new Map();
  function Hl(r) {
    var c = ci.get(r);
    return c === void 0 && (c = "</" + r + ">", ci.set(r, c)), c;
  }
  function Ua(r, c) {
    r = r.preamble, r.htmlChunks === null && c.htmlChunks && (r.htmlChunks = c.htmlChunks), r.headChunks === null && c.headChunks && (r.headChunks = c.headChunks), r.bodyChunks === null && c.bodyChunks && (r.bodyChunks = c.bodyChunks);
  }
  function Jl(r, c) {
    c = c.bootstrapChunks;
    for (var g = 0; g < c.length - 1; g++)
      r.push(c[g]);
    return g < c.length ? (g = c[g], c.length = 0, r.push(g)) : !0;
  }
  function Kl(r, c, g) {
    if (r.push('<!--$?--><template id="'), g === null) throw Error(f(395));
    return r.push(c.boundaryPrefix), c = g.toString(16), r.push(c), r.push('"></template>');
  }
  function Rn(r, c, g, m) {
    switch (g.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return r.push('<div hidden id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 4:
        return r.push('<svg aria-hidden="true" style="display:none" id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 5:
        return r.push('<math aria-hidden="true" style="display:none" id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 6:
        return r.push('<table hidden id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 7:
        return r.push('<table hidden><tbody id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 8:
        return r.push('<table hidden><tr id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      case 9:
        return r.push('<table hidden><colgroup id="'), r.push(c.segmentPrefix), c = m.toString(16), r.push(c), r.push('">');
      default:
        throw Error(f(397));
    }
  }
  function jl(r, c) {
    switch (c.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return r.push("</div>");
      case 4:
        return r.push("</svg>");
      case 5:
        return r.push("</math>");
      case 6:
        return r.push("</table>");
      case 7:
        return r.push("</tbody></table>");
      case 8:
        return r.push("</tr></table>");
      case 9:
        return r.push("</colgroup></table>");
      default:
        throw Error(f(397));
    }
  }
  var Fa = /[<\u2028\u2029]/g;
  function sr(r) {
    return JSON.stringify(r).replace(
      Fa,
      function(c) {
        switch (c) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Ya = /[&><\u2028\u2029]/g;
  function fr(r) {
    return JSON.stringify(r).replace(
      Ya,
      function(c) {
        switch (c) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var oi = !1, fn = !0;
  function ol(r) {
    var c = r.rules, g = r.hrefs, m = 0;
    if (g.length) {
      for (this.push(en.startInlineStyle), this.push(' media="not all" data-precedence="'), this.push(r.precedence), this.push('" data-href="'); m < g.length - 1; m++)
        this.push(g[m]), this.push(" ");
      for (this.push(g[m]), this.push('">'), m = 0; m < c.length; m++) this.push(c[m]);
      fn = this.push("</style>"), oi = !0, c.length = 0, g.length = 0;
    }
  }
  function zt(r) {
    return r.state !== 2 ? oi = !0 : !1;
  }
  function zi(r, c, g) {
    return oi = !1, fn = !0, en = g, c.styles.forEach(ol, r), en = null, c.stylesheets.forEach(zt), oi && (g.stylesToHoist = !0), fn;
  }
  function Nn(r) {
    for (var c = 0; c < r.length; c++) this.push(r[c]);
    r.length = 0;
  }
  var Zt = [];
  function xa(r) {
    tn(Zt, r.props);
    for (var c = 0; c < Zt.length; c++)
      this.push(Zt[c]);
    Zt.length = 0, r.state = 2;
  }
  function nt(r) {
    var c = 0 < r.sheets.size;
    r.sheets.forEach(xa, this), r.sheets.clear();
    var g = r.rules, m = r.hrefs;
    if (!c || m.length) {
      if (this.push(en.startInlineStyle), this.push(' data-precedence="'), this.push(r.precedence), r = 0, m.length) {
        for (this.push('" data-href="'); r < m.length - 1; r++)
          this.push(m[r]), this.push(" ");
        this.push(m[r]);
      }
      for (this.push('">'), r = 0; r < g.length; r++)
        this.push(g[r]);
      this.push("</style>"), g.length = 0, m.length = 0;
    }
  }
  function on(r) {
    if (r.state === 0) {
      r.state = 1;
      var c = r.props;
      for (tn(Zt, {
        rel: "preload",
        as: "style",
        href: r.props.href,
        crossOrigin: c.crossOrigin,
        fetchPriority: c.fetchPriority,
        integrity: c.integrity,
        media: c.media,
        hrefLang: c.hrefLang,
        referrerPolicy: c.referrerPolicy
      }), r = 0; r < Zt.length; r++)
        this.push(Zt[r]);
      Zt.length = 0;
    }
  }
  function si(r) {
    r.sheets.forEach(on, this), r.sheets.clear();
  }
  function Ga(r, c) {
    (c.instructions & 32) === 0 && (c.instructions |= 32, r.push(
      ' id="',
      P("_" + c.idPrefix + "R_"),
      '"'
    ));
  }
  function kr(r, c) {
    r.push("[");
    var g = "[";
    c.stylesheets.forEach(function(m) {
      if (m.state !== 2)
        if (m.state === 3)
          r.push(g), m = fr(
            "" + m.props.href
          ), r.push(m), r.push("]"), g = ",[";
        else {
          r.push(g);
          var x = m.props["data-precedence"], N = m.props, L = Q("" + m.props.href);
          L = fr(L), r.push(L), x = "" + x, r.push(","), x = fr(x), r.push(x);
          for (var ee in N)
            if (He.call(N, ee) && (x = N[ee], x != null))
              switch (ee) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "link"));
                default:
                  St(
                    r,
                    ee,
                    x
                  );
              }
          r.push("]"), g = ",[", m.state = 3;
        }
    }), r.push("]");
  }
  function St(r, c, g) {
    var m = c.toLowerCase();
    switch (typeof g) {
      case "function":
      case "symbol":
        return;
    }
    switch (c) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        m = "class", c = "" + g;
        break;
      case "hidden":
        if (g === !1) return;
        c = "";
        break;
      case "src":
      case "href":
        g = Q(g), c = "" + g;
        break;
      default:
        if (2 < c.length && (c[0] === "o" || c[0] === "O") && (c[1] === "n" || c[1] === "N") || !Ae(c))
          return;
        c = "" + g;
    }
    r.push(","), m = fr(m), r.push(m), r.push(","), m = fr(c), r.push(m);
  }
  function Dt() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function Ea(r) {
    var c = Vn || null;
    if (c) {
      var g = c.resumableState, m = c.renderState;
      if (typeof r == "string" && r) {
        if (!g.dnsResources.hasOwnProperty(r)) {
          g.dnsResources[r] = null, g = m.headers;
          var x, N;
          (N = g && 0 < g.remainingCapacity) && (N = (x = "<" + ("" + r).replace(
            ql,
            ga
          ) + ">; rel=dns-prefetch", 0 <= (g.remainingCapacity -= x.length + 2))), N ? (m.resets.dns[r] = null, g.preconnects && (g.preconnects += ", "), g.preconnects += x) : (x = [], tn(x, { href: r, rel: "dns-prefetch" }), m.preconnects.add(x));
        }
        mi(c);
      }
    } else Ne.D(r);
  }
  function $n(r, c) {
    var g = Vn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (typeof r == "string" && r) {
        var N = c === "use-credentials" ? "credentials" : typeof c == "string" ? "anonymous" : "default";
        if (!m.connectResources[N].hasOwnProperty(r)) {
          m.connectResources[N][r] = null, m = x.headers;
          var L, ee;
          if (ee = m && 0 < m.remainingCapacity) {
            if (ee = "<" + ("" + r).replace(
              ql,
              ga
            ) + ">; rel=preconnect", typeof c == "string") {
              var Y = ("" + c).replace(
                $l,
                fi
              );
              ee += '; crossorigin="' + Y + '"';
            }
            ee = (L = ee, 0 <= (m.remainingCapacity -= L.length + 2));
          }
          ee ? (x.resets.connect[N][r] = null, m.preconnects && (m.preconnects += ", "), m.preconnects += L) : (N = [], tn(N, {
            rel: "preconnect",
            href: r,
            crossOrigin: c
          }), x.preconnects.add(N));
        }
        mi(g);
      }
    } else Ne.C(r, c);
  }
  function Di(r, c, g) {
    var m = Vn || null;
    if (m) {
      var x = m.resumableState, N = m.renderState;
      if (c && r) {
        switch (c) {
          case "image":
            if (g)
              var L = g.imageSrcSet, ee = g.imageSizes, Y = g.fetchPriority;
            var te = L ? L + `
` + (ee || "") : r;
            if (x.imageResources.hasOwnProperty(te)) return;
            x.imageResources[te] = It, x = N.headers;
            var se;
            x && 0 < x.remainingCapacity && typeof L != "string" && Y === "high" && (se = dn(r, c, g), 0 <= (x.remainingCapacity -= se.length + 2)) ? (N.resets.image[te] = It, x.highImagePreloads && (x.highImagePreloads += ", "), x.highImagePreloads += se) : (x = [], tn(
              x,
              Me(
                { rel: "preload", href: L ? void 0 : r, as: c },
                g
              )
            ), Y === "high" ? N.highImagePreloads.add(x) : (N.bulkPreloads.add(x), N.preloads.images.set(te, x)));
            break;
          case "style":
            if (x.styleResources.hasOwnProperty(r)) return;
            L = [], tn(
              L,
              Me({ rel: "preload", href: r, as: c }, g)
            ), x.styleResources[r] = !g || typeof g.crossOrigin != "string" && typeof g.integrity != "string" ? It : [g.crossOrigin, g.integrity], N.preloads.stylesheets.set(r, L), N.bulkPreloads.add(L);
            break;
          case "script":
            if (x.scriptResources.hasOwnProperty(r)) return;
            L = [], N.preloads.scripts.set(r, L), N.bulkPreloads.add(L), tn(
              L,
              Me({ rel: "preload", href: r, as: c }, g)
            ), x.scriptResources[r] = !g || typeof g.crossOrigin != "string" && typeof g.integrity != "string" ? It : [g.crossOrigin, g.integrity];
            break;
          default:
            if (x.unknownResources.hasOwnProperty(c)) {
              if (L = x.unknownResources[c], L.hasOwnProperty(r))
                return;
            } else
              L = {}, x.unknownResources[c] = L;
            if (L[r] = It, (x = N.headers) && 0 < x.remainingCapacity && c === "font" && (te = dn(r, c, g), 0 <= (x.remainingCapacity -= te.length + 2)))
              N.resets.font[r] = It, x.fontPreloads && (x.fontPreloads += ", "), x.fontPreloads += te;
            else
              switch (x = [], r = Me({ rel: "preload", href: r, as: c }, g), tn(x, r), c) {
                case "font":
                  N.fontPreloads.add(x);
                  break;
                default:
                  N.bulkPreloads.add(x);
              }
        }
        mi(m);
      }
    } else Ne.L(r, c, g);
  }
  function Xa(r, c) {
    var g = Vn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = c && typeof c.as == "string" ? c.as : "script";
        switch (N) {
          case "script":
            if (m.moduleScriptResources.hasOwnProperty(r)) return;
            N = [], m.moduleScriptResources[r] = !c || typeof c.crossOrigin != "string" && typeof c.integrity != "string" ? It : [c.crossOrigin, c.integrity], x.preloads.moduleScripts.set(r, N);
            break;
          default:
            if (m.moduleUnknownResources.hasOwnProperty(N)) {
              var L = m.unknownResources[N];
              if (L.hasOwnProperty(r)) return;
            } else
              L = {}, m.moduleUnknownResources[N] = L;
            N = [], L[r] = It;
        }
        tn(N, Me({ rel: "modulepreload", href: r }, c)), x.bulkPreloads.add(N), mi(g);
      }
    } else Ne.m(r, c);
  }
  function xl(r, c, g) {
    var m = Vn || null;
    if (m) {
      var x = m.resumableState, N = m.renderState;
      if (r) {
        c = c || "default";
        var L = N.styles.get(c), ee = x.styleResources.hasOwnProperty(r) ? x.styleResources[r] : void 0;
        ee !== null && (x.styleResources[r] = null, L || (L = {
          precedence: P(c),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, N.styles.set(c, L)), c = {
          state: 0,
          props: Me(
            { rel: "stylesheet", href: r, "data-precedence": c },
            g
          )
        }, ee && (ee.length === 2 && Li(c.props, ee), (N = N.preloads.stylesheets.get(r)) && 0 < N.length ? N.length = 0 : c.state = 1), L.sheets.set(r, c), mi(m));
      }
    } else Ne.S(r, c, g);
  }
  function Ia(r, c) {
    var g = Vn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = m.scriptResources.hasOwnProperty(r) ? m.scriptResources[r] : void 0;
        N !== null && (m.scriptResources[r] = null, c = Me({ src: r, async: !0 }, c), N && (N.length === 2 && Li(c, N), r = x.preloads.scripts.get(r)) && (r.length = 0), r = [], x.scripts.add(r), Wl(r, c), mi(g));
      }
    } else Ne.X(r, c);
  }
  function Vt(r, c) {
    var g = Vn || null;
    if (g) {
      var m = g.resumableState, x = g.renderState;
      if (r) {
        var N = m.moduleScriptResources.hasOwnProperty(
          r
        ) ? m.moduleScriptResources[r] : void 0;
        N !== null && (m.moduleScriptResources[r] = null, c = Me({ src: r, type: "module", async: !0 }, c), N && (N.length === 2 && Li(c, N), r = x.preloads.moduleScripts.get(r)) && (r.length = 0), r = [], x.scripts.add(r), Wl(r, c), mi(g));
      }
    } else Ne.M(r, c);
  }
  function Li(r, c) {
    r.crossOrigin == null && (r.crossOrigin = c[0]), r.integrity == null && (r.integrity = c[1]);
  }
  function dn(r, c, g) {
    r = ("" + r).replace(
      ql,
      ga
    ), c = ("" + c).replace(
      $l,
      fi
    ), c = "<" + r + '>; rel=preload; as="' + c + '"';
    for (var m in g)
      He.call(g, m) && (r = g[m], typeof r == "string" && (c += "; " + m.toLowerCase() + '="' + ("" + r).replace(
        $l,
        fi
      ) + '"'));
    return c;
  }
  var ql = /[<>\r\n]/g;
  function ga(r) {
    switch (r) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var $l = /["';,\r\n]/g;
  function fi(r) {
    switch (r) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function dr(r) {
    this.styles.add(r);
  }
  function ki(r) {
    this.stylesheets.add(r);
  }
  function El(r, c) {
    c.styles.forEach(dr, r), c.stylesheets.forEach(ki, r), c.suspenseyImages && (r.suspenseyImages = !0);
  }
  function el(r, c) {
    var g = r.idPrefix, m = [], x = r.bootstrapScriptContent, N = r.bootstrapScripts, L = r.bootstrapModules;
    x !== void 0 && (m.push("<script"), Ga(m, r), m.push(
      ">",
      ("" + x).replace(Pl, kl),
      "<\/script>"
    )), x = g + "P:";
    var ee = g + "S:";
    g += "B:";
    var Y = /* @__PURE__ */ new Set(), te = /* @__PURE__ */ new Set(), se = /* @__PURE__ */ new Set(), ie = /* @__PURE__ */ new Map(), ve = /* @__PURE__ */ new Set(), Be = /* @__PURE__ */ new Set(), Ie = /* @__PURE__ */ new Set(), Ze = {
      images: /* @__PURE__ */ new Map(),
      stylesheets: /* @__PURE__ */ new Map(),
      scripts: /* @__PURE__ */ new Map(),
      moduleScripts: /* @__PURE__ */ new Map()
    };
    if (N !== void 0)
      for (var je = 0; je < N.length; je++) {
        var Qe = N[je], qe, Qt = void 0, Lt = void 0, ht = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: void 0
        };
        typeof Qe == "string" ? ht.href = qe = Qe : (ht.href = qe = Qe.src, ht.integrity = Lt = typeof Qe.integrity == "string" ? Qe.integrity : void 0, ht.crossOrigin = Qt = typeof Qe == "string" || Qe.crossOrigin == null ? void 0 : Qe.crossOrigin === "use-credentials" ? "use-credentials" : ""), Qe = r;
        var gt = qe;
        Qe.scriptResources[gt] = null, Qe.moduleScriptResources[gt] = null, Qe = [], tn(Qe, ht), ve.add(Qe), m.push('<script src="', P(qe), '"'), typeof Lt == "string" && m.push(
          ' integrity="',
          P(Lt),
          '"'
        ), typeof Qt == "string" && m.push(
          ' crossorigin="',
          P(Qt),
          '"'
        ), Ga(m, r), m.push(' async=""><\/script>');
      }
    if (L !== void 0)
      for (N = 0; N < L.length; N++)
        ht = L[N], Qt = qe = void 0, Lt = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: void 0
        }, typeof ht == "string" ? Lt.href = je = ht : (Lt.href = je = ht.src, Lt.integrity = Qt = typeof ht.integrity == "string" ? ht.integrity : void 0, Lt.crossOrigin = qe = typeof ht == "string" || ht.crossOrigin == null ? void 0 : ht.crossOrigin === "use-credentials" ? "use-credentials" : ""), ht = r, Qe = je, ht.scriptResources[Qe] = null, ht.moduleScriptResources[Qe] = null, ht = [], tn(ht, Lt), ve.add(ht), m.push(
          '<script type="module" src="',
          P(je),
          '"'
        ), typeof Qt == "string" && m.push(
          ' integrity="',
          P(Qt),
          '"'
        ), typeof qe == "string" && m.push(
          ' crossorigin="',
          P(qe),
          '"'
        ), Ga(m, r), m.push(' async=""><\/script>');
    return {
      placeholderPrefix: x,
      segmentPrefix: ee,
      boundaryPrefix: g,
      startInlineScript: "<script",
      startInlineStyle: "<style",
      preamble: { htmlChunks: null, headChunks: null, bodyChunks: null },
      externalRuntimeScript: null,
      bootstrapChunks: m,
      importMapChunks: [],
      onHeaders: void 0,
      headers: null,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: Y,
      fontPreloads: te,
      highImagePreloads: se,
      styles: ie,
      bootstrapScripts: ve,
      scripts: Be,
      bulkPreloads: Ie,
      preloads: Ze,
      nonce: { script: void 0, style: void 0 },
      stylesToHoist: !1,
      generateStaticMarkup: c
    };
  }
  function Bl(r, c, g, m) {
    return g.generateStaticMarkup ? (r.push(P(c)), !1) : (c === "" ? r = m : (m && r.push("<!-- -->"), r.push(P(c)), r = !0), r);
  }
  function Sn(r, c, g, m) {
    c.generateStaticMarkup || g && m && r.push("<!-- -->");
  }
  var hr = Function.prototype.bind, lc = Symbol.for("react.client.reference");
  function di(r) {
    if (r == null) return null;
    if (typeof r == "function")
      return r.$$typeof === lc ? null : r.displayName || r.name || null;
    if (typeof r == "string") return r;
    switch (r) {
      case p:
        return "Fragment";
      case _:
        return "Profiler";
      case w:
        return "StrictMode";
      case I:
        return "Suspense";
      case F:
        return "SuspenseList";
      case he:
        return "Activity";
    }
    if (typeof r == "object")
      switch (r.$$typeof) {
        case y:
          return "Portal";
        case z:
          return r.displayName || "Context";
        case C:
          return (r._context.displayName || "Context") + ".Consumer";
        case B:
          var c = r.render;
          return r = r.displayName, r || (r = c.displayName || c.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
        case ce:
          return c = r.displayName || null, c !== null ? c : di(r.type) || "Memo";
        case ae:
          c = r._payload, r = r._init;
          try {
            return di(r(c));
          } catch {
          }
      }
    return null;
  }
  var nn = {}, va = null;
  function Hr(r, c) {
    if (r !== c) {
      r.context._currentValue2 = r.parentValue, r = r.parent;
      var g = c.parent;
      if (r === null) {
        if (g !== null) throw Error(f(401));
      } else {
        if (g === null) throw Error(f(401));
        Hr(r, g);
      }
      c.context._currentValue2 = c.value;
    }
  }
  function tl(r) {
    r.context._currentValue2 = r.parentValue, r = r.parent, r !== null && tl(r);
  }
  function wl(r) {
    var c = r.parent;
    c !== null && wl(c), r.context._currentValue2 = r.value;
  }
  function Hi(r, c) {
    if (r.context._currentValue2 = r.parentValue, r = r.parent, r === null) throw Error(f(402));
    r.depth === c.depth ? Hr(r, c) : Hi(r, c);
  }
  function be(r, c) {
    var g = c.parent;
    if (g === null) throw Error(f(402));
    r.depth === g.depth ? Hr(r, g) : be(r, g), c.context._currentValue2 = c.value;
  }
  function D(r) {
    var c = va;
    c !== r && (c === null ? wl(r) : r === null ? tl(c) : c.depth === r.depth ? Hr(c, r) : c.depth > r.depth ? Hi(c, r) : be(c, r), va = r);
  }
  var W = {
    enqueueSetState: function(r, c) {
      r = r._reactInternals, r.queue !== null && r.queue.push(c);
    },
    enqueueReplaceState: function(r, c) {
      r = r._reactInternals, r.replace = !0, r.queue = [c];
    },
    enqueueForceUpdate: function() {
    }
  }, me = { id: 1, overflow: "" };
  function Ee(r, c, g) {
    var m = r.id;
    r = r.overflow;
    var x = 32 - We(m) - 1;
    m &= ~(1 << x), g += 1;
    var N = 32 - We(c) + x;
    if (30 < N) {
      var L = x - x % 5;
      return N = (m & (1 << L) - 1).toString(32), m >>= L, x -= L, {
        id: 1 << 32 - We(c) + x | g << x | m,
        overflow: N + r
      };
    }
    return {
      id: 1 << N | g << x | m,
      overflow: r
    };
  }
  var We = Math.clz32 ? Math.clz32 : ln, ot = Math.log, xn = Math.LN2;
  function ln(r) {
    return r >>>= 0, r === 0 ? 32 : 31 - (ot(r) / xn | 0) | 0;
  }
  function Ht() {
  }
  var Wt = Error(f(460));
  function Bi(r, c, g) {
    switch (g = r[g], g === void 0 ? r.push(c) : g !== c && (c.then(Ht, Ht), c = g), c.status) {
      case "fulfilled":
        return c.value;
      case "rejected":
        throw c.reason;
      default:
        switch (typeof c.status == "string" ? c.then(Ht, Ht) : (r = c, r.status = "pending", r.then(
          function(m) {
            if (c.status === "pending") {
              var x = c;
              x.status = "fulfilled", x.value = m;
            }
          },
          function(m) {
            if (c.status === "pending") {
              var x = c;
              x.status = "rejected", x.reason = m;
            }
          }
        )), c.status) {
          case "fulfilled":
            return c.value;
          case "rejected":
            throw c.reason;
        }
        throw Bt = c, Wt;
    }
  }
  var Bt = null;
  function Br() {
    if (Bt === null) throw Error(f(459));
    var r = Bt;
    return Bt = null, r;
  }
  function so(r, c) {
    return r === c && (r !== 0 || 1 / r === 1 / c) || r !== r && c !== c;
  }
  var gr = typeof Object.is == "function" ? Object.is : so, Ul = null, ac = null, vu = null, ic = null, Ui = null, dt = null, vr = !1, Fi = !1, ya = 0, yr = 0, Yi = -1, yu = 0, hi = null, wa = null, bu = 0;
  function hn() {
    if (Ul === null)
      throw Error(f(321));
    return Ul;
  }
  function Gi() {
    if (0 < bu) throw Error(f(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Ur() {
    return dt === null ? Ui === null ? (vr = !1, Ui = dt = Gi()) : (vr = !0, dt = Ui) : dt.next === null ? (vr = !1, dt = dt.next = Gi()) : (vr = !0, dt = dt.next), dt;
  }
  function Za() {
    var r = hi;
    return hi = null, r;
  }
  function mu() {
    ic = vu = ac = Ul = null, Fi = !1, Ui = null, bu = 0, dt = wa = null;
  }
  function rc(r, c) {
    return typeof c == "function" ? c(r) : c;
  }
  function uc(r, c, g) {
    if (Ul = hn(), dt = Ur(), vr) {
      var m = dt.queue;
      if (c = m.dispatch, wa !== null && (g = wa.get(m), g !== void 0)) {
        wa.delete(m), m = dt.memoizedState;
        do
          m = r(m, g.action), g = g.next;
        while (g !== null);
        return dt.memoizedState = m, [m, c];
      }
      return [dt.memoizedState, c];
    }
    return r = r === rc ? typeof c == "function" ? c() : c : g !== void 0 ? g(c) : c, dt.memoizedState = r, r = dt.queue = { last: null, dispatch: null }, r = r.dispatch = cc.bind(
      null,
      Ul,
      r
    ), [dt.memoizedState, r];
  }
  function Fr(r, c) {
    if (Ul = hn(), dt = Ur(), c = c === void 0 ? null : c, dt !== null) {
      var g = dt.memoizedState;
      if (g !== null && c !== null) {
        var m = g[1];
        e: if (m === null) m = !1;
        else {
          for (var x = 0; x < m.length && x < c.length; x++)
            if (!gr(c[x], m[x])) {
              m = !1;
              break e;
            }
          m = !0;
        }
        if (m) return g[0];
      }
    }
    return r = r(), dt.memoizedState = [r, c], r;
  }
  function cc(r, c, g) {
    if (25 <= bu) throw Error(f(301));
    if (r === Ul)
      if (Fi = !0, r = { action: g, next: null }, wa === null && (wa = /* @__PURE__ */ new Map()), g = wa.get(c), g === void 0)
        wa.set(c, r);
      else {
        for (c = g; c.next !== null; ) c = c.next;
        c.next = r;
      }
  }
  function Qo() {
    throw Error(f(440));
  }
  function Ys() {
    throw Error(f(394));
  }
  function Gs() {
    throw Error(f(479));
  }
  function fo(r, c, g) {
    hn();
    var m = yr++, x = vu;
    if (typeof r.$$FORM_ACTION == "function") {
      var N = null, L = ic;
      x = x.formState;
      var ee = r.$$IS_SIGNATURE_EQUAL;
      if (x !== null && typeof ee == "function") {
        var Y = x[1];
        ee.call(r, x[2], x[3]) && (N = g !== void 0 ? "p" + g : "k" + we(
          JSON.stringify([L, null, m]),
          0
        ), Y === N && (Yi = m, c = x[0]));
      }
      var te = r.bind(null, c);
      return r = function(ie) {
        te(ie);
      }, typeof te.$$FORM_ACTION == "function" && (r.$$FORM_ACTION = function(ie) {
        ie = te.$$FORM_ACTION(ie), g !== void 0 && (g += "", ie.action = g);
        var ve = ie.data;
        return ve && (N === null && (N = g !== void 0 ? "p" + g : "k" + we(
          JSON.stringify([
            L,
            null,
            m
          ]),
          0
        )), ve.append("$ACTION_KEY", N)), ie;
      }), [c, r, !1];
    }
    var se = r.bind(null, c);
    return [
      c,
      function(ie) {
        se(ie);
      },
      !1
    ];
  }
  function oc(r) {
    var c = yu;
    return yu += 1, hi === null && (hi = []), Bi(hi, r, c);
  }
  function Xs() {
    throw Error(f(393));
  }
  var Po = {
    readContext: function(r) {
      return r._currentValue2;
    },
    use: function(r) {
      if (r !== null && typeof r == "object") {
        if (typeof r.then == "function") return oc(r);
        if (r.$$typeof === z)
          return r._currentValue2;
      }
      throw Error(f(438, String(r)));
    },
    useContext: function(r) {
      return hn(), r._currentValue2;
    },
    useMemo: Fr,
    useReducer: uc,
    useRef: function(r) {
      Ul = hn(), dt = Ur();
      var c = dt.memoizedState;
      return c === null ? (r = { current: r }, dt.memoizedState = r) : c;
    },
    useState: function(r) {
      return uc(rc, r);
    },
    useInsertionEffect: Ht,
    useLayoutEffect: Ht,
    useCallback: function(r, c) {
      return Fr(function() {
        return r;
      }, c);
    },
    useImperativeHandle: Ht,
    useEffect: Ht,
    useDebugValue: Ht,
    useDeferredValue: function(r, c) {
      return hn(), c !== void 0 ? c : r;
    },
    useTransition: function() {
      return hn(), [!1, Ys];
    },
    useId: function() {
      var r = ac.treeContext, c = r.overflow;
      r = r.id, r = (r & ~(1 << 32 - We(r) - 1)).toString(32) + c;
      var g = sc;
      if (g === null) throw Error(f(404));
      return c = ya++, r = "_" + g.idPrefix + "R_" + r, 0 < c && (r += "H" + c.toString(32)), r + "_";
    },
    useSyncExternalStore: function(r, c, g) {
      if (g === void 0)
        throw Error(f(407));
      return g();
    },
    useOptimistic: function(r) {
      return hn(), [r, Gs];
    },
    useActionState: fo,
    useFormState: fo,
    useHostTransitionStatus: function() {
      return hn(), _e;
    },
    useMemoCache: function(r) {
      for (var c = Array(r), g = 0; g < r; g++)
        c[g] = de;
      return c;
    },
    useCacheRefresh: function() {
      return Xs;
    },
    useEffectEvent: function() {
      return Qo;
    }
  }, sc = null, Is = {
    getCacheForType: function() {
      throw Error(f(248));
    },
    cacheSignal: function() {
      throw Error(f(248));
    }
  }, ho, go;
  function Yr(r) {
    if (ho === void 0)
      try {
        throw Error();
      } catch (g) {
        var c = g.stack.trim().match(/\n( *(at )?)/);
        ho = c && c[1] || "", go = -1 < g.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < g.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + ho + r + go;
  }
  var vo = !1;
  function fc(r, c) {
    if (!r || vo) return "";
    vo = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var m = {
        DetermineComponentFrameRoot: function() {
          try {
            if (c) {
              var ie = function() {
                throw Error();
              };
              if (Object.defineProperty(ie.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(ie, []);
                } catch (Be) {
                  var ve = Be;
                }
                Reflect.construct(r, [], ie);
              } else {
                try {
                  ie.call();
                } catch (Be) {
                  ve = Be;
                }
                r.call(ie.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Be) {
                ve = Be;
              }
              (ie = r()) && typeof ie.catch == "function" && ie.catch(function() {
              });
            }
          } catch (Be) {
            if (Be && ve && typeof Be.stack == "string")
              return [Be.stack, ve.stack];
          }
          return [null, null];
        }
      };
      m.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var x = Object.getOwnPropertyDescriptor(
        m.DetermineComponentFrameRoot,
        "name"
      );
      x && x.configurable && Object.defineProperty(
        m.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var N = m.DetermineComponentFrameRoot(), L = N[0], ee = N[1];
      if (L && ee) {
        var Y = L.split(`
`), te = ee.split(`
`);
        for (x = m = 0; m < Y.length && !Y[m].includes("DetermineComponentFrameRoot"); )
          m++;
        for (; x < te.length && !te[x].includes(
          "DetermineComponentFrameRoot"
        ); )
          x++;
        if (m === Y.length || x === te.length)
          for (m = Y.length - 1, x = te.length - 1; 1 <= m && 0 <= x && Y[m] !== te[x]; )
            x--;
        for (; 1 <= m && 0 <= x; m--, x--)
          if (Y[m] !== te[x]) {
            if (m !== 1 || x !== 1)
              do
                if (m--, x--, 0 > x || Y[m] !== te[x]) {
                  var se = `
` + Y[m].replace(" at new ", " at ");
                  return r.displayName && se.includes("<anonymous>") && (se = se.replace("<anonymous>", r.displayName)), se;
                }
              while (1 <= m && 0 <= x);
            break;
          }
      }
    } finally {
      vo = !1, Error.prepareStackTrace = g;
    }
    return (g = r ? r.displayName || r.name : "") ? Yr(g) : "";
  }
  function Wo(r) {
    if (typeof r == "string") return Yr(r);
    if (typeof r == "function")
      return r.prototype && r.prototype.isReactComponent ? fc(r, !0) : fc(r, !1);
    if (typeof r == "object" && r !== null) {
      switch (r.$$typeof) {
        case B:
          return fc(r.render, !1);
        case ce:
          return fc(r.type, !1);
        case ae:
          var c = r, g = c._payload;
          c = c._init;
          try {
            r = c(g);
          } catch {
            return Yr("Lazy");
          }
          return Wo(r);
      }
      if (typeof r.name == "string") {
        e: {
          g = r.name, c = r.env;
          var m = r.debugLocation;
          if (m != null && (r = Error.prepareStackTrace, Error.prepareStackTrace = void 0, m = m.stack, Error.prepareStackTrace = r, m.startsWith(`Error: react-stack-top-frame
`) && (m = m.slice(29)), r = m.indexOf(`
`), r !== -1 && (m = m.slice(r + 1)), r = m.indexOf("react_stack_bottom_frame"), r !== -1 && (r = m.lastIndexOf(`
`, r)), r = r !== -1 ? m = m.slice(0, r) : "", m = r.lastIndexOf(`
`), r = m === -1 ? r : r.slice(m + 1), r.indexOf(g) !== -1)) {
            g = `
` + r;
            break e;
          }
          g = Yr(
            g + (c ? " [" + c + "]" : "")
          );
        }
        return g;
      }
    }
    switch (r) {
      case F:
        return Yr("SuspenseList");
      case I:
        return Yr("Suspense");
    }
    return "";
  }
  function Xi(r, c) {
    return (500 < c.byteSize || !1) && c.contentPreamble === null;
  }
  function Zs(r) {
    if (typeof r == "object" && r !== null && typeof r.environmentName == "string") {
      var c = r.environmentName;
      r = [r].slice(0), typeof r[0] == "string" ? r.splice(
        0,
        1,
        "[%s] " + r[0],
        " " + c + " "
      ) : r.splice(0, 0, "[%s]", " " + c + " "), r.unshift(console), c = hr.apply(console.error, r), c();
    } else console.error(r);
    return null;
  }
  function Vs(r, c, g, m, x, N, L, ee, Y, te, se) {
    var ie = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = r, this.renderState = c, this.rootFormatContext = g, this.progressiveChunkSize = m === void 0 ? 12800 : m, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = ie, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = x === void 0 ? Zs : x, this.onPostpone = te === void 0 ? Ht : te, this.onAllReady = N === void 0 ? Ht : N, this.onShellReady = L === void 0 ? Ht : L, this.onShellError = ee === void 0 ? Ht : ee, this.onFatalError = Y === void 0 ? Ht : Y, this.formState = se === void 0 ? null : se;
  }
  function Qs(r, c, g, m, x, N, L, ee, Y, te, se, ie) {
    return c = new Vs(
      c,
      g,
      m,
      x,
      N,
      L,
      ee,
      Y,
      te,
      se,
      ie
    ), g = br(
      c,
      0,
      null,
      m,
      !1,
      !1
    ), g.parentFlushed = !0, r = dc(
      c,
      null,
      r,
      -1,
      null,
      g,
      null,
      null,
      c.abortableTasks,
      null,
      m,
      null,
      me,
      null,
      null
    ), Ii(r), c.pingedTasks.push(r), c;
  }
  var Vn = null;
  function Gr(r, c) {
    r.pingedTasks.push(c), r.pingedTasks.length === 1 && (r.flushScheduled = r.destination !== null, jo(r));
  }
  function yo(r, c, g, m, x) {
    return g = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: c,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: g,
      errorDigest: null,
      contentState: Dt(),
      fallbackState: Dt(),
      contentPreamble: m,
      fallbackPreamble: x,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, c !== null && (c.pendingTasks++, m = c.boundaries, m !== null && (r.allPendingTasks++, g.pendingTasks++, m.push(g)), r = c.inheritedHoistables, r !== null && El(g.contentState, r)), g;
  }
  function dc(r, c, g, m, x, N, L, ee, Y, te, se, ie, ve, Be, Ie) {
    r.allPendingTasks++, x === null ? r.pendingRootTasks++ : x.pendingTasks++, Be !== null && Be.pendingTasks++;
    var Ze = {
      replay: null,
      node: g,
      childIndex: m,
      ping: function() {
        return Gr(r, Ze);
      },
      blockedBoundary: x,
      blockedSegment: N,
      blockedPreamble: L,
      hoistableState: ee,
      abortSet: Y,
      keyPath: te,
      formatContext: se,
      context: ie,
      treeContext: ve,
      row: Be,
      componentStack: Ie,
      thenableState: c
    };
    return Y.add(Ze), Ze;
  }
  function Jo(r, c, g, m, x, N, L, ee, Y, te, se, ie, ve, Be) {
    r.allPendingTasks++, N === null ? r.pendingRootTasks++ : N.pendingTasks++, ve !== null && ve.pendingTasks++, g.pendingTasks++;
    var Ie = {
      replay: g,
      node: m,
      childIndex: x,
      ping: function() {
        return Gr(r, Ie);
      },
      blockedBoundary: N,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: L,
      abortSet: ee,
      keyPath: Y,
      formatContext: te,
      context: se,
      treeContext: ie,
      row: ve,
      componentStack: Be,
      thenableState: c
    };
    return ee.add(Ie), Ie;
  }
  function br(r, c, g, m, x, N) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: c,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: m,
      boundary: g,
      lastPushedText: x,
      textEmbedded: N
    };
  }
  function Ii(r) {
    var c = r.node;
    if (typeof c == "object" && c !== null)
      switch (c.$$typeof) {
        case v:
          r.componentStack = { parent: r.componentStack, type: c.type };
      }
  }
  function pu(r) {
    return r === null ? null : { parent: r.parent, type: "Suspense Fallback" };
  }
  function Zi(r) {
    var c = {};
    return r && Object.defineProperty(c, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var g = "", m = r;
          do
            g += Wo(m.type), m = m.parent;
          while (m);
          var x = g;
        } catch (N) {
          x = `
Error generating stack: ` + N.message + `
` + N.stack;
        }
        return Object.defineProperty(c, "componentStack", {
          value: x
        }), x;
      }
    }), c;
  }
  function sl(r, c, g) {
    if (r = r.onError, c = r(c, g), c == null || typeof c == "string") return c;
  }
  function Vi(r, c) {
    var g = r.onShellError, m = r.onFatalError;
    g(c), m(c), r.destination !== null ? (r.status = 14, r.destination.destroy(c)) : (r.status = 13, r.fatalError = c);
  }
  function Ct(r, c) {
    Va(r, c.next, c.hoistables);
  }
  function Va(r, c, g) {
    for (; c !== null; ) {
      g !== null && (El(c.hoistables, g), c.inheritedHoistables = g);
      var m = c.boundaries;
      if (m !== null) {
        c.boundaries = null;
        for (var x = 0; x < m.length; x++) {
          var N = m[x];
          g !== null && El(N.contentState, g), Wi(r, N, null, null);
        }
      }
      if (c.pendingTasks--, 0 < c.pendingTasks) break;
      g = c.hoistables, c = c.next;
    }
  }
  function hc(r, c) {
    var g = c.boundaries;
    if (g !== null && c.pendingTasks === g.length) {
      for (var m = !0, x = 0; x < g.length; x++) {
        var N = g[x];
        if (N.pendingTasks !== 1 || N.parentFlushed || Xi(r, N)) {
          m = !1;
          break;
        }
      }
      m && Va(r, c, c.hoistables);
    }
  }
  function Xr(r) {
    var c = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: Dt(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return r !== null && 0 < r.pendingTasks && (c.pendingTasks++, c.boundaries = [], r.next = c), c;
  }
  function bo(r, c, g, m, x) {
    var N = c.keyPath, L = c.treeContext, ee = c.row;
    c.keyPath = g, g = m.length;
    var Y = null;
    if (c.replay !== null) {
      var te = c.replay.slots;
      if (te !== null && typeof te == "object")
        for (var se = 0; se < g; se++) {
          var ie = x !== "backwards" && x !== "unstable_legacy-backwards" ? se : g - 1 - se, ve = m[ie];
          c.row = Y = Xr(
            Y
          ), c.treeContext = Ee(L, g, ie);
          var Be = te[ie];
          typeof Be == "number" ? (vc(r, c, Be, ve, ie), delete te[ie]) : Ln(r, c, ve, ie), --Y.pendingTasks === 0 && Ct(r, Y);
        }
      else
        for (te = 0; te < g; te++)
          se = x !== "backwards" && x !== "unstable_legacy-backwards" ? te : g - 1 - te, ie = m[se], c.row = Y = Xr(Y), c.treeContext = Ee(L, g, se), Ln(r, c, ie, se), --Y.pendingTasks === 0 && Ct(r, Y);
    } else if (x !== "backwards" && x !== "unstable_legacy-backwards")
      for (x = 0; x < g; x++)
        te = m[x], c.row = Y = Xr(Y), c.treeContext = Ee(
          L,
          g,
          x
        ), Ln(r, c, te, x), --Y.pendingTasks === 0 && Ct(r, Y);
    else {
      for (x = c.blockedSegment, te = x.children.length, se = x.chunks.length, ie = g - 1; 0 <= ie; ie--) {
        ve = m[ie], c.row = Y = Xr(
          Y
        ), c.treeContext = Ee(L, g, ie), Be = br(
          r,
          se,
          null,
          c.formatContext,
          ie === 0 ? x.lastPushedText : !0,
          !0
        ), x.children.splice(te, 0, Be), c.blockedSegment = Be;
        try {
          Ln(r, c, ve, ie), Sn(
            Be.chunks,
            r.renderState,
            Be.lastPushedText,
            Be.textEmbedded
          ), Be.status = 1, --Y.pendingTasks === 0 && Ct(r, Y);
        } catch (Ie) {
          throw Be.status = r.status === 12 ? 3 : 4, Ie;
        }
      }
      c.blockedSegment = x, x.lastPushedText = !1;
    }
    ee !== null && Y !== null && 0 < Y.pendingTasks && (ee.pendingTasks++, Y.next = ee), c.treeContext = L, c.row = ee, c.keyPath = N;
  }
  function gc(r, c, g, m, x, N) {
    var L = c.thenableState;
    for (c.thenableState = null, Ul = {}, ac = c, vu = r, ic = g, yr = ya = 0, Yi = -1, yu = 0, hi = L, r = m(x, N); Fi; )
      Fi = !1, yr = ya = 0, Yi = -1, yu = 0, bu += 1, dt = null, r = m(x, N);
    return mu(), r;
  }
  function mo(r, c, g, m, x, N, L) {
    var ee = !1;
    if (N !== 0 && r.formState !== null) {
      var Y = c.blockedSegment;
      if (Y !== null) {
        ee = !0, Y = Y.chunks;
        for (var te = 0; te < N; te++)
          te === L ? Y.push("<!--F!-->") : Y.push("<!--F-->");
      }
    }
    N = c.keyPath, c.keyPath = g, x ? (g = c.treeContext, c.treeContext = Ee(g, 1, 0), Ln(r, c, m, -1), c.treeContext = g) : ee ? Ln(r, c, m, -1) : ba(r, c, m, -1), c.keyPath = N;
  }
  function gi(r, c, g, m, x, N) {
    if (typeof m == "function")
      if (m.prototype && m.prototype.isReactComponent) {
        var L = x;
        if ("ref" in x) {
          L = {};
          for (var ee in x)
            ee !== "ref" && (L[ee] = x[ee]);
        }
        var Y = m.defaultProps;
        if (Y) {
          L === x && (L = Me({}, L, x));
          for (var te in Y)
            L[te] === void 0 && (L[te] = Y[te]);
        }
        x = L, L = nn, Y = m.contextType, typeof Y == "object" && Y !== null && (L = Y._currentValue2), L = new m(x, L);
        var se = L.state !== void 0 ? L.state : null;
        if (L.updater = W, L.props = x, L.state = se, Y = { queue: [], replace: !1 }, L._reactInternals = Y, N = m.contextType, L.context = typeof N == "object" && N !== null ? N._currentValue2 : nn, N = m.getDerivedStateFromProps, typeof N == "function" && (N = N(x, se), se = N == null ? se : Me({}, se, N), L.state = se), typeof m.getDerivedStateFromProps != "function" && typeof L.getSnapshotBeforeUpdate != "function" && (typeof L.UNSAFE_componentWillMount == "function" || typeof L.componentWillMount == "function"))
          if (m = L.state, typeof L.componentWillMount == "function" && L.componentWillMount(), typeof L.UNSAFE_componentWillMount == "function" && L.UNSAFE_componentWillMount(), m !== L.state && W.enqueueReplaceState(
            L,
            L.state,
            null
          ), Y.queue !== null && 0 < Y.queue.length)
            if (m = Y.queue, N = Y.replace, Y.queue = null, Y.replace = !1, N && m.length === 1)
              L.state = m[0];
            else {
              for (Y = N ? m[0] : L.state, se = !0, N = N ? 1 : 0; N < m.length; N++)
                te = m[N], te = typeof te == "function" ? te.call(L, Y, x, void 0) : te, te != null && (se ? (se = !1, Y = Me({}, Y, te)) : Me(Y, te));
              L.state = Y;
            }
          else Y.queue = null;
        if (m = L.render(), r.status === 12) throw null;
        x = c.keyPath, c.keyPath = g, ba(r, c, m, -1), c.keyPath = x;
      } else {
        if (m = gc(r, c, g, m, x, void 0), r.status === 12) throw null;
        mo(
          r,
          c,
          g,
          m,
          ya !== 0,
          yr,
          Yi
        );
      }
    else if (typeof m == "string")
      if (L = c.blockedSegment, L === null)
        L = x.children, Y = c.formatContext, se = c.keyPath, c.formatContext = Ci(Y, m, x), c.keyPath = g, Ln(r, c, L, -1), c.formatContext = Y, c.keyPath = se;
      else {
        if (se = Tn(
          L.chunks,
          m,
          x,
          r.resumableState,
          r.renderState,
          c.blockedPreamble,
          c.hoistableState,
          c.formatContext,
          L.lastPushedText
        ), L.lastPushedText = !1, Y = c.formatContext, N = c.keyPath, c.keyPath = g, (c.formatContext = Ci(Y, m, x)).insertionMode === 3) {
          g = br(
            r,
            0,
            null,
            c.formatContext,
            !1,
            !1
          ), L.preambleChildren.push(g), c.blockedSegment = g;
          try {
            g.status = 6, Ln(r, c, se, -1), Sn(
              g.chunks,
              r.renderState,
              g.lastPushedText,
              g.textEmbedded
            ), g.status = 1;
          } finally {
            c.blockedSegment = L;
          }
        } else Ln(r, c, se, -1);
        c.formatContext = Y, c.keyPath = N;
        e: {
          switch (c = L.chunks, r = r.resumableState, m) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= Y.insertionMode) {
                r.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (Y.insertionMode === 0) {
                r.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= Y.insertionMode) break e;
          }
          c.push(Hl(m));
        }
        L.lastPushedText = !1;
      }
    else {
      switch (m) {
        case ge:
        case w:
        case _:
        case p:
          m = c.keyPath, c.keyPath = g, ba(r, c, x.children, -1), c.keyPath = m;
          return;
        case he:
          m = c.blockedSegment, m === null ? x.mode !== "hidden" && (m = c.keyPath, c.keyPath = g, Ln(r, c, x.children, -1), c.keyPath = m) : x.mode !== "hidden" && (r.renderState.generateStaticMarkup || m.chunks.push("<!--&-->"), m.lastPushedText = !1, L = c.keyPath, c.keyPath = g, Ln(r, c, x.children, -1), c.keyPath = L, r.renderState.generateStaticMarkup || m.chunks.push("<!--/&-->"), m.lastPushedText = !1);
          return;
        case F:
          e: {
            if (m = x.children, x = x.revealOrder, x === "forwards" || x === "backwards" || x === "unstable_legacy-backwards") {
              if (xe(m)) {
                bo(r, c, g, m, x);
                break e;
              }
              if ((L = ye(m)) && (L = L.call(m))) {
                if (Y = L.next(), !Y.done) {
                  do
                    Y = L.next();
                  while (!Y.done);
                  bo(r, c, g, m, x);
                }
                break e;
              }
            }
            x === "together" ? (x = c.keyPath, L = c.row, Y = c.row = Xr(null), Y.boundaries = [], Y.together = !0, c.keyPath = g, ba(r, c, m, -1), --Y.pendingTasks === 0 && Ct(r, Y), c.keyPath = x, c.row = L, L !== null && 0 < Y.pendingTasks && (L.pendingTasks++, Y.next = L)) : (x = c.keyPath, c.keyPath = g, ba(r, c, m, -1), c.keyPath = x);
          }
          return;
        case De:
        case $:
          throw Error(f(343));
        case I:
          e: if (c.replay !== null) {
            m = c.keyPath, L = c.formatContext, Y = c.row, c.keyPath = g, c.formatContext = vt(
              r.resumableState,
              L
            ), c.row = null, g = x.children;
            try {
              Ln(r, c, g, -1);
            } finally {
              c.keyPath = m, c.formatContext = L, c.row = Y;
            }
          } else {
            m = c.keyPath, N = c.formatContext;
            var ie = c.row, ve = c.blockedBoundary;
            te = c.blockedPreamble;
            var Be = c.hoistableState;
            ee = c.blockedSegment;
            var Ie = x.fallback;
            x = x.children;
            var Ze = /* @__PURE__ */ new Set(), je = yo(
              r,
              c.row,
              Ze,
              null,
              null
            );
            r.trackedPostpones !== null && (je.trackedContentKeyPath = g);
            var Qe = br(
              r,
              ee.chunks.length,
              je,
              c.formatContext,
              !1,
              !1
            );
            ee.children.push(Qe), ee.lastPushedText = !1;
            var qe = br(
              r,
              0,
              null,
              c.formatContext,
              !1,
              !1
            );
            if (qe.parentFlushed = !0, r.trackedPostpones !== null) {
              L = c.componentStack, Y = [g[0], "Suspense Fallback", g[2]], se = [Y[1], Y[2], [], null], r.trackedPostpones.workingMap.set(Y, se), je.trackedFallbackNode = se, c.blockedSegment = Qe, c.blockedPreamble = je.fallbackPreamble, c.keyPath = Y, c.formatContext = cr(
                r.resumableState,
                N
              ), c.componentStack = pu(L), Qe.status = 6;
              try {
                Ln(r, c, Ie, -1), Sn(
                  Qe.chunks,
                  r.renderState,
                  Qe.lastPushedText,
                  Qe.textEmbedded
                ), Qe.status = 1;
              } catch (Qt) {
                throw Qe.status = r.status === 12 ? 3 : 4, Qt;
              } finally {
                c.blockedSegment = ee, c.blockedPreamble = te, c.keyPath = m, c.formatContext = N;
              }
              c = dc(
                r,
                null,
                x,
                -1,
                je,
                qe,
                je.contentPreamble,
                je.contentState,
                c.abortSet,
                g,
                vt(
                  r.resumableState,
                  c.formatContext
                ),
                c.context,
                c.treeContext,
                null,
                L
              ), Ii(c), r.pingedTasks.push(c);
            } else {
              c.blockedBoundary = je, c.blockedPreamble = je.contentPreamble, c.hoistableState = je.contentState, c.blockedSegment = qe, c.keyPath = g, c.formatContext = vt(
                r.resumableState,
                N
              ), c.row = null, qe.status = 6;
              try {
                if (Ln(r, c, x, -1), Sn(
                  qe.chunks,
                  r.renderState,
                  qe.lastPushedText,
                  qe.textEmbedded
                ), qe.status = 1, Eu(je, qe), je.pendingTasks === 0 && je.status === 0) {
                  if (je.status = 1, !Xi(r, je)) {
                    ie !== null && --ie.pendingTasks === 0 && Ct(r, ie), r.pendingRootTasks === 0 && c.blockedPreamble && kn(r);
                    break e;
                  }
                } else
                  ie !== null && ie.together && hc(r, ie);
              } catch (Qt) {
                je.status = 4, r.status === 12 ? (qe.status = 3, L = r.fatalError) : (qe.status = 4, L = Qt), Y = Zi(c.componentStack), se = sl(
                  r,
                  L,
                  Y
                ), je.errorDigest = se, Pi(r, je);
              } finally {
                c.blockedBoundary = ve, c.blockedPreamble = te, c.hoistableState = Be, c.blockedSegment = ee, c.keyPath = m, c.formatContext = N, c.row = ie;
              }
              c = dc(
                r,
                null,
                Ie,
                -1,
                ve,
                Qe,
                je.fallbackPreamble,
                je.fallbackState,
                Ze,
                [g[0], "Suspense Fallback", g[2]],
                cr(
                  r.resumableState,
                  c.formatContext
                ),
                c.context,
                c.treeContext,
                c.row,
                pu(
                  c.componentStack
                )
              ), Ii(c), r.pingedTasks.push(c);
            }
          }
          return;
      }
      if (typeof m == "object" && m !== null)
        switch (m.$$typeof) {
          case B:
            if ("ref" in x)
              for (Ie in L = {}, x)
                Ie !== "ref" && (L[Ie] = x[Ie]);
            else L = x;
            m = gc(
              r,
              c,
              g,
              m.render,
              L,
              N
            ), mo(
              r,
              c,
              g,
              m,
              ya !== 0,
              yr,
              Yi
            );
            return;
          case ce:
            gi(r, c, g, m.type, x, N);
            return;
          case z:
            if (Y = x.children, L = c.keyPath, x = x.value, se = m._currentValue2, m._currentValue2 = x, N = va, va = m = {
              parent: N,
              depth: N === null ? 0 : N.depth + 1,
              context: m,
              parentValue: se,
              value: x
            }, c.context = m, c.keyPath = g, ba(r, c, Y, -1), r = va, r === null) throw Error(f(403));
            r.context._currentValue2 = r.parentValue, r = va = r.parent, c.context = r, c.keyPath = L;
            return;
          case C:
            x = x.children, m = x(m._context._currentValue2), x = c.keyPath, c.keyPath = g, ba(r, c, m, -1), c.keyPath = x;
            return;
          case ae:
            if (L = m._init, m = L(m._payload), r.status === 12) throw null;
            gi(r, c, g, m, x, N);
            return;
        }
      throw Error(
        f(130, m == null ? m : typeof m, "")
      );
    }
  }
  function vc(r, c, g, m, x) {
    var N = c.replay, L = c.blockedBoundary, ee = br(
      r,
      0,
      null,
      c.formatContext,
      !1,
      !1
    );
    ee.id = g, ee.parentFlushed = !0;
    try {
      c.replay = null, c.blockedSegment = ee, Ln(r, c, m, x), ee.status = 1, L === null ? r.completedRootSegment = ee : (Eu(L, ee), L.parentFlushed && r.partialBoundaries.push(L));
    } finally {
      c.replay = N, c.blockedSegment = null;
    }
  }
  function ba(r, c, g, m) {
    c.replay !== null && typeof c.replay.slots == "number" ? vc(r, c, c.replay.slots, g, m) : (c.node = g, c.childIndex = m, g = c.componentStack, Ii(c), po(r, c), c.componentStack = g);
  }
  function po(r, c) {
    var g = c.node, m = c.childIndex;
    if (g !== null) {
      if (typeof g == "object") {
        switch (g.$$typeof) {
          case v:
            var x = g.type, N = g.key, L = g.props;
            g = L.ref;
            var ee = g !== void 0 ? g : null, Y = di(x), te = N ?? (m === -1 ? 0 : m);
            if (N = [c.keyPath, Y, te], c.replay !== null)
              e: {
                var se = c.replay;
                for (m = se.nodes, g = 0; g < m.length; g++) {
                  var ie = m[g];
                  if (te === ie[1]) {
                    if (ie.length === 4) {
                      if (Y !== null && Y !== ie[0])
                        throw Error(
                          f(490, ie[0], Y)
                        );
                      var ve = ie[2];
                      Y = ie[3], te = c.node, c.replay = {
                        nodes: ve,
                        slots: Y,
                        pendingTasks: 1
                      };
                      try {
                        if (gi(r, c, N, x, L, ee), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
                          throw Error(f(488));
                        c.replay.pendingTasks--;
                      } catch (gt) {
                        if (typeof gt == "object" && gt !== null && (gt === Wt || typeof gt.then == "function"))
                          throw c.node === te ? c.replay = se : m.splice(g, 1), gt;
                        c.replay.pendingTasks--, L = Zi(c.componentStack), N = r, r = c.blockedBoundary, x = gt, L = sl(N, x, L), vi(
                          N,
                          r,
                          ve,
                          Y,
                          x,
                          L
                        );
                      }
                      c.replay = se;
                    } else {
                      if (x !== I)
                        throw Error(
                          f(
                            490,
                            "Suspense",
                            di(x) || "Unknown"
                          )
                        );
                      t: {
                        se = void 0, x = ie[5], ee = ie[2], Y = ie[3], te = ie[4] === null ? [] : ie[4][2], ie = ie[4] === null ? null : ie[4][3];
                        var Be = c.keyPath, Ie = c.formatContext, Ze = c.row, je = c.replay, Qe = c.blockedBoundary, qe = c.hoistableState, Qt = L.children, Lt = L.fallback, ht = /* @__PURE__ */ new Set();
                        L = yo(
                          r,
                          c.row,
                          ht,
                          null,
                          null
                        ), L.parentFlushed = !0, L.rootSegmentID = x, c.blockedBoundary = L, c.hoistableState = L.contentState, c.keyPath = N, c.formatContext = vt(
                          r.resumableState,
                          Ie
                        ), c.row = null, c.replay = {
                          nodes: ee,
                          slots: Y,
                          pendingTasks: 1
                        };
                        try {
                          if (Ln(r, c, Qt, -1), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
                            throw Error(f(488));
                          if (c.replay.pendingTasks--, L.pendingTasks === 0 && L.status === 0) {
                            L.status = 1, r.completedBoundaries.push(L);
                            break t;
                          }
                        } catch (gt) {
                          L.status = 4, ve = Zi(c.componentStack), se = sl(
                            r,
                            gt,
                            ve
                          ), L.errorDigest = se, c.replay.pendingTasks--, r.clientRenderedBoundaries.push(L);
                        } finally {
                          c.blockedBoundary = Qe, c.hoistableState = qe, c.replay = je, c.keyPath = Be, c.formatContext = Ie, c.row = Ze;
                        }
                        ve = Jo(
                          r,
                          null,
                          {
                            nodes: te,
                            slots: ie,
                            pendingTasks: 0
                          },
                          Lt,
                          -1,
                          Qe,
                          L.fallbackState,
                          ht,
                          [N[0], "Suspense Fallback", N[2]],
                          cr(
                            r.resumableState,
                            c.formatContext
                          ),
                          c.context,
                          c.treeContext,
                          c.row,
                          pu(
                            c.componentStack
                          )
                        ), Ii(ve), r.pingedTasks.push(ve);
                      }
                    }
                    m.splice(g, 1);
                    break e;
                  }
                }
              }
            else gi(r, c, N, x, L, ee);
            return;
          case y:
            throw Error(f(257));
          case ae:
            if (ve = g._init, g = ve(g._payload), r.status === 12) throw null;
            ba(r, c, g, m);
            return;
        }
        if (xe(g)) {
          Tu(r, c, g, m);
          return;
        }
        if ((ve = ye(g)) && (ve = ve.call(g))) {
          if (g = ve.next(), !g.done) {
            L = [];
            do
              L.push(g.value), g = ve.next();
            while (!g.done);
            Tu(r, c, L, m);
          }
          return;
        }
        if (typeof g.then == "function")
          return c.thenableState = null, ba(r, c, oc(g), m);
        if (g.$$typeof === z)
          return ba(
            r,
            c,
            g._currentValue2,
            m
          );
        throw m = Object.prototype.toString.call(g), Error(
          f(
            31,
            m === "[object Object]" ? "object with keys {" + Object.keys(g).join(", ") + "}" : m
          )
        );
      }
      typeof g == "string" ? (m = c.blockedSegment, m !== null && (m.lastPushedText = Bl(
        m.chunks,
        g,
        r.renderState,
        m.lastPushedText
      ))) : (typeof g == "number" || typeof g == "bigint") && (m = c.blockedSegment, m !== null && (m.lastPushedText = Bl(
        m.chunks,
        "" + g,
        r.renderState,
        m.lastPushedText
      )));
    }
  }
  function Tu(r, c, g, m) {
    var x = c.keyPath;
    if (m !== -1 && (c.keyPath = [c.keyPath, "Fragment", m], c.replay !== null)) {
      for (var N = c.replay, L = N.nodes, ee = 0; ee < L.length; ee++) {
        var Y = L[ee];
        if (Y[1] === m) {
          m = Y[2], Y = Y[3], c.replay = { nodes: m, slots: Y, pendingTasks: 1 };
          try {
            if (Tu(r, c, g, -1), c.replay.pendingTasks === 1 && 0 < c.replay.nodes.length)
              throw Error(f(488));
            c.replay.pendingTasks--;
          } catch (ie) {
            if (typeof ie == "object" && ie !== null && (ie === Wt || typeof ie.then == "function"))
              throw ie;
            c.replay.pendingTasks--, g = Zi(c.componentStack);
            var te = c.blockedBoundary, se = ie;
            g = sl(r, se, g), vi(
              r,
              te,
              m,
              Y,
              se,
              g
            );
          }
          c.replay = N, L.splice(ee, 1);
          break;
        }
      }
      c.keyPath = x;
      return;
    }
    if (N = c.treeContext, L = g.length, c.replay !== null && (ee = c.replay.slots, ee !== null && typeof ee == "object")) {
      for (m = 0; m < L; m++)
        Y = g[m], c.treeContext = Ee(N, L, m), te = ee[m], typeof te == "number" ? (vc(r, c, te, Y, m), delete ee[m]) : Ln(r, c, Y, m);
      c.treeContext = N, c.keyPath = x;
      return;
    }
    for (ee = 0; ee < L; ee++)
      m = g[ee], c.treeContext = Ee(N, L, ee), Ln(r, c, m, ee);
    c.treeContext = N, c.keyPath = x;
  }
  function Ir(r, c, g) {
    if (g.status = 5, g.rootSegmentID = r.nextSegmentId++, r = g.trackedContentKeyPath, r === null) throw Error(f(486));
    var m = g.trackedFallbackNode, x = [], N = c.workingMap.get(r);
    return N === void 0 ? (g = [
      r[1],
      r[2],
      x,
      null,
      m,
      g.rootSegmentID
    ], c.workingMap.set(r, g), Aa(g, r[0], c), g) : (N[4] = m, N[5] = g.rootSegmentID, N);
  }
  function Qi(r, c, g, m) {
    m.status = 5;
    var x = g.keyPath, N = g.blockedBoundary;
    if (N === null)
      m.id = r.nextSegmentId++, c.rootSlots = m.id, r.completedRootSegment !== null && (r.completedRootSegment.status = 5);
    else {
      if (N !== null && N.status === 0) {
        var L = Ir(
          r,
          c,
          N
        );
        if (N.trackedContentKeyPath === x && g.childIndex === -1) {
          m.id === -1 && (m.id = m.parentFlushed ? N.rootSegmentID : r.nextSegmentId++), L[3] = m.id;
          return;
        }
      }
      if (m.id === -1 && (m.id = m.parentFlushed && N !== null ? N.rootSegmentID : r.nextSegmentId++), g.childIndex === -1)
        x === null ? c.rootSlots = m.id : (g = c.workingMap.get(x), g === void 0 ? (g = [x[1], x[2], [], m.id], Aa(g, x[0], c)) : g[3] = m.id);
      else {
        if (x === null) {
          if (r = c.rootSlots, r === null)
            r = c.rootSlots = {};
          else if (typeof r == "number")
            throw Error(f(491));
        } else if (N = c.workingMap, L = N.get(x), L === void 0)
          r = {}, L = [x[1], x[2], [], r], N.set(x, L), Aa(L, x[0], c);
        else if (r = L[3], r === null)
          r = L[3] = {};
        else if (typeof r == "number")
          throw Error(f(491));
        r[g.childIndex] = m.id;
      }
    }
  }
  function Pi(r, c) {
    r = r.trackedPostpones, r !== null && (c = c.trackedContentKeyPath, c !== null && (c = r.workingMap.get(c), c !== void 0 && (c.length = 4, c[2] = [], c[3] = null)));
  }
  function yc(r, c, g) {
    return Jo(
      r,
      g,
      c.replay,
      c.node,
      c.childIndex,
      c.blockedBoundary,
      c.hoistableState,
      c.abortSet,
      c.keyPath,
      c.formatContext,
      c.context,
      c.treeContext,
      c.row,
      c.componentStack
    );
  }
  function mr(r, c, g) {
    var m = c.blockedSegment, x = br(
      r,
      m.chunks.length,
      null,
      c.formatContext,
      m.lastPushedText,
      !0
    );
    return m.children.push(x), m.lastPushedText = !1, dc(
      r,
      g,
      c.node,
      c.childIndex,
      c.blockedBoundary,
      x,
      c.blockedPreamble,
      c.hoistableState,
      c.abortSet,
      c.keyPath,
      c.formatContext,
      c.context,
      c.treeContext,
      c.row,
      c.componentStack
    );
  }
  function Ln(r, c, g, m) {
    var x = c.formatContext, N = c.context, L = c.keyPath, ee = c.treeContext, Y = c.componentStack, te = c.blockedSegment;
    if (te === null) {
      te = c.replay;
      try {
        return ba(r, c, g, m);
      } catch (ve) {
        if (mu(), g = ve === Wt ? Br() : ve, r.status !== 12 && typeof g == "object" && g !== null) {
          if (typeof g.then == "function") {
            m = ve === Wt ? Za() : null, r = yc(r, c, m).ping, g.then(r, r), c.formatContext = x, c.context = N, c.keyPath = L, c.treeContext = ee, c.componentStack = Y, c.replay = te, D(N);
            return;
          }
          if (g.message === "Maximum call stack size exceeded") {
            g = ve === Wt ? Za() : null, g = yc(r, c, g), r.pingedTasks.push(g), c.formatContext = x, c.context = N, c.keyPath = L, c.treeContext = ee, c.componentStack = Y, c.replay = te, D(N);
            return;
          }
        }
      }
    } else {
      var se = te.children.length, ie = te.chunks.length;
      try {
        return ba(r, c, g, m);
      } catch (ve) {
        if (mu(), te.children.length = se, te.chunks.length = ie, g = ve === Wt ? Br() : ve, r.status !== 12 && typeof g == "object" && g !== null) {
          if (typeof g.then == "function") {
            te = g, g = ve === Wt ? Za() : null, r = mr(r, c, g).ping, te.then(r, r), c.formatContext = x, c.context = N, c.keyPath = L, c.treeContext = ee, c.componentStack = Y, D(N);
            return;
          }
          if (g.message === "Maximum call stack size exceeded") {
            te = ve === Wt ? Za() : null, te = mr(r, c, te), r.pingedTasks.push(te), c.formatContext = x, c.context = N, c.keyPath = L, c.treeContext = ee, c.componentStack = Y, D(N);
            return;
          }
        }
      }
    }
    throw c.formatContext = x, c.context = N, c.keyPath = L, c.treeContext = ee, D(N), g;
  }
  function Ko(r) {
    var c = r.blockedBoundary, g = r.blockedSegment;
    g !== null && (g.status = 3, Wi(this, c, r.row, g));
  }
  function vi(r, c, g, m, x, N) {
    for (var L = 0; L < g.length; L++) {
      var ee = g[L];
      if (ee.length === 4)
        vi(
          r,
          c,
          ee[2],
          ee[3],
          x,
          N
        );
      else {
        ee = ee[5];
        var Y = r, te = N, se = yo(
          Y,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        se.parentFlushed = !0, se.rootSegmentID = ee, se.status = 4, se.errorDigest = te, se.parentFlushed && Y.clientRenderedBoundaries.push(se);
      }
    }
    if (g.length = 0, m !== null) {
      if (c === null) throw Error(f(487));
      if (c.status !== 4 && (c.status = 4, c.errorDigest = N, c.parentFlushed && r.clientRenderedBoundaries.push(c)), typeof m == "object") for (var ie in m) delete m[ie];
    }
  }
  function Su(r, c, g) {
    var m = r.blockedBoundary, x = r.blockedSegment;
    if (x !== null) {
      if (x.status === 6) return;
      x.status = 3;
    }
    var N = Zi(r.componentStack);
    if (m === null) {
      if (c.status !== 13 && c.status !== 14) {
        if (m = r.replay, m === null) {
          c.trackedPostpones !== null && x !== null ? (m = c.trackedPostpones, sl(c, g, N), Qi(c, m, r, x), Wi(c, null, r.row, x)) : (sl(c, g, N), Vi(c, g));
          return;
        }
        m.pendingTasks--, m.pendingTasks === 0 && 0 < m.nodes.length && (x = sl(c, g, N), vi(
          c,
          null,
          m.nodes,
          m.slots,
          g,
          x
        )), c.pendingRootTasks--, c.pendingRootTasks === 0 && mc(c);
      }
    } else {
      var L = c.trackedPostpones;
      if (m.status !== 4) {
        if (L !== null && x !== null)
          return sl(c, g, N), Qi(c, L, r, x), m.fallbackAbortableTasks.forEach(function(ee) {
            return Su(ee, c, g);
          }), m.fallbackAbortableTasks.clear(), Wi(c, m, r.row, x);
        m.status = 4, x = sl(c, g, N), m.status = 4, m.errorDigest = x, Pi(c, m), m.parentFlushed && c.clientRenderedBoundaries.push(m);
      }
      m.pendingTasks--, x = m.row, x !== null && --x.pendingTasks === 0 && Ct(c, x), m.fallbackAbortableTasks.forEach(function(ee) {
        return Su(ee, c, g);
      }), m.fallbackAbortableTasks.clear();
    }
    r = r.row, r !== null && --r.pendingTasks === 0 && Ct(c, r), c.allPendingTasks--, c.allPendingTasks === 0 && xu(c);
  }
  function bc(r, c) {
    try {
      var g = r.renderState, m = g.onHeaders;
      if (m) {
        var x = g.headers;
        if (x) {
          g.headers = null;
          var N = x.preconnects;
          if (x.fontPreloads && (N && (N += ", "), N += x.fontPreloads), x.highImagePreloads && (N && (N += ", "), N += x.highImagePreloads), !c) {
            var L = g.styles.values(), ee = L.next();
            e: for (; 0 < x.remainingCapacity && !ee.done; ee = L.next())
              for (var Y = ee.value.sheets.values(), te = Y.next(); 0 < x.remainingCapacity && !te.done; te = Y.next()) {
                var se = te.value, ie = se.props, ve = ie.href, Be = se.props, Ie = dn(Be.href, "style", {
                  crossOrigin: Be.crossOrigin,
                  integrity: Be.integrity,
                  nonce: Be.nonce,
                  type: Be.type,
                  fetchPriority: Be.fetchPriority,
                  referrerPolicy: Be.referrerPolicy,
                  media: Be.media
                });
                if (0 <= (x.remainingCapacity -= Ie.length + 2))
                  g.resets.style[ve] = It, N && (N += ", "), N += Ie, g.resets.style[ve] = typeof ie.crossOrigin == "string" || typeof ie.integrity == "string" ? [ie.crossOrigin, ie.integrity] : It;
                else break e;
              }
          }
          m(N ? { Link: N } : {});
        }
      }
    } catch (Ze) {
      sl(r, Ze, {});
    }
  }
  function mc(r) {
    r.trackedPostpones === null && bc(r, !0), r.trackedPostpones === null && kn(r), r.onShellError = Ht, r = r.onShellReady, r();
  }
  function xu(r) {
    bc(
      r,
      r.trackedPostpones === null ? !0 : r.completedRootSegment === null || r.completedRootSegment.status !== 5
    ), kn(r), r = r.onAllReady, r();
  }
  function Eu(r, c) {
    if (c.chunks.length === 0 && c.children.length === 1 && c.children[0].boundary === null && c.children[0].id === -1) {
      var g = c.children[0];
      g.id = c.id, g.parentFlushed = !0, g.status !== 1 && g.status !== 3 && g.status !== 4 || Eu(r, g);
    } else r.completedSegments.push(c);
  }
  function Wi(r, c, g, m) {
    if (g !== null && (--g.pendingTasks === 0 ? Ct(r, g) : g.together && hc(r, g)), r.allPendingTasks--, c === null) {
      if (m !== null && m.parentFlushed) {
        if (r.completedRootSegment !== null)
          throw Error(f(389));
        r.completedRootSegment = m;
      }
      r.pendingRootTasks--, r.pendingRootTasks === 0 && mc(r);
    } else if (c.pendingTasks--, c.status !== 4)
      if (c.pendingTasks === 0) {
        if (c.status === 0 && (c.status = 1), m !== null && m.parentFlushed && (m.status === 1 || m.status === 3) && Eu(c, m), c.parentFlushed && r.completedBoundaries.push(c), c.status === 1)
          g = c.row, g !== null && El(g.hoistables, c.contentState), Xi(r, c) || (c.fallbackAbortableTasks.forEach(Ko, r), c.fallbackAbortableTasks.clear(), g !== null && --g.pendingTasks === 0 && Ct(r, g)), r.pendingRootTasks === 0 && r.trackedPostpones === null && c.contentPreamble !== null && kn(r);
        else if (c.status === 5 && (c = c.row, c !== null)) {
          if (r.trackedPostpones !== null) {
            g = r.trackedPostpones;
            var x = c.next;
            if (x !== null && (m = x.boundaries, m !== null))
              for (x.boundaries = null, x = 0; x < m.length; x++) {
                var N = m[x];
                Ir(r, g, N), Wi(r, N, null, null);
              }
          }
          --c.pendingTasks === 0 && Ct(r, c);
        }
      } else
        m === null || !m.parentFlushed || m.status !== 1 && m.status !== 3 || (Eu(c, m), c.completedSegments.length === 1 && c.parentFlushed && r.partialBoundaries.push(c)), c = c.row, c !== null && c.together && hc(r, c);
    r.allPendingTasks === 0 && xu(r);
  }
  function jo(r) {
    if (r.status !== 14 && r.status !== 13) {
      var c = va, g = ct.H;
      ct.H = Po;
      var m = ct.A;
      ct.A = Is;
      var x = Vn;
      Vn = r;
      var N = sc;
      sc = r.resumableState;
      try {
        var L = r.pingedTasks, ee;
        for (ee = 0; ee < L.length; ee++) {
          var Y = L[ee], te = r, se = Y.blockedSegment;
          if (se === null) {
            var ie = te;
            if (Y.replay.pendingTasks !== 0) {
              D(Y.context);
              try {
                if (typeof Y.replay.slots == "number" ? vc(
                  ie,
                  Y,
                  Y.replay.slots,
                  Y.node,
                  Y.childIndex
                ) : po(ie, Y), Y.replay.pendingTasks === 1 && 0 < Y.replay.nodes.length)
                  throw Error(f(488));
                Y.replay.pendingTasks--, Y.abortSet.delete(Y), Wi(
                  ie,
                  Y.blockedBoundary,
                  Y.row,
                  null
                );
              } catch (Rt) {
                mu();
                var ve = Rt === Wt ? Br() : Rt;
                if (typeof ve == "object" && ve !== null && typeof ve.then == "function") {
                  var Be = Y.ping;
                  ve.then(Be, Be), Y.thenableState = Rt === Wt ? Za() : null;
                } else {
                  Y.replay.pendingTasks--, Y.abortSet.delete(Y);
                  var Ie = Zi(Y.componentStack);
                  te = void 0;
                  var Ze = ie, je = Y.blockedBoundary, Qe = ie.status === 12 ? ie.fatalError : ve, qe = Y.replay.nodes, Qt = Y.replay.slots;
                  te = sl(
                    Ze,
                    Qe,
                    Ie
                  ), vi(
                    Ze,
                    je,
                    qe,
                    Qt,
                    Qe,
                    te
                  ), ie.pendingRootTasks--, ie.pendingRootTasks === 0 && mc(ie), ie.allPendingTasks--, ie.allPendingTasks === 0 && xu(ie);
                }
              } finally {
              }
            }
          } else if (ie = void 0, Ze = se, Ze.status === 0) {
            Ze.status = 6, D(Y.context);
            var Lt = Ze.children.length, ht = Ze.chunks.length;
            try {
              po(te, Y), Sn(
                Ze.chunks,
                te.renderState,
                Ze.lastPushedText,
                Ze.textEmbedded
              ), Y.abortSet.delete(Y), Ze.status = 1, Wi(
                te,
                Y.blockedBoundary,
                Y.row,
                Ze
              );
            } catch (Rt) {
              mu(), Ze.children.length = Lt, Ze.chunks.length = ht;
              var gt = Rt === Wt ? Br() : te.status === 12 ? te.fatalError : Rt;
              if (te.status === 12 && te.trackedPostpones !== null) {
                var lt = te.trackedPostpones, Fl = Zi(Y.componentStack);
                Y.abortSet.delete(Y), sl(te, gt, Fl), Qi(te, lt, Y, Ze), Wi(
                  te,
                  Y.blockedBoundary,
                  Y.row,
                  Ze
                );
              } else if (typeof gt == "object" && gt !== null && typeof gt.then == "function") {
                Ze.status = 0, Y.thenableState = Rt === Wt ? Za() : null;
                var Pe = Y.ping;
                gt.then(Pe, Pe);
              } else {
                var Al = Zi(Y.componentStack);
                Y.abortSet.delete(Y), Ze.status = 4;
                var rt = Y.blockedBoundary, En = Y.row;
                if (En !== null && --En.pendingTasks === 0 && Ct(te, En), te.allPendingTasks--, ie = sl(
                  te,
                  gt,
                  Al
                ), rt === null) Vi(te, gt);
                else if (rt.pendingTasks--, rt.status !== 4) {
                  rt.status = 4, rt.errorDigest = ie, Pi(te, rt);
                  var gn = rt.row;
                  gn !== null && --gn.pendingTasks === 0 && Ct(te, gn), rt.parentFlushed && te.clientRenderedBoundaries.push(rt), te.pendingRootTasks === 0 && te.trackedPostpones === null && rt.contentPreamble !== null && kn(te);
                }
                te.allPendingTasks === 0 && xu(te);
              }
            } finally {
            }
          }
        }
        L.splice(0, ee), r.destination !== null && bi(r, r.destination);
      } catch (Rt) {
        sl(r, Rt, {}), Vi(r, Rt);
      } finally {
        sc = N, ct.H = g, ct.A = m, g === Po && D(c), Vn = x;
      }
    }
  }
  function pr(r, c, g) {
    c.preambleChildren.length && g.push(c.preambleChildren);
    for (var m = !1, x = 0; x < c.children.length; x++)
      m = wu(
        r,
        c.children[x],
        g
      ) || m;
    return m;
  }
  function wu(r, c, g) {
    var m = c.boundary;
    if (m === null)
      return pr(
        r,
        c,
        g
      );
    var x = m.contentPreamble, N = m.fallbackPreamble;
    if (x === null || N === null) return !1;
    switch (m.status) {
      case 1:
        if (Ua(r.renderState, x), r.byteSize += m.byteSize, c = m.completedSegments[0], !c) throw Error(f(391));
        return pr(
          r,
          c,
          g
        );
      case 5:
        if (r.trackedPostpones !== null) return !0;
      case 4:
        if (c.status === 1)
          return Ua(r.renderState, N), pr(
            r,
            c,
            g
          );
      default:
        return !0;
    }
  }
  function kn(r) {
    if (r.completedRootSegment && r.completedPreambleSegments === null) {
      var c = [], g = r.byteSize, m = wu(
        r,
        r.completedRootSegment,
        c
      ), x = r.renderState.preamble;
      m === !1 || x.headChunks && x.bodyChunks ? r.completedPreambleSegments = c : r.byteSize = g;
    }
  }
  function Qa(r, c, g, m) {
    switch (g.parentFlushed = !0, g.status) {
      case 0:
        g.id = r.nextSegmentId++;
      case 5:
        return m = g.id, g.lastPushedText = !1, g.textEmbedded = !1, r = r.renderState, c.push('<template id="'), c.push(r.placeholderPrefix), r = m.toString(16), c.push(r), c.push('"></template>');
      case 1:
        g.status = 2;
        var x = !0, N = g.chunks, L = 0;
        g = g.children;
        for (var ee = 0; ee < g.length; ee++) {
          for (x = g[ee]; L < x.index; L++)
            c.push(N[L]);
          x = Ki(r, c, x, m);
        }
        for (; L < N.length - 1; L++)
          c.push(N[L]);
        return L < N.length && (x = c.push(N[L])), x;
      case 3:
        return !0;
      default:
        throw Error(f(390));
    }
  }
  var Ji = 0;
  function Ki(r, c, g, m) {
    var x = g.boundary;
    if (x === null)
      return Qa(r, c, g, m);
    if (x.parentFlushed = !0, x.status === 4) {
      var N = x.row;
      return N !== null && --N.pendingTasks === 0 && Ct(r, N), r.renderState.generateStaticMarkup || (x = x.errorDigest, c.push("<!--$!-->"), c.push("<template"), x && (c.push(' data-dgst="'), x = P(x), c.push(x), c.push('"')), c.push("></template>")), Qa(r, c, g, m), r = r.renderState.generateStaticMarkup ? !0 : c.push("<!--/$-->"), r;
    }
    if (x.status !== 1)
      return x.status === 0 && (x.rootSegmentID = r.nextSegmentId++), 0 < x.completedSegments.length && r.partialBoundaries.push(x), Kl(
        c,
        r.renderState,
        x.rootSegmentID
      ), m && El(m, x.fallbackState), Qa(r, c, g, m), c.push("<!--/$-->");
    if (!Au && Xi(r, x) && Ji + x.byteSize > r.progressiveChunkSize)
      return x.rootSegmentID = r.nextSegmentId++, r.completedBoundaries.push(x), Kl(
        c,
        r.renderState,
        x.rootSegmentID
      ), Qa(r, c, g, m), c.push("<!--/$-->");
    if (Ji += x.byteSize, m && El(m, x.contentState), g = x.row, g !== null && Xi(r, x) && --g.pendingTasks === 0 && Ct(r, g), r.renderState.generateStaticMarkup || c.push("<!--$-->"), g = x.completedSegments, g.length !== 1) throw Error(f(391));
    return Ki(r, c, g[0], m), r = r.renderState.generateStaticMarkup ? !0 : c.push("<!--/$-->"), r;
  }
  function pc(r, c, g, m) {
    return Rn(
      c,
      r.renderState,
      g.parentFormatContext,
      g.id
    ), Ki(r, c, g, m), jl(c, g.parentFormatContext);
  }
  function To(r, c, g) {
    Ji = g.byteSize;
    for (var m = g.completedSegments, x = 0; x < m.length; x++)
      yi(
        r,
        c,
        g,
        m[x]
      );
    m.length = 0, m = g.row, m !== null && Xi(r, g) && --m.pendingTasks === 0 && Ct(r, m), zi(
      c,
      g.contentState,
      r.renderState
    ), m = r.resumableState, r = r.renderState, x = g.rootSegmentID, g = g.contentState;
    var N = r.stylesToHoist;
    return r.stylesToHoist = !1, c.push(r.startInlineScript), c.push(">"), N ? ((m.instructions & 4) === 0 && (m.instructions |= 4, c.push(
      '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
    )), (m.instructions & 2) === 0 && (m.instructions |= 2, c.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), (m.instructions & 8) === 0 ? (m.instructions |= 8, c.push(
      `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
    )) : c.push('$RR("')) : ((m.instructions & 2) === 0 && (m.instructions |= 2, c.push(
      `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
    )), c.push('$RC("')), m = x.toString(16), c.push(r.boundaryPrefix), c.push(m), c.push('","'), c.push(r.segmentPrefix), c.push(m), N ? (c.push('",'), kr(c, g)) : c.push('"'), g = c.push(")<\/script>"), Jl(c, r) && g;
  }
  function yi(r, c, g, m) {
    if (m.status === 2) return !0;
    var x = g.contentState, N = m.id;
    if (N === -1) {
      if ((m.id = g.rootSegmentID) === -1)
        throw Error(f(392));
      return pc(r, c, m, x);
    }
    return N === g.rootSegmentID ? pc(r, c, m, x) : (pc(r, c, m, x), g = r.resumableState, r = r.renderState, c.push(r.startInlineScript), c.push(">"), (g.instructions & 1) === 0 ? (g.instructions |= 1, c.push(
      '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
    )) : c.push('$RS("'), c.push(r.segmentPrefix), N = N.toString(16), c.push(N), c.push('","'), c.push(r.placeholderPrefix), c.push(N), c = c.push('")<\/script>'), c);
  }
  var Au = !1;
  function bi(r, c) {
    try {
      if (!(0 < r.pendingRootTasks)) {
        var g, m = r.completedRootSegment;
        if (m !== null) {
          if (m.status === 5) return;
          var x = r.completedPreambleSegments;
          if (x === null) return;
          Ji = r.byteSize;
          var N = r.resumableState, L = r.renderState, ee = L.preamble, Y = ee.htmlChunks, te = ee.headChunks, se;
          if (Y) {
            for (se = 0; se < Y.length; se++)
              c.push(Y[se]);
            if (te)
              for (se = 0; se < te.length; se++)
                c.push(te[se]);
            else {
              var ie = ft("head");
              c.push(ie), c.push(">");
            }
          } else if (te)
            for (se = 0; se < te.length; se++)
              c.push(te[se]);
          var ve = L.charsetChunks;
          for (se = 0; se < ve.length; se++)
            c.push(ve[se]);
          ve.length = 0, L.preconnects.forEach(Nn, c), L.preconnects.clear();
          var Be = L.viewportChunks;
          for (se = 0; se < Be.length; se++)
            c.push(Be[se]);
          Be.length = 0, L.fontPreloads.forEach(Nn, c), L.fontPreloads.clear(), L.highImagePreloads.forEach(Nn, c), L.highImagePreloads.clear(), en = L, L.styles.forEach(nt, c), en = null;
          var Ie = L.importMapChunks;
          for (se = 0; se < Ie.length; se++)
            c.push(Ie[se]);
          Ie.length = 0, L.bootstrapScripts.forEach(Nn, c), L.scripts.forEach(Nn, c), L.scripts.clear(), L.bulkPreloads.forEach(Nn, c), L.bulkPreloads.clear(), N.instructions |= 32;
          var Ze = L.hoistableChunks;
          for (se = 0; se < Ze.length; se++)
            c.push(Ze[se]);
          for (N = Ze.length = 0; N < x.length; N++) {
            var je = x[N];
            for (L = 0; L < je.length; L++)
              Ki(r, c, je[L], null);
          }
          var Qe = r.renderState.preamble, qe = Qe.headChunks;
          if (Qe.htmlChunks || qe) {
            var Qt = Hl("head");
            c.push(Qt);
          }
          var Lt = Qe.bodyChunks;
          if (Lt)
            for (x = 0; x < Lt.length; x++)
              c.push(Lt[x]);
          Ki(r, c, m, null), r.completedRootSegment = null;
          var ht = r.renderState;
          if (r.allPendingTasks !== 0 || r.clientRenderedBoundaries.length !== 0 || r.completedBoundaries.length !== 0 || r.trackedPostpones !== null && (r.trackedPostpones.rootNodes.length !== 0 || r.trackedPostpones.rootSlots !== null)) {
            var gt = r.resumableState;
            if ((gt.instructions & 64) === 0) {
              if (gt.instructions |= 64, c.push(ht.startInlineScript), (gt.instructions & 32) === 0) {
                gt.instructions |= 32;
                var lt = "_" + gt.idPrefix + "R_";
                c.push(' id="');
                var Fl = P(lt);
                c.push(Fl), c.push('"');
              }
              c.push(">"), c.push(
                "requestAnimationFrame(function(){$RT=performance.now()});"
              ), c.push("<\/script>");
            }
          }
          Jl(c, ht);
        }
        var Pe = r.renderState;
        m = 0;
        var Al = Pe.viewportChunks;
        for (m = 0; m < Al.length; m++)
          c.push(Al[m]);
        Al.length = 0, Pe.preconnects.forEach(Nn, c), Pe.preconnects.clear(), Pe.fontPreloads.forEach(Nn, c), Pe.fontPreloads.clear(), Pe.highImagePreloads.forEach(
          Nn,
          c
        ), Pe.highImagePreloads.clear(), Pe.styles.forEach(si, c), Pe.scripts.forEach(Nn, c), Pe.scripts.clear(), Pe.bulkPreloads.forEach(Nn, c), Pe.bulkPreloads.clear();
        var rt = Pe.hoistableChunks;
        for (m = 0; m < rt.length; m++)
          c.push(rt[m]);
        rt.length = 0;
        var En = r.clientRenderedBoundaries;
        for (g = 0; g < En.length; g++) {
          var gn = En[g];
          Pe = c;
          var Rt = r.resumableState, nl = r.renderState, $i = gn.rootSegmentID, _l = gn.errorDigest;
          Pe.push(nl.startInlineScript), Pe.push(">"), (Rt.instructions & 4) === 0 ? (Rt.instructions |= 4, Pe.push(
            '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
          )) : Pe.push('$RX("'), Pe.push(nl.boundaryPrefix);
          var Zr = $i.toString(16);
          if (Pe.push(Zr), Pe.push('"'), _l) {
            Pe.push(",");
            var ll = sr(
              _l || ""
            );
            Pe.push(ll);
          }
          var wn = Pe.push(")<\/script>");
          if (!wn) {
            r.destination = null, g++, En.splice(0, g);
            return;
          }
        }
        En.splice(0, g);
        var al = r.completedBoundaries;
        for (g = 0; g < al.length; g++)
          if (!To(r, c, al[g])) {
            r.destination = null, g++, al.splice(0, g);
            return;
          }
        al.splice(0, g), Au = !0;
        var Yl = r.partialBoundaries;
        for (g = 0; g < Yl.length; g++) {
          var Ol = Yl[g];
          e: {
            En = r, gn = c, Ji = Ol.byteSize;
            var Mn = Ol.completedSegments;
            for (wn = 0; wn < Mn.length; wn++)
              if (!yi(
                En,
                gn,
                Ol,
                Mn[wn]
              )) {
                wn++, Mn.splice(0, wn);
                var Hn = !1;
                break e;
              }
            Mn.splice(0, wn);
            var Jt = Ol.row;
            Jt !== null && Jt.together && Ol.pendingTasks === 1 && (Jt.pendingTasks === 1 ? Va(
              En,
              Jt,
              Jt.hoistables
            ) : Jt.pendingTasks--), Hn = zi(
              gn,
              Ol.contentState,
              En.renderState
            );
          }
          if (!Hn) {
            r.destination = null, g++, Yl.splice(0, g);
            return;
          }
        }
        Yl.splice(0, g), Au = !1;
        var fl = r.completedBoundaries;
        for (g = 0; g < fl.length; g++)
          if (!To(r, c, fl[g])) {
            r.destination = null, g++, fl.splice(0, g);
            return;
          }
        fl.splice(0, g);
      }
    } finally {
      Au = !1, r.allPendingTasks === 0 && r.clientRenderedBoundaries.length === 0 && r.completedBoundaries.length === 0 && (r.flushScheduled = !1, g = r.resumableState, g.hasBody && (Yl = Hl("body"), c.push(Yl)), g.hasHtml && (g = Hl("html"), c.push(g)), r.status = 14, c.push(null), r.destination = null);
    }
  }
  function mi(r) {
    if (r.flushScheduled === !1 && r.pingedTasks.length === 0 && r.destination !== null) {
      r.flushScheduled = !0;
      var c = r.destination;
      c ? bi(r, c) : r.flushScheduled = !1;
    }
  }
  function ji(r, c) {
    if (r.status === 13)
      r.status = 14, c.destroy(r.fatalError);
    else if (r.status !== 14 && r.destination === null) {
      r.destination = c;
      try {
        bi(r, c);
      } catch (g) {
        sl(r, g, {}), Vi(r, g);
      }
    }
  }
  function Tc(r, c) {
    (r.status === 11 || r.status === 10) && (r.status = 12);
    try {
      var g = r.abortableTasks;
      if (0 < g.size) {
        var m = c === void 0 ? Error(f(432)) : typeof c == "object" && c !== null && typeof c.then == "function" ? Error(f(530)) : c;
        r.fatalError = m, g.forEach(function(x) {
          return Su(x, r, m);
        }), g.clear();
      }
      r.destination !== null && bi(r, r.destination);
    } catch (x) {
      sl(r, x, {}), Vi(r, x);
    }
  }
  function Aa(r, c, g) {
    if (c === null) g.rootNodes.push(r);
    else {
      var m = g.workingMap, x = m.get(c);
      x === void 0 && (x = [c[1], c[2], [], null], m.set(c, x), Aa(x, c[0], g)), x[2].push(r);
    }
  }
  function Pa() {
  }
  function qi(r, c, g, m) {
    var x = !1, N = null, L = "", ee = !1;
    if (c = Xn(c ? c.identifierPrefix : void 0), r = Qs(
      r,
      c,
      el(c, g),
      $e(0, null, 0, null),
      1 / 0,
      Pa,
      void 0,
      function() {
        ee = !0;
      },
      void 0,
      void 0,
      void 0
    ), r.flushScheduled = r.destination !== null, jo(r), r.status === 10 && (r.status = 11), r.trackedPostpones === null && bc(r, r.pendingRootTasks === 0), Tc(r, m), ji(r, {
      push: function(Y) {
        return Y !== null && (L += Y), !0;
      },
      destroy: function(Y) {
        x = !0, N = Y;
      }
    }), x && N !== m) throw N;
    if (!ee) throw Error(f(426));
    return L;
  }
  return Uf.renderToStaticMarkup = function(r, c) {
    return qi(
      r,
      c,
      !0,
      'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, Uf.renderToString = function(r, c) {
    return qi(
      r,
      c,
      !1,
      'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server'
    );
  }, Uf.version = "19.2.6", Uf;
}
var ko = {};
var vb;
function pp() {
  if (vb) return ko;
  vb = 1;
  var a = Xt, o = qg;
  function f(i) {
    var u = "https://react.dev/errors/" + i;
    if (1 < arguments.length) {
      u += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var h = 2; h < arguments.length; h++)
        u += "&args[]=" + encodeURIComponent(arguments[h]);
    }
    return "Minified React error #" + i + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var v = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), _ = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), z = Symbol.for("react.context"), B = Symbol.for("react.forward_ref"), I = Symbol.for("react.suspense"), F = Symbol.for("react.suspense_list"), ce = Symbol.for("react.memo"), ae = Symbol.for("react.lazy"), $ = Symbol.for("react.scope"), he = Symbol.for("react.activity"), ge = Symbol.for("react.legacy_hidden"), de = Symbol.for("react.memo_cache_sentinel"), De = Symbol.for("react.view_transition"), Re = Symbol.iterator;
  function ye(i) {
    return i === null || typeof i != "object" ? null : (i = Re && i[Re] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var xe = Array.isArray;
  function we(i, u) {
    var h = i.length & 3, b = i.length - h, T = u;
    for (u = 0; u < b; ) {
      var O = i.charCodeAt(u) & 255 | (i.charCodeAt(++u) & 255) << 8 | (i.charCodeAt(++u) & 255) << 16 | (i.charCodeAt(++u) & 255) << 24;
      ++u, O = 3432918353 * (O & 65535) + ((3432918353 * (O >>> 16) & 65535) << 16) & 4294967295, O = O << 15 | O >>> 17, O = 461845907 * (O & 65535) + ((461845907 * (O >>> 16) & 65535) << 16) & 4294967295, T ^= O, T = T << 13 | T >>> 19, T = 5 * (T & 65535) + ((5 * (T >>> 16) & 65535) << 16) & 4294967295, T = (T & 65535) + 27492 + (((T >>> 16) + 58964 & 65535) << 16);
    }
    switch (O = 0, h) {
      case 3:
        O ^= (i.charCodeAt(u + 2) & 255) << 16;
      case 2:
        O ^= (i.charCodeAt(u + 1) & 255) << 8;
      case 1:
        O ^= i.charCodeAt(u) & 255, O = 3432918353 * (O & 65535) + ((3432918353 * (O >>> 16) & 65535) << 16) & 4294967295, O = O << 15 | O >>> 17, T ^= 461845907 * (O & 65535) + ((461845907 * (O >>> 16) & 65535) << 16) & 4294967295;
    }
    return T ^= i.length, T ^= T >>> 16, T = 2246822507 * (T & 65535) + ((2246822507 * (T >>> 16) & 65535) << 16) & 4294967295, T ^= T >>> 13, T = 3266489909 * (T & 65535) + ((3266489909 * (T >>> 16) & 65535) << 16) & 4294967295, (T ^ T >>> 16) >>> 0;
  }
  var Me = new MessageChannel(), He = [];
  Me.port1.onmessage = function() {
    var i = He.shift();
    i && i();
  };
  function Ot(i) {
    He.push(i), Me.port2.postMessage(null);
  }
  function wt(i) {
    setTimeout(function() {
      throw i;
    });
  }
  var At = Promise, Ae = typeof queueMicrotask == "function" ? queueMicrotask : function(i) {
    At.resolve(null).then(i).catch(wt);
  }, Xe = null, it = 0;
  function U(i, u) {
    if (u.byteLength !== 0)
      if (2048 < u.byteLength)
        0 < it && (i.enqueue(
          new Uint8Array(Xe.buffer, 0, it)
        ), Xe = new Uint8Array(2048), it = 0), i.enqueue(u);
      else {
        var h = Xe.length - it;
        h < u.byteLength && (h === 0 ? i.enqueue(Xe) : (Xe.set(u.subarray(0, h), it), i.enqueue(Xe), u = u.subarray(h)), Xe = new Uint8Array(2048), it = 0), Xe.set(u, it), it += u.byteLength;
      }
  }
  function P(i, u) {
    return U(i, u), !0;
  }
  function Se(i) {
    Xe && 0 < it && (i.enqueue(new Uint8Array(Xe.buffer, 0, it)), Xe = null, it = 0);
  }
  var et = new TextEncoder();
  function ue(i) {
    return et.encode(i);
  }
  function Q(i) {
    return et.encode(i);
  }
  function ct(i) {
    return i.byteLength;
  }
  function tt(i, u) {
    typeof i.error == "function" ? i.error(u) : i.close();
  }
  var _e = Object.assign, Ne = Object.prototype.hasOwnProperty, It = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), en = {}, Pl = {};
  function kl(i) {
    return Ne.call(Pl, i) ? !0 : Ne.call(en, i) ? !1 : It.test(i) ? Pl[i] = !0 : (en[i] = !0, !1);
  }
  var Xn = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  ), $e = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Ci = /["'&<>]/;
  function Ce(i) {
    if (typeof i == "boolean" || typeof i == "number" || typeof i == "bigint")
      return "" + i;
    i = "" + i;
    var u = Ci.exec(i);
    if (u) {
      var h = "", b, T = 0;
      for (b = u.index; b < i.length; b++) {
        switch (i.charCodeAt(b)) {
          case 34:
            u = "&quot;";
            break;
          case 38:
            u = "&amp;";
            break;
          case 39:
            u = "&#x27;";
            break;
          case 60:
            u = "&lt;";
            break;
          case 62:
            u = "&gt;";
            break;
          default:
            continue;
        }
        T !== b && (h += i.slice(T, b)), T = b + 1, h += u;
      }
      i = T !== b ? h + i.slice(T, b) : h;
    }
    return i;
  }
  var cr = /([A-Z])/g, vt = /^ms-/, ka = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Ta(i) {
    return ka.test("" + i) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : i;
  }
  var jn = a.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, pn = o.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Ri = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ul = pn.d;
  pn.d = {
    f: ul.f,
    r: ul.r,
    D: Su,
    C: bc,
    L: mc,
    m: xu,
    X: Wi,
    S: Eu,
    M: jo
  };
  var In = [], cl = null;
  Q('"></template>');
  var Ni = Q("<script"), Ue = Q("<\/script>"), qn = Q('<script src="'), Lr = Q('<script type="module" src="'), Mi = Q(' nonce="'), tn = Q(' integrity="'), Ha = Q(' crossorigin="'), ui = Q(' async=""><\/script>'), Sa = Q("<style"), or = /(<\/|<)(s)(cript)/gi;
  function Wl(i, u, h, b) {
    return "" + u + (h === "s" ? "\\u0073" : "\\u0053") + b;
  }
  var Zn = Q(
    '<script type="importmap">'
  ), Sl = Q("<\/script>");
  function Cn(i, u, h, b, T, O) {
    h = typeof u == "string" ? u : u && u.script;
    var M = h === void 0 ? Ni : Q(
      '<script nonce="' + Ce(h) + '"'
    ), Z = typeof u == "string" ? void 0 : u && u.style, k = Z === void 0 ? Sa : Q(
      '<style nonce="' + Ce(Z) + '"'
    ), X = i.idPrefix, J = [], ne = i.bootstrapScriptContent, pe = i.bootstrapScripts, Te = i.bootstrapModules;
    if (ne !== void 0 && (J.push(M), Ir(J, i), J.push(
      Dt,
      ue(
        ("" + ne).replace(or, Wl)
      ),
      Ue
    )), ne = [], b !== void 0 && (ne.push(Zn), ne.push(
      ue(
        ("" + JSON.stringify(b)).replace(or, Wl)
      )
    ), ne.push(Sl)), b = T ? {
      preconnects: "",
      fontPreloads: "",
      highImagePreloads: "",
      remainingCapacity: 2 + (typeof O == "number" ? O : 2e3)
    } : null, T = {
      placeholderPrefix: Q(X + "P:"),
      segmentPrefix: Q(X + "S:"),
      boundaryPrefix: Q(X + "B:"),
      startInlineScript: M,
      startInlineStyle: k,
      preamble: ft(),
      externalRuntimeScript: null,
      bootstrapChunks: J,
      importMapChunks: ne,
      onHeaders: T,
      headers: b,
      resets: {
        font: {},
        dns: {},
        connect: { default: {}, anonymous: {}, credentials: {} },
        image: {},
        style: {}
      },
      charsetChunks: [],
      viewportChunks: [],
      hoistableChunks: [],
      preconnects: /* @__PURE__ */ new Set(),
      fontPreloads: /* @__PURE__ */ new Set(),
      highImagePreloads: /* @__PURE__ */ new Set(),
      styles: /* @__PURE__ */ new Map(),
      bootstrapScripts: /* @__PURE__ */ new Set(),
      scripts: /* @__PURE__ */ new Set(),
      bulkPreloads: /* @__PURE__ */ new Set(),
      preloads: {
        images: /* @__PURE__ */ new Map(),
        stylesheets: /* @__PURE__ */ new Map(),
        scripts: /* @__PURE__ */ new Map(),
        moduleScripts: /* @__PURE__ */ new Map()
      },
      nonce: { script: h, style: Z },
      hoistableState: null,
      stylesToHoist: !1
    }, pe !== void 0)
      for (b = 0; b < pe.length; b++)
        X = pe[b], Z = M = void 0, k = {
          rel: "preload",
          as: "script",
          fetchPriority: "low",
          nonce: u
        }, typeof X == "string" ? k.href = O = X : (k.href = O = X.src, k.integrity = Z = typeof X.integrity == "string" ? X.integrity : void 0, k.crossOrigin = M = typeof X == "string" || X.crossOrigin == null ? void 0 : X.crossOrigin === "use-credentials" ? "use-credentials" : ""), X = i, ne = O, X.scriptResources[ne] = null, X.moduleScriptResources[ne] = null, X = [], dn(X, k), T.bootstrapScripts.add(X), J.push(
          qn,
          ue(Ce(O)),
          zt
        ), h && J.push(
          Mi,
          ue(Ce(h)),
          zt
        ), typeof Z == "string" && J.push(
          tn,
          ue(Ce(Z)),
          zt
        ), typeof M == "string" && J.push(
          Ha,
          ue(Ce(M)),
          zt
        ), Ir(J, i), J.push(ui);
    if (Te !== void 0)
      for (u = 0; u < Te.length; u++)
        Z = Te[u], O = b = void 0, M = {
          rel: "modulepreload",
          fetchPriority: "low",
          nonce: h
        }, typeof Z == "string" ? M.href = pe = Z : (M.href = pe = Z.src, M.integrity = O = typeof Z.integrity == "string" ? Z.integrity : void 0, M.crossOrigin = b = typeof Z == "string" || Z.crossOrigin == null ? void 0 : Z.crossOrigin === "use-credentials" ? "use-credentials" : ""), Z = i, k = pe, Z.scriptResources[k] = null, Z.moduleScriptResources[k] = null, Z = [], dn(Z, M), T.bootstrapScripts.add(Z), J.push(
          Lr,
          ue(Ce(pe)),
          zt
        ), h && J.push(
          Mi,
          ue(Ce(h)),
          zt
        ), typeof O == "string" && J.push(
          tn,
          ue(Ce(O)),
          zt
        ), typeof b == "string" && J.push(
          Ha,
          ue(Ce(b)),
          zt
        ), Ir(J, i), J.push(ui);
    return T;
  }
  function Ba(i, u, h, b, T) {
    return {
      idPrefix: i === void 0 ? "" : i,
      nextFormID: 0,
      streamingFormat: 0,
      bootstrapScriptContent: h,
      bootstrapScripts: b,
      bootstrapModules: T,
      instructions: 0,
      hasBody: !1,
      hasHtml: !1,
      unknownResources: {},
      dnsResources: {},
      connectResources: { default: {}, anonymous: {}, credentials: {} },
      imageResources: {},
      styleResources: {},
      scriptResources: {},
      moduleUnknownResources: {},
      moduleScriptResources: {}
    };
  }
  function ft() {
    return { htmlChunks: null, headChunks: null, bodyChunks: null };
  }
  function Tn(i, u, h, b) {
    return {
      insertionMode: i,
      selectedValue: u,
      tagScope: h,
      viewTransition: b
    };
  }
  function ci(i) {
    return Tn(
      i === "http://www.w3.org/2000/svg" ? 4 : i === "http://www.w3.org/1998/Math/MathML" ? 5 : 0,
      null,
      0,
      null
    );
  }
  function Hl(i, u, h) {
    var b = i.tagScope & -25;
    switch (u) {
      case "noscript":
        return Tn(2, null, b | 1, null);
      case "select":
        return Tn(
          2,
          h.value != null ? h.value : h.defaultValue,
          b,
          null
        );
      case "svg":
        return Tn(4, null, b, null);
      case "picture":
        return Tn(2, null, b | 2, null);
      case "math":
        return Tn(5, null, b, null);
      case "foreignObject":
        return Tn(2, null, b, null);
      case "table":
        return Tn(6, null, b, null);
      case "thead":
      case "tbody":
      case "tfoot":
        return Tn(7, null, b, null);
      case "colgroup":
        return Tn(9, null, b, null);
      case "tr":
        return Tn(8, null, b, null);
      case "head":
        if (2 > i.insertionMode)
          return Tn(3, null, b, null);
        break;
      case "html":
        if (i.insertionMode === 0)
          return Tn(1, null, b, null);
    }
    return 6 <= i.insertionMode || 2 > i.insertionMode ? Tn(2, null, b, null) : i.tagScope !== b ? Tn(
      i.insertionMode,
      i.selectedValue,
      b,
      null
    ) : i;
  }
  function Ua(i) {
    return i === null ? null : {
      update: i.update,
      enter: "none",
      exit: "none",
      share: i.update,
      name: i.autoName,
      autoName: i.autoName,
      nameIdx: 0
    };
  }
  function Jl(i, u) {
    return u.tagScope & 32 && (i.instructions |= 128), Tn(
      u.insertionMode,
      u.selectedValue,
      u.tagScope | 12,
      Ua(u.viewTransition)
    );
  }
  function Kl(i, u) {
    i = Ua(u.viewTransition);
    var h = u.tagScope | 16;
    return i !== null && i.share !== "none" && (h |= 64), Tn(
      u.insertionMode,
      u.selectedValue,
      h,
      i
    );
  }
  var Rn = Q("<!-- -->");
  function jl(i, u, h, b) {
    return u === "" ? b : (b && i.push(Rn), i.push(ue(Ce(u))), !0);
  }
  var Fa = /* @__PURE__ */ new Map(), sr = Q(' style="'), Ya = Q(":"), fr = Q(";");
  function oi(i, u) {
    if (typeof u != "object") throw Error(f(62));
    var h = !0, b;
    for (b in u)
      if (Ne.call(u, b)) {
        var T = u[b];
        if (T != null && typeof T != "boolean" && T !== "") {
          if (b.indexOf("--") === 0) {
            var O = ue(Ce(b));
            T = ue(
              Ce(("" + T).trim())
            );
          } else
            O = Fa.get(b), O === void 0 && (O = Q(
              Ce(
                b.replace(cr, "-$1").toLowerCase().replace(vt, "-ms-")
              )
            ), Fa.set(b, O)), T = typeof T == "number" ? T === 0 || Xn.has(b) ? ue("" + T) : ue(T + "px") : ue(
              Ce(("" + T).trim())
            );
          h ? (h = !1, i.push(
            sr,
            O,
            Ya,
            T
          )) : i.push(fr, O, Ya, T);
        }
      }
    h || i.push(zt);
  }
  var fn = Q(" "), ol = Q('="'), zt = Q('"'), zi = Q('=""');
  function Nn(i, u, h) {
    h && typeof h != "function" && typeof h != "symbol" && i.push(fn, ue(u), zi);
  }
  function Zt(i, u, h) {
    typeof h != "function" && typeof h != "symbol" && typeof h != "boolean" && i.push(
      fn,
      ue(u),
      ol,
      ue(Ce(h)),
      zt
    );
  }
  var xa = Q(
    Ce(
      "javascript:throw new Error('React form unexpectedly submitted.')"
    )
  ), nt = Q('<input type="hidden"');
  function on(i, u) {
    this.push(nt), si(i), Zt(this, "name", u), Zt(this, "value", i), this.push(Ea);
  }
  function si(i) {
    if (typeof i != "string") throw Error(f(480));
  }
  function Ga(i, u) {
    if (typeof u.$$FORM_ACTION == "function") {
      var h = i.nextFormID++;
      i = i.idPrefix + h;
      try {
        var b = u.$$FORM_ACTION(i);
        if (b) {
          var T = b.data;
          T != null && T.forEach(si);
        }
        return b;
      } catch (O) {
        if (typeof O == "object" && O !== null && typeof O.then == "function")
          throw O;
      }
    }
    return null;
  }
  function kr(i, u, h, b, T, O, M, Z) {
    var k = null;
    if (typeof b == "function") {
      var X = Ga(u, b);
      X !== null ? (Z = X.name, b = X.action || "", T = X.encType, O = X.method, M = X.target, k = X.data) : (i.push(
        fn,
        ue("formAction"),
        ol,
        xa,
        zt
      ), M = O = T = b = Z = null, Ia(u, h));
    }
    return Z != null && St(i, "name", Z), b != null && St(i, "formAction", b), T != null && St(i, "formEncType", T), O != null && St(i, "formMethod", O), M != null && St(i, "formTarget", M), k;
  }
  function St(i, u, h) {
    switch (u) {
      case "className":
        Zt(i, "class", h);
        break;
      case "tabIndex":
        Zt(i, "tabindex", h);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Zt(i, u, h);
        break;
      case "style":
        oi(i, h);
        break;
      case "src":
      case "href":
        if (h === "") break;
      case "action":
      case "formAction":
        if (h == null || typeof h == "function" || typeof h == "symbol" || typeof h == "boolean")
          break;
        h = Ta("" + h), i.push(
          fn,
          ue(u),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "ref":
        break;
      case "autoFocus":
      case "multiple":
      case "muted":
        Nn(i, u.toLowerCase(), h);
        break;
      case "xlinkHref":
        if (typeof h == "function" || typeof h == "symbol" || typeof h == "boolean")
          break;
        h = Ta("" + h), i.push(
          fn,
          ue("xlink:href"),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        typeof h != "function" && typeof h != "symbol" && i.push(
          fn,
          ue(u),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        h && typeof h != "function" && typeof h != "symbol" && i.push(
          fn,
          ue(u),
          zi
        );
        break;
      case "capture":
      case "download":
        h === !0 ? i.push(
          fn,
          ue(u),
          zi
        ) : h !== !1 && typeof h != "function" && typeof h != "symbol" && i.push(
          fn,
          ue(u),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        typeof h != "function" && typeof h != "symbol" && !isNaN(h) && 1 <= h && i.push(
          fn,
          ue(u),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "rowSpan":
      case "start":
        typeof h == "function" || typeof h == "symbol" || isNaN(h) || i.push(
          fn,
          ue(u),
          ol,
          ue(Ce(h)),
          zt
        );
        break;
      case "xlinkActuate":
        Zt(i, "xlink:actuate", h);
        break;
      case "xlinkArcrole":
        Zt(i, "xlink:arcrole", h);
        break;
      case "xlinkRole":
        Zt(i, "xlink:role", h);
        break;
      case "xlinkShow":
        Zt(i, "xlink:show", h);
        break;
      case "xlinkTitle":
        Zt(i, "xlink:title", h);
        break;
      case "xlinkType":
        Zt(i, "xlink:type", h);
        break;
      case "xmlBase":
        Zt(i, "xml:base", h);
        break;
      case "xmlLang":
        Zt(i, "xml:lang", h);
        break;
      case "xmlSpace":
        Zt(i, "xml:space", h);
        break;
      default:
        if ((!(2 < u.length) || u[0] !== "o" && u[0] !== "O" || u[1] !== "n" && u[1] !== "N") && (u = $e.get(u) || u, kl(u))) {
          switch (typeof h) {
            case "function":
            case "symbol":
              return;
            case "boolean":
              var b = u.toLowerCase().slice(0, 5);
              if (b !== "data-" && b !== "aria-") return;
          }
          i.push(
            fn,
            ue(u),
            ol,
            ue(Ce(h)),
            zt
          );
        }
    }
  }
  var Dt = Q(">"), Ea = Q("/>");
  function $n(i, u, h) {
    if (u != null) {
      if (h != null) throw Error(f(60));
      if (typeof u != "object" || !("__html" in u))
        throw Error(f(61));
      u = u.__html, u != null && i.push(ue("" + u));
    }
  }
  function Di(i) {
    var u = "";
    return a.Children.forEach(i, function(h) {
      h != null && (u += h);
    }), u;
  }
  var Xa = Q(' selected=""'), xl = Q(
    `addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error('React form unexpectedly submitted.')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});`
  );
  function Ia(i, u) {
    if ((i.instructions & 16) === 0) {
      i.instructions |= 16;
      var h = u.preamble, b = u.bootstrapChunks;
      (h.htmlChunks || h.headChunks) && b.length === 0 ? (b.push(u.startInlineScript), Ir(b, i), b.push(
        Dt,
        xl,
        Ue
      )) : b.unshift(
        u.startInlineScript,
        Dt,
        xl,
        Ue
      );
    }
  }
  var Vt = Q("<!--F!-->"), Li = Q("<!--F-->");
  function dn(i, u) {
    i.push(nn("link"));
    for (var h in u)
      if (Ne.call(u, h)) {
        var b = u[h];
        if (b != null)
          switch (h) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, "link"));
            default:
              St(i, h, b);
          }
      }
    return i.push(Ea), null;
  }
  var ql = /(<\/|<)(s)(tyle)/gi;
  function ga(i, u, h, b) {
    return "" + u + (h === "s" ? "\\73 " : "\\53 ") + b;
  }
  function $l(i, u, h) {
    i.push(nn(h));
    for (var b in u)
      if (Ne.call(u, b)) {
        var T = u[b];
        if (T != null)
          switch (b) {
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(f(399, h));
            default:
              St(i, b, T);
          }
      }
    return i.push(Ea), null;
  }
  function fi(i, u) {
    i.push(nn("title"));
    var h = null, b = null, T;
    for (T in u)
      if (Ne.call(u, T)) {
        var O = u[T];
        if (O != null)
          switch (T) {
            case "children":
              h = O;
              break;
            case "dangerouslySetInnerHTML":
              b = O;
              break;
            default:
              St(i, T, O);
          }
      }
    return i.push(Dt), u = Array.isArray(h) ? 2 > h.length ? h[0] : null : h, typeof u != "function" && typeof u != "symbol" && u !== null && u !== void 0 && i.push(ue(Ce("" + u))), $n(i, b, h), i.push(wl("title")), null;
  }
  var dr = Q("<!--head-->"), ki = Q("<!--body-->"), El = Q("<!--html-->");
  function el(i, u) {
    i.push(nn("script"));
    var h = null, b = null, T;
    for (T in u)
      if (Ne.call(u, T)) {
        var O = u[T];
        if (O != null)
          switch (T) {
            case "children":
              h = O;
              break;
            case "dangerouslySetInnerHTML":
              b = O;
              break;
            default:
              St(i, T, O);
          }
      }
    return i.push(Dt), $n(i, b, h), typeof h == "string" && i.push(
      ue(("" + h).replace(or, Wl))
    ), i.push(wl("script")), null;
  }
  function Bl(i, u, h) {
    i.push(nn(h));
    var b = h = null, T;
    for (T in u)
      if (Ne.call(u, T)) {
        var O = u[T];
        if (O != null)
          switch (T) {
            case "children":
              h = O;
              break;
            case "dangerouslySetInnerHTML":
              b = O;
              break;
            default:
              St(i, T, O);
          }
      }
    return i.push(Dt), $n(i, b, h), h;
  }
  function Sn(i, u, h) {
    i.push(nn(h));
    var b = h = null, T;
    for (T in u)
      if (Ne.call(u, T)) {
        var O = u[T];
        if (O != null)
          switch (T) {
            case "children":
              h = O;
              break;
            case "dangerouslySetInnerHTML":
              b = O;
              break;
            default:
              St(i, T, O);
          }
      }
    return i.push(Dt), $n(i, b, h), typeof h == "string" ? (i.push(ue(Ce(h))), null) : h;
  }
  var hr = Q(`
`), lc = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, di = /* @__PURE__ */ new Map();
  function nn(i) {
    var u = di.get(i);
    if (u === void 0) {
      if (!lc.test(i))
        throw Error(f(65, i));
      u = Q("<" + i), di.set(i, u);
    }
    return u;
  }
  var va = Q("<!DOCTYPE html>");
  function Hr(i, u, h, b, T, O, M, Z, k) {
    switch (u) {
      case "div":
      case "span":
      case "svg":
      case "path":
        break;
      case "a":
        i.push(nn("a"));
        var X = null, J = null, ne;
        for (ne in h)
          if (Ne.call(h, ne)) {
            var pe = h[ne];
            if (pe != null)
              switch (ne) {
                case "children":
                  X = pe;
                  break;
                case "dangerouslySetInnerHTML":
                  J = pe;
                  break;
                case "href":
                  pe === "" ? Zt(i, "href", "") : St(i, ne, pe);
                  break;
                default:
                  St(i, ne, pe);
              }
          }
        if (i.push(Dt), $n(i, J, X), typeof X == "string") {
          i.push(ue(Ce(X)));
          var Te = null;
        } else Te = X;
        return Te;
      case "g":
      case "p":
      case "li":
        break;
      case "select":
        i.push(nn("select"));
        var Ve = null, Le = null, at;
        for (at in h)
          if (Ne.call(h, at)) {
            var bt = h[at];
            if (bt != null)
              switch (at) {
                case "children":
                  Ve = bt;
                  break;
                case "dangerouslySetInnerHTML":
                  Le = bt;
                  break;
                case "defaultValue":
                case "value":
                  break;
                default:
                  St(
                    i,
                    at,
                    bt
                  );
              }
          }
        return i.push(Dt), $n(i, Le, Ve), Ve;
      case "option":
        var Oe = Z.selectedValue;
        i.push(nn("option"));
        var Ke = null, mt = null, Ml = null, Ye = null, yn;
        for (yn in h)
          if (Ne.call(h, yn)) {
            var jt = h[yn];
            if (jt != null)
              switch (yn) {
                case "children":
                  Ke = jt;
                  break;
                case "selected":
                  Ml = jt;
                  break;
                case "dangerouslySetInnerHTML":
                  Ye = jt;
                  break;
                case "value":
                  mt = jt;
                default:
                  St(
                    i,
                    yn,
                    jt
                  );
              }
          }
        if (Oe != null) {
          var Un = mt !== null ? "" + mt : Di(Ke);
          if (xe(Oe)) {
            for (var Zl = 0; Zl < Oe.length; Zl++)
              if ("" + Oe[Zl] === Un) {
                i.push(Xa);
                break;
              }
          } else
            "" + Oe === Un && i.push(Xa);
        } else Ml && i.push(Xa);
        return i.push(Dt), $n(i, Ye, Ke), Ke;
      case "textarea":
        i.push(nn("textarea"));
        var bn = null, kt = null, pa = null, Fn;
        for (Fn in h)
          if (Ne.call(h, Fn)) {
            var ua = h[Fn];
            if (ua != null)
              switch (Fn) {
                case "children":
                  pa = ua;
                  break;
                case "value":
                  bn = ua;
                  break;
                case "defaultValue":
                  kt = ua;
                  break;
                case "dangerouslySetInnerHTML":
                  throw Error(f(91));
                default:
                  St(
                    i,
                    Fn,
                    ua
                  );
              }
          }
        if (bn === null && kt !== null && (bn = kt), i.push(Dt), pa != null) {
          if (bn != null) throw Error(f(92));
          if (xe(pa)) {
            if (1 < pa.length)
              throw Error(f(93));
            bn = "" + pa[0];
          }
          bn = "" + pa;
        }
        return typeof bn == "string" && bn[0] === `
` && i.push(hr), bn !== null && i.push(
          ue(Ce("" + bn))
        ), null;
      case "input":
        i.push(nn("input"));
        var qr = null, Lu = null, wi = null, Er = null, ku = null, mn = null, Pt = null, Cc = null, Hu = null, $r;
        for ($r in h)
          if (Ne.call(h, $r)) {
            var Ma = h[$r];
            if (Ma != null)
              switch ($r) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "input"));
                case "name":
                  qr = Ma;
                  break;
                case "formAction":
                  Lu = Ma;
                  break;
                case "formEncType":
                  wi = Ma;
                  break;
                case "formMethod":
                  Er = Ma;
                  break;
                case "formTarget":
                  ku = Ma;
                  break;
                case "defaultChecked":
                  Hu = Ma;
                  break;
                case "defaultValue":
                  Pt = Ma;
                  break;
                case "checked":
                  Cc = Ma;
                  break;
                case "value":
                  mn = Ma;
                  break;
                default:
                  St(
                    i,
                    $r,
                    Ma
                  );
              }
          }
        var lr = kr(
          i,
          b,
          T,
          Lu,
          wi,
          Er,
          ku,
          qr
        );
        return Cc !== null ? Nn(i, "checked", Cc) : Hu !== null && Nn(i, "checked", Hu), mn !== null ? St(i, "value", mn) : Pt !== null && St(i, "value", Pt), i.push(Ea), lr != null && lr.forEach(on, i), null;
      case "button":
        i.push(nn("button"));
        var eu = null, qo = null, $o = null, Ps = null, Ws = null, Js = null, Ks = null, Rc;
        for (Rc in h)
          if (Ne.call(h, Rc)) {
            var ar = h[Rc];
            if (ar != null)
              switch (Rc) {
                case "children":
                  eu = ar;
                  break;
                case "dangerouslySetInnerHTML":
                  qo = ar;
                  break;
                case "name":
                  $o = ar;
                  break;
                case "formAction":
                  Ps = ar;
                  break;
                case "formEncType":
                  Ws = ar;
                  break;
                case "formMethod":
                  Js = ar;
                  break;
                case "formTarget":
                  Ks = ar;
                  break;
                default:
                  St(
                    i,
                    Rc,
                    ar
                  );
              }
          }
        var es = kr(
          i,
          b,
          T,
          Ps,
          Ws,
          Js,
          Ks,
          $o
        );
        if (i.push(Dt), es != null && es.forEach(on, i), $n(i, qo, eu), typeof eu == "string") {
          i.push(
            ue(Ce(eu))
          );
          var js = null;
        } else js = eu;
        return js;
      case "form":
        i.push(nn("form"));
        var xo = null, qs = null, tu = null, Nc = null, Bu = null, Mc = null, zc;
        for (zc in h)
          if (Ne.call(h, zc)) {
            var wr = h[zc];
            if (wr != null)
              switch (zc) {
                case "children":
                  xo = wr;
                  break;
                case "dangerouslySetInnerHTML":
                  qs = wr;
                  break;
                case "action":
                  tu = wr;
                  break;
                case "encType":
                  Nc = wr;
                  break;
                case "method":
                  Bu = wr;
                  break;
                case "target":
                  Mc = wr;
                  break;
                default:
                  St(
                    i,
                    zc,
                    wr
                  );
              }
          }
        var ts = null, ns = null;
        if (typeof tu == "function") {
          var Uu = Ga(
            b,
            tu
          );
          Uu !== null ? (tu = Uu.action || "", Nc = Uu.encType, Bu = Uu.method, Mc = Uu.target, ts = Uu.data, ns = Uu.name) : (i.push(
            fn,
            ue("action"),
            ol,
            xa,
            zt
          ), Mc = Bu = Nc = tu = null, Ia(b, T));
        }
        if (tu != null && St(i, "action", tu), Nc != null && St(i, "encType", Nc), Bu != null && St(i, "method", Bu), Mc != null && St(i, "target", Mc), i.push(Dt), ns !== null && (i.push(nt), Zt(i, "name", ns), i.push(Ea), ts != null && ts.forEach(on, i)), $n(i, qs, xo), typeof xo == "string") {
          i.push(
            ue(Ce(xo))
          );
          var $s = null;
        } else $s = xo;
        return $s;
      case "menuitem":
        i.push(nn("menuitem"));
        for (var Ar in h)
          if (Ne.call(h, Ar)) {
            var ef = h[Ar];
            if (ef != null)
              switch (Ar) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(400));
                default:
                  St(
                    i,
                    Ar,
                    ef
                  );
              }
          }
        return i.push(Dt), null;
      case "object":
        i.push(nn("object"));
        var nu = null, Eo = null, Dc;
        for (Dc in h)
          if (Ne.call(h, Dc)) {
            var Fu = h[Dc];
            if (Fu != null)
              switch (Dc) {
                case "children":
                  nu = Fu;
                  break;
                case "dangerouslySetInnerHTML":
                  Eo = Fu;
                  break;
                case "data":
                  var jf = Ta("" + Fu);
                  if (jf === "") break;
                  i.push(
                    fn,
                    ue("data"),
                    ol,
                    ue(Ce(jf)),
                    zt
                  );
                  break;
                default:
                  St(
                    i,
                    Dc,
                    Fu
                  );
              }
          }
        if (i.push(Dt), $n(i, Eo, nu), typeof nu == "string") {
          i.push(
            ue(Ce(nu))
          );
          var tf = null;
        } else tf = nu;
        return tf;
      case "title":
        var qf = Z.tagScope & 1, $f = Z.tagScope & 4;
        if (Z.insertionMode === 4 || qf || h.itemProp != null)
          var ls = fi(
            i,
            h
          );
        else
          $f ? ls = null : (fi(T.hoistableChunks, h), ls = void 0);
        return ls;
      case "link":
        var ed = Z.tagScope & 1, nf = Z.tagScope & 4, td = h.rel, _r = h.href, Lc = h.precedence;
        if (Z.insertionMode === 4 || ed || h.itemProp != null || typeof td != "string" || typeof _r != "string" || _r === "") {
          dn(i, h);
          var kc = null;
        } else if (h.rel === "stylesheet")
          if (typeof Lc != "string" || h.disabled != null || h.onLoad || h.onError)
            kc = dn(
              i,
              h
            );
          else {
            var Yu = T.styles.get(Lc), as = b.styleResources.hasOwnProperty(_r) ? b.styleResources[_r] : void 0;
            if (as !== null) {
              b.styleResources[_r] = null, Yu || (Yu = {
                precedence: ue(Ce(Lc)),
                rules: [],
                hrefs: [],
                sheets: /* @__PURE__ */ new Map()
              }, T.styles.set(Lc, Yu));
              var Hc = {
                state: 0,
                props: _e({}, h, {
                  "data-precedence": h.precedence,
                  precedence: null
                })
              };
              if (as) {
                as.length === 2 && pr(Hc.props, as);
                var is = T.preloads.stylesheets.get(_r);
                is && 0 < is.length ? is.length = 0 : Hc.state = 1;
              }
              Yu.sheets.set(_r, Hc), M && M.stylesheets.add(Hc);
            } else if (Yu) {
              var lf = Yu.sheets.get(_r);
              lf && M && M.stylesheets.add(lf);
            }
            k && i.push(Rn), kc = null;
          }
        else
          h.onLoad || h.onError ? kc = dn(
            i,
            h
          ) : (k && i.push(Rn), kc = nf ? null : dn(T.hoistableChunks, h));
        return kc;
      case "script":
        var af = Z.tagScope & 1, rs = h.async;
        if (typeof h.src != "string" || !h.src || !rs || typeof rs == "function" || typeof rs == "symbol" || h.onLoad || h.onError || Z.insertionMode === 4 || af || h.itemProp != null)
          var rf = el(
            i,
            h
          );
        else {
          var us = h.src;
          if (h.type === "module")
            var cs = b.moduleScriptResources, uf = T.preloads.moduleScripts;
          else
            cs = b.scriptResources, uf = T.preloads.scripts;
          var lu = cs.hasOwnProperty(us) ? cs[us] : void 0;
          if (lu !== null) {
            cs[us] = null;
            var wo = h;
            if (lu) {
              lu.length === 2 && (wo = _e({}, h), pr(wo, lu));
              var Ao = uf.get(us);
              Ao && (Ao.length = 0);
            }
            var cf = [];
            T.scripts.add(cf), el(cf, wo);
          }
          k && i.push(Rn), rf = null;
        }
        return rf;
      case "style":
        var nd = Z.tagScope & 1, au = h.precedence, Gu = h.href, of = h.nonce;
        if (Z.insertionMode === 4 || nd || h.itemProp != null || typeof au != "string" || typeof Gu != "string" || Gu === "") {
          i.push(nn("style"));
          var Xu = null, os = null, Iu;
          for (Iu in h)
            if (Ne.call(h, Iu)) {
              var _o = h[Iu];
              if (_o != null)
                switch (Iu) {
                  case "children":
                    Xu = _o;
                    break;
                  case "dangerouslySetInnerHTML":
                    os = _o;
                    break;
                  default:
                    St(
                      i,
                      Iu,
                      _o
                    );
                }
            }
          i.push(Dt);
          var Bc = Array.isArray(Xu) ? 2 > Xu.length ? Xu[0] : null : Xu;
          typeof Bc != "function" && typeof Bc != "symbol" && Bc !== null && Bc !== void 0 && i.push(
            ue(("" + Bc).replace(ql, ga))
          ), $n(i, os, Xu), i.push(wl("style"));
          var iu = null;
        } else {
          var ru = T.styles.get(au);
          if ((b.styleResources.hasOwnProperty(Gu) ? b.styleResources[Gu] : void 0) !== null) {
            b.styleResources[Gu] = null, ru || (ru = {
              precedence: ue(
                Ce(au)
              ),
              rules: [],
              hrefs: [],
              sheets: /* @__PURE__ */ new Map()
            }, T.styles.set(au, ru));
            var sf = T.nonce.style;
            if (!sf || sf === of) {
              ru.hrefs.push(
                ue(Ce(Gu))
              );
              var ff = ru.rules, Or = null, df = null, Uc;
              for (Uc in h)
                if (Ne.call(h, Uc)) {
                  var ss = h[Uc];
                  if (ss != null)
                    switch (Uc) {
                      case "children":
                        Or = ss;
                        break;
                      case "dangerouslySetInnerHTML":
                        df = ss;
                    }
                }
              var Fc = Array.isArray(Or) ? 2 > Or.length ? Or[0] : null : Or;
              typeof Fc != "function" && typeof Fc != "symbol" && Fc !== null && Fc !== void 0 && ff.push(
                ue(
                  ("" + Fc).replace(ql, ga)
                )
              ), $n(ff, df, Or);
            }
          }
          ru && M && M.styles.add(ru), k && i.push(Rn), iu = void 0;
        }
        return iu;
      case "meta":
        var bh = Z.tagScope & 1, hf = Z.tagScope & 4;
        if (Z.insertionMode === 4 || bh || h.itemProp != null)
          var Yn = $l(
            i,
            h,
            "meta"
          );
        else
          k && i.push(Rn), Yn = hf ? null : typeof h.charSet == "string" ? $l(T.charsetChunks, h, "meta") : h.name === "viewport" ? $l(T.viewportChunks, h, "meta") : $l(T.hoistableChunks, h, "meta");
        return Yn;
      case "listing":
      case "pre":
        i.push(nn(u));
        var Gn = null, Yc = null, Gc;
        for (Gc in h)
          if (Ne.call(h, Gc)) {
            var Oo = h[Gc];
            if (Oo != null)
              switch (Gc) {
                case "children":
                  Gn = Oo;
                  break;
                case "dangerouslySetInnerHTML":
                  Yc = Oo;
                  break;
                default:
                  St(
                    i,
                    Gc,
                    Oo
                  );
              }
          }
        if (i.push(Dt), Yc != null) {
          if (Gn != null) throw Error(f(60));
          if (typeof Yc != "object" || !("__html" in Yc))
            throw Error(f(61));
          var uu = Yc.__html;
          uu != null && (typeof uu == "string" && 0 < uu.length && uu[0] === `
` ? i.push(hr, ue(uu)) : i.push(ue("" + uu)));
        }
        return typeof Gn == "string" && Gn[0] === `
` && i.push(hr), Gn;
      case "img":
        var Co = Z.tagScope & 3, zl = h.src, Wn = h.srcSet;
        if (!(h.loading === "lazy" || !zl && !Wn || typeof zl != "string" && zl != null || typeof Wn != "string" && Wn != null || h.fetchPriority === "low" || Co) && (typeof zl != "string" || zl[4] !== ":" || zl[0] !== "d" && zl[0] !== "D" || zl[1] !== "a" && zl[1] !== "A" || zl[2] !== "t" && zl[2] !== "T" || zl[3] !== "a" && zl[3] !== "A") && (typeof Wn != "string" || Wn[4] !== ":" || Wn[0] !== "d" && Wn[0] !== "D" || Wn[1] !== "a" && Wn[1] !== "A" || Wn[2] !== "t" && Wn[2] !== "T" || Wn[3] !== "a" && Wn[3] !== "A")) {
          M !== null && Z.tagScope & 64 && (M.suspenseyImages = !0);
          var gf = typeof h.sizes == "string" ? h.sizes : void 0, Xc = Wn ? Wn + `
` + (gf || "") : zl, Ic = T.preloads.images, Cr = Ic.get(Xc);
          if (Cr)
            (h.fetchPriority === "high" || 10 > T.highImagePreloads.size) && (Ic.delete(Xc), T.highImagePreloads.add(Cr));
          else if (!b.imageResources.hasOwnProperty(Xc)) {
            b.imageResources[Xc] = In;
            var fs = h.crossOrigin, vf = typeof fs == "string" ? fs === "use-credentials" ? fs : "" : void 0, cu = T.headers, Ro;
            cu && 0 < cu.remainingCapacity && typeof h.srcSet != "string" && (h.fetchPriority === "high" || 500 > cu.highImagePreloads.length) && (Ro = wu(zl, "image", {
              imageSrcSet: h.srcSet,
              imageSizes: h.sizes,
              crossOrigin: vf,
              integrity: h.integrity,
              nonce: h.nonce,
              type: h.type,
              fetchPriority: h.fetchPriority,
              referrerPolicy: h.refererPolicy
            }), 0 <= (cu.remainingCapacity -= Ro.length + 2)) ? (T.resets.image[Xc] = In, cu.highImagePreloads && (cu.highImagePreloads += ", "), cu.highImagePreloads += Ro) : (Cr = [], dn(Cr, {
              rel: "preload",
              as: "image",
              href: Wn ? void 0 : zl,
              imageSrcSet: Wn,
              imageSizes: gf,
              crossOrigin: vf,
              integrity: h.integrity,
              type: h.type,
              fetchPriority: h.fetchPriority,
              referrerPolicy: h.referrerPolicy
            }), h.fetchPriority === "high" || 10 > T.highImagePreloads.size ? T.highImagePreloads.add(Cr) : (T.bulkPreloads.add(Cr), Ic.set(Xc, Cr)));
          }
        }
        return $l(i, h, "img");
      case "base":
      case "area":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "param":
      case "source":
      case "track":
      case "wbr":
        return $l(i, h, u);
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        break;
      case "head":
        if (2 > Z.insertionMode) {
          var No = O || T.preamble;
          if (No.headChunks)
            throw Error(f(545, "`<head>`"));
          O !== null && i.push(dr), No.headChunks = [];
          var ds = Bl(
            No.headChunks,
            h,
            "head"
          );
        } else
          ds = Sn(
            i,
            h,
            "head"
          );
        return ds;
      case "body":
        if (2 > Z.insertionMode) {
          var hs = O || T.preamble;
          if (hs.bodyChunks)
            throw Error(f(545, "`<body>`"));
          O !== null && i.push(ki), hs.bodyChunks = [];
          var gs = Bl(
            hs.bodyChunks,
            h,
            "body"
          );
        } else
          gs = Sn(
            i,
            h,
            "body"
          );
        return gs;
      case "html":
        if (Z.insertionMode === 0) {
          var Zc = O || T.preamble;
          if (Zc.htmlChunks)
            throw Error(f(545, "`<html>`"));
          O !== null && i.push(El), Zc.htmlChunks = [va];
          var vs = Bl(
            Zc.htmlChunks,
            h,
            "html"
          );
        } else
          vs = Sn(
            i,
            h,
            "html"
          );
        return vs;
      default:
        if (u.indexOf("-") !== -1) {
          i.push(nn(u));
          var ys = null, bs = null, Zu;
          for (Zu in h)
            if (Ne.call(h, Zu)) {
              var rl = h[Zu];
              if (rl != null) {
                var ms = Zu;
                switch (Zu) {
                  case "children":
                    ys = rl;
                    break;
                  case "dangerouslySetInnerHTML":
                    bs = rl;
                    break;
                  case "style":
                    oi(i, rl);
                    break;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "ref":
                    break;
                  case "className":
                    ms = "class";
                  default:
                    if (kl(Zu) && typeof rl != "function" && typeof rl != "symbol" && rl !== !1) {
                      if (rl === !0) rl = "";
                      else if (typeof rl == "object") continue;
                      i.push(
                        fn,
                        ue(ms),
                        ol,
                        ue(Ce(rl)),
                        zt
                      );
                    }
                }
              }
            }
          return i.push(Dt), $n(i, bs, ys), ys;
        }
    }
    return Sn(i, h, u);
  }
  var tl = /* @__PURE__ */ new Map();
  function wl(i) {
    var u = tl.get(i);
    return u === void 0 && (u = Q("</" + i + ">"), tl.set(i, u)), u;
  }
  function Hi(i, u) {
    i = i.preamble, i.htmlChunks === null && u.htmlChunks && (i.htmlChunks = u.htmlChunks), i.headChunks === null && u.headChunks && (i.headChunks = u.headChunks), i.bodyChunks === null && u.bodyChunks && (i.bodyChunks = u.bodyChunks);
  }
  function be(i, u) {
    u = u.bootstrapChunks;
    for (var h = 0; h < u.length - 1; h++)
      U(i, u[h]);
    return h < u.length ? (h = u[h], u.length = 0, P(i, h)) : !0;
  }
  var D = Q(
    "requestAnimationFrame(function(){$RT=performance.now()});"
  ), W = Q('<template id="'), me = Q('"></template>'), Ee = Q("<!--&-->"), We = Q("<!--/&-->"), ot = Q("<!--$-->"), xn = Q(
    '<!--$?--><template id="'
  ), ln = Q('"></template>'), Ht = Q("<!--$!-->"), Wt = Q("<!--/$-->"), Bi = Q("<template"), Bt = Q('"'), Br = Q(' data-dgst="');
  Q(' data-msg="'), Q(' data-stck="'), Q(' data-cstck="');
  var so = Q("></template>");
  function gr(i, u, h) {
    if (U(i, xn), h === null) throw Error(f(395));
    return U(i, u.boundaryPrefix), U(i, ue(h.toString(16))), P(i, ln);
  }
  var Ul = Q('<div hidden id="'), ac = Q('">'), vu = Q("</div>"), ic = Q(
    '<svg aria-hidden="true" style="display:none" id="'
  ), Ui = Q('">'), dt = Q("</svg>"), vr = Q(
    '<math aria-hidden="true" style="display:none" id="'
  ), Fi = Q('">'), ya = Q("</math>"), yr = Q('<table hidden id="'), Yi = Q('">'), yu = Q("</table>"), hi = Q('<table hidden><tbody id="'), wa = Q('">'), bu = Q("</tbody></table>"), hn = Q('<table hidden><tr id="'), Gi = Q('">'), Ur = Q("</tr></table>"), Za = Q(
    '<table hidden><colgroup id="'
  ), mu = Q('">'), rc = Q("</colgroup></table>");
  function uc(i, u, h, b) {
    switch (h.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return U(i, Ul), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, ac);
      case 4:
        return U(i, ic), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, Ui);
      case 5:
        return U(i, vr), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, Fi);
      case 6:
        return U(i, yr), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, Yi);
      case 7:
        return U(i, hi), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, wa);
      case 8:
        return U(i, hn), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, Gi);
      case 9:
        return U(i, Za), U(i, u.segmentPrefix), U(i, ue(b.toString(16))), P(i, mu);
      default:
        throw Error(f(397));
    }
  }
  function Fr(i, u) {
    switch (u.insertionMode) {
      case 0:
      case 1:
      case 3:
      case 2:
        return P(i, vu);
      case 4:
        return P(i, dt);
      case 5:
        return P(i, ya);
      case 6:
        return P(i, yu);
      case 7:
        return P(i, bu);
      case 8:
        return P(i, Ur);
      case 9:
        return P(i, rc);
      default:
        throw Error(f(397));
    }
  }
  var cc = Q(
    '$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'
  ), Qo = Q('$RS("'), Ys = Q('","'), Gs = Q('")<\/script>');
  Q('<template data-rsi="" data-sid="'), Q('" data-pid="');
  var fo = Q(
    `$RB=[];$RV=function(a){$RT=performance.now();for(var b=0;b<a.length;b+=2){var c=a[b],e=a[b+1];null!==e.parentNode&&e.parentNode.removeChild(e);var f=c.parentNode;if(f){var g=c.previousSibling,h=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d||"/&"===d)if(0===h)break;else h--;else"$"!==d&&"$?"!==d&&"$~"!==d&&"$!"!==d&&"&"!==d||h++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;e.firstChild;)f.insertBefore(e.firstChild,c);g.data="$";g._reactRetry&&requestAnimationFrame(g._reactRetry)}}a.length=0};
$RC=function(a,b){if(b=document.getElementById(b))(a=document.getElementById(a))?(a.previousSibling.data="$~",$RB.push(a,b),2===$RB.length&&("number"!==typeof $RT?requestAnimationFrame($RV.bind(null,$RB)):(a=performance.now(),setTimeout($RV.bind(null,$RB),2300>a&&2E3<a?2300-a:$RT+300-a)))):b.parentNode.removeChild(b)};`
  );
  ue(
    `$RV=function(A,g){function k(a,b){var e=a.getAttribute(b);e&&(b=a.style,l.push(a,b.viewTransitionName,b.viewTransitionClass),"auto"!==e&&(b.viewTransitionClass=e),(a=a.getAttribute("vt-name"))||(a="_T_"+K++ +"_"),b.viewTransitionName=a,B=!0)}var B=!1,K=0,l=[];try{var f=document.__reactViewTransition;if(f){f.finished.finally($RV.bind(null,g));return}var m=new Map;for(f=1;f<g.length;f+=2)for(var h=g[f].querySelectorAll("[vt-share]"),d=0;d<h.length;d++){var c=h[d];m.set(c.getAttribute("vt-name"),c)}var u=[];for(h=0;h<g.length;h+=2){var C=g[h],x=C.parentNode;if(x){var v=x.getBoundingClientRect();if(v.left||v.top||v.width||v.height){c=C;for(f=0;c;){if(8===c.nodeType){var r=c.data;if("/$"===r)if(0===f)break;else f--;else"$"!==r&&"$?"!==r&&"$~"!==r&&"$!"!==r||f++}else if(1===c.nodeType){d=c;var D=d.getAttribute("vt-name"),y=m.get(D);k(d,y?"vt-share":"vt-exit");y&&(k(y,"vt-share"),m.set(D,null));var E=d.querySelectorAll("[vt-share]");for(d=0;d<E.length;d++){var F=E[d],G=F.getAttribute("vt-name"),
H=m.get(G);H&&(k(F,"vt-share"),k(H,"vt-share"),m.set(G,null))}}c=c.nextSibling}for(var I=g[h+1],t=I.firstElementChild;t;)null!==m.get(t.getAttribute("vt-name"))&&k(t,"vt-enter"),t=t.nextElementSibling;c=x;do for(var n=c.firstElementChild;n;){var J=n.getAttribute("vt-update");J&&"none"!==J&&!l.includes(n)&&k(n,"vt-update");n=n.nextElementSibling}while((c=c.parentNode)&&1===c.nodeType&&"none"!==c.getAttribute("vt-update"));u.push.apply(u,I.querySelectorAll('img[src]:not([loading="lazy"])'))}}}if(B){var z=
document.__reactViewTransition=document.startViewTransition({update:function(){A(g);for(var a=[document.documentElement.clientHeight,document.fonts.ready],b={},e=0;e<u.length;b={g:b.g},e++)if(b.g=u[e],!b.g.complete){var p=b.g.getBoundingClientRect();0<p.bottom&&0<p.right&&p.top<window.innerHeight&&p.left<window.innerWidth&&(p=new Promise(function(w){return function(q){w.g.addEventListener("load",q);w.g.addEventListener("error",q)}}(b)),a.push(p))}return Promise.race([Promise.all(a),new Promise(function(w){var q=
performance.now();setTimeout(w,2300>q&&2E3<q?2300-q:500)})])},types:[]});z.ready.finally(function(){for(var a=l.length-3;0<=a;a-=3){var b=l[a],e=b.style;e.viewTransitionName=l[a+1];e.viewTransitionClass=l[a+1];""===b.getAttribute("style")&&b.removeAttribute("style")}});z.finished.finally(function(){document.__reactViewTransition===z&&(document.__reactViewTransition=null)});$RB=[];return}}catch(a){}A(g)}.bind(null,$RV);`
  );
  var oc = Q('$RC("'), Xs = Q(
    `$RM=new Map;$RR=function(n,w,p){function u(q){this._p=null;q()}for(var r=new Map,t=document,h,b,e=t.querySelectorAll("link[data-precedence],style[data-precedence]"),v=[],k=0;b=e[k++];)"not all"===b.getAttribute("media")?v.push(b):("LINK"===b.tagName&&$RM.set(b.getAttribute("href"),b),r.set(b.dataset.precedence,h=b));e=0;b=[];var l,a;for(k=!0;;){if(k){var f=p[e++];if(!f){k=!1;e=0;continue}var c=!1,m=0;var d=f[m++];if(a=$RM.get(d)){var g=a._p;c=!0}else{a=t.createElement("link");a.href=d;a.rel=
"stylesheet";for(a.dataset.precedence=l=f[m++];g=f[m++];)a.setAttribute(g,f[m++]);g=a._p=new Promise(function(q,x){a.onload=u.bind(a,q);a.onerror=u.bind(a,x)});$RM.set(d,a)}d=a.getAttribute("media");!g||d&&!matchMedia(d).matches||b.push(g);if(c)continue}else{a=v[e++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=r.get(l)||h;c===h&&(h=a);r.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=t.head,c.insertBefore(a,c.firstChild))}if(p=document.getElementById(n))p.previousSibling.data=
"$~";Promise.all(b).then($RC.bind(null,n,w),$RX.bind(null,n,"CSS failed to load"))};$RR("`
  ), Po = Q('$RR("'), sc = Q('","'), Is = Q('",'), ho = Q('"'), go = Q(")<\/script>");
  Q('<template data-rci="" data-bid="'), Q('<template data-rri="" data-bid="'), Q('" data-sid="'), Q('" data-sty="');
  var Yr = Q(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};'
  ), vo = Q(
    '$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'
  ), fc = Q('$RX("'), Wo = Q('"'), Xi = Q(","), Zs = Q(")<\/script>");
  Q('<template data-rxi="" data-bid="'), Q('" data-dgst="'), Q('" data-msg="'), Q('" data-stck="'), Q('" data-cstck="');
  var Vs = /[<\u2028\u2029]/g;
  function Qs(i) {
    return JSON.stringify(i).replace(
      Vs,
      function(u) {
        switch (u) {
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var Vn = /[&><\u2028\u2029]/g;
  function Gr(i) {
    return JSON.stringify(i).replace(
      Vn,
      function(u) {
        switch (u) {
          case "&":
            return "\\u0026";
          case ">":
            return "\\u003e";
          case "<":
            return "\\u003c";
          case "\u2028":
            return "\\u2028";
          case "\u2029":
            return "\\u2029";
          default:
            throw Error(
              "escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
            );
        }
      }
    );
  }
  var yo = Q(
    ' media="not all" data-precedence="'
  ), dc = Q('" data-href="'), Jo = Q('">'), br = Q("</style>"), Ii = !1, pu = !0;
  function Zi(i) {
    var u = i.rules, h = i.hrefs, b = 0;
    if (h.length) {
      for (U(this, cl.startInlineStyle), U(this, yo), U(this, i.precedence), U(this, dc); b < h.length - 1; b++)
        U(this, h[b]), U(this, gc);
      for (U(this, h[b]), U(this, Jo), b = 0; b < u.length; b++) U(this, u[b]);
      pu = P(
        this,
        br
      ), Ii = !0, u.length = 0, h.length = 0;
    }
  }
  function sl(i) {
    return i.state !== 2 ? Ii = !0 : !1;
  }
  function Vi(i, u, h) {
    return Ii = !1, pu = !0, cl = h, u.styles.forEach(Zi, i), cl = null, u.stylesheets.forEach(sl), Ii && (h.stylesToHoist = !0), pu;
  }
  function Ct(i) {
    for (var u = 0; u < i.length; u++) U(this, i[u]);
    i.length = 0;
  }
  var Va = [];
  function hc(i) {
    dn(Va, i.props);
    for (var u = 0; u < Va.length; u++)
      U(this, Va[u]);
    Va.length = 0, i.state = 2;
  }
  var Xr = Q(' data-precedence="'), bo = Q('" data-href="'), gc = Q(" "), mo = Q('">'), gi = Q("</style>");
  function vc(i) {
    var u = 0 < i.sheets.size;
    i.sheets.forEach(hc, this), i.sheets.clear();
    var h = i.rules, b = i.hrefs;
    if (!u || b.length) {
      if (U(this, cl.startInlineStyle), U(this, Xr), U(this, i.precedence), i = 0, b.length) {
        for (U(this, bo); i < b.length - 1; i++)
          U(this, b[i]), U(this, gc);
        U(this, b[i]);
      }
      for (U(this, mo), i = 0; i < h.length; i++)
        U(this, h[i]);
      U(this, gi), h.length = 0, b.length = 0;
    }
  }
  function ba(i) {
    if (i.state === 0) {
      i.state = 1;
      var u = i.props;
      for (dn(Va, {
        rel: "preload",
        as: "style",
        href: i.props.href,
        crossOrigin: u.crossOrigin,
        fetchPriority: u.fetchPriority,
        integrity: u.integrity,
        media: u.media,
        hrefLang: u.hrefLang,
        referrerPolicy: u.referrerPolicy
      }), i = 0; i < Va.length; i++)
        U(this, Va[i]);
      Va.length = 0;
    }
  }
  function po(i) {
    i.sheets.forEach(ba, this), i.sheets.clear();
  }
  Q('<link rel="expect" href="#'), Q('" blocking="render"/>');
  var Tu = Q(' id="');
  function Ir(i, u) {
    (u.instructions & 32) === 0 && (u.instructions |= 32, i.push(
      Tu,
      ue(Ce("_" + u.idPrefix + "R_")),
      zt
    ));
  }
  var Qi = Q("["), Pi = Q(",["), yc = Q(","), mr = Q("]");
  function Ln(i, u) {
    U(i, Qi);
    var h = Qi;
    u.stylesheets.forEach(function(b) {
      if (b.state !== 2)
        if (b.state === 3)
          U(i, h), U(
            i,
            ue(
              Gr("" + b.props.href)
            )
          ), U(i, mr), h = Pi;
        else {
          U(i, h);
          var T = b.props["data-precedence"], O = b.props, M = Ta("" + b.props.href);
          U(
            i,
            ue(Gr(M))
          ), T = "" + T, U(i, yc), U(
            i,
            ue(Gr(T))
          );
          for (var Z in O)
            if (Ne.call(O, Z) && (T = O[Z], T != null))
              switch (Z) {
                case "href":
                case "rel":
                case "precedence":
                case "data-precedence":
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(f(399, "link"));
                default:
                  Ko(
                    i,
                    Z,
                    T
                  );
              }
          U(i, mr), h = Pi, b.state = 3;
        }
    }), U(i, mr);
  }
  function Ko(i, u, h) {
    var b = u.toLowerCase();
    switch (typeof h) {
      case "function":
      case "symbol":
        return;
    }
    switch (u) {
      case "innerHTML":
      case "dangerouslySetInnerHTML":
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "style":
      case "ref":
        return;
      case "className":
        b = "class", u = "" + h;
        break;
      case "hidden":
        if (h === !1) return;
        u = "";
        break;
      case "src":
      case "href":
        h = Ta(h), u = "" + h;
        break;
      default:
        if (2 < u.length && (u[0] === "o" || u[0] === "O") && (u[1] === "n" || u[1] === "N") || !kl(u))
          return;
        u = "" + h;
    }
    U(i, yc), U(
      i,
      ue(Gr(b))
    ), U(i, yc), U(
      i,
      ue(Gr(u))
    );
  }
  function vi() {
    return { styles: /* @__PURE__ */ new Set(), stylesheets: /* @__PURE__ */ new Set(), suspenseyImages: !1 };
  }
  function Su(i) {
    var u = Kt || null;
    if (u) {
      var h = u.resumableState, b = u.renderState;
      if (typeof i == "string" && i) {
        if (!h.dnsResources.hasOwnProperty(i)) {
          h.dnsResources[i] = null, h = b.headers;
          var T, O;
          (O = h && 0 < h.remainingCapacity) && (O = (T = "<" + ("" + i).replace(
            kn,
            Qa
          ) + ">; rel=dns-prefetch", 0 <= (h.remainingCapacity -= T.length + 2))), O ? (b.resets.dns[i] = null, h.preconnects && (h.preconnects += ", "), h.preconnects += T) : (T = [], dn(T, { href: i, rel: "dns-prefetch" }), b.preconnects.add(T));
        }
        vl(u);
      }
    } else ul.D(i);
  }
  function bc(i, u) {
    var h = Kt || null;
    if (h) {
      var b = h.resumableState, T = h.renderState;
      if (typeof i == "string" && i) {
        var O = u === "use-credentials" ? "credentials" : typeof u == "string" ? "anonymous" : "default";
        if (!b.connectResources[O].hasOwnProperty(i)) {
          b.connectResources[O][i] = null, b = T.headers;
          var M, Z;
          if (Z = b && 0 < b.remainingCapacity) {
            if (Z = "<" + ("" + i).replace(
              kn,
              Qa
            ) + ">; rel=preconnect", typeof u == "string") {
              var k = ("" + u).replace(
                Ji,
                Ki
              );
              Z += '; crossorigin="' + k + '"';
            }
            Z = (M = Z, 0 <= (b.remainingCapacity -= M.length + 2));
          }
          Z ? (T.resets.connect[O][i] = null, b.preconnects && (b.preconnects += ", "), b.preconnects += M) : (O = [], dn(O, {
            rel: "preconnect",
            href: i,
            crossOrigin: u
          }), T.preconnects.add(O));
        }
        vl(h);
      }
    } else ul.C(i, u);
  }
  function mc(i, u, h) {
    var b = Kt || null;
    if (b) {
      var T = b.resumableState, O = b.renderState;
      if (u && i) {
        switch (u) {
          case "image":
            if (h)
              var M = h.imageSrcSet, Z = h.imageSizes, k = h.fetchPriority;
            var X = M ? M + `
` + (Z || "") : i;
            if (T.imageResources.hasOwnProperty(X)) return;
            T.imageResources[X] = In, T = O.headers;
            var J;
            T && 0 < T.remainingCapacity && typeof M != "string" && k === "high" && (J = wu(i, u, h), 0 <= (T.remainingCapacity -= J.length + 2)) ? (O.resets.image[X] = In, T.highImagePreloads && (T.highImagePreloads += ", "), T.highImagePreloads += J) : (T = [], dn(
              T,
              _e(
                { rel: "preload", href: M ? void 0 : i, as: u },
                h
              )
            ), k === "high" ? O.highImagePreloads.add(T) : (O.bulkPreloads.add(T), O.preloads.images.set(X, T)));
            break;
          case "style":
            if (T.styleResources.hasOwnProperty(i)) return;
            M = [], dn(
              M,
              _e({ rel: "preload", href: i, as: u }, h)
            ), T.styleResources[i] = !h || typeof h.crossOrigin != "string" && typeof h.integrity != "string" ? In : [h.crossOrigin, h.integrity], O.preloads.stylesheets.set(i, M), O.bulkPreloads.add(M);
            break;
          case "script":
            if (T.scriptResources.hasOwnProperty(i)) return;
            M = [], O.preloads.scripts.set(i, M), O.bulkPreloads.add(M), dn(
              M,
              _e({ rel: "preload", href: i, as: u }, h)
            ), T.scriptResources[i] = !h || typeof h.crossOrigin != "string" && typeof h.integrity != "string" ? In : [h.crossOrigin, h.integrity];
            break;
          default:
            if (T.unknownResources.hasOwnProperty(u)) {
              if (M = T.unknownResources[u], M.hasOwnProperty(i))
                return;
            } else
              M = {}, T.unknownResources[u] = M;
            if (M[i] = In, (T = O.headers) && 0 < T.remainingCapacity && u === "font" && (X = wu(i, u, h), 0 <= (T.remainingCapacity -= X.length + 2)))
              O.resets.font[i] = In, T.fontPreloads && (T.fontPreloads += ", "), T.fontPreloads += X;
            else
              switch (T = [], i = _e({ rel: "preload", href: i, as: u }, h), dn(T, i), u) {
                case "font":
                  O.fontPreloads.add(T);
                  break;
                default:
                  O.bulkPreloads.add(T);
              }
        }
        vl(b);
      }
    } else ul.L(i, u, h);
  }
  function xu(i, u) {
    var h = Kt || null;
    if (h) {
      var b = h.resumableState, T = h.renderState;
      if (i) {
        var O = u && typeof u.as == "string" ? u.as : "script";
        switch (O) {
          case "script":
            if (b.moduleScriptResources.hasOwnProperty(i)) return;
            O = [], b.moduleScriptResources[i] = !u || typeof u.crossOrigin != "string" && typeof u.integrity != "string" ? In : [u.crossOrigin, u.integrity], T.preloads.moduleScripts.set(i, O);
            break;
          default:
            if (b.moduleUnknownResources.hasOwnProperty(O)) {
              var M = b.unknownResources[O];
              if (M.hasOwnProperty(i)) return;
            } else
              M = {}, b.moduleUnknownResources[O] = M;
            O = [], M[i] = In;
        }
        dn(O, _e({ rel: "modulepreload", href: i }, u)), T.bulkPreloads.add(O), vl(h);
      }
    } else ul.m(i, u);
  }
  function Eu(i, u, h) {
    var b = Kt || null;
    if (b) {
      var T = b.resumableState, O = b.renderState;
      if (i) {
        u = u || "default";
        var M = O.styles.get(u), Z = T.styleResources.hasOwnProperty(i) ? T.styleResources[i] : void 0;
        Z !== null && (T.styleResources[i] = null, M || (M = {
          precedence: ue(Ce(u)),
          rules: [],
          hrefs: [],
          sheets: /* @__PURE__ */ new Map()
        }, O.styles.set(u, M)), u = {
          state: 0,
          props: _e(
            { rel: "stylesheet", href: i, "data-precedence": u },
            h
          )
        }, Z && (Z.length === 2 && pr(u.props, Z), (O = O.preloads.stylesheets.get(i)) && 0 < O.length ? O.length = 0 : u.state = 1), M.sheets.set(i, u), vl(b));
      }
    } else ul.S(i, u, h);
  }
  function Wi(i, u) {
    var h = Kt || null;
    if (h) {
      var b = h.resumableState, T = h.renderState;
      if (i) {
        var O = b.scriptResources.hasOwnProperty(i) ? b.scriptResources[i] : void 0;
        O !== null && (b.scriptResources[i] = null, u = _e({ src: i, async: !0 }, u), O && (O.length === 2 && pr(u, O), i = T.preloads.scripts.get(i)) && (i.length = 0), i = [], T.scripts.add(i), el(i, u), vl(h));
      }
    } else ul.X(i, u);
  }
  function jo(i, u) {
    var h = Kt || null;
    if (h) {
      var b = h.resumableState, T = h.renderState;
      if (i) {
        var O = b.moduleScriptResources.hasOwnProperty(
          i
        ) ? b.moduleScriptResources[i] : void 0;
        O !== null && (b.moduleScriptResources[i] = null, u = _e({ src: i, type: "module", async: !0 }, u), O && (O.length === 2 && pr(u, O), i = T.preloads.moduleScripts.get(i)) && (i.length = 0), i = [], T.scripts.add(i), el(i, u), vl(h));
      }
    } else ul.M(i, u);
  }
  function pr(i, u) {
    i.crossOrigin == null && (i.crossOrigin = u[0]), i.integrity == null && (i.integrity = u[1]);
  }
  function wu(i, u, h) {
    i = ("" + i).replace(
      kn,
      Qa
    ), u = ("" + u).replace(
      Ji,
      Ki
    ), u = "<" + i + '>; rel=preload; as="' + u + '"';
    for (var b in h)
      Ne.call(h, b) && (i = h[b], typeof i == "string" && (u += "; " + b.toLowerCase() + '="' + ("" + i).replace(
        Ji,
        Ki
      ) + '"'));
    return u;
  }
  var kn = /[<>\r\n]/g;
  function Qa(i) {
    switch (i) {
      case "<":
        return "%3C";
      case ">":
        return "%3E";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  var Ji = /["';,\r\n]/g;
  function Ki(i) {
    switch (i) {
      case '"':
        return "%22";
      case "'":
        return "%27";
      case ";":
        return "%3B";
      case ",":
        return "%2C";
      case `
`:
        return "%0A";
      case "\r":
        return "%0D";
      default:
        throw Error(
          "escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React"
        );
    }
  }
  function pc(i) {
    this.styles.add(i);
  }
  function To(i) {
    this.stylesheets.add(i);
  }
  function yi(i, u) {
    u.styles.forEach(pc, i), u.stylesheets.forEach(To, i), u.suspenseyImages && (i.suspenseyImages = !0);
  }
  function Au(i) {
    return 0 < i.stylesheets.size || i.suspenseyImages;
  }
  var bi = Function.prototype.bind, mi = Symbol.for("react.client.reference");
  function ji(i) {
    if (i == null) return null;
    if (typeof i == "function")
      return i.$$typeof === mi ? null : i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case p:
        return "Fragment";
      case _:
        return "Profiler";
      case w:
        return "StrictMode";
      case I:
        return "Suspense";
      case F:
        return "SuspenseList";
      case he:
        return "Activity";
    }
    if (typeof i == "object")
      switch (i.$$typeof) {
        case y:
          return "Portal";
        case z:
          return i.displayName || "Context";
        case C:
          return (i._context.displayName || "Context") + ".Consumer";
        case B:
          var u = i.render;
          return i = i.displayName, i || (i = u.displayName || u.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
        case ce:
          return u = i.displayName || null, u !== null ? u : ji(i.type) || "Memo";
        case ae:
          u = i._payload, i = i._init;
          try {
            return ji(i(u));
          } catch {
          }
      }
    return null;
  }
  var Tc = {}, Aa = null;
  function Pa(i, u) {
    if (i !== u) {
      i.context._currentValue = i.parentValue, i = i.parent;
      var h = u.parent;
      if (i === null) {
        if (h !== null) throw Error(f(401));
      } else {
        if (h === null) throw Error(f(401));
        Pa(i, h);
      }
      u.context._currentValue = u.value;
    }
  }
  function qi(i) {
    i.context._currentValue = i.parentValue, i = i.parent, i !== null && qi(i);
  }
  function r(i) {
    var u = i.parent;
    u !== null && r(u), i.context._currentValue = i.value;
  }
  function c(i, u) {
    if (i.context._currentValue = i.parentValue, i = i.parent, i === null) throw Error(f(402));
    i.depth === u.depth ? Pa(i, u) : c(i, u);
  }
  function g(i, u) {
    var h = u.parent;
    if (h === null) throw Error(f(402));
    i.depth === h.depth ? Pa(i, h) : g(i, h), u.context._currentValue = u.value;
  }
  function m(i) {
    var u = Aa;
    u !== i && (u === null ? r(i) : i === null ? qi(u) : u.depth === i.depth ? Pa(u, i) : u.depth > i.depth ? c(u, i) : g(u, i), Aa = i);
  }
  var x = {
    enqueueSetState: function(i, u) {
      i = i._reactInternals, i.queue !== null && i.queue.push(u);
    },
    enqueueReplaceState: function(i, u) {
      i = i._reactInternals, i.replace = !0, i.queue = [u];
    },
    enqueueForceUpdate: function() {
    }
  }, N = { id: 1, overflow: "" };
  function L(i, u, h) {
    var b = i.id;
    i = i.overflow;
    var T = 32 - ee(b) - 1;
    b &= ~(1 << T), h += 1;
    var O = 32 - ee(u) + T;
    if (30 < O) {
      var M = T - T % 5;
      return O = (b & (1 << M) - 1).toString(32), b >>= M, T -= M, {
        id: 1 << 32 - ee(u) + T | h << T | b,
        overflow: O + i
      };
    }
    return {
      id: 1 << O | h << T | b,
      overflow: i
    };
  }
  var ee = Math.clz32 ? Math.clz32 : se, Y = Math.log, te = Math.LN2;
  function se(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (Y(i) / te | 0) | 0;
  }
  function ie() {
  }
  var ve = Error(f(460));
  function Be(i, u, h) {
    switch (h = i[h], h === void 0 ? i.push(u) : h !== u && (u.then(ie, ie), u = h), u.status) {
      case "fulfilled":
        return u.value;
      case "rejected":
        throw u.reason;
      default:
        switch (typeof u.status == "string" ? u.then(ie, ie) : (i = u, i.status = "pending", i.then(
          function(b) {
            if (u.status === "pending") {
              var T = u;
              T.status = "fulfilled", T.value = b;
            }
          },
          function(b) {
            if (u.status === "pending") {
              var T = u;
              T.status = "rejected", T.reason = b;
            }
          }
        )), u.status) {
          case "fulfilled":
            return u.value;
          case "rejected":
            throw u.reason;
        }
        throw Ie = u, ve;
    }
  }
  var Ie = null;
  function Ze() {
    if (Ie === null) throw Error(f(459));
    var i = Ie;
    return Ie = null, i;
  }
  function je(i, u) {
    return i === u && (i !== 0 || 1 / i === 1 / u) || i !== i && u !== u;
  }
  var Qe = typeof Object.is == "function" ? Object.is : je, qe = null, Qt = null, Lt = null, ht = null, gt = null, lt = null, Fl = !1, Pe = !1, Al = 0, rt = 0, En = -1, gn = 0, Rt = null, nl = null, $i = 0;
  function _l() {
    if (qe === null)
      throw Error(f(321));
    return qe;
  }
  function Zr() {
    if (0 < $i) throw Error(f(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ll() {
    return lt === null ? gt === null ? (Fl = !1, gt = lt = Zr()) : (Fl = !0, lt = gt) : lt.next === null ? (Fl = !1, lt = lt.next = Zr()) : (Fl = !0, lt = lt.next), lt;
  }
  function wn() {
    var i = Rt;
    return Rt = null, i;
  }
  function al() {
    ht = Lt = Qt = qe = null, Pe = !1, gt = null, $i = 0, lt = nl = null;
  }
  function Yl(i, u) {
    return typeof u == "function" ? u(i) : u;
  }
  function Ol(i, u, h) {
    if (qe = _l(), lt = ll(), Fl) {
      var b = lt.queue;
      if (u = b.dispatch, nl !== null && (h = nl.get(b), h !== void 0)) {
        nl.delete(b), b = lt.memoizedState;
        do
          b = i(b, h.action), h = h.next;
        while (h !== null);
        return lt.memoizedState = b, [b, u];
      }
      return [lt.memoizedState, u];
    }
    return i = i === Yl ? typeof u == "function" ? u() : u : h !== void 0 ? h(u) : u, lt.memoizedState = i, i = lt.queue = { last: null, dispatch: null }, i = i.dispatch = Hn.bind(
      null,
      qe,
      i
    ), [lt.memoizedState, i];
  }
  function Mn(i, u) {
    if (qe = _l(), lt = ll(), u = u === void 0 ? null : u, lt !== null) {
      var h = lt.memoizedState;
      if (h !== null && u !== null) {
        var b = h[1];
        e: if (b === null) b = !1;
        else {
          for (var T = 0; T < b.length && T < u.length; T++)
            if (!Qe(u[T], b[T])) {
              b = !1;
              break e;
            }
          b = !0;
        }
        if (b) return h[0];
      }
    }
    return i = i(), lt.memoizedState = [i, u], i;
  }
  function Hn(i, u, h) {
    if (25 <= $i) throw Error(f(301));
    if (i === qe)
      if (Pe = !0, i = { action: h, next: null }, nl === null && (nl = /* @__PURE__ */ new Map()), h = nl.get(u), h === void 0)
        nl.set(u, i);
      else {
        for (u = h; u.next !== null; ) u = u.next;
        u.next = i;
      }
  }
  function Jt() {
    throw Error(f(440));
  }
  function fl() {
    throw Error(f(394));
  }
  function Gl() {
    throw Error(f(479));
  }
  function _a(i, u, h) {
    _l();
    var b = rt++, T = Lt;
    if (typeof i.$$FORM_ACTION == "function") {
      var O = null, M = ht;
      T = T.formState;
      var Z = i.$$IS_SIGNATURE_EQUAL;
      if (T !== null && typeof Z == "function") {
        var k = T[1];
        Z.call(i, T[2], T[3]) && (O = h !== void 0 ? "p" + h : "k" + we(
          JSON.stringify([M, null, b]),
          0
        ), k === O && (En = b, u = T[0]));
      }
      var X = i.bind(null, u);
      return i = function(ne) {
        X(ne);
      }, typeof X.$$FORM_ACTION == "function" && (i.$$FORM_ACTION = function(ne) {
        ne = X.$$FORM_ACTION(ne), h !== void 0 && (h += "", ne.action = h);
        var pe = ne.data;
        return pe && (O === null && (O = h !== void 0 ? "p" + h : "k" + we(
          JSON.stringify([
            M,
            null,
            b
          ]),
          0
        )), pe.append("$ACTION_KEY", O)), ne;
      }), [u, i, !1];
    }
    var J = i.bind(null, u);
    return [
      u,
      function(ne) {
        J(ne);
      },
      !1
    ];
  }
  function Sc(i) {
    var u = gn;
    return gn += 1, Rt === null && (Rt = []), Be(Rt, i, u);
  }
  function xc() {
    throw Error(f(393));
  }
  var _u = {
    readContext: function(i) {
      return i._currentValue;
    },
    use: function(i) {
      if (i !== null && typeof i == "object") {
        if (typeof i.then == "function") return Sc(i);
        if (i.$$typeof === z) return i._currentValue;
      }
      throw Error(f(438, String(i)));
    },
    useContext: function(i) {
      return _l(), i._currentValue;
    },
    useMemo: Mn,
    useReducer: Ol,
    useRef: function(i) {
      qe = _l(), lt = ll();
      var u = lt.memoizedState;
      return u === null ? (i = { current: i }, lt.memoizedState = i) : u;
    },
    useState: function(i) {
      return Ol(Yl, i);
    },
    useInsertionEffect: ie,
    useLayoutEffect: ie,
    useCallback: function(i, u) {
      return Mn(function() {
        return i;
      }, u);
    },
    useImperativeHandle: ie,
    useEffect: ie,
    useDebugValue: ie,
    useDeferredValue: function(i, u) {
      return _l(), u !== void 0 ? u : i;
    },
    useTransition: function() {
      return _l(), [!1, fl];
    },
    useId: function() {
      var i = Qt.treeContext, u = i.overflow;
      i = i.id, i = (i & ~(1 << 32 - ee(i) - 1)).toString(32) + u;
      var h = Vr;
      if (h === null) throw Error(f(404));
      return u = Al++, i = "_" + h.idPrefix + "R_" + i, 0 < u && (i += "H" + u.toString(32)), i + "_";
    },
    useSyncExternalStore: function(i, u, h) {
      if (h === void 0)
        throw Error(f(407));
      return h();
    },
    useOptimistic: function(i) {
      return _l(), [i, Gl];
    },
    useActionState: _a,
    useFormState: _a,
    useHostTransitionStatus: function() {
      return _l(), Ri;
    },
    useMemoCache: function(i) {
      for (var u = Array(i), h = 0; h < i; h++)
        u[h] = de;
      return u;
    },
    useCacheRefresh: function() {
      return xc;
    },
    useEffectEvent: function() {
      return Jt;
    }
  }, Vr = null, Qn = {
    getCacheForType: function() {
      throw Error(f(248));
    },
    cacheSignal: function() {
      throw Error(f(248));
    }
  }, _t, Je;
  function Xl(i) {
    if (_t === void 0)
      try {
        throw Error();
      } catch (h) {
        var u = h.stack.trim().match(/\n( *(at )?)/);
        _t = u && u[1] || "", Je = -1 < h.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < h.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + _t + i + Je;
  }
  var Cl = !1;
  function Wa(i, u) {
    if (!i || Cl) return "";
    Cl = !0;
    var h = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var b = {
        DetermineComponentFrameRoot: function() {
          try {
            if (u) {
              var ne = function() {
                throw Error();
              };
              if (Object.defineProperty(ne.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(ne, []);
                } catch (Te) {
                  var pe = Te;
                }
                Reflect.construct(i, [], ne);
              } else {
                try {
                  ne.call();
                } catch (Te) {
                  pe = Te;
                }
                i.call(ne.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (Te) {
                pe = Te;
              }
              (ne = i()) && typeof ne.catch == "function" && ne.catch(function() {
              });
            }
          } catch (Te) {
            if (Te && pe && typeof Te.stack == "string")
              return [Te.stack, pe.stack];
          }
          return [null, null];
        }
      };
      b.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var T = Object.getOwnPropertyDescriptor(
        b.DetermineComponentFrameRoot,
        "name"
      );
      T && T.configurable && Object.defineProperty(
        b.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var O = b.DetermineComponentFrameRoot(), M = O[0], Z = O[1];
      if (M && Z) {
        var k = M.split(`
`), X = Z.split(`
`);
        for (T = b = 0; b < k.length && !k[b].includes("DetermineComponentFrameRoot"); )
          b++;
        for (; T < X.length && !X[T].includes(
          "DetermineComponentFrameRoot"
        ); )
          T++;
        if (b === k.length || T === X.length)
          for (b = k.length - 1, T = X.length - 1; 1 <= b && 0 <= T && k[b] !== X[T]; )
            T--;
        for (; 1 <= b && 0 <= T; b--, T--)
          if (k[b] !== X[T]) {
            if (b !== 1 || T !== 1)
              do
                if (b--, T--, 0 > T || k[b] !== X[T]) {
                  var J = `
` + k[b].replace(" at new ", " at ");
                  return i.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", i.displayName)), J;
                }
              while (1 <= b && 0 <= T);
            break;
          }
      }
    } finally {
      Cl = !1, Error.prepareStackTrace = h;
    }
    return (h = i ? i.displayName || i.name : "") ? Xl(h) : "";
  }
  function Ja(i) {
    if (typeof i == "string") return Xl(i);
    if (typeof i == "function")
      return i.prototype && i.prototype.isReactComponent ? Wa(i, !0) : Wa(i, !1);
    if (typeof i == "object" && i !== null) {
      switch (i.$$typeof) {
        case B:
          return Wa(i.render, !1);
        case ce:
          return Wa(i.type, !1);
        case ae:
          var u = i, h = u._payload;
          u = u._init;
          try {
            i = u(h);
          } catch {
            return Xl("Lazy");
          }
          return Ja(i);
      }
      if (typeof i.name == "string") {
        e: {
          h = i.name, u = i.env;
          var b = i.debugLocation;
          if (b != null && (i = Error.prepareStackTrace, Error.prepareStackTrace = void 0, b = b.stack, Error.prepareStackTrace = i, b.startsWith(`Error: react-stack-top-frame
`) && (b = b.slice(29)), i = b.indexOf(`
`), i !== -1 && (b = b.slice(i + 1)), i = b.indexOf("react_stack_bottom_frame"), i !== -1 && (i = b.lastIndexOf(`
`, i)), i = i !== -1 ? b = b.slice(0, i) : "", b = i.lastIndexOf(`
`), i = b === -1 ? i : i.slice(b + 1), i.indexOf(h) !== -1)) {
            h = `
` + i;
            break e;
          }
          h = Xl(
            h + (u ? " [" + u + "]" : "")
          );
        }
        return h;
      }
    }
    switch (i) {
      case F:
        return Xl("SuspenseList");
      case I:
        return Xl("Suspense");
    }
    return "";
  }
  function ea(i, u) {
    return (500 < u.byteSize || Au(u.contentState)) && u.contentPreamble === null;
  }
  function Qr(i) {
    if (typeof i == "object" && i !== null && typeof i.environmentName == "string") {
      var u = i.environmentName;
      i = [i].slice(0), typeof i[0] == "string" ? i.splice(
        0,
        1,
        "%c%s%c " + i[0],
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + u + " ",
        ""
      ) : i.splice(
        0,
        0,
        "%c%s%c",
        "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px",
        " " + u + " ",
        ""
      ), i.unshift(console), u = bi.apply(console.error, i), u();
    } else console.error(i);
    return null;
  }
  function Oa(i, u, h, b, T, O, M, Z, k, X, J) {
    var ne = /* @__PURE__ */ new Set();
    this.destination = null, this.flushScheduled = !1, this.resumableState = i, this.renderState = u, this.rootFormatContext = h, this.progressiveChunkSize = b === void 0 ? 12800 : b, this.status = 10, this.fatalError = null, this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0, this.completedPreambleSegments = this.completedRootSegment = null, this.byteSize = 0, this.abortableTasks = ne, this.pingedTasks = [], this.clientRenderedBoundaries = [], this.completedBoundaries = [], this.partialBoundaries = [], this.trackedPostpones = null, this.onError = T === void 0 ? Qr : T, this.onPostpone = X === void 0 ? ie : X, this.onAllReady = O === void 0 ? ie : O, this.onShellReady = M === void 0 ? ie : M, this.onShellError = Z === void 0 ? ie : Z, this.onFatalError = k === void 0 ? ie : k, this.formState = J === void 0 ? null : J;
  }
  function ma(i, u, h, b, T, O, M, Z, k, X, J, ne) {
    return u = new Oa(
      u,
      h,
      b,
      T,
      O,
      M,
      Z,
      k,
      X,
      J,
      ne
    ), h = Il(
      u,
      0,
      null,
      b,
      !1,
      !1
    ), h.parentFlushed = !0, i = hl(
      u,
      null,
      i,
      -1,
      null,
      h,
      null,
      null,
      u.abortableTasks,
      null,
      b,
      null,
      N,
      null,
      null
    ), la(i), u.pingedTasks.push(i), u;
  }
  function Tr(i, u, h, b, T, O, M, Z, k, X, J) {
    return i = ma(
      i,
      u,
      h,
      b,
      T,
      O,
      M,
      Z,
      k,
      X,
      J,
      void 0
    ), i.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, i;
  }
  function ta(i, u, h, b, T, O, M, Z, k) {
    return h = new Oa(
      u.resumableState,
      h,
      u.rootFormatContext,
      u.progressiveChunkSize,
      b,
      T,
      O,
      M,
      Z,
      k,
      null
    ), h.nextSegmentId = u.nextSegmentId, typeof u.replaySlots == "number" ? (b = Il(
      h,
      0,
      null,
      u.rootFormatContext,
      !1,
      !1
    ), b.parentFlushed = !0, i = hl(
      h,
      null,
      i,
      -1,
      null,
      b,
      null,
      null,
      h.abortableTasks,
      null,
      u.rootFormatContext,
      null,
      N,
      null,
      null
    ), la(i), h.pingedTasks.push(i), h) : (i = Pr(
      h,
      null,
      {
        nodes: u.replayNodes,
        slots: u.replaySlots,
        pendingTasks: 0
      },
      i,
      -1,
      null,
      null,
      h.abortableTasks,
      null,
      u.rootFormatContext,
      null,
      N,
      null,
      null
    ), la(i), h.pingedTasks.push(i), h);
  }
  function Ou(i, u, h, b, T, O, M, Z, k) {
    return i = ta(
      i,
      u,
      h,
      b,
      T,
      O,
      M,
      Z,
      k
    ), i.trackedPostpones = {
      workingMap: /* @__PURE__ */ new Map(),
      rootNodes: [],
      rootSlots: null
    }, i;
  }
  var Kt = null;
  function dl(i, u) {
    i.pingedTasks.push(u), i.pingedTasks.length === 1 && (i.flushScheduled = i.destination !== null, i.trackedPostpones !== null || i.status === 10 ? Ae(function() {
      return _c(i);
    }) : Ot(function() {
      return _c(i);
    }));
  }
  function na(i, u, h, b, T) {
    return h = {
      status: 0,
      rootSegmentID: -1,
      parentFlushed: !1,
      pendingTasks: 0,
      row: u,
      completedSegments: [],
      byteSize: 0,
      fallbackAbortableTasks: h,
      errorDigest: null,
      contentState: vi(),
      fallbackState: vi(),
      contentPreamble: b,
      fallbackPreamble: T,
      trackedContentKeyPath: null,
      trackedFallbackNode: null
    }, u !== null && (u.pendingTasks++, b = u.boundaries, b !== null && (i.allPendingTasks++, h.pendingTasks++, b.push(h)), i = u.inheritedHoistables, i !== null && yi(h.contentState, i)), h;
  }
  function hl(i, u, h, b, T, O, M, Z, k, X, J, ne, pe, Te, Ve) {
    i.allPendingTasks++, T === null ? i.pendingRootTasks++ : T.pendingTasks++, Te !== null && Te.pendingTasks++;
    var Le = {
      replay: null,
      node: h,
      childIndex: b,
      ping: function() {
        return dl(i, Le);
      },
      blockedBoundary: T,
      blockedSegment: O,
      blockedPreamble: M,
      hoistableState: Z,
      abortSet: k,
      keyPath: X,
      formatContext: J,
      context: ne,
      treeContext: pe,
      row: Te,
      componentStack: Ve,
      thenableState: u
    };
    return k.add(Le), Le;
  }
  function Pr(i, u, h, b, T, O, M, Z, k, X, J, ne, pe, Te) {
    i.allPendingTasks++, O === null ? i.pendingRootTasks++ : O.pendingTasks++, pe !== null && pe.pendingTasks++, h.pendingTasks++;
    var Ve = {
      replay: h,
      node: b,
      childIndex: T,
      ping: function() {
        return dl(i, Ve);
      },
      blockedBoundary: O,
      blockedSegment: null,
      blockedPreamble: null,
      hoistableState: M,
      abortSet: Z,
      keyPath: k,
      formatContext: X,
      context: J,
      treeContext: ne,
      row: pe,
      componentStack: Te,
      thenableState: u
    };
    return Z.add(Ve), Ve;
  }
  function Il(i, u, h, b, T, O) {
    return {
      status: 0,
      parentFlushed: !1,
      id: -1,
      index: u,
      chunks: [],
      children: [],
      preambleChildren: [],
      parentFormatContext: b,
      boundary: h,
      lastPushedText: T,
      textEmbedded: O
    };
  }
  function la(i) {
    var u = i.node;
    if (typeof u == "object" && u !== null)
      switch (u.$$typeof) {
        case v:
          i.componentStack = { parent: i.componentStack, type: u.type };
      }
  }
  function Ka(i) {
    return i === null ? null : { parent: i.parent, type: "Suspense Fallback" };
  }
  function Pn(i) {
    var u = {};
    return i && Object.defineProperty(u, "componentStack", {
      configurable: !0,
      enumerable: !0,
      get: function() {
        try {
          var h = "", b = i;
          do
            h += Ja(b.type), b = b.parent;
          while (b);
          var T = h;
        } catch (O) {
          T = `
Error generating stack: ` + O.message + `
` + O.stack;
        }
        return Object.defineProperty(u, "componentStack", {
          value: T
        }), T;
      }
    }), u;
  }
  function yt(i, u, h) {
    if (i = i.onError, u = i(u, h), u == null || typeof u == "string") return u;
  }
  function pi(i, u) {
    var h = i.onShellError, b = i.onFatalError;
    h(u), b(u), i.destination !== null ? (i.status = 14, tt(i.destination, u)) : (i.status = 13, i.fatalError = u);
  }
  function il(i, u) {
    So(i, u.next, u.hoistables);
  }
  function So(i, u, h) {
    for (; u !== null; ) {
      h !== null && (yi(u.hoistables, h), u.inheritedHoistables = h);
      var b = u.boundaries;
      if (b !== null) {
        u.boundaries = null;
        for (var T = 0; T < b.length; T++) {
          var O = b[T];
          h !== null && yi(O.contentState, h), Bn(i, O, null, null);
        }
      }
      if (u.pendingTasks--, 0 < u.pendingTasks) break;
      h = u.hoistables, u = u.next;
    }
  }
  function Cu(i, u) {
    var h = u.boundaries;
    if (h !== null && u.pendingTasks === h.length) {
      for (var b = !0, T = 0; T < h.length; T++) {
        var O = h[T];
        if (O.pendingTasks !== 1 || O.parentFlushed || ea(i, O)) {
          b = !1;
          break;
        }
      }
      b && So(i, u, u.hoistables);
    }
  }
  function Ru(i) {
    var u = {
      pendingTasks: 1,
      boundaries: null,
      hoistables: vi(),
      inheritedHoistables: null,
      together: !1,
      next: null
    };
    return i !== null && 0 < i.pendingTasks && (u.pendingTasks++, u.boundaries = [], i.next = u), u;
  }
  function An(i, u, h, b, T) {
    var O = u.keyPath, M = u.treeContext, Z = u.row;
    u.keyPath = h, h = b.length;
    var k = null;
    if (u.replay !== null) {
      var X = u.replay.slots;
      if (X !== null && typeof X == "object")
        for (var J = 0; J < h; J++) {
          var ne = T !== "backwards" && T !== "unstable_legacy-backwards" ? J : h - 1 - J, pe = b[ne];
          u.row = k = Ru(
            k
          ), u.treeContext = L(M, h, ne);
          var Te = X[ne];
          typeof Te == "number" ? (ja(i, u, Te, pe, ne), delete X[ne]) : an(i, u, pe, ne), --k.pendingTasks === 0 && il(i, k);
        }
      else
        for (X = 0; X < h; X++)
          J = T !== "backwards" && T !== "unstable_legacy-backwards" ? X : h - 1 - X, ne = b[J], u.row = k = Ru(k), u.treeContext = L(M, h, J), an(i, u, ne, J), --k.pendingTasks === 0 && il(i, k);
    } else if (T !== "backwards" && T !== "unstable_legacy-backwards")
      for (T = 0; T < h; T++)
        X = b[T], u.row = k = Ru(k), u.treeContext = L(
          M,
          h,
          T
        ), an(i, u, X, T), --k.pendingTasks === 0 && il(i, k);
    else {
      for (T = u.blockedSegment, X = T.children.length, J = T.chunks.length, ne = h - 1; 0 <= ne; ne--) {
        pe = b[ne], u.row = k = Ru(
          k
        ), u.treeContext = L(M, h, ne), Te = Il(
          i,
          J,
          null,
          u.formatContext,
          ne === 0 ? T.lastPushedText : !0,
          !0
        ), T.children.splice(X, 0, Te), u.blockedSegment = Te;
        try {
          an(i, u, pe, ne), Te.lastPushedText && Te.textEmbedded && Te.chunks.push(Rn), Te.status = 1, Rl(i, u.blockedBoundary, Te), --k.pendingTasks === 0 && il(i, k);
        } catch (Ve) {
          throw Te.status = i.status === 12 ? 3 : 4, Ve;
        }
      }
      u.blockedSegment = T, T.lastPushedText = !1;
    }
    Z !== null && k !== null && 0 < k.pendingTasks && (Z.pendingTasks++, k.next = Z), u.treeContext = M, u.row = Z, u.keyPath = O;
  }
  function Ec(i, u, h, b, T, O) {
    var M = u.thenableState;
    for (u.thenableState = null, qe = {}, Qt = u, Lt = i, ht = h, rt = Al = 0, En = -1, gn = 0, Rt = M, i = b(T, O); Pe; )
      Pe = !1, rt = Al = 0, En = -1, gn = 0, $i += 1, lt = null, i = b(T, O);
    return al(), i;
  }
  function aa(i, u, h, b, T, O, M) {
    var Z = !1;
    if (O !== 0 && i.formState !== null) {
      var k = u.blockedSegment;
      if (k !== null) {
        Z = !0, k = k.chunks;
        for (var X = 0; X < O; X++)
          X === M ? k.push(Vt) : k.push(Li);
      }
    }
    O = u.keyPath, u.keyPath = h, T ? (h = u.treeContext, u.treeContext = L(h, 1, 0), an(i, u, b, -1), u.treeContext = h) : Z ? an(i, u, b, -1) : vn(i, u, b, -1), u.keyPath = O;
  }
  function Ca(i, u, h, b, T, O) {
    if (typeof b == "function")
      if (b.prototype && b.prototype.isReactComponent) {
        var M = T;
        if ("ref" in T) {
          M = {};
          for (var Z in T)
            Z !== "ref" && (M[Z] = T[Z]);
        }
        var k = b.defaultProps;
        if (k) {
          M === T && (M = _e({}, M, T));
          for (var X in k)
            M[X] === void 0 && (M[X] = k[X]);
        }
        T = M, M = Tc, k = b.contextType, typeof k == "object" && k !== null && (M = k._currentValue), M = new b(T, M);
        var J = M.state !== void 0 ? M.state : null;
        if (M.updater = x, M.props = T, M.state = J, k = { queue: [], replace: !1 }, M._reactInternals = k, O = b.contextType, M.context = typeof O == "object" && O !== null ? O._currentValue : Tc, O = b.getDerivedStateFromProps, typeof O == "function" && (O = O(T, J), J = O == null ? J : _e({}, J, O), M.state = J), typeof b.getDerivedStateFromProps != "function" && typeof M.getSnapshotBeforeUpdate != "function" && (typeof M.UNSAFE_componentWillMount == "function" || typeof M.componentWillMount == "function"))
          if (b = M.state, typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount(), b !== M.state && x.enqueueReplaceState(
            M,
            M.state,
            null
          ), k.queue !== null && 0 < k.queue.length)
            if (b = k.queue, O = k.replace, k.queue = null, k.replace = !1, O && b.length === 1)
              M.state = b[0];
            else {
              for (k = O ? b[0] : M.state, J = !0, O = O ? 1 : 0; O < b.length; O++)
                X = b[O], X = typeof X == "function" ? X.call(M, k, T, void 0) : X, X != null && (J ? (J = !1, k = _e({}, k, X)) : _e(k, X));
              M.state = k;
            }
          else k.queue = null;
        if (b = M.render(), i.status === 12) throw null;
        T = u.keyPath, u.keyPath = h, vn(i, u, b, -1), u.keyPath = T;
      } else {
        if (b = Ec(i, u, h, b, T, void 0), i.status === 12) throw null;
        aa(
          i,
          u,
          h,
          b,
          Al !== 0,
          rt,
          En
        );
      }
    else if (typeof b == "string")
      if (M = u.blockedSegment, M === null)
        M = T.children, k = u.formatContext, J = u.keyPath, u.formatContext = Hl(k, b, T), u.keyPath = h, an(i, u, M, -1), u.formatContext = k, u.keyPath = J;
      else {
        if (J = Hr(
          M.chunks,
          b,
          T,
          i.resumableState,
          i.renderState,
          u.blockedPreamble,
          u.hoistableState,
          u.formatContext,
          M.lastPushedText
        ), M.lastPushedText = !1, k = u.formatContext, O = u.keyPath, u.keyPath = h, (u.formatContext = Hl(k, b, T)).insertionMode === 3) {
          h = Il(
            i,
            0,
            null,
            u.formatContext,
            !1,
            !1
          ), M.preambleChildren.push(h), u.blockedSegment = h;
          try {
            h.status = 6, an(i, u, J, -1), h.lastPushedText && h.textEmbedded && h.chunks.push(Rn), h.status = 1, Rl(i, u.blockedBoundary, h);
          } finally {
            u.blockedSegment = M;
          }
        } else an(i, u, J, -1);
        u.formatContext = k, u.keyPath = O;
        e: {
          switch (u = M.chunks, i = i.resumableState, b) {
            case "title":
            case "style":
            case "script":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
              break e;
            case "body":
              if (1 >= k.insertionMode) {
                i.hasBody = !0;
                break e;
              }
              break;
            case "html":
              if (k.insertionMode === 0) {
                i.hasHtml = !0;
                break e;
              }
              break;
            case "head":
              if (1 >= k.insertionMode) break e;
          }
          u.push(wl(b));
        }
        M.lastPushedText = !1;
      }
    else {
      switch (b) {
        case ge:
        case w:
        case _:
        case p:
          b = u.keyPath, u.keyPath = h, vn(i, u, T.children, -1), u.keyPath = b;
          return;
        case he:
          b = u.blockedSegment, b === null ? T.mode !== "hidden" && (b = u.keyPath, u.keyPath = h, an(i, u, T.children, -1), u.keyPath = b) : T.mode !== "hidden" && (b.chunks.push(Ee), b.lastPushedText = !1, M = u.keyPath, u.keyPath = h, an(i, u, T.children, -1), u.keyPath = M, b.chunks.push(We), b.lastPushedText = !1);
          return;
        case F:
          e: {
            if (b = T.children, T = T.revealOrder, T === "forwards" || T === "backwards" || T === "unstable_legacy-backwards") {
              if (xe(b)) {
                An(i, u, h, b, T);
                break e;
              }
              if ((M = ye(b)) && (M = M.call(b))) {
                if (k = M.next(), !k.done) {
                  do
                    k = M.next();
                  while (!k.done);
                  An(i, u, h, b, T);
                }
                break e;
              }
            }
            T === "together" ? (T = u.keyPath, M = u.row, k = u.row = Ru(null), k.boundaries = [], k.together = !0, u.keyPath = h, vn(i, u, b, -1), --k.pendingTasks === 0 && il(i, k), u.keyPath = T, u.row = M, M !== null && 0 < k.pendingTasks && (M.pendingTasks++, k.next = M)) : (T = u.keyPath, u.keyPath = h, vn(i, u, b, -1), u.keyPath = T);
          }
          return;
        case De:
        case $:
          throw Error(f(343));
        case I:
          e: if (u.replay !== null) {
            b = u.keyPath, M = u.formatContext, k = u.row, u.keyPath = h, u.formatContext = Kl(
              i.resumableState,
              M
            ), u.row = null, h = T.children;
            try {
              an(i, u, h, -1);
            } finally {
              u.keyPath = b, u.formatContext = M, u.row = k;
            }
          } else {
            b = u.keyPath, O = u.formatContext;
            var ne = u.row;
            X = u.blockedBoundary, Z = u.blockedPreamble;
            var pe = u.hoistableState, Te = u.blockedSegment, Ve = T.fallback;
            T = T.children;
            var Le = /* @__PURE__ */ new Set(), at = 2 > u.formatContext.insertionMode ? na(
              i,
              u.row,
              Le,
              ft(),
              ft()
            ) : na(
              i,
              u.row,
              Le,
              null,
              null
            );
            i.trackedPostpones !== null && (at.trackedContentKeyPath = h);
            var bt = Il(
              i,
              Te.chunks.length,
              at,
              u.formatContext,
              !1,
              !1
            );
            Te.children.push(bt), Te.lastPushedText = !1;
            var Oe = Il(
              i,
              0,
              null,
              u.formatContext,
              !1,
              !1
            );
            if (Oe.parentFlushed = !0, i.trackedPostpones !== null) {
              M = u.componentStack, k = [h[0], "Suspense Fallback", h[2]], J = [k[1], k[2], [], null], i.trackedPostpones.workingMap.set(k, J), at.trackedFallbackNode = J, u.blockedSegment = bt, u.blockedPreamble = at.fallbackPreamble, u.keyPath = k, u.formatContext = Jl(
                i.resumableState,
                O
              ), u.componentStack = Ka(M), bt.status = 6;
              try {
                an(i, u, Ve, -1), bt.lastPushedText && bt.textEmbedded && bt.chunks.push(Rn), bt.status = 1, Rl(i, X, bt);
              } catch (Ke) {
                throw bt.status = i.status === 12 ? 3 : 4, Ke;
              } finally {
                u.blockedSegment = Te, u.blockedPreamble = Z, u.keyPath = b, u.formatContext = O;
              }
              u = hl(
                i,
                null,
                T,
                -1,
                at,
                Oe,
                at.contentPreamble,
                at.contentState,
                u.abortSet,
                h,
                Kl(
                  i.resumableState,
                  u.formatContext
                ),
                u.context,
                u.treeContext,
                null,
                M
              ), la(u), i.pingedTasks.push(u);
            } else {
              u.blockedBoundary = at, u.blockedPreamble = at.contentPreamble, u.hoistableState = at.contentState, u.blockedSegment = Oe, u.keyPath = h, u.formatContext = Kl(
                i.resumableState,
                O
              ), u.row = null, Oe.status = 6;
              try {
                if (an(i, u, T, -1), Oe.lastPushedText && Oe.textEmbedded && Oe.chunks.push(Rn), Oe.status = 1, Rl(i, at, Oe), Kr(at, Oe), at.pendingTasks === 0 && at.status === 0) {
                  if (at.status = 1, !ea(i, at)) {
                    ne !== null && --ne.pendingTasks === 0 && il(i, ne), i.pendingRootTasks === 0 && u.blockedPreamble && ia(i);
                    break e;
                  }
                } else
                  ne !== null && ne.together && Cu(i, ne);
              } catch (Ke) {
                at.status = 4, i.status === 12 ? (Oe.status = 3, M = i.fatalError) : (Oe.status = 4, M = Ke), k = Pn(u.componentStack), J = yt(
                  i,
                  M,
                  k
                ), at.errorDigest = J, Ac(i, at);
              } finally {
                u.blockedBoundary = X, u.blockedPreamble = Z, u.hoistableState = pe, u.blockedSegment = Te, u.keyPath = b, u.formatContext = O, u.row = ne;
              }
              u = hl(
                i,
                null,
                Ve,
                -1,
                X,
                bt,
                at.fallbackPreamble,
                at.fallbackState,
                Le,
                [h[0], "Suspense Fallback", h[2]],
                Jl(
                  i.resumableState,
                  u.formatContext
                ),
                u.context,
                u.treeContext,
                u.row,
                Ka(
                  u.componentStack
                )
              ), la(u), i.pingedTasks.push(u);
            }
          }
          return;
      }
      if (typeof b == "object" && b !== null)
        switch (b.$$typeof) {
          case B:
            if ("ref" in T)
              for (Te in M = {}, T)
                Te !== "ref" && (M[Te] = T[Te]);
            else M = T;
            b = Ec(
              i,
              u,
              h,
              b.render,
              M,
              O
            ), aa(
              i,
              u,
              h,
              b,
              Al !== 0,
              rt,
              En
            );
            return;
          case ce:
            Ca(i, u, h, b.type, T, O);
            return;
          case z:
            if (k = T.children, M = u.keyPath, T = T.value, J = b._currentValue, b._currentValue = T, O = Aa, Aa = b = {
              parent: O,
              depth: O === null ? 0 : O.depth + 1,
              context: b,
              parentValue: J,
              value: T
            }, u.context = b, u.keyPath = h, vn(i, u, k, -1), i = Aa, i === null) throw Error(f(403));
            i.context._currentValue = i.parentValue, i = Aa = i.parent, u.context = i, u.keyPath = M;
            return;
          case C:
            T = T.children, b = T(b._context._currentValue), T = u.keyPath, u.keyPath = h, vn(i, u, b, -1), u.keyPath = T;
            return;
          case ae:
            if (M = b._init, b = M(b._payload), i.status === 12) throw null;
            Ca(i, u, h, b, T, O);
            return;
        }
      throw Error(
        f(130, b == null ? b : typeof b, "")
      );
    }
  }
  function ja(i, u, h, b, T) {
    var O = u.replay, M = u.blockedBoundary, Z = Il(
      i,
      0,
      null,
      u.formatContext,
      !1,
      !1
    );
    Z.id = h, Z.parentFlushed = !0;
    try {
      u.replay = null, u.blockedSegment = Z, an(i, u, b, T), Z.status = 1, Rl(i, M, Z), M === null ? i.completedRootSegment = Z : (Kr(M, Z), M.parentFlushed && i.partialBoundaries.push(M));
    } finally {
      u.replay = O, u.blockedSegment = null;
    }
  }
  function vn(i, u, h, b) {
    u.replay !== null && typeof u.replay.slots == "number" ? ja(i, u, u.replay.slots, h, b) : (u.node = h, u.childIndex = b, h = u.componentStack, la(u), Ra(i, u), u.componentStack = h);
  }
  function Ra(i, u) {
    var h = u.node, b = u.childIndex;
    if (h !== null) {
      if (typeof h == "object") {
        switch (h.$$typeof) {
          case v:
            var T = h.type, O = h.key, M = h.props;
            h = M.ref;
            var Z = h !== void 0 ? h : null, k = ji(T), X = O ?? (b === -1 ? 0 : b);
            if (O = [u.keyPath, k, X], u.replay !== null)
              e: {
                var J = u.replay;
                for (b = J.nodes, h = 0; h < b.length; h++) {
                  var ne = b[h];
                  if (X === ne[1]) {
                    if (ne.length === 4) {
                      if (k !== null && k !== ne[0])
                        throw Error(
                          f(490, ne[0], k)
                        );
                      var pe = ne[2];
                      k = ne[3], X = u.node, u.replay = {
                        nodes: pe,
                        slots: k,
                        pendingTasks: 1
                      };
                      try {
                        if (Ca(i, u, O, T, M, Z), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
                          throw Error(f(488));
                        u.replay.pendingTasks--;
                      } catch (Ye) {
                        if (typeof Ye == "object" && Ye !== null && (Ye === ve || typeof Ye.then == "function"))
                          throw u.node === X ? u.replay = J : b.splice(h, 1), Ye;
                        u.replay.pendingTasks--, M = Pn(u.componentStack), O = i, i = u.blockedBoundary, T = Ye, M = yt(O, T, M), Na(
                          O,
                          i,
                          pe,
                          k,
                          T,
                          M
                        );
                      }
                      u.replay = J;
                    } else {
                      if (T !== I)
                        throw Error(
                          f(
                            490,
                            "Suspense",
                            ji(T) || "Unknown"
                          )
                        );
                      t: {
                        J = void 0, T = ne[5], Z = ne[2], k = ne[3], X = ne[4] === null ? [] : ne[4][2], ne = ne[4] === null ? null : ne[4][3];
                        var Te = u.keyPath, Ve = u.formatContext, Le = u.row, at = u.replay, bt = u.blockedBoundary, Oe = u.hoistableState, Ke = M.children, mt = M.fallback, Ml = /* @__PURE__ */ new Set();
                        M = 2 > u.formatContext.insertionMode ? na(
                          i,
                          u.row,
                          Ml,
                          ft(),
                          ft()
                        ) : na(
                          i,
                          u.row,
                          Ml,
                          null,
                          null
                        ), M.parentFlushed = !0, M.rootSegmentID = T, u.blockedBoundary = M, u.hoistableState = M.contentState, u.keyPath = O, u.formatContext = Kl(
                          i.resumableState,
                          Ve
                        ), u.row = null, u.replay = {
                          nodes: Z,
                          slots: k,
                          pendingTasks: 1
                        };
                        try {
                          if (an(i, u, Ke, -1), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
                            throw Error(f(488));
                          if (u.replay.pendingTasks--, M.pendingTasks === 0 && M.status === 0) {
                            M.status = 1, i.completedBoundaries.push(M);
                            break t;
                          }
                        } catch (Ye) {
                          M.status = 4, pe = Pn(u.componentStack), J = yt(
                            i,
                            Ye,
                            pe
                          ), M.errorDigest = J, u.replay.pendingTasks--, i.clientRenderedBoundaries.push(M);
                        } finally {
                          u.blockedBoundary = bt, u.hoistableState = Oe, u.replay = at, u.keyPath = Te, u.formatContext = Ve, u.row = Le;
                        }
                        pe = Pr(
                          i,
                          null,
                          {
                            nodes: X,
                            slots: ne,
                            pendingTasks: 0
                          },
                          mt,
                          -1,
                          bt,
                          M.fallbackState,
                          Ml,
                          [O[0], "Suspense Fallback", O[2]],
                          Jl(
                            i.resumableState,
                            u.formatContext
                          ),
                          u.context,
                          u.treeContext,
                          u.row,
                          Ka(
                            u.componentStack
                          )
                        ), la(pe), i.pingedTasks.push(pe);
                      }
                    }
                    b.splice(h, 1);
                    break e;
                  }
                }
              }
            else Ca(i, u, O, T, M, Z);
            return;
          case y:
            throw Error(f(257));
          case ae:
            if (pe = h._init, h = pe(h._payload), i.status === 12) throw null;
            vn(i, u, h, b);
            return;
        }
        if (xe(h)) {
          Wr(i, u, h, b);
          return;
        }
        if ((pe = ye(h)) && (pe = pe.call(h))) {
          if (h = pe.next(), !h.done) {
            M = [];
            do
              M.push(h.value), h = pe.next();
            while (!h.done);
            Wr(i, u, M, b);
          }
          return;
        }
        if (typeof h.then == "function")
          return u.thenableState = null, vn(i, u, Sc(h), b);
        if (h.$$typeof === z)
          return vn(
            i,
            u,
            h._currentValue,
            b
          );
        throw b = Object.prototype.toString.call(h), Error(
          f(
            31,
            b === "[object Object]" ? "object with keys {" + Object.keys(h).join(", ") + "}" : b
          )
        );
      }
      typeof h == "string" ? (b = u.blockedSegment, b !== null && (b.lastPushedText = jl(
        b.chunks,
        h,
        i.renderState,
        b.lastPushedText
      ))) : (typeof h == "number" || typeof h == "bigint") && (b = u.blockedSegment, b !== null && (b.lastPushedText = jl(
        b.chunks,
        "" + h,
        i.renderState,
        b.lastPushedText
      )));
    }
  }
  function Wr(i, u, h, b) {
    var T = u.keyPath;
    if (b !== -1 && (u.keyPath = [u.keyPath, "Fragment", b], u.replay !== null)) {
      for (var O = u.replay, M = O.nodes, Z = 0; Z < M.length; Z++) {
        var k = M[Z];
        if (k[1] === b) {
          b = k[2], k = k[3], u.replay = { nodes: b, slots: k, pendingTasks: 1 };
          try {
            if (Wr(i, u, h, -1), u.replay.pendingTasks === 1 && 0 < u.replay.nodes.length)
              throw Error(f(488));
            u.replay.pendingTasks--;
          } catch (ne) {
            if (typeof ne == "object" && ne !== null && (ne === ve || typeof ne.then == "function"))
              throw ne;
            u.replay.pendingTasks--, h = Pn(u.componentStack);
            var X = u.blockedBoundary, J = ne;
            h = yt(i, J, h), Na(
              i,
              X,
              b,
              k,
              J,
              h
            );
          }
          u.replay = O, M.splice(Z, 1);
          break;
        }
      }
      u.keyPath = T;
      return;
    }
    if (O = u.treeContext, M = h.length, u.replay !== null && (Z = u.replay.slots, Z !== null && typeof Z == "object")) {
      for (b = 0; b < M; b++)
        k = h[b], u.treeContext = L(O, M, b), X = Z[b], typeof X == "number" ? (ja(i, u, X, k, b), delete Z[b]) : an(i, u, k, b);
      u.treeContext = O, u.keyPath = T;
      return;
    }
    for (Z = 0; Z < M; Z++)
      b = h[Z], u.treeContext = L(O, M, Z), an(i, u, b, Z);
    u.treeContext = O, u.keyPath = T;
  }
  function Nu(i, u, h) {
    if (h.status = 5, h.rootSegmentID = i.nextSegmentId++, i = h.trackedContentKeyPath, i === null) throw Error(f(486));
    var b = h.trackedFallbackNode, T = [], O = u.workingMap.get(i);
    return O === void 0 ? (h = [
      i[1],
      i[2],
      T,
      null,
      b,
      h.rootSegmentID
    ], u.workingMap.set(i, h), jr(h, i[0], u), h) : (O[4] = b, O[5] = h.rootSegmentID, O);
  }
  function wc(i, u, h, b) {
    b.status = 5;
    var T = h.keyPath, O = h.blockedBoundary;
    if (O === null)
      b.id = i.nextSegmentId++, u.rootSlots = b.id, i.completedRootSegment !== null && (i.completedRootSegment.status = 5);
    else {
      if (O !== null && O.status === 0) {
        var M = Nu(
          i,
          u,
          O
        );
        if (O.trackedContentKeyPath === T && h.childIndex === -1) {
          b.id === -1 && (b.id = b.parentFlushed ? O.rootSegmentID : i.nextSegmentId++), M[3] = b.id;
          return;
        }
      }
      if (b.id === -1 && (b.id = b.parentFlushed && O !== null ? O.rootSegmentID : i.nextSegmentId++), h.childIndex === -1)
        T === null ? u.rootSlots = b.id : (h = u.workingMap.get(T), h === void 0 ? (h = [T[1], T[2], [], b.id], jr(h, T[0], u)) : h[3] = b.id);
      else {
        if (T === null) {
          if (i = u.rootSlots, i === null)
            i = u.rootSlots = {};
          else if (typeof i == "number")
            throw Error(f(491));
        } else if (O = u.workingMap, M = O.get(T), M === void 0)
          i = {}, M = [T[1], T[2], [], i], O.set(T, M), jr(M, T[0], u);
        else if (i = M[3], i === null)
          i = M[3] = {};
        else if (typeof i == "number")
          throw Error(f(491));
        i[h.childIndex] = b.id;
      }
    }
  }
  function Ac(i, u) {
    i = i.trackedPostpones, i !== null && (u = u.trackedContentKeyPath, u !== null && (u = i.workingMap.get(u), u !== void 0 && (u.length = 4, u[2] = [], u[3] = null)));
  }
  function qa(i, u, h) {
    return Pr(
      i,
      h,
      u.replay,
      u.node,
      u.childIndex,
      u.blockedBoundary,
      u.hoistableState,
      u.abortSet,
      u.keyPath,
      u.formatContext,
      u.context,
      u.treeContext,
      u.row,
      u.componentStack
    );
  }
  function Mu(i, u, h) {
    var b = u.blockedSegment, T = Il(
      i,
      b.chunks.length,
      null,
      u.formatContext,
      b.lastPushedText,
      !0
    );
    return b.children.push(T), b.lastPushedText = !1, hl(
      i,
      h,
      u.node,
      u.childIndex,
      u.blockedBoundary,
      T,
      u.blockedPreamble,
      u.hoistableState,
      u.abortSet,
      u.keyPath,
      u.formatContext,
      u.context,
      u.treeContext,
      u.row,
      u.componentStack
    );
  }
  function an(i, u, h, b) {
    var T = u.formatContext, O = u.context, M = u.keyPath, Z = u.treeContext, k = u.componentStack, X = u.blockedSegment;
    if (X === null) {
      X = u.replay;
      try {
        return vn(i, u, h, b);
      } catch (pe) {
        if (al(), h = pe === ve ? Ze() : pe, i.status !== 12 && typeof h == "object" && h !== null) {
          if (typeof h.then == "function") {
            b = pe === ve ? wn() : null, i = qa(i, u, b).ping, h.then(i, i), u.formatContext = T, u.context = O, u.keyPath = M, u.treeContext = Z, u.componentStack = k, u.replay = X, m(O);
            return;
          }
          if (h.message === "Maximum call stack size exceeded") {
            h = pe === ve ? wn() : null, h = qa(i, u, h), i.pingedTasks.push(h), u.formatContext = T, u.context = O, u.keyPath = M, u.treeContext = Z, u.componentStack = k, u.replay = X, m(O);
            return;
          }
        }
      }
    } else {
      var J = X.children.length, ne = X.chunks.length;
      try {
        return vn(i, u, h, b);
      } catch (pe) {
        if (al(), X.children.length = J, X.chunks.length = ne, h = pe === ve ? Ze() : pe, i.status !== 12 && typeof h == "object" && h !== null) {
          if (typeof h.then == "function") {
            X = h, h = pe === ve ? wn() : null, i = Mu(i, u, h).ping, X.then(i, i), u.formatContext = T, u.context = O, u.keyPath = M, u.treeContext = Z, u.componentStack = k, m(O);
            return;
          }
          if (h.message === "Maximum call stack size exceeded") {
            X = pe === ve ? wn() : null, X = Mu(i, u, X), i.pingedTasks.push(X), u.formatContext = T, u.context = O, u.keyPath = M, u.treeContext = Z, u.componentStack = k, m(O);
            return;
          }
        }
      }
    }
    throw u.formatContext = T, u.context = O, u.keyPath = M, u.treeContext = Z, m(O), h;
  }
  function zu(i) {
    var u = i.blockedBoundary, h = i.blockedSegment;
    h !== null && (h.status = 3, Bn(this, u, i.row, h));
  }
  function Na(i, u, h, b, T, O) {
    for (var M = 0; M < h.length; M++) {
      var Z = h[M];
      if (Z.length === 4)
        Na(
          i,
          u,
          Z[2],
          Z[3],
          T,
          O
        );
      else {
        Z = Z[5];
        var k = i, X = O, J = na(
          k,
          null,
          /* @__PURE__ */ new Set(),
          null,
          null
        );
        J.parentFlushed = !0, J.rootSegmentID = Z, J.status = 4, J.errorDigest = X, J.parentFlushed && k.clientRenderedBoundaries.push(J);
      }
    }
    if (h.length = 0, b !== null) {
      if (u === null) throw Error(f(487));
      if (u.status !== 4 && (u.status = 4, u.errorDigest = O, u.parentFlushed && i.clientRenderedBoundaries.push(u)), typeof b == "object") for (var ne in b) delete b[ne];
    }
  }
  function er(i, u, h) {
    var b = i.blockedBoundary, T = i.blockedSegment;
    if (T !== null) {
      if (T.status === 6) return;
      T.status = 3;
    }
    var O = Pn(i.componentStack);
    if (b === null) {
      if (u.status !== 13 && u.status !== 14) {
        if (b = i.replay, b === null) {
          u.trackedPostpones !== null && T !== null ? (b = u.trackedPostpones, yt(u, h, O), wc(u, b, i, T), Bn(u, null, i.row, T)) : (yt(u, h, O), pi(u, h));
          return;
        }
        b.pendingTasks--, b.pendingTasks === 0 && 0 < b.nodes.length && (T = yt(u, h, O), Na(
          u,
          null,
          b.nodes,
          b.slots,
          h,
          T
        )), u.pendingRootTasks--, u.pendingRootTasks === 0 && Sr(u);
      }
    } else {
      var M = u.trackedPostpones;
      if (b.status !== 4) {
        if (M !== null && T !== null)
          return yt(u, h, O), wc(u, M, i, T), b.fallbackAbortableTasks.forEach(function(Z) {
            return er(Z, u, h);
          }), b.fallbackAbortableTasks.clear(), Bn(u, b, i.row, T);
        b.status = 4, T = yt(u, h, O), b.status = 4, b.errorDigest = T, Ac(u, b), b.parentFlushed && u.clientRenderedBoundaries.push(b);
      }
      b.pendingTasks--, T = b.row, T !== null && --T.pendingTasks === 0 && il(u, T), b.fallbackAbortableTasks.forEach(function(Z) {
        return er(Z, u, h);
      }), b.fallbackAbortableTasks.clear();
    }
    i = i.row, i !== null && --i.pendingTasks === 0 && il(u, i), u.allPendingTasks--, u.allPendingTasks === 0 && Jr(u);
  }
  function tr(i, u) {
    try {
      var h = i.renderState, b = h.onHeaders;
      if (b) {
        var T = h.headers;
        if (T) {
          h.headers = null;
          var O = T.preconnects;
          if (T.fontPreloads && (O && (O += ", "), O += T.fontPreloads), T.highImagePreloads && (O && (O += ", "), O += T.highImagePreloads), !u) {
            var M = h.styles.values(), Z = M.next();
            e: for (; 0 < T.remainingCapacity && !Z.done; Z = M.next())
              for (var k = Z.value.sheets.values(), X = k.next(); 0 < T.remainingCapacity && !X.done; X = k.next()) {
                var J = X.value, ne = J.props, pe = ne.href, Te = J.props, Ve = wu(Te.href, "style", {
                  crossOrigin: Te.crossOrigin,
                  integrity: Te.integrity,
                  nonce: Te.nonce,
                  type: Te.type,
                  fetchPriority: Te.fetchPriority,
                  referrerPolicy: Te.referrerPolicy,
                  media: Te.media
                });
                if (0 <= (T.remainingCapacity -= Ve.length + 2))
                  h.resets.style[pe] = In, O && (O += ", "), O += Ve, h.resets.style[pe] = typeof ne.crossOrigin == "string" || typeof ne.integrity == "string" ? [ne.crossOrigin, ne.integrity] : In;
                else break e;
              }
          }
          b(O ? { Link: O } : {});
        }
      }
    } catch (Le) {
      yt(i, Le, {});
    }
  }
  function Sr(i) {
    i.trackedPostpones === null && tr(i, !0), i.trackedPostpones === null && ia(i), i.onShellError = ie, i = i.onShellReady, i();
  }
  function Jr(i) {
    tr(
      i,
      i.trackedPostpones === null ? !0 : i.completedRootSegment === null || i.completedRootSegment.status !== 5
    ), ia(i), i = i.onAllReady, i();
  }
  function Kr(i, u) {
    if (u.chunks.length === 0 && u.children.length === 1 && u.children[0].boundary === null && u.children[0].id === -1) {
      var h = u.children[0];
      h.id = u.id, h.parentFlushed = !0, h.status !== 1 && h.status !== 3 && h.status !== 4 || Kr(i, h);
    } else i.completedSegments.push(u);
  }
  function Rl(i, u, h) {
    if (ct !== null) {
      h = h.chunks;
      for (var b = 0, T = 0; T < h.length; T++)
        b += h[T].byteLength;
      u === null ? i.byteSize += b : u.byteSize += b;
    }
  }
  function Bn(i, u, h, b) {
    if (h !== null && (--h.pendingTasks === 0 ? il(i, h) : h.together && Cu(i, h)), i.allPendingTasks--, u === null) {
      if (b !== null && b.parentFlushed) {
        if (i.completedRootSegment !== null)
          throw Error(f(389));
        i.completedRootSegment = b;
      }
      i.pendingRootTasks--, i.pendingRootTasks === 0 && Sr(i);
    } else if (u.pendingTasks--, u.status !== 4)
      if (u.pendingTasks === 0) {
        if (u.status === 0 && (u.status = 1), b !== null && b.parentFlushed && (b.status === 1 || b.status === 3) && Kr(u, b), u.parentFlushed && i.completedBoundaries.push(u), u.status === 1)
          h = u.row, h !== null && yi(h.hoistables, u.contentState), ea(i, u) || (u.fallbackAbortableTasks.forEach(zu, i), u.fallbackAbortableTasks.clear(), h !== null && --h.pendingTasks === 0 && il(i, h)), i.pendingRootTasks === 0 && i.trackedPostpones === null && u.contentPreamble !== null && ia(i);
        else if (u.status === 5 && (u = u.row, u !== null)) {
          if (i.trackedPostpones !== null) {
            h = i.trackedPostpones;
            var T = u.next;
            if (T !== null && (b = T.boundaries, b !== null))
              for (T.boundaries = null, T = 0; T < b.length; T++) {
                var O = b[T];
                Nu(i, h, O), Bn(i, O, null, null);
              }
          }
          --u.pendingTasks === 0 && il(i, u);
        }
      } else
        b === null || !b.parentFlushed || b.status !== 1 && b.status !== 3 || (Kr(u, b), u.completedSegments.length === 1 && u.parentFlushed && i.partialBoundaries.push(u)), u = u.row, u !== null && u.together && Cu(i, u);
    i.allPendingTasks === 0 && Jr(i);
  }
  function _c(i) {
    if (i.status !== 14 && i.status !== 13) {
      var u = Aa, h = jn.H;
      jn.H = _u;
      var b = jn.A;
      jn.A = Qn;
      var T = Kt;
      Kt = i;
      var O = Vr;
      Vr = i.resumableState;
      try {
        var M = i.pingedTasks, Z;
        for (Z = 0; Z < M.length; Z++) {
          var k = M[Z], X = i, J = k.blockedSegment;
          if (J === null) {
            var ne = X;
            if (k.replay.pendingTasks !== 0) {
              m(k.context);
              try {
                if (typeof k.replay.slots == "number" ? ja(
                  ne,
                  k,
                  k.replay.slots,
                  k.node,
                  k.childIndex
                ) : Ra(ne, k), k.replay.pendingTasks === 1 && 0 < k.replay.nodes.length)
                  throw Error(f(488));
                k.replay.pendingTasks--, k.abortSet.delete(k), Bn(
                  ne,
                  k.blockedBoundary,
                  k.row,
                  null
                );
              } catch (Fn) {
                al();
                var pe = Fn === ve ? Ze() : Fn;
                if (typeof pe == "object" && pe !== null && typeof pe.then == "function") {
                  var Te = k.ping;
                  pe.then(Te, Te), k.thenableState = Fn === ve ? wn() : null;
                } else {
                  k.replay.pendingTasks--, k.abortSet.delete(k);
                  var Ve = Pn(k.componentStack);
                  X = void 0;
                  var Le = ne, at = k.blockedBoundary, bt = ne.status === 12 ? ne.fatalError : pe, Oe = k.replay.nodes, Ke = k.replay.slots;
                  X = yt(
                    Le,
                    bt,
                    Ve
                  ), Na(
                    Le,
                    at,
                    Oe,
                    Ke,
                    bt,
                    X
                  ), ne.pendingRootTasks--, ne.pendingRootTasks === 0 && Sr(ne), ne.allPendingTasks--, ne.allPendingTasks === 0 && Jr(ne);
                }
              } finally {
              }
            }
          } else if (ne = void 0, Le = J, Le.status === 0) {
            Le.status = 6, m(k.context);
            var mt = Le.children.length, Ml = Le.chunks.length;
            try {
              Ra(X, k), Le.lastPushedText && Le.textEmbedded && Le.chunks.push(Rn), k.abortSet.delete(k), Le.status = 1, Rl(X, k.blockedBoundary, Le), Bn(
                X,
                k.blockedBoundary,
                k.row,
                Le
              );
            } catch (Fn) {
              al(), Le.children.length = mt, Le.chunks.length = Ml;
              var Ye = Fn === ve ? Ze() : X.status === 12 ? X.fatalError : Fn;
              if (X.status === 12 && X.trackedPostpones !== null) {
                var yn = X.trackedPostpones, jt = Pn(k.componentStack);
                k.abortSet.delete(k), yt(X, Ye, jt), wc(X, yn, k, Le), Bn(
                  X,
                  k.blockedBoundary,
                  k.row,
                  Le
                );
              } else if (typeof Ye == "object" && Ye !== null && typeof Ye.then == "function") {
                Le.status = 0, k.thenableState = Fn === ve ? wn() : null;
                var Un = k.ping;
                Ye.then(Un, Un);
              } else {
                var Zl = Pn(k.componentStack);
                k.abortSet.delete(k), Le.status = 4;
                var bn = k.blockedBoundary, kt = k.row;
                if (kt !== null && --kt.pendingTasks === 0 && il(X, kt), X.allPendingTasks--, ne = yt(
                  X,
                  Ye,
                  Zl
                ), bn === null) pi(X, Ye);
                else if (bn.pendingTasks--, bn.status !== 4) {
                  bn.status = 4, bn.errorDigest = ne, Ac(X, bn);
                  var pa = bn.row;
                  pa !== null && --pa.pendingTasks === 0 && il(X, pa), bn.parentFlushed && X.clientRenderedBoundaries.push(bn), X.pendingRootTasks === 0 && X.trackedPostpones === null && bn.contentPreamble !== null && ia(X);
                }
                X.allPendingTasks === 0 && Jr(X);
              }
            } finally {
            }
          }
        }
        M.splice(0, Z), i.destination !== null && xr(i, i.destination);
      } catch (Fn) {
        yt(i, Fn, {}), pi(i, Fn);
      } finally {
        Vr = O, jn.H = h, jn.A = b, h === _u && m(u), Kt = T;
      }
    }
  }
  function Ti(i, u, h) {
    u.preambleChildren.length && h.push(u.preambleChildren);
    for (var b = !1, T = 0; T < u.children.length; T++)
      b = nr(
        i,
        u.children[T],
        h
      ) || b;
    return b;
  }
  function nr(i, u, h) {
    var b = u.boundary;
    if (b === null)
      return Ti(
        i,
        u,
        h
      );
    var T = b.contentPreamble, O = b.fallbackPreamble;
    if (T === null || O === null) return !1;
    switch (b.status) {
      case 1:
        if (Hi(i.renderState, T), i.byteSize += b.byteSize, u = b.completedSegments[0], !u) throw Error(f(391));
        return Ti(
          i,
          u,
          h
        );
      case 5:
        if (i.trackedPostpones !== null) return !0;
      case 4:
        if (u.status === 1)
          return Hi(i.renderState, O), Ti(
            i,
            u,
            h
          );
      default:
        return !0;
    }
  }
  function ia(i) {
    if (i.completedRootSegment && i.completedPreambleSegments === null) {
      var u = [], h = i.byteSize, b = nr(
        i,
        i.completedRootSegment,
        u
      ), T = i.renderState.preamble;
      b === !1 || T.headChunks && T.bodyChunks ? i.completedPreambleSegments = u : i.byteSize = h;
    }
  }
  function $a(i, u, h, b) {
    switch (h.parentFlushed = !0, h.status) {
      case 0:
        h.id = i.nextSegmentId++;
      case 5:
        return b = h.id, h.lastPushedText = !1, h.textEmbedded = !1, i = i.renderState, U(u, W), U(u, i.placeholderPrefix), i = ue(b.toString(16)), U(u, i), P(u, me);
      case 1:
        h.status = 2;
        var T = !0, O = h.chunks, M = 0;
        h = h.children;
        for (var Z = 0; Z < h.length; Z++) {
          for (T = h[Z]; M < T.index; M++)
            U(u, O[M]);
          T = Si(i, u, T, b);
        }
        for (; M < O.length - 1; M++)
          U(u, O[M]);
        return M < O.length && (T = P(u, O[M])), T;
      case 3:
        return !0;
      default:
        throw Error(f(390));
    }
  }
  var ra = 0;
  function Si(i, u, h, b) {
    var T = h.boundary;
    if (T === null)
      return $a(i, u, h, b);
    if (T.parentFlushed = !0, T.status === 4) {
      var O = T.row;
      O !== null && --O.pendingTasks === 0 && il(i, O), T = T.errorDigest, P(u, Ht), U(u, Bi), T && (U(u, Br), U(u, ue(Ce(T))), U(
        u,
        Bt
      )), P(u, so), $a(i, u, h, b);
    } else if (T.status !== 1)
      T.status === 0 && (T.rootSegmentID = i.nextSegmentId++), 0 < T.completedSegments.length && i.partialBoundaries.push(T), gr(
        u,
        i.renderState,
        T.rootSegmentID
      ), b && yi(b, T.fallbackState), $a(i, u, h, b);
    else if (!gl && ea(i, T) && (ra + T.byteSize > i.progressiveChunkSize || Au(T.contentState)))
      T.rootSegmentID = i.nextSegmentId++, i.completedBoundaries.push(T), gr(
        u,
        i.renderState,
        T.rootSegmentID
      ), $a(i, u, h, b);
    else {
      if (ra += T.byteSize, b && yi(b, T.contentState), h = T.row, h !== null && ea(i, T) && --h.pendingTasks === 0 && il(i, h), P(u, ot), h = T.completedSegments, h.length !== 1) throw Error(f(391));
      Si(i, u, h[0], b);
    }
    return P(u, Wt);
  }
  function ei(i, u, h, b) {
    return uc(
      u,
      i.renderState,
      h.parentFormatContext,
      h.id
    ), Si(i, u, h, b), Fr(u, h.parentFormatContext);
  }
  function xi(i, u, h) {
    ra = h.byteSize;
    for (var b = h.completedSegments, T = 0; T < b.length; T++)
      Oc(
        i,
        u,
        h,
        b[T]
      );
    b.length = 0, b = h.row, b !== null && ea(i, h) && --b.pendingTasks === 0 && il(i, b), Vi(
      u,
      h.contentState,
      i.renderState
    ), b = i.resumableState, i = i.renderState, T = h.rootSegmentID, h = h.contentState;
    var O = i.stylesToHoist;
    return i.stylesToHoist = !1, U(u, i.startInlineScript), U(u, Dt), O ? ((b.instructions & 4) === 0 && (b.instructions |= 4, U(u, Yr)), (b.instructions & 2) === 0 && (b.instructions |= 2, U(u, fo)), (b.instructions & 8) === 0 ? (b.instructions |= 8, U(u, Xs)) : U(u, Po)) : ((b.instructions & 2) === 0 && (b.instructions |= 2, U(u, fo)), U(u, oc)), b = ue(T.toString(16)), U(u, i.boundaryPrefix), U(u, b), U(u, sc), U(u, i.segmentPrefix), U(u, b), O ? (U(u, Is), Ln(u, h)) : U(u, ho), h = P(u, go), be(u, i) && h;
  }
  function Oc(i, u, h, b) {
    if (b.status === 2) return !0;
    var T = h.contentState, O = b.id;
    if (O === -1) {
      if ((b.id = h.rootSegmentID) === -1)
        throw Error(f(392));
      return ei(i, u, b, T);
    }
    return O === h.rootSegmentID ? ei(i, u, b, T) : (ei(i, u, b, T), h = i.resumableState, i = i.renderState, U(u, i.startInlineScript), U(u, Dt), (h.instructions & 1) === 0 ? (h.instructions |= 1, U(u, cc)) : U(u, Qo), U(u, i.segmentPrefix), O = ue(O.toString(16)), U(u, O), U(u, Ys), U(u, i.placeholderPrefix), U(u, O), u = P(u, Gs), u);
  }
  var gl = !1;
  function xr(i, u) {
    Xe = new Uint8Array(2048), it = 0;
    try {
      if (!(0 < i.pendingRootTasks)) {
        var h, b = i.completedRootSegment;
        if (b !== null) {
          if (b.status === 5) return;
          var T = i.completedPreambleSegments;
          if (T === null) return;
          ra = i.byteSize;
          var O = i.resumableState, M = i.renderState, Z = M.preamble, k = Z.htmlChunks, X = Z.headChunks, J;
          if (k) {
            for (J = 0; J < k.length; J++)
              U(u, k[J]);
            if (X)
              for (J = 0; J < X.length; J++)
                U(u, X[J]);
            else
              U(u, nn("head")), U(u, Dt);
          } else if (X)
            for (J = 0; J < X.length; J++)
              U(u, X[J]);
          var ne = M.charsetChunks;
          for (J = 0; J < ne.length; J++)
            U(u, ne[J]);
          ne.length = 0, M.preconnects.forEach(Ct, u), M.preconnects.clear();
          var pe = M.viewportChunks;
          for (J = 0; J < pe.length; J++)
            U(u, pe[J]);
          pe.length = 0, M.fontPreloads.forEach(Ct, u), M.fontPreloads.clear(), M.highImagePreloads.forEach(Ct, u), M.highImagePreloads.clear(), cl = M, M.styles.forEach(vc, u), cl = null;
          var Te = M.importMapChunks;
          for (J = 0; J < Te.length; J++)
            U(u, Te[J]);
          Te.length = 0, M.bootstrapScripts.forEach(Ct, u), M.scripts.forEach(Ct, u), M.scripts.clear(), M.bulkPreloads.forEach(Ct, u), M.bulkPreloads.clear(), k || X || (O.instructions |= 32);
          var Ve = M.hoistableChunks;
          for (J = 0; J < Ve.length; J++)
            U(u, Ve[J]);
          for (O = Ve.length = 0; O < T.length; O++) {
            var Le = T[O];
            for (M = 0; M < Le.length; M++)
              Si(i, u, Le[M], null);
          }
          var at = i.renderState.preamble, bt = at.headChunks;
          (at.htmlChunks || bt) && U(u, wl("head"));
          var Oe = at.bodyChunks;
          if (Oe)
            for (T = 0; T < Oe.length; T++)
              U(u, Oe[T]);
          Si(i, u, b, null), i.completedRootSegment = null;
          var Ke = i.renderState;
          if (i.allPendingTasks !== 0 || i.clientRenderedBoundaries.length !== 0 || i.completedBoundaries.length !== 0 || i.trackedPostpones !== null && (i.trackedPostpones.rootNodes.length !== 0 || i.trackedPostpones.rootSlots !== null)) {
            var mt = i.resumableState;
            if ((mt.instructions & 64) === 0) {
              if (mt.instructions |= 64, U(u, Ke.startInlineScript), (mt.instructions & 32) === 0) {
                mt.instructions |= 32;
                var Ml = "_" + mt.idPrefix + "R_";
                U(u, Tu), U(
                  u,
                  ue(Ce(Ml))
                ), U(u, zt);
              }
              U(u, Dt), U(u, D), P(u, Ue);
            }
          }
          be(u, Ke);
        }
        var Ye = i.renderState;
        b = 0;
        var yn = Ye.viewportChunks;
        for (b = 0; b < yn.length; b++)
          U(u, yn[b]);
        yn.length = 0, Ye.preconnects.forEach(Ct, u), Ye.preconnects.clear(), Ye.fontPreloads.forEach(Ct, u), Ye.fontPreloads.clear(), Ye.highImagePreloads.forEach(
          Ct,
          u
        ), Ye.highImagePreloads.clear(), Ye.styles.forEach(po, u), Ye.scripts.forEach(Ct, u), Ye.scripts.clear(), Ye.bulkPreloads.forEach(Ct, u), Ye.bulkPreloads.clear();
        var jt = Ye.hoistableChunks;
        for (b = 0; b < jt.length; b++)
          U(u, jt[b]);
        jt.length = 0;
        var Un = i.clientRenderedBoundaries;
        for (h = 0; h < Un.length; h++) {
          var Zl = Un[h];
          Ye = u;
          var bn = i.resumableState, kt = i.renderState, pa = Zl.rootSegmentID, Fn = Zl.errorDigest;
          U(
            Ye,
            kt.startInlineScript
          ), U(Ye, Dt), (bn.instructions & 4) === 0 ? (bn.instructions |= 4, U(Ye, vo)) : U(Ye, fc), U(Ye, kt.boundaryPrefix), U(Ye, ue(pa.toString(16))), U(Ye, Wo), Fn && (U(
            Ye,
            Xi
          ), U(
            Ye,
            ue(
              Qs(Fn || "")
            )
          ));
          var ua = P(
            Ye,
            Zs
          );
          if (!ua) {
            i.destination = null, h++, Un.splice(0, h);
            return;
          }
        }
        Un.splice(0, h);
        var qr = i.completedBoundaries;
        for (h = 0; h < qr.length; h++)
          if (!xi(i, u, qr[h])) {
            i.destination = null, h++, qr.splice(0, h);
            return;
          }
        qr.splice(0, h), Se(u), Xe = new Uint8Array(2048), it = 0, gl = !0;
        var Lu = i.partialBoundaries;
        for (h = 0; h < Lu.length; h++) {
          var wi = Lu[h];
          e: {
            Un = i, Zl = u, ra = wi.byteSize;
            var Er = wi.completedSegments;
            for (ua = 0; ua < Er.length; ua++)
              if (!Oc(
                Un,
                Zl,
                wi,
                Er[ua]
              )) {
                ua++, Er.splice(0, ua);
                var ku = !1;
                break e;
              }
            Er.splice(0, ua);
            var mn = wi.row;
            mn !== null && mn.together && wi.pendingTasks === 1 && (mn.pendingTasks === 1 ? So(
              Un,
              mn,
              mn.hoistables
            ) : mn.pendingTasks--), ku = Vi(
              Zl,
              wi.contentState,
              Un.renderState
            );
          }
          if (!ku) {
            i.destination = null, h++, Lu.splice(0, h);
            return;
          }
        }
        Lu.splice(0, h), gl = !1;
        var Pt = i.completedBoundaries;
        for (h = 0; h < Pt.length; h++)
          if (!xi(i, u, Pt[h])) {
            i.destination = null, h++, Pt.splice(0, h);
            return;
          }
        Pt.splice(0, h);
      }
    } finally {
      gl = !1, i.allPendingTasks === 0 && i.clientRenderedBoundaries.length === 0 && i.completedBoundaries.length === 0 ? (i.flushScheduled = !1, h = i.resumableState, h.hasBody && U(u, wl("body")), h.hasHtml && U(u, wl("html")), Se(u), i.status = 14, u.close(), i.destination = null) : Se(u);
    }
  }
  function Ei(i) {
    i.flushScheduled = i.destination !== null, Ae(function() {
      return _c(i);
    }), Ot(function() {
      i.status === 10 && (i.status = 11), i.trackedPostpones === null && tr(i, i.pendingRootTasks === 0);
    });
  }
  function vl(i) {
    i.flushScheduled === !1 && i.pingedTasks.length === 0 && i.destination !== null && (i.flushScheduled = !0, Ot(function() {
      var u = i.destination;
      u ? xr(i, u) : i.flushScheduled = !1;
    }));
  }
  function Nl(i, u) {
    if (i.status === 13)
      i.status = 14, tt(u, i.fatalError);
    else if (i.status !== 14 && i.destination === null) {
      i.destination = u;
      try {
        xr(i, u);
      } catch (h) {
        yt(i, h, {}), pi(i, h);
      }
    }
  }
  function yl(i, u) {
    (i.status === 11 || i.status === 10) && (i.status = 12);
    try {
      var h = i.abortableTasks;
      if (0 < h.size) {
        var b = u === void 0 ? Error(f(432)) : typeof u == "object" && u !== null && typeof u.then == "function" ? Error(f(530)) : u;
        i.fatalError = b, h.forEach(function(T) {
          return er(T, i, b);
        }), h.clear();
      }
      i.destination !== null && xr(i, i.destination);
    } catch (T) {
      yt(i, T, {}), pi(i, T);
    }
  }
  function jr(i, u, h) {
    if (u === null) h.rootNodes.push(i);
    else {
      var b = h.workingMap, T = b.get(u);
      T === void 0 && (T = [u[1], u[2], [], null], b.set(u, T), jr(T, u[0], h)), T[2].push(i);
    }
  }
  function Du(i) {
    var u = i.trackedPostpones;
    if (u === null || u.rootNodes.length === 0 && u.rootSlots === null)
      return i.trackedPostpones = null;
    if (i.completedRootSegment === null || i.completedRootSegment.status !== 5 && i.completedPreambleSegments !== null) {
      var h = i.nextSegmentId, b = u.rootSlots, T = i.resumableState;
      T.bootstrapScriptContent = void 0, T.bootstrapScripts = void 0, T.bootstrapModules = void 0;
    } else {
      h = 0, b = -1, T = i.resumableState;
      var O = i.renderState;
      T.nextFormID = 0, T.hasBody = !1, T.hasHtml = !1, T.unknownResources = { font: O.resets.font }, T.dnsResources = O.resets.dns, T.connectResources = O.resets.connect, T.imageResources = O.resets.image, T.styleResources = O.resets.style, T.scriptResources = {}, T.moduleUnknownResources = {}, T.moduleScriptResources = {}, T.instructions = 0;
    }
    return {
      nextSegmentId: h,
      rootFormatContext: i.rootFormatContext,
      progressiveChunkSize: i.progressiveChunkSize,
      resumableState: i.resumableState,
      replayNodes: u.rootNodes,
      replaySlots: b
    };
  }
  function ti() {
    var i = a.version;
    if (i !== "19.2.6")
      throw Error(
        f(
          527,
          i,
          "19.2.6"
        )
      );
  }
  return ti(), ti(), ko.prerender = function(i, u) {
    return new Promise(function(h, b) {
      var T = u ? u.onHeaders : void 0, O;
      T && (O = function(J) {
        T(new Headers(J));
      });
      var M = Ba(
        u ? u.identifierPrefix : void 0,
        u ? u.unstable_externalRuntimeSrc : void 0,
        u ? u.bootstrapScriptContent : void 0,
        u ? u.bootstrapScripts : void 0,
        u ? u.bootstrapModules : void 0
      ), Z = Tr(
        i,
        M,
        Cn(
          M,
          void 0,
          u ? u.unstable_externalRuntimeSrc : void 0,
          u ? u.importMap : void 0,
          O,
          u ? u.maxHeadersLength : void 0
        ),
        ci(u ? u.namespaceURI : void 0),
        u ? u.progressiveChunkSize : void 0,
        u ? u.onError : void 0,
        function() {
          var J = new ReadableStream(
            {
              type: "bytes",
              pull: function(ne) {
                Nl(Z, ne);
              },
              cancel: function(ne) {
                Z.destination = null, yl(Z, ne);
              }
            },
            { highWaterMark: 0 }
          );
          J = { postponed: Du(Z), prelude: J }, h(J);
        },
        void 0,
        void 0,
        b,
        u ? u.onPostpone : void 0
      );
      if (u && u.signal) {
        var k = u.signal;
        if (k.aborted) yl(Z, k.reason);
        else {
          var X = function() {
            yl(Z, k.reason), k.removeEventListener("abort", X);
          };
          k.addEventListener("abort", X);
        }
      }
      Ei(Z);
    });
  }, ko.renderToReadableStream = function(i, u) {
    return new Promise(function(h, b) {
      var T, O, M = new Promise(function(Te, Ve) {
        O = Te, T = Ve;
      }), Z = u ? u.onHeaders : void 0, k;
      Z && (k = function(Te) {
        Z(new Headers(Te));
      });
      var X = Ba(
        u ? u.identifierPrefix : void 0,
        u ? u.unstable_externalRuntimeSrc : void 0,
        u ? u.bootstrapScriptContent : void 0,
        u ? u.bootstrapScripts : void 0,
        u ? u.bootstrapModules : void 0
      ), J = ma(
        i,
        X,
        Cn(
          X,
          u ? u.nonce : void 0,
          u ? u.unstable_externalRuntimeSrc : void 0,
          u ? u.importMap : void 0,
          k,
          u ? u.maxHeadersLength : void 0
        ),
        ci(u ? u.namespaceURI : void 0),
        u ? u.progressiveChunkSize : void 0,
        u ? u.onError : void 0,
        O,
        function() {
          var Te = new ReadableStream(
            {
              type: "bytes",
              pull: function(Ve) {
                Nl(J, Ve);
              },
              cancel: function(Ve) {
                J.destination = null, yl(J, Ve);
              }
            },
            { highWaterMark: 0 }
          );
          Te.allReady = M, h(Te);
        },
        function(Te) {
          M.catch(function() {
          }), b(Te);
        },
        T,
        u ? u.onPostpone : void 0,
        u ? u.formState : void 0
      );
      if (u && u.signal) {
        var ne = u.signal;
        if (ne.aborted) yl(J, ne.reason);
        else {
          var pe = function() {
            yl(J, ne.reason), ne.removeEventListener("abort", pe);
          };
          ne.addEventListener("abort", pe);
        }
      }
      Ei(J);
    });
  }, ko.resume = function(i, u, h) {
    return new Promise(function(b, T) {
      var O, M, Z = new Promise(function(ne, pe) {
        M = ne, O = pe;
      }), k = ta(
        i,
        u,
        Cn(
          u.resumableState,
          h ? h.nonce : void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        h ? h.onError : void 0,
        M,
        function() {
          var ne = new ReadableStream(
            {
              type: "bytes",
              pull: function(pe) {
                Nl(k, pe);
              },
              cancel: function(pe) {
                k.destination = null, yl(k, pe);
              }
            },
            { highWaterMark: 0 }
          );
          ne.allReady = Z, b(ne);
        },
        function(ne) {
          Z.catch(function() {
          }), T(ne);
        },
        O,
        h ? h.onPostpone : void 0
      );
      if (h && h.signal) {
        var X = h.signal;
        if (X.aborted) yl(k, X.reason);
        else {
          var J = function() {
            yl(k, X.reason), X.removeEventListener("abort", J);
          };
          X.addEventListener("abort", J);
        }
      }
      Ei(k);
    });
  }, ko.resumeAndPrerender = function(i, u, h) {
    return new Promise(function(b, T) {
      var O = Ou(
        i,
        u,
        Cn(
          u.resumableState,
          void 0,
          void 0,
          void 0,
          void 0,
          void 0
        ),
        h ? h.onError : void 0,
        function() {
          var k = new ReadableStream(
            {
              type: "bytes",
              pull: function(X) {
                Nl(O, X);
              },
              cancel: function(X) {
                O.destination = null, yl(O, X);
              }
            },
            { highWaterMark: 0 }
          );
          k = { postponed: Du(O), prelude: k }, b(k);
        },
        void 0,
        void 0,
        T,
        h ? h.onPostpone : void 0
      );
      if (h && h.signal) {
        var M = h.signal;
        if (M.aborted) yl(O, M.reason);
        else {
          var Z = function() {
            yl(O, M.reason), M.removeEventListener("abort", Z);
          };
          M.addEventListener("abort", Z);
        }
      }
      Ei(O);
    });
  }, ko.version = "19.2.6", ko;
}
var yb;
function Tp() {
  if (yb) return Lo;
  yb = 1;
  var a, o;
  return a = mp(), o = pp(), Lo.version = a.version, Lo.renderToString = a.renderToString, Lo.renderToStaticMarkup = a.renderToStaticMarkup, Lo.renderToReadableStream = o.renderToReadableStream, Lo.resume = o.resume, Lo;
}
Tp();
const Sp = "staticMarkup";
function Vo() {
  const o = nh().indexOf(Sp) > -1 ? !0 : void 0;
  return {
    isBootstrap: o,
    isReact: o ? void 0 : !0
  };
}
const Tl = ({ gaData: a, prefix: o = "", children: f }) => {
  const { isReact: v } = Vo(), { onClick: y, ...p } = f.props;
  if (v)
    return Xt.cloneElement(f, {
      ...p,
      onClick: (C) => (a && a.event && a.action && rm(a), y ? y(C) : !0)
    });
  let w = "";
  ["input", "header", "header-input"].includes(o) && (w = `-${o}`);
  const _ = {
    [`data-ga${w}`]: a.text,
    [`data-ga${w}-name`]: a.name,
    [`data-ga${w}-event`]: a.event,
    [`data-ga${w}-action`]: a.action,
    [`data-ga${w}-type`]: a.type,
    [`data-ga${w}-region`]: a.region,
    [`data-ga${w}-section`]: a.section,
    [`data-ga${w}-component`]: a.component
  };
  return Xt.cloneElement(f, {
    ...p,
    onClick: y,
    ..._
  });
}, om = ({
  id: a,
  parentId: o,
  /** @type {AccordionCard} */
  item: f,
  openCard: v,
  onClick: y,
  gaData: p,
  ref: w
}) => {
  var z, B, I, F, ce, ae;
  const _ = a === v, C = _ ? "open" : "close";
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      ref: w,
      className: Mt("accordion-item", "mt-3", {
        [`accordion-item-${f.color}`]: f.color,
        "accordion-header-icon": (z = f.content) == null ? void 0 : z.icon
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "accordion-header", children: /* @__PURE__ */ A.jsx("h4", { children: /* @__PURE__ */ A.jsx(
          Tl,
          {
            gaData: {
              ...p,
              action: C,
              text: f.content.header
            },
            children: /* @__PURE__ */ A.jsxs(
              "button",
              {
                "data-testid": "accordion-opener",
                className: Mt({ collapsed: !_ }),
                "data-bs-toggle": "collapse",
                href: `#card-body-${a}`,
                type: "button",
                "aria-expanded": _,
                "aria-controls": `card-body-${a}`,
                onClick: ($) => y($, a),
                children: [
                  (B = f.content) != null && B.icon ? /* @__PURE__ */ A.jsxs("span", { className: "accordion-icon", children: [
                    /* @__PURE__ */ A.jsx(
                      "i",
                      {
                        className: `${(I = f.content.icon) == null ? void 0 : I[0]} fa-${(F = f.content.icon) == null ? void 0 : F[1]} me-2`
                      }
                    ),
                    f.content.header
                  ] }) : (ce = f.content) == null ? void 0 : ce.header,
                  /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-up" })
                ]
              }
            )
          }
        ) }) }),
        ((ae = f.content) == null ? void 0 : ae.body) && /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-bs-parent": `#${o}`,
            id: `card-body-${a}`,
            className: Mt("collapse", { show: _ }),
            children: /* @__PURE__ */ A.jsx(
              "div",
              {
                className: "accordion-body",
                dangerouslySetInnerHTML: La(f.content.body)
              }
            )
          }
        )
      ]
    }
  );
};
om.propTypes = {
  id: E.number,
  // @ts-ignore a technical type mismatch between PropTypes definition and your TypeScript
  item: cm,
  parentId: E.string,
  openCard: E.number,
  onClick: E.func,
  gaData: E.object
};
const xp = {
  event: "collapse",
  name: "onclick",
  type: "click",
  region: "main content"
}, sm = ({ cards: a, openedCard: o }) => {
  const [f, v] = fa(o), y = `accordion-${nh()}`, p = Yo(
    /** @type { HTMLDivElement[]} */
    []
  ), w = (_, C) => {
    if (_.preventDefault(), f !== C) {
      const z = p.current[f - 1], B = z == null ? void 0 : z.lastElementChild;
      gp(B), v(C);
    } else
      v(null);
  };
  return /* @__PURE__ */ A.jsx("div", { className: "accordion", id: y, children: a == null ? void 0 : a.map(
    (_, C) => _.content.body && _.content.header && /* @__PURE__ */ A.jsx(
      om,
      {
        ref: (z) => {
          p.current[C] = z;
        },
        id: C + 1,
        parentId: y,
        item: _,
        openCard: f,
        onClick: w,
        gaData: xp
      },
      C + 1
    )
  ) });
};
sm.propTypes = {
  /**
   * Cards to show in the accordion component
   */
  cards: E.arrayOf(cm).isRequired,
  /**
   * Opened card based on rendered card position
   */
  openedCard: E.number
};
const bb = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, co = ({
  label: a = "",
  cardTitle: o = "",
  gaData: f,
  ariaLabel: v,
  block: y,
  color: p = "gray",
  disabled: w,
  element: _ = "button",
  href: C,
  icon: z,
  innerRef: B,
  onClick: I,
  size: F = "default",
  variant: ce,
  classes: ae,
  target: $ = "_self",
  ...he
}) => {
  if (ce) {
    const De = {
      borderless: "borderless",
      outline: "outline",
      filled: "filled"
    }, Re = Mt("btn", De[ce], {
      [`btn-${De[ce]}-${p}`]: !0,
      "btn-medium": F === "medium",
      "btn-small": F === "small",
      "btn-large": F === "large" || F === "default",
      disabled: w
    });
    let ye = _;
    return C && _ === "button" && (ye = "a"), /* @__PURE__ */ A.jsx(
      Tl,
      {
        gaData: {
          ...bb,
          section: o,
          ...f,
          text: a
        },
        children: /* @__PURE__ */ A.jsxs(
          ye,
          {
            type: ye === "button" && I ? "button" : void 0,
            ...he,
            className: Mt(ae) || Re,
            href: C,
            ref: B,
            onClick: I,
            "aria-label": v,
            target: ye === "a" ? $ : null,
            disabled: w,
            children: [
              z && /* @__PURE__ */ A.jsx("i", { className: `${z == null ? void 0 : z[0]} fa-${z == null ? void 0 : z[1]} me-1` }),
              a
            ]
          }
        )
      }
    );
  }
  const ge = Mt("btn", {
    [`btn-${p}`]: !0,
    "btn-md": F === "small",
    "btn-sm": F === "xsmall",
    "btn-block": y,
    disabled: w
  });
  let de = _;
  return C && _ === "button" && (de = "a"), /* @__PURE__ */ A.jsx(
    Tl,
    {
      gaData: {
        ...bb,
        section: o,
        // @deprecated - remove at some point
        ...f,
        text: a
      },
      children: /* @__PURE__ */ A.jsxs(
        de,
        {
          type: de === "button" && I ? "button" : void 0,
          ...he,
          className: Mt(ae) || ge,
          href: C,
          ref: B,
          onClick: I,
          "aria-label": v,
          target: de === "a" ? $ : null,
          children: [
            z && /* @__PURE__ */ A.jsx("i", { className: `${z == null ? void 0 : z[0]} fa-${z == null ? void 0 : z[1]} me-1` }),
            a
          ]
        }
      )
    }
  );
};
co.propTypes = {
  /**
   * Button label
   */
  label: E.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: $g,
  /**
    ARIA label for accessibility
  */
  ariaLabel: E.string,
  /**
    Render button as a block-button?
  */
  block: E.bool,
  /**
    Button background color
  */
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: E.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: E.oneOfType([
    E.func,
    E.string,
    E.shape({ $$typeof: E.symbol, render: E.func }),
    E.arrayOf(
      E.oneOfType([
        E.func,
        E.string,
        E.shape({ $$typeof: E.symbol, render: E.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: E.string,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func,
  /**
    Button size. Legacy sizes (default, small, xsmall) or new sizes (large, medium, small) when used with variant prop.
  */
  size: E.oneOf(["default", "small", "xsmall", "large", "medium"]),
  /**
    Button style variant (borderless, outline, filled). When provided, uses new UDS button styles.
  */
  variant: E.oneOf(["borderless", "outline", "filled"]),
  /**
    Classes to add to button
  */
  classes: E.arrayOf(E.string),
  /**
   Link target type
   */
  target: E.oneOf(["_blank", "_self", "_top", "_parent"])
};
function Ep(a) {
  var o = /* @__PURE__ */ Object.create(null);
  return function(f) {
    return o[f] === void 0 && (o[f] = a(f)), o[f];
  };
}
var wp = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ap = /* @__PURE__ */ Ep(
  function(a) {
    return wp.test(a) || a.charCodeAt(0) === 111 && a.charCodeAt(1) === 110 && a.charCodeAt(2) < 91;
  }
  /* Z+1 */
), On = "-ms-", Zf = "-moz-", Gt = "-webkit-", fm = "comm", lh = "rule", ev = "decl", _p = "@import", Op = "@namespace", dm = "@keyframes", Cp = "@layer", hm = Math.abs, tv = String.fromCharCode, zg = Object.assign;
function Rp(a, o) {
  return Ll(a, 0) ^ 45 ? (((o << 2 ^ Ll(a, 0)) << 2 ^ Ll(a, 1)) << 2 ^ Ll(a, 2)) << 2 ^ Ll(a, 3) : 0;
}
function gm(a) {
  return a.trim();
}
function $u(a, o) {
  return (a = o.exec(a)) ? a[0] : a;
}
function st(a, o, f) {
  return a.replace(o, f);
}
function Yd(a, o, f) {
  return a.indexOf(o, f);
}
function Ll(a, o) {
  return a.charCodeAt(o) | 0;
}
function Go(a, o, f) {
  return a.slice(o, f);
}
function zr(a) {
  return a.length;
}
function vm(a) {
  return a.length;
}
function Xf(a, o) {
  return o.push(a), a;
}
function Np(a, o) {
  return a.map(o).join("");
}
function mb(a, o) {
  return a.filter(function(f) {
    return !$u(f, o);
  });
}
var ah = 1, ks = 1, ym = 0, ur = 0, ml = 0, Fs = "";
function ih(a, o, f, v, y, p, w, _) {
  return { value: a, root: o, parent: f, type: v, props: y, children: p, line: ah, column: ks, length: w, return: "", siblings: _ };
}
function io(a, o) {
  return zg(ih("", null, null, "", null, null, 0, a.siblings), a, { length: -a.length }, o);
}
function zs(a) {
  for (; a.root; )
    a = io(a.root, { children: [a] });
  Xf(a, a.siblings);
}
function Mp() {
  return ml;
}
function zp() {
  return ml = ur > 0 ? Ll(Fs, --ur) : 0, ks--, ml === 10 && (ks = 1, ah--), ml;
}
function Dr() {
  return ml = ur < ym ? Ll(Fs, ur++) : 0, ks++, ml === 10 && (ks = 1, ah++), ml;
}
function uo() {
  return Ll(Fs, ur);
}
function Gd() {
  return ur;
}
function rh(a, o) {
  return Go(Fs, a, o);
}
function Pf(a) {
  switch (a) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Dp(a) {
  return ah = ks = 1, ym = zr(Fs = a), ur = 0, [];
}
function Lp(a) {
  return Fs = "", a;
}
function mg(a) {
  return gm(rh(ur - 1, Dg(a === 91 ? a + 2 : a === 40 ? a + 1 : a)));
}
function kp(a) {
  for (; (ml = uo()) && ml < 33; )
    Dr();
  return Pf(a) > 2 || Pf(ml) > 3 ? "" : " ";
}
function Hp(a, o) {
  for (; --o && Dr() && !(ml < 48 || ml > 102 || ml > 57 && ml < 65 || ml > 70 && ml < 97); )
    ;
  return rh(a, Gd() + (o < 6 && uo() == 32 && Dr() == 32));
}
function Dg(a) {
  for (; Dr(); )
    switch (ml) {
      // ] ) " '
      case a:
        return ur;
      // " '
      case 34:
      case 39:
        a !== 34 && a !== 39 && Dg(ml);
        break;
      // (
      case 40:
        a === 41 && Dg(a);
        break;
      // \
      case 92:
        Dr();
        break;
    }
  return ur;
}
function Bp(a, o) {
  for (; Dr() && a + ml !== 57; )
    if (a + ml === 84 && uo() === 47)
      break;
  return "/*" + rh(o, ur - 1) + "*" + tv(a === 47 ? a : Dr());
}
function Up(a) {
  for (; !Pf(uo()); )
    Dr();
  return rh(a, ur);
}
function Fp(a) {
  return Lp(Xd("", null, null, null, [""], a = Dp(a), 0, [0], a));
}
function Xd(a, o, f, v, y, p, w, _, C) {
  for (var z = 0, B = 0, I = w, F = 0, ce = 0, ae = 0, $ = 1, he = 1, ge = 1, de = 0, De = "", Re = y, ye = p, xe = v, we = De; he; )
    switch (ae = de, de = Dr()) {
      // (
      case 40:
        if (ae != 108 && Ll(we, I - 1) == 58) {
          Yd(we += st(mg(de), "&", "&\f"), "&\f", hm(z ? _[z - 1] : 0)) != -1 && (ge = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        we += mg(de);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        we += kp(ae);
        break;
      // \
      case 92:
        we += Hp(Gd() - 1, 7);
        continue;
      // /
      case 47:
        switch (uo()) {
          case 42:
          case 47:
            Xf(Yp(Bp(Dr(), Gd()), o, f, C), C), (Pf(ae || 1) == 5 || Pf(uo() || 1) == 5) && zr(we) && Go(we, -1, void 0) !== " " && (we += " ");
            break;
          default:
            we += "/";
        }
        break;
      // {
      case 123 * $:
        _[z++] = zr(we) * ge;
      // } ; \0
      case 125 * $:
      case 59:
      case 0:
        switch (de) {
          // \0 }
          case 0:
          case 125:
            he = 0;
          // ;
          case 59 + B:
            ge == -1 && (we = st(we, /\f/g, "")), ce > 0 && (zr(we) - I || $ === 0 && ae === 47) && Xf(ce > 32 ? Tb(we + ";", v, f, I - 1, C) : Tb(st(we, " ", "") + ";", v, f, I - 2, C), C);
            break;
          // @ ;
          case 59:
            we += ";";
          // { rule/at-rule
          default:
            if (Xf(xe = pb(we, o, f, z, B, y, _, De, Re = [], ye = [], I, p), p), de === 123)
              if (B === 0)
                Xd(we, o, xe, xe, Re, p, I, _, ye);
              else {
                switch (F) {
                  // c(ontainer)
                  case 99:
                    if (Ll(we, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Ll(we, 2) === 97) break;
                  default:
                    B = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                B ? Xd(a, xe, xe, v && Xf(pb(a, xe, xe, 0, 0, y, _, De, y, Re = [], I, ye), ye), y, ye, I, _, v ? Re : ye) : Xd(we, xe, xe, xe, [""], ye, 0, _, ye);
              }
        }
        z = B = ce = 0, $ = ge = 1, De = we = "", I = w;
        break;
      // :
      case 58:
        I = 1 + zr(we), ce = ae;
      default:
        if ($ < 1) {
          if (de == 123)
            --$;
          else if (de == 125 && $++ == 0 && zp() == 125)
            continue;
        }
        switch (we += tv(de), de * $) {
          // &
          case 38:
            ge = B > 0 ? 1 : (we += "\f", -1);
            break;
          // ,
          case 44:
            _[z++] = (zr(we) - 1) * ge, ge = 1;
            break;
          // @
          case 64:
            uo() === 45 && (we += mg(Dr())), F = uo(), B = I = zr(De = we += Up(Gd())), de++;
            break;
          // -
          case 45:
            ae === 45 && zr(we) == 2 && ($ = 0);
        }
    }
  return p;
}
function pb(a, o, f, v, y, p, w, _, C, z, B, I) {
  for (var F = y - 1, ce = y === 0 ? p : [""], ae = vm(ce), $ = 0, he = 0, ge = 0; $ < v; ++$)
    for (var de = 0, De = Go(a, F + 1, F = hm(he = w[$])), Re = a; de < ae; ++de)
      (Re = gm(he > 0 ? ce[de] + " " + De : st(De, /&\f/g, ce[de]))) && (C[ge++] = Re);
  return ih(a, o, f, y === 0 ? lh : _, C, z, B, I);
}
function Yp(a, o, f, v) {
  return ih(a, o, f, fm, tv(Mp()), Go(a, 2, -2), 0, v);
}
function Tb(a, o, f, v, y) {
  return ih(a, o, f, ev, Go(a, 0, v), Go(a, v + 1, -1), v, y);
}
function bm(a, o, f) {
  switch (Rp(a, o)) {
    // color-adjust
    case 5103:
      return Gt + "print-" + a + a;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return Gt + a + a;
    // mask-composite
    case 4855:
      return Gt + a.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + a;
    // tab-size
    case 4789:
      return Zf + a + a;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Gt + a + Zf + a + On + a + a;
    // writing-mode
    case 5936:
      switch (Ll(a, o + 11)) {
        // vertical-l(r)
        case 114:
          return Gt + a + On + st(a, /[svh]\w+-[tblr]{2}/, "tb") + a;
        // vertical-r(l)
        case 108:
          return Gt + a + On + st(a, /[svh]\w+-[tblr]{2}/, "tb-rl") + a;
        // horizontal(-)tb
        case 45:
          return Gt + a + On + st(a, /[svh]\w+-[tblr]{2}/, "lr") + a;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return Gt + a + On + a + a;
    // order
    case 6165:
      return Gt + a + On + "flex-" + a + a;
    // align-items
    case 5187:
      return Gt + a + st(a, /(\w+).+(:[^]+)/, Gt + "box-$1$2" + On + "flex-$1$2") + a;
    // align-self
    case 5443:
      return Gt + a + On + "flex-item-" + st(a, /flex-|-self/g, "") + ($u(a, /flex-|baseline/) ? "" : On + "grid-row-" + st(a, /flex-|-self/g, "")) + a;
    // align-content
    case 4675:
      return Gt + a + On + "flex-line-pack" + st(a, /align-content|flex-|-self/g, "") + a;
    // flex-shrink
    case 5548:
      return Gt + a + On + st(a, "shrink", "negative") + a;
    // flex-basis
    case 5292:
      return Gt + a + On + st(a, "basis", "preferred-size") + a;
    // flex-grow
    case 6060:
      return Gt + "box-" + st(a, "-grow", "") + Gt + a + On + st(a, "grow", "positive") + a;
    // transition
    case 4554:
      return Gt + st(a, /([^-])(transform)/g, "$1" + Gt + "$2") + a;
    // cursor
    case 6187:
      return st(st(st(a, /(zoom-|grab)/, Gt + "$1"), /(image-set)/, Gt + "$1"), a, "") + a;
    // background, background-image
    case 5495:
    case 3959:
      return st(a, /(image-set\([^]*)/, Gt + "$1$`$1");
    // justify-content
    case 4968:
      return st(st(a, /(.+:)(flex-)?(.*)/, Gt + "box-pack:$3" + On + "flex-pack:$3"), /space-between/, "justify") + Gt + a + a;
    // justify-self
    case 4200:
      if (!$u(a, /flex-|baseline/)) return On + "grid-column-align" + Go(a, o) + a;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return On + st(a, "template-", "") + a;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return f && f.some(function(v, y) {
        return o = y, $u(v.props, /grid-\w+-end/);
      }) ? ~Yd(a + (f = f[o].value), "span", 0) ? a : On + st(a, "-start", "") + a + On + "grid-row-span:" + (~Yd(f, "span", 0) ? $u(f, /\d+/) : +$u(f, /\d+/) - +$u(a, /\d+/)) + ";" : On + st(a, "-start", "") + a;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return f && f.some(function(v) {
        return $u(v.props, /grid-\w+-start/);
      }) ? a : On + st(st(a, "-end", "-span"), "span ", "") + a;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return st(a, /(.+)-inline(.+)/, Gt + "$1$2") + a;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (zr(a) - 1 - o > 6)
        switch (Ll(a, o + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Ll(a, o + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return st(a, /(.+:)(.+)-([^]+)/, "$1" + Gt + "$2-$3$1" + Zf + (Ll(a, o + 3) == 108 ? "$3" : "$2-$3")) + a;
          // (s)tretch
          case 115:
            return ~Yd(a, "stretch", 0) ? bm(st(a, "stretch", "fill-available"), o, f) + a : a;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return st(a, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(v, y, p, w, _, C, z) {
        return On + y + ":" + p + z + (w ? On + y + "-span:" + (_ ? C : +C - +p) + z : "") + a;
      });
    // position: sticky
    case 4949:
      if (Ll(a, o + 6) === 121)
        return st(a, ":", ":" + Gt) + a;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Ll(a, Ll(a, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return st(a, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Gt + (Ll(a, 14) === 45 ? "inline-" : "") + "box$3$1" + Gt + "$2$3$1" + On + "$2box$3") + a;
        // (inline-)?gri(d)
        case 100:
          return st(a, ":", ":" + On) + a;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return st(a, "scroll-", "scroll-snap-") + a;
  }
  return a;
}
function jd(a, o) {
  for (var f = "", v = 0; v < a.length; v++)
    f += o(a[v], v, a, o) || "";
  return f;
}
function Gp(a, o, f, v) {
  switch (a.type) {
    case Cp:
      if (a.children.length) break;
    case _p:
    case Op:
    case ev:
      return a.return = a.return || a.value;
    case fm:
      return "";
    case dm:
      return a.return = a.value + "{" + jd(a.children, v) + "}";
    case lh:
      if (!zr(a.value = a.props.join(","))) return "";
  }
  return zr(f = jd(a.children, v)) ? a.return = a.value + "{" + f + "}" : "";
}
function Xp(a) {
  var o = vm(a);
  return function(f, v, y, p) {
    for (var w = "", _ = 0; _ < o; _++)
      w += a[_](f, v, y, p) || "";
    return w;
  };
}
function Ip(a) {
  return function(o) {
    o.root || (o = o.return) && a(o);
  };
}
function Zp(a, o, f, v) {
  if (a.length > -1 && !a.return)
    switch (a.type) {
      case ev:
        a.return = bm(a.value, a.length, f);
        return;
      case dm:
        return jd([io(a, { value: st(a.value, "@", "@" + Gt) })], v);
      case lh:
        if (a.length)
          return Np(f = a.props, function(y) {
            switch ($u(y, v = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                zs(io(a, { props: [st(y, /:(read-\w+)/, ":" + Zf + "$1")] })), zs(io(a, { props: [y] })), zg(a, { props: mb(f, v) });
                break;
              // :placeholder
              case "::placeholder":
                zs(io(a, { props: [st(y, /:(plac\w+)/, ":" + Gt + "input-$1")] })), zs(io(a, { props: [st(y, /:(plac\w+)/, ":" + Zf + "$1")] })), zs(io(a, { props: [st(y, /:(plac\w+)/, On + "input-$1")] })), zs(io(a, { props: [y] })), zg(a, { props: mb(f, v) });
                break;
            }
            return "";
          });
    }
}
var cn = { env: { NODE_ENV: "production" } }, pg, Tg;
const Xo = typeof cn < "u" && cn.env !== void 0 && (cn.env.REACT_APP_SC_ATTR || cn.env.SC_ATTR) || "data-styled", mm = "active", pm = "data-styled-version", uh = "6.4.2", nv = `/*!sc*/
`, Vf = typeof window < "u" && typeof document < "u";
function Sb(a) {
  if (typeof cn < "u" && cn.env !== void 0) {
    const o = cn.env[a];
    if (o !== void 0 && o !== "") return o !== "false";
  }
}
const Vp = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Tg = (pg = Sb("REACT_APP_SC_DISABLE_SPEEDY")) !== null && pg !== void 0 ? pg : Sb("SC_DISABLE_SPEEDY")) !== null && Tg !== void 0 ? Tg : typeof cn < "u" && cn.env !== void 0 && cn.env.NODE_ENV !== "production"), Qp = "sc-keyframes-", Pp = cn.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Jf(a, ...o) {
  return cn.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${a} for more information.${o.length > 0 ? ` Args: ${o.join(", ")}` : ""}`) : new Error((function(...f) {
    let v = f[0];
    const y = [];
    for (let p = 1, w = f.length; p < w; p += 1) y.push(f[p]);
    return y.forEach((p) => {
      v = v.replace(/%[a-z]/, p);
    }), v;
  })(Pp[a], ...o).trim());
}
const Wp = 1 << 30;
let Id = /* @__PURE__ */ new Map(), qd = /* @__PURE__ */ new Map(), Zd = 1;
const Ld = (a) => {
  if (Id.has(a)) return Id.get(a);
  for (; qd.has(Zd); ) Zd++;
  const o = Zd++;
  if (cn.env.NODE_ENV !== "production" && ((0 | o) < 0 || o > Wp)) throw Jf(16, `${o}`);
  return Id.set(a, o), qd.set(o, a), o;
}, Jp = (a) => qd.get(a), Kp = (a, o) => {
  Zd = o + 1, Id.set(a, o), qd.set(o, a);
}, xb = /invalid hook call/i, kd = /* @__PURE__ */ new Set(), jp = (a, o) => {
  if (cn.env.NODE_ENV !== "production") {
    const f = `The component ${a}${o ? ` with the id of "${o}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, v = console.error;
    try {
      let y = !0;
      console.error = (p, ...w) => {
        xb.test(p) ? (y = !1, kd.delete(f)) : v(p, ...w);
      }, typeof Xt.useState == "function" && Xt.useState(null), y && !kd.has(f) && (console.warn(f), kd.add(f));
    } catch (y) {
      xb.test(y.message) && kd.delete(f);
    } finally {
      console.error = v;
    }
  }
}, lv = Object.freeze([]), Hs = Object.freeze({});
function qp(a, o, f = Hs) {
  return a.theme !== f.theme && a.theme || o || f.theme;
}
const $p = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, eT = /(^-|-$)/g;
function Tm(a) {
  return a.replace($p, "-").replace(eT, "");
}
const tT = /(a)(d)/gi, Eb = (a) => String.fromCharCode(a + (a > 25 ? 39 : 97));
function Sm(a) {
  let o, f = "";
  for (o = Math.abs(a); o > 52; o = o / 52 | 0) f = Eb(o % 52) + f;
  return (Eb(o % 52) + f).replace(tT, "$1-$2");
}
const Lg = 5381, Uo = (a, o) => {
  let f = o.length;
  for (; f; ) a = 33 * a ^ o.charCodeAt(--f);
  return a;
}, xm = (a) => Uo(Lg, a);
function nT(a) {
  return Sm(xm(a) >>> 0);
}
function av(a) {
  return cn.env.NODE_ENV !== "production" && typeof a == "string" && a || a.displayName || a.name || "Component";
}
function Vd(a) {
  return typeof a == "string" && (cn.env.NODE_ENV === "production" || a.charAt(0) === a.charAt(0).toLowerCase());
}
function lT(a) {
  return Vd(a) ? `styled.${a}` : `Styled(${av(a)})`;
}
const Em = Symbol.for("react.memo"), aT = Symbol.for("react.forward_ref"), iT = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, rT = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, wm = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, uT = { [aT]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [Em]: wm };
function wb(a) {
  return ("type" in (o = a) && o.type.$$typeof) === Em ? wm : "$$typeof" in a ? uT[a.$$typeof] : iT;
  var o;
}
const cT = Object.defineProperty, oT = Object.getOwnPropertyNames, sT = Object.getOwnPropertySymbols, fT = Object.getOwnPropertyDescriptor, dT = Object.getPrototypeOf, hT = Object.prototype;
function Am(a, o, f) {
  if (typeof o != "string") {
    const v = dT(o);
    v && v !== hT && Am(a, v, f);
    const y = oT(o).concat(sT(o)), p = wb(a), w = wb(o);
    for (let _ = 0; _ < y.length; ++_) {
      const C = y[_];
      if (!(C in rT || f && f[C] || w && C in w || p && C in p)) {
        const z = fT(o, C);
        try {
          cT(a, C, z);
        } catch {
        }
      }
    }
  }
  return a;
}
function ch(a) {
  return typeof a == "function";
}
const gT = Symbol.for("react.forward_ref");
function _m(a) {
  return a != null && (typeof a == "object" || typeof a == "function") && a.$$typeof === gT && "styledComponentId" in a;
}
function If(a, o) {
  return a && o ? a + " " + o : a || o || "";
}
function Ab(a, o) {
  return a.join("");
}
function Io(a) {
  return a !== null && typeof a == "object" && a.constructor.name === Object.name && !("props" in a && a.$$typeof);
}
function kg(a, o, f = !1) {
  if (!f && !Io(a) && !Array.isArray(a)) return o;
  if (Array.isArray(o)) for (let v = 0; v < o.length; v++) a[v] = kg(a[v], o[v]);
  else if (Io(o)) for (const v in o) a[v] = kg(a[v], o[v]);
  return a;
}
function Om(a, o) {
  Object.defineProperty(a, "toString", { value: o });
}
const vT = class {
  constructor(a) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = a, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(a) {
    if (a === this._cGroup) return this._cIndex;
    let o = this._cIndex;
    if (a > this._cGroup) for (let f = this._cGroup; f < a; f++) o += this.groupSizes[f];
    else for (let f = this._cGroup - 1; f >= a; f--) o -= this.groupSizes[f];
    return this._cGroup = a, this._cIndex = o, o;
  }
  insertRules(a, o) {
    if (a >= this.groupSizes.length) {
      const y = this.groupSizes, p = y.length;
      let w = p;
      for (; a >= w; ) if (w <<= 1, w < 0) throw Jf(16, `${a}`);
      this.groupSizes = new Uint32Array(w), this.groupSizes.set(y), this.length = w;
      for (let _ = p; _ < w; _++) this.groupSizes[_] = 0;
    }
    let f = this.indexOfGroup(a + 1), v = 0;
    for (let y = 0, p = o.length; y < p; y++) this.tag.insertRule(f, o[y]) && (this.groupSizes[a]++, f++, v++);
    v > 0 && this._cGroup > a && (this._cIndex += v);
  }
  clearGroup(a) {
    if (a < this.length) {
      const o = this.groupSizes[a], f = this.indexOfGroup(a), v = f + o;
      this.groupSizes[a] = 0;
      for (let y = f; y < v; y++) this.tag.deleteRule(f);
      o > 0 && this._cGroup > a && (this._cIndex -= o);
    }
  }
  getGroup(a) {
    let o = "";
    if (a >= this.length || this.groupSizes[a] === 0) return o;
    const f = this.groupSizes[a], v = this.indexOfGroup(a), y = v + f;
    for (let p = v; p < y; p++) o += this.tag.getRule(p) + nv;
    return o;
  }
}, yT = `style[${Xo}][${pm}="${uh}"]`, bT = new RegExp(`^${Xo}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), _b = (a) => typeof ShadowRoot < "u" && a instanceof ShadowRoot || "host" in a && a.nodeType === 11, Hg = (a) => {
  if (!a) return document;
  if (_b(a)) return a;
  if ("getRootNode" in a) {
    const o = a.getRootNode();
    if (_b(o)) return o;
  }
  return document;
}, mT = (a, o, f) => {
  const v = f.split(",");
  let y;
  for (let p = 0, w = v.length; p < w; p++) (y = v[p]) && a.registerName(o, y);
}, pT = (a, o) => {
  var f;
  const v = ((f = o.textContent) !== null && f !== void 0 ? f : "").split(nv), y = [];
  for (let p = 0, w = v.length; p < w; p++) {
    const _ = v[p].trim();
    if (!_) continue;
    const C = _.match(bT);
    if (C) {
      const z = 0 | parseInt(C[1], 10), B = C[2];
      z !== 0 && (Kp(B, z), mT(a, B, C[3]), a.getTag().insertRules(z, y)), y.length = 0;
    } else y.push(_);
  }
}, Sg = (a) => {
  const o = Hg(a.options.target).querySelectorAll(yT);
  for (let f = 0, v = o.length; f < v; f++) {
    const y = o[f];
    y && y.getAttribute(Xo) !== mm && (pT(a, y), y.parentNode && y.parentNode.removeChild(y));
  }
};
let Ff = !1;
function TT() {
  if (Ff !== !1) return Ff;
  if (typeof document < "u") {
    const a = document.head.querySelector('meta[property="csp-nonce"]');
    if (a) return Ff = a.nonce || a.getAttribute("content") || void 0;
    const o = document.head.querySelector('meta[name="sc-nonce"]');
    if (o) return Ff = o.getAttribute("content") || void 0;
  }
  return Ff = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const Cm = (a, o) => {
  const f = document.head, v = a || f, y = document.createElement("style"), p = ((C) => {
    const z = Array.from(C.querySelectorAll(`style[${Xo}]`));
    return z[z.length - 1];
  })(v), w = p !== void 0 ? p.nextSibling : null;
  y.setAttribute(Xo, mm), y.setAttribute(pm, uh);
  const _ = o || TT();
  return _ && y.setAttribute("nonce", _), v.insertBefore(y, w), y;
}, ST = class {
  constructor(a, o) {
    this.element = Cm(a, o), this.element.appendChild(document.createTextNode("")), this.sheet = ((f) => {
      var v;
      if (f.sheet) return f.sheet;
      const y = (v = f.getRootNode().styleSheets) !== null && v !== void 0 ? v : document.styleSheets;
      for (let p = 0, w = y.length; p < w; p++) {
        const _ = y[p];
        if (_.ownerNode === f) return _;
      }
      throw Jf(17);
    })(this.element), this.length = 0;
  }
  insertRule(a, o) {
    try {
      return this.sheet.insertRule(o, a), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(a) {
    this.sheet.deleteRule(a), this.length--;
  }
  getRule(a) {
    const o = this.sheet.cssRules[a];
    return o && o.cssText ? o.cssText : "";
  }
}, xT = class {
  constructor(a, o) {
    this.element = Cm(a, o), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(a, o) {
    if (a <= this.length && a >= 0) {
      const f = document.createTextNode(o);
      return this.element.insertBefore(f, this.nodes[a] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(a) {
    this.element.removeChild(this.nodes[a]), this.length--;
  }
  getRule(a) {
    return a < this.length ? this.nodes[a].textContent : "";
  }
};
let Ob = Vf;
const ET = { isServer: !Vf, useCSSOMInjection: !Vp };
class oh {
  static registerId(o) {
    return Ld(o);
  }
  constructor(o = Hs, f = {}, v) {
    this.options = Object.assign(Object.assign({}, ET), o), this.gs = f, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(v), this.server = !!o.isServer, !this.server && Vf && Ob && (Ob = !1, Sg(this)), Om(this, () => ((y) => {
      const p = y.getTag(), { length: w } = p;
      let _ = "";
      for (let C = 0; C < w; C++) {
        const z = Jp(C);
        if (z === void 0) continue;
        const B = y.names.get(z);
        if (B === void 0 || !B.size) continue;
        const I = p.getGroup(C);
        if (I.length === 0) continue;
        const F = Xo + ".g" + C + '[id="' + z + '"]';
        let ce = "";
        for (const ae of B) ae.length > 0 && (ce += ae + ",");
        _ += I + F + '{content:"' + ce + '"}' + nv;
      }
      return _;
    })(this));
  }
  rehydrate() {
    !this.server && Vf && Sg(this);
  }
  reconstructWithOptions(o, f = !0) {
    const v = new oh(Object.assign(Object.assign({}, this.options), o), this.gs, f && this.names || void 0);
    return v.keyframeIds = new Set(this.keyframeIds), !this.server && Vf && o.target !== this.options.target && Hg(this.options.target) !== Hg(o.target) && Sg(v), v;
  }
  allocateGSInstance(o) {
    return this.gs[o] = (this.gs[o] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (o = (({ useCSSOMInjection: f, target: v, nonce: y }) => f ? new ST(v, y) : new xT(v, y))(this.options), new vT(o)));
    var o;
  }
  hasNameForId(o, f) {
    var v, y;
    return (y = (v = this.names.get(o)) === null || v === void 0 ? void 0 : v.has(f)) !== null && y !== void 0 && y;
  }
  registerName(o, f) {
    Ld(o), o.startsWith(Qp) && this.keyframeIds.add(o);
    const v = this.names.get(o);
    v ? v.add(f) : this.names.set(o, /* @__PURE__ */ new Set([f]));
  }
  insertRules(o, f, v) {
    this.registerName(o, f), this.getTag().insertRules(Ld(o), v);
  }
  clearNames(o) {
    this.names.has(o) && this.names.get(o).clear();
  }
  clearRules(o) {
    this.getTag().clearGroup(Ld(o)), this.clearNames(o);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const Rm = /* @__PURE__ */ new WeakSet(), wT = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function AT(a, o) {
  return o == null || typeof o == "boolean" || o === "" ? "" : typeof o != "number" || o === 0 || a in wT || a.startsWith("--") ? String(o).trim() : o + "px";
}
const Bo = 47;
function Cb(a) {
  if (a.charCodeAt(0) === 45 && a.charCodeAt(1) === 45) return a;
  let o = "";
  for (let f = 0; f < a.length; f++) {
    const v = a.charCodeAt(f);
    o += v >= 65 && v <= 90 ? "-" + String.fromCharCode(v + 32) : a[f];
  }
  return o.startsWith("ms-") ? "-" + o : o;
}
const _T = Symbol.for("sc-keyframes");
function Bg(a) {
  return typeof a == "object" && a !== null && _T in a;
}
function Nm(a) {
  return ch(a) && !(a.prototype && a.prototype.isReactComponent);
}
const Mm = (a) => a == null || a === !1 || a === "", OT = Symbol.for("react.client.reference");
function Rb(a) {
  return a.$$typeof === OT;
}
function Nb(a) {
  const o = a.$$id, f = (o && o.includes("#") ? o.split("#").pop() : o) || a.name || "unknown";
  console.warn(`Interpolating a client component (${f}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function zm(a, o) {
  for (const f in a) {
    const v = a[f];
    a.hasOwnProperty(f) && !Mm(v) && (Array.isArray(v) && Rm.has(v) || ch(v) ? o.push(Cb(f) + ":", v, ";") : Io(v) ? (o.push(f + " {"), zm(v, o), o.push("}")) : o.push(Cb(f) + ": " + AT(f, v) + ";"));
  }
}
function Fo(a, o, f, v, y = []) {
  if (Mm(a)) return y;
  const p = typeof a;
  if (p === "string") return y.push(a), y;
  if (p === "function") {
    if (Rb(a)) return cn.env.NODE_ENV !== "production" && Nb(a), y;
    if (Nm(a) && o) {
      const w = a(o);
      return cn.env.NODE_ENV === "production" || typeof w != "object" || Array.isArray(w) || Bg(w) || Io(w) || w === null || console.error(`${av(a)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), Fo(w, o, f, v, y);
    }
    return y.push(a), y;
  }
  if (Array.isArray(a)) {
    for (let w = 0; w < a.length; w++) Fo(a[w], o, f, v, y);
    return y;
  }
  return _m(a) ? (y.push(`.${a.styledComponentId}`), y) : Bg(a) ? (f ? (a.inject(f, v), y.push(a.getName(v))) : y.push(a), y) : Rb(a) ? (cn.env.NODE_ENV !== "production" && Nb(a), y) : Io(a) ? a.toString !== Object.prototype.toString ? (y.push(a.toString()), y) : (zm(a, y), y) : (y.push(a.toString()), y);
}
const CT = xm(uh);
class RT {
  constructor(o, f, v) {
    this.rules = o, this.componentId = f, this.baseHash = Uo(CT, f), this.baseStyle = v, oh.registerId(f);
  }
  generateAndInjectStyles(o, f, v) {
    let y = this.baseStyle ? this.baseStyle.generateAndInjectStyles(o, f, v) : "";
    {
      let p = "";
      for (let w = 0; w < this.rules.length; w++) {
        const _ = this.rules[w];
        if (typeof _ == "string") p += _;
        else if (_) if (Nm(_)) {
          const C = _(o);
          typeof C == "string" ? p += C : C != null && C !== !1 && (cn.env.NODE_ENV === "production" || typeof C != "object" || Array.isArray(C) || Bg(C) || Io(C) || console.error(`${av(_)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), p += Ab(Fo(C, o, f, v)));
        } else p += Ab(Fo(_, o, f, v));
      }
      if (p) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const w = v.hash ? v.hash + p : p;
        let _ = this.dynamicNameCache.get(w);
        if (!_) {
          if (_ = Sm(Uo(Uo(this.baseHash, v.hash), p) >>> 0), this.dynamicNameCache.size >= 200) {
            const C = this.dynamicNameCache.keys().next().value;
            C !== void 0 && this.dynamicNameCache.delete(C);
          }
          this.dynamicNameCache.set(w, _);
        }
        if (!f.hasNameForId(this.componentId, _)) {
          const C = v(p, "." + _, void 0, this.componentId);
          f.insertRules(this.componentId, _, C);
        }
        y = If(y, _);
      }
    }
    return y;
  }
}
const NT = /&/g;
function Dm(a, o) {
  let f = 0;
  for (; --o >= 0 && a.charCodeAt(o) === 92; ) f++;
  return !(1 & ~f);
}
function xg(a) {
  const o = a.length;
  let f = "", v = 0, y = 0, p = 0, w = !1, _ = !1;
  for (let C = 0; C < o; C++) {
    const z = a.charCodeAt(C);
    if (p !== 0 || w || z !== Bo || a.charCodeAt(C + 1) !== 42) if (w) z === 42 && a.charCodeAt(C + 1) === Bo && (w = !1, C++);
    else if (z !== 34 && z !== 39 || Dm(a, C)) {
      if (p === 0) if (z === 123) y++;
      else if (z === 125) {
        if (y--, y < 0) {
          _ = !0;
          let B = C + 1;
          for (; B < o; ) {
            const I = a.charCodeAt(B);
            if (I === 59 || I === 10) break;
            B++;
          }
          B < o && a.charCodeAt(B) === 59 && B++, y = 0, C = B - 1, v = B;
          continue;
        }
        y === 0 && (f += a.substring(v, C + 1), v = C + 1);
      } else z === 59 && y === 0 && (f += a.substring(v, C + 1), v = C + 1);
    } else p === 0 ? p = z : p === z && (p = 0);
    else w = !0, C++;
  }
  return _ || y !== 0 || p !== 0 ? (v < o && y === 0 && p === 0 && (f += a.substring(v)), f) : a;
}
function Lm(a, o) {
  const f = o + " ", v = "," + f;
  for (let y = 0; y < a.length; y++) {
    const p = a[y];
    if (p.type === "rule") {
      p.value = (f + p.value).replaceAll(",", v);
      const w = p.props, _ = [];
      for (let C = 0; C < w.length; C++) _[C] = f + w[C];
      p.props = _;
    }
    Array.isArray(p.children) && p.type !== "@keyframes" && Lm(p.children, o);
  }
  return a;
}
function MT({ options: a = Hs, plugins: o = lv } = Hs) {
  let f, v, y;
  const p = (F, ce, ae) => ae.startsWith(v) && ae.endsWith(v) && ae.replaceAll(v, "").length > 0 ? `.${f}` : F, w = o.slice();
  w.push((F) => {
    F.type === lh && F.value.includes("&") && (y || (y = new RegExp(`\\${v}\\b`, "g")), F.props[0] = F.props[0].replace(NT, v).replace(y, p));
  }), a.prefix && w.push(Zp), w.push(Gp);
  let _ = [];
  const C = Xp(w.concat(Ip((F) => _.push(F)))), z = (F, ce = "", ae = "", $ = "&") => {
    f = $, v = ce, y = void 0;
    const he = (function(de) {
      const De = de.indexOf("//") !== -1, Re = de.indexOf("}") !== -1;
      if (!De && !Re) return de;
      if (!De) return xg(de);
      const ye = de.length;
      let xe = "", we = 0, Me = 0, He = 0, Ot = 0, wt = 0, At = !1;
      for (; Me < ye; ) {
        const Ae = de.charCodeAt(Me);
        if (Ae !== 34 && Ae !== 39 || Dm(de, Me)) if (He === 0) if (Ae === Bo && Me + 1 < ye && de.charCodeAt(Me + 1) === 42) {
          for (Me += 2; Me + 1 < ye && (de.charCodeAt(Me) !== 42 || de.charCodeAt(Me + 1) !== Bo); ) Me++;
          Me += 2;
        } else if (Ae !== 40) if (Ae !== 41) if (Ot > 0) Me++;
        else if (Ae === 42 && Me + 1 < ye && de.charCodeAt(Me + 1) === Bo) xe += de.substring(we, Me), Me += 2, we = Me, At = !0;
        else if (Ae === Bo && Me + 1 < ye && de.charCodeAt(Me + 1) === Bo) {
          for (xe += de.substring(we, Me); Me < ye && de.charCodeAt(Me) !== 10; ) Me++;
          we = Me, At = !0;
        } else Ae === 123 ? wt++ : Ae === 125 && wt--, Me++;
        else Ot > 0 && Ot--, Me++;
        else Ot++, Me++;
        else Me++;
        else He === 0 ? He = Ae : He === Ae && (He = 0), Me++;
      }
      return At ? (we < ye && (xe += de.substring(we)), wt === 0 ? xe : xg(xe)) : wt === 0 ? de : xg(de);
    })(F);
    let ge = Fp(ae || ce ? ae + " " + ce + " { " + he + " }" : he);
    return a.namespace && (ge = Lm(ge, a.namespace)), _ = [], jd(ge, C), _;
  }, B = a;
  let I = Lg;
  for (let F = 0; F < o.length; F++) o[F].name || Jf(15), I = Uo(I, o[F].name);
  return B != null && B.namespace && (I = Uo(I, B.namespace)), B != null && B.prefix && (I = Uo(I, "p")), z.hash = I !== Lg ? I.toString() : "", z;
}
const zT = new oh(), DT = MT(), km = Xt.createContext({ shouldForwardProp: void 0, styleSheet: zT, stylis: DT, stylisPlugins: void 0 });
km.Consumer;
function LT() {
  return Xt.useContext(km);
}
const Hm = Xt.createContext(void 0);
Hm.Consumer;
const Mb = Object.prototype.hasOwnProperty, Eg = {};
function kT(a, o) {
  const f = typeof a != "string" ? "sc" : Tm(a);
  Eg[f] = (Eg[f] || 0) + 1;
  const v = f + "-" + nT(uh + f + Eg[f]);
  return o ? o + "-" + v : v;
}
let wg;
function HT(a, o, f) {
  const v = _m(a), y = a, p = !Vd(a), { attrs: w = lv, componentId: _ = kT(o.displayName, o.parentComponentId), displayName: C = lT(a) } = o, z = o.displayName && o.componentId ? Tm(o.displayName) + "-" + o.componentId : o.componentId || _, B = v && y.attrs ? y.attrs.concat(w).filter(Boolean) : w;
  let { shouldForwardProp: I } = o;
  if (v && y.shouldForwardProp) {
    const $ = y.shouldForwardProp;
    if (o.shouldForwardProp) {
      const he = o.shouldForwardProp;
      I = (ge, de) => $(ge, de) && he(ge, de);
    } else I = $;
  }
  const F = new RT(f, z, v ? y.componentStyle : void 0);
  function ce($, he) {
    return (function(ge, de, De) {
      const { attrs: Re, componentStyle: ye, defaultProps: xe, foldedComponentIds: we, styledComponentId: Me, target: He } = ge, Ot = Xt.useContext(Hm), wt = LT(), At = ge.shouldForwardProp || wt.shouldForwardProp;
      cn.env.NODE_ENV !== "production" && Xt.useDebugValue && Xt.useDebugValue(Me);
      const Ae = qp(de, Ot, xe) || Hs;
      let Xe, it;
      {
        const et = Xt.useRef(null), ue = et.current;
        if (ue !== null && ue[1] === Ae && ue[2] === wt.styleSheet && ue[3] === wt.stylis && ue[7] === ye && (function(Q, ct, tt) {
          const _e = Q, Ne = ct;
          let It = 0;
          for (const en in Ne) if (Mb.call(Ne, en) && (It++, _e[en] !== Ne[en])) return !1;
          return It === tt;
        })(ue[0], de, ue[4])) Xe = ue[5], it = ue[6];
        else {
          Xe = (function(ct, tt, _e) {
            const Ne = Object.assign(Object.assign({}, tt), { className: void 0, theme: _e }), It = ct.length > 1;
            for (let en = 0; en < ct.length; en++) {
              const Pl = ct[en], kl = ch(Pl) ? Pl(It ? Object.assign({}, Ne) : Ne) : Pl;
              for (const Xn in kl) Xn === "className" ? Ne.className = If(Ne.className, kl[Xn]) : Xn === "style" ? Ne.style = Object.assign(Object.assign({}, Ne.style), kl[Xn]) : Xn in tt && tt[Xn] === void 0 || (Ne[Xn] = kl[Xn]);
            }
            return "className" in tt && typeof tt.className == "string" && (Ne.className = If(Ne.className, tt.className)), Ne;
          })(Re, de, Ae), it = (function(ct, tt, _e, Ne) {
            const It = ct.generateAndInjectStyles(tt, _e, Ne);
            return cn.env.NODE_ENV !== "production" && Xt.useDebugValue && Xt.useDebugValue(It), It;
          })(ye, Xe, wt.styleSheet, wt.stylis);
          let Q = 0;
          for (const ct in de) Mb.call(de, ct) && Q++;
          et.current = [de, Ae, wt.styleSheet, wt.stylis, Q, Xe, it, ye];
        }
      }
      cn.env.NODE_ENV !== "production" && ge.warnTooManyClasses && ge.warnTooManyClasses(it);
      const U = Xe.as || He, P = (function(et, ue, Q, ct) {
        const tt = {};
        for (const _e in et) et[_e] === void 0 || _e[0] === "$" || _e === "as" || _e === "theme" && et.theme === Q || (_e === "forwardedAs" ? tt.as = et.forwardedAs : ct && !ct(_e, ue) || (tt[_e] = et[_e], ct || cn.env.NODE_ENV !== "development" || Ap(_e) || (wg || (wg = /* @__PURE__ */ new Set())).has(_e) || !Vd(ue) || ue.includes("-") || (wg.add(_e), console.warn(`styled-components: it looks like an unknown prop "${_e}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return tt;
      })(Xe, U, Ae, At);
      let Se = If(we, Me);
      return it && (Se += " " + it), Xe.className && (Se += " " + Xe.className), P[Vd(U) && U.includes("-") ? "class" : "className"] = Se, De && (P.ref = De), T1(U, P);
    })(ae, $, he);
  }
  ce.displayName = C;
  let ae = Xt.forwardRef(ce);
  return ae.attrs = B, ae.componentStyle = F, ae.displayName = C, ae.shouldForwardProp = I, ae.foldedComponentIds = v ? If(y.foldedComponentIds, y.styledComponentId) : "", ae.styledComponentId = z, ae.target = v ? y.target : a, Object.defineProperty(ae, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set($) {
    this._foldedDefaultProps = v ? (function(he, ...ge) {
      for (const de of ge) kg(he, de, !0);
      return he;
    })({}, y.defaultProps, $) : $;
  } }), cn.env.NODE_ENV !== "production" && (jp(C, z), ae.warnTooManyClasses = /* @__PURE__ */ (($, he) => {
    let ge = {}, de = !1;
    return (De) => {
      !de && (ge[De] = !0, Object.keys(ge).length >= 200) && (console.warn(`Over 200 classes were generated for component ${$}${he ? ` with the id of "${he}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), de = !0, ge = {});
    };
  })(C, z)), Om(ae, () => `.${ae.styledComponentId}`), p && Am(ae, a, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), ae;
}
var BT = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function zb(a, o) {
  const f = [a[0]];
  for (let v = 0, y = o.length; v < y; v += 1) f.push(o[v], a[v + 1]);
  return f;
}
const Db = (a) => (Rm.add(a), a);
function UT(a, ...o) {
  if (ch(a) || Io(a)) return Db(Fo(zb(lv, [a, ...o])));
  const f = a;
  return o.length === 0 && f.length === 1 && typeof f[0] == "string" ? Fo(f) : Db(Fo(zb(f, o)));
}
function Ug(a, o, f = Hs) {
  if (!o) throw Jf(1, o);
  const v = (y, ...p) => a(o, f, UT(y, ...p));
  return v.attrs = (y) => Ug(a, o, Object.assign(Object.assign({}, f), { attrs: Array.prototype.concat(f.attrs, y).filter(Boolean) })), v.withConfig = (y) => Ug(a, o, Object.assign(Object.assign({}, f), y)), v;
}
const Bm = (a) => Ug(HT, a), gu = Bm;
BT.forEach((a) => {
  gu[a] = Bm(a);
});
cn.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Hd = `__sc-${Xo}__`;
cn.env.NODE_ENV !== "production" && cn.env.NODE_ENV !== "test" && typeof window < "u" && (window[Hd] || (window[Hd] = 0), window[Hd] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Hd] += 1);
const FT = gu.div`
  &.sticky {
    position: fixed;
    top: var(--uds-anchor-menu-top, 0px);
    left: 0;
    width: 100%;
  }
  .mobile-menu-toggler {
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: inherit;
    i {
      transition: all 0.3s;
    }
  }
  .show-menu i {
    transform: rotate(-180deg);
  }
  .nav-link {
    border: none;
    background-color: #ffffff;
    i {
      width: 2rem !important;
      text-align: center !important;
    }
  }
`, Qd = "On This Page", YT = {
  event: "collapse",
  name: "onclick",
  type: "click",
  text: Qd
}, Um = ({
  items: a,
  firstElementId: o,
  focusFirstFocusableElement: f = !1
}) => {
  const { isReact: v, isBootstrap: y } = Vo(), p = Yo(null), w = z1("(max-width: 991px)"), [_, C] = fa({
    hasHeader: !1,
    hasAltMenuSpacing: !1,
    containerClass: "container-xl",
    activeContainer: "",
    showMenu: !1,
    sticky: !1
  }), z = () => document.getElementById("asu-header") || document.getElementById("headerContainer") || document.getElementById("asuHeader"), B = () => {
    const ye = z();
    return Math.max((ye == null ? void 0 : ye.getBoundingClientRect().bottom) || 0, 0);
  }, I = () => {
    var wt;
    const ye = {}, xe = window.scrollY, we = B(), Me = (wt = document.getElementById(o)) == null ? void 0 : wt.getBoundingClientRect().top, He = 103;
    Me >= 0 && (ye.sticky = !1, ye.activeContainer = ""), xe > p.current.getBoundingClientRect().top && (ye.sticky = !0);
    const Ot = _.hasHeader ? we + He : He;
    a == null || a.forEach(({ targetIdName: At }) => {
      const Ae = document.getElementById(At), Xe = (Ae == null ? void 0 : Ae.getBoundingClientRect().top) - Ot, it = (Ae == null ? void 0 : Ae.getBoundingClientRect().bottom) - Ot;
      Xe < 0 && it > 0 && (ye.activeContainer = At);
    }), C((At) => ({
      ...At,
      ...ye
    }));
  }, F = () => {
    Ng(I, 150), Mg(I, 150);
  }, ce = () => !!z(), ae = () => !!document.getElementById(
    "degreeDetailPageContainer"
  );
  function $(ye = null) {
    if (ye === null) return _.containerClass;
    const xe = Object.values(ye.classList).filter(
      (we) => [
        "container-sm",
        "container-md",
        "container",
        "container-lg",
        "container-xl",
        "container-fluid"
      ].includes(we)
    );
    return xe.length > 0 ? xe.join(" ") : $(ye.parentElement);
  }
  Da(() => {
    const ye = document.getElementById(o) || null, xe = {
      hasHeader: ce(),
      hasAltMenuSpacing: ae(),
      containerClass: $(ye)
    };
    C((we) => ({
      ...we,
      ...xe
    }));
  }, []), Da(() => (window == null || window.addEventListener("scroll", F), () => window.removeEventListener("scroll", F)), [_.hasHeader]);
  const he = (ye) => {
    var Ot, wt;
    const xe = B(), we = window.scrollY - (_.hasHeader ? xe + 100 : 100), Me = w ? 410 : 90;
    let He = ((Ot = document.getElementById(ye)) == null ? void 0 : Ot.getBoundingClientRect().top) + we;
    p.current.classList.contains("sticky") || (He -= Me), f && ((wt = hp(`#${ye}`)) == null || wt.focus()), window.scrollTo({ top: He, behavior: "smooth" });
  }, ge = () => {
    C((ye) => ({
      ...ye,
      showMenu: !ye.showMenu
    }));
  }, de = _.hasHeader ? B() : 0, De = y ? "div" : FT, Re = y ? {} : {
    // @ts-ignore
    requiresAltMenuSpacing: _.hasAltMenuSpacing
  };
  return (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ A.jsx(
    De,
    {
      ...Re,
      ref: p,
      id: "uds-anchor-menu",
      className: Mt(
        "uds-anchor-menu",
        "uds-anchor-menu-expanded-lg",
        "mb-4",
        {
          sticky: _.sticky,
          "with-header": _.hasHeader
        }
      ),
      style: (
        /** @type {React.CSSProperties} */
        {
          ..._.showMenu ? { borderBottom: 0 } : {},
          "--uds-anchor-menu-top": `${de}px`
        }
      ),
      children: /* @__PURE__ */ A.jsxs("div", { className: `${_.containerClass} uds-anchor-menu-wrapper`, children: [
        /* @__PURE__ */ A.jsx("h2", { children: w ? /* @__PURE__ */ A.jsx(
          Tl,
          {
            gaData: {
              ...YT,
              action: _.showMenu ? "close" : "open"
            },
            children: /* @__PURE__ */ A.jsxs(
              "button",
              {
                className: Mt("mobile-menu-toggler", {
                  "show-menu": _.showMenu
                }),
                type: "button",
                onClick: ge,
                "data-bs-toggle": "collapse",
                "data-bs-target": "#collapseAnchorMenu",
                "aria-controls": "collapseAnchorMenu",
                "aria-expanded": _.showMenu,
                children: [
                  Qd,
                  ":",
                  /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-down" })
                ]
              }
            )
          }
        ) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          Qd,
          ":"
        ] }) }),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-testid": "anchor-menu-container",
            id: "collapseAnchorMenu",
            className: Mt("card", "card-body", "collapse", {
              show: _.showMenu
            }),
            children: /* @__PURE__ */ A.jsx(
              "nav",
              {
                "data-testid": "anchor-menu",
                className: "nav",
                "aria-label": Qd,
                children: a == null ? void 0 : a.map((ye) => (
                  // Use this package button
                  // @ts-ignore
                  /* @__PURE__ */ A.jsx(
                    co,
                    {
                      "data-testid": `anchor-item-${ye.targetIdName}`,
                      classes: Mt("nav-link", {
                        active: _.activeContainer === ye.targetIdName
                      }).split(" "),
                      ariaLabel: ye.text,
                      label: ye.text,
                      icon: ye.icon,
                      onClick: v && (() => he(ye.targetIdName)),
                      href: y && `#${ye.targetIdName}`
                    },
                    ye.targetIdName
                  )
                ))
              }
            )
          }
        )
      ] })
    }
  );
};
Um.propTypes = {
  /**
   * Anchor menu items
   */
  items: E.arrayOf(
    E.shape({
      text: E.string.isRequired,
      targetIdName: E.string.isRequired,
      icon: E.arrayOf(E.string)
    })
  ).isRequired,
  /**
   * First next sibling element of the anchor menu
   */
  firstElementId: E.string.isRequired,
  /**
   * If true it focus the first focusable element into the section
   * If false it focus the next menu item into the nav bar
   */
  focusFirstFocusableElement: E.bool
};
var Fg = function() {
  return Fg = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, Fg.apply(this, arguments);
}, GT = function(a, o) {
  var f = {};
  for (var v in a) Object.prototype.hasOwnProperty.call(a, v) && o.indexOf(v) < 0 && (f[v] = a[v]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var y = 0, v = Object.getOwnPropertySymbols(a); y < v.length; y++)
      o.indexOf(v[y]) < 0 && Object.prototype.propertyIsEnumerable.call(a, v[y]) && (f[v[y]] = a[v[y]]);
  return f;
};
function sh(a) {
  var o = function(f) {
    var v = f.bgStyle, y = f.borderRadius, p = f.iconFillColor, w = f.round, _ = f.size, C = GT(f, ["bgStyle", "borderRadius", "iconFillColor", "round", "size"]);
    return Xt.createElement(
      "svg",
      Fg({ viewBox: "0 0 64 64", width: _, height: _ }, C),
      w ? Xt.createElement("circle", { cx: "32", cy: "32", r: "31", fill: a.color, style: v }) : Xt.createElement("rect", { width: "64", height: "64", rx: y, ry: y, fill: a.color, style: v }),
      Xt.createElement("path", { d: a.path, fill: p })
    );
  };
  return o.defaultProps = {
    bgStyle: {},
    borderRadius: 0,
    iconFillColor: "white",
    size: 64
  }, o;
}
var XT = sh({
  color: "#7f7f7f",
  path: "M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
});
function fh(a) {
  var o = Object.entries(a).filter(function(f) {
    var v = f[1];
    return v != null;
  }).map(function(f) {
    var v = f[0], y = f[1];
    return "".concat(encodeURIComponent(v), "=").concat(encodeURIComponent(String(y)));
  });
  return o.length > 0 ? "?".concat(o.join("&")) : "";
}
var IT = /* @__PURE__ */ (function() {
  var a = function(o, f) {
    return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, y) {
      v.__proto__ = y;
    } || function(v, y) {
      for (var p in y) Object.prototype.hasOwnProperty.call(y, p) && (v[p] = y[p]);
    }, a(o, f);
  };
  return function(o, f) {
    if (typeof f != "function" && f !== null)
      throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
    a(o, f);
    function v() {
      this.constructor = o;
    }
    o.prototype = f === null ? Object.create(f) : (v.prototype = f.prototype, new v());
  };
})(), ec = function() {
  return ec = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, ec.apply(this, arguments);
}, ZT = function(a, o, f, v) {
  function y(p) {
    return p instanceof f ? p : new f(function(w) {
      w(p);
    });
  }
  return new (f || (f = Promise))(function(p, w) {
    function _(B) {
      try {
        z(v.next(B));
      } catch (I) {
        w(I);
      }
    }
    function C(B) {
      try {
        z(v.throw(B));
      } catch (I) {
        w(I);
      }
    }
    function z(B) {
      B.done ? p(B.value) : y(B.value).then(_, C);
    }
    z((v = v.apply(a, o || [])).next());
  });
}, VT = function(a, o) {
  var f = { label: 0, sent: function() {
    if (p[0] & 1) throw p[1];
    return p[1];
  }, trys: [], ops: [] }, v, y, p, w;
  return w = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (w[Symbol.iterator] = function() {
    return this;
  }), w;
  function _(z) {
    return function(B) {
      return C([z, B]);
    };
  }
  function C(z) {
    if (v) throw new TypeError("Generator is already executing.");
    for (; f; ) try {
      if (v = 1, y && (p = z[0] & 2 ? y.return : z[0] ? y.throw || ((p = y.return) && p.call(y), 0) : y.next) && !(p = p.call(y, z[1])).done) return p;
      switch (y = 0, p && (z = [z[0] & 2, p.value]), z[0]) {
        case 0:
        case 1:
          p = z;
          break;
        case 4:
          return f.label++, { value: z[1], done: !1 };
        case 5:
          f.label++, y = z[1], z = [0];
          continue;
        case 7:
          z = f.ops.pop(), f.trys.pop();
          continue;
        default:
          if (p = f.trys, !(p = p.length > 0 && p[p.length - 1]) && (z[0] === 6 || z[0] === 2)) {
            f = 0;
            continue;
          }
          if (z[0] === 3 && (!p || z[1] > p[0] && z[1] < p[3])) {
            f.label = z[1];
            break;
          }
          if (z[0] === 6 && f.label < p[1]) {
            f.label = p[1], p = z;
            break;
          }
          if (p && f.label < p[2]) {
            f.label = p[2], f.ops.push(z);
            break;
          }
          p[2] && f.ops.pop(), f.trys.pop();
          continue;
      }
      z = o.call(a, f);
    } catch (B) {
      z = [6, B], y = 0;
    } finally {
      v = p = 0;
    }
    if (z[0] & 5) throw z[1];
    return { value: z[0] ? z[1] : void 0, done: !0 };
  }
}, Fm = function(a, o) {
  var f = {};
  for (var v in a) Object.prototype.hasOwnProperty.call(a, v) && o.indexOf(v) < 0 && (f[v] = a[v]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var y = 0, v = Object.getOwnPropertySymbols(a); y < v.length; y++)
      o.indexOf(v[y]) < 0 && Object.prototype.propertyIsEnumerable.call(a, v[y]) && (f[v[y]] = a[v[y]]);
  return f;
}, QT = function(a) {
  return !!a && (typeof a == "object" || typeof a == "function") && typeof a.then == "function";
}, PT = function(a, o) {
  return {
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - a / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - o / 2
  };
}, WT = function(a, o) {
  return {
    top: (window.screen.height - o) / 2,
    left: (window.screen.width - a) / 2
  };
};
function JT(a, o, f) {
  var v = o.height, y = o.width, p = Fm(o, ["height", "width"]), w = ec({ height: v, width: y, location: "no", toolbar: "no", status: "no", directories: "no", menubar: "no", scrollbars: "yes", resizable: "no", centerscreen: "yes", chrome: "yes" }, p), _ = window.open(a, "", Object.keys(w).map(function(z) {
    return "".concat(z, "=").concat(w[z]);
  }).join(", "));
  if (f)
    var C = window.setInterval(function() {
      try {
        (_ === null || _.closed) && (window.clearInterval(C), f(_));
      } catch (z) {
        console.error(z);
      }
    }, 1e3);
  return _;
}
var KT = (
  /** @class */
  (function(a) {
    IT(o, a);
    function o() {
      var f = a !== null && a.apply(this, arguments) || this;
      return f.openShareDialog = function(v) {
        var y = f.props, p = y.onShareWindowClose, w = y.windowHeight, _ = w === void 0 ? 400 : w, C = y.windowPosition, z = C === void 0 ? "windowCenter" : C, B = y.windowWidth, I = B === void 0 ? 550 : B, F = ec({ height: _, width: I }, z === "windowCenter" ? PT(I, _) : WT(I, _));
        JT(v, F, p);
      }, f.handleClick = function(v) {
        return ZT(f, void 0, void 0, function() {
          var y, p, w, _, C, z, B, I, F, ce;
          return VT(this, function(ae) {
            switch (ae.label) {
              case 0:
                return y = this.props, p = y.beforeOnClick, w = y.disabled, _ = y.networkLink, C = y.onClick, z = y.url, B = y.openShareDialogOnClick, I = y.opts, F = _(z, I), w ? [
                  2
                  /*return*/
                ] : (v.preventDefault(), p ? (ce = p(), QT(ce) ? [4, ce] : [3, 2]) : [3, 2]);
              case 1:
                ae.sent(), ae.label = 2;
              case 2:
                return B && this.openShareDialog(F), C && C(v, F), [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, f;
    }
    return o.prototype.render = function() {
      var f = this.props;
      f.beforeOnClick;
      var v = f.children, y = f.className, p = f.disabled, w = f.disabledStyle, _ = f.forwardedRef;
      f.networkLink;
      var C = f.networkName;
      f.onShareWindowClose, f.openShareDialogOnClick, f.opts;
      var z = f.resetButtonStyle, B = f.style;
      f.url, f.windowHeight, f.windowPosition, f.windowWidth;
      var I = Fm(f, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]), F = Mt("react-share__ShareButton", {
        "react-share__ShareButton--disabled": !!p,
        disabled: !!p
      }, y), ce = ec(ec(z ? { backgroundColor: "transparent", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer" } : {}, B), p && w);
      return Xt.createElement("button", ec({}, I, { "aria-label": I["aria-label"] || C, className: F, onClick: this.handleClick, ref: _, style: ce }), v);
    }, o.defaultProps = {
      disabledStyle: { opacity: 0.6 },
      openShareDialogOnClick: !0,
      resetButtonStyle: !0
    }, o;
  })(S1)
), $d = function() {
  return $d = Object.assign || function(a) {
    for (var o, f = 1, v = arguments.length; f < v; f++) {
      o = arguments[f];
      for (var y in o) Object.prototype.hasOwnProperty.call(o, y) && (a[y] = o[y]);
    }
    return a;
  }, $d.apply(this, arguments);
};
function dh(a, o, f, v) {
  function y(p, w) {
    var _ = f(p), C = $d({}, p), z = Object.keys(_);
    return z.forEach(function(B) {
      delete C[B];
    }), Xt.createElement(KT, $d({}, v, C, { forwardedRef: w, networkName: a, networkLink: o, opts: f(p) }));
  }
  return y.displayName = "ShareButton-".concat(a), x1(y);
}
function jT(a, o) {
  var f = o.subject, v = o.body, y = o.separator;
  return "mailto:" + fh({ subject: f, body: v ? v + y + a : a });
}
var qT = dh("email", jT, function(a) {
  return {
    subject: a.subject,
    body: a.body,
    separator: a.separator || " "
  };
}, {
  openShareDialogOnClick: !1,
  onClick: function(a, o) {
    window.location.href = o;
  }
}), Lb = sh({
  color: "#3b5998",
  path: "M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
}), $T = /* @__PURE__ */ (function() {
  var a = function(o, f) {
    return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(v, y) {
      v.__proto__ = y;
    } || function(v, y) {
      for (var p in y) Object.prototype.hasOwnProperty.call(y, p) && (v[p] = y[p]);
    }, a(o, f);
  };
  return function(o, f) {
    if (typeof f != "function" && f !== null)
      throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
    a(o, f);
    function v() {
      this.constructor = o;
    }
    o.prototype = f === null ? Object.create(f) : (v.prototype = f.prototype, new v());
  };
})(), eS = (
  /** @class */
  (function(a) {
    $T(o, a);
    function o(f) {
      var v = a.call(this, f) || this;
      return v.name = "AssertionError", v;
    }
    return o;
  })(Error)
);
function Qf(a, o) {
  if (!a)
    throw new eS(o);
}
function tS(a, o) {
  var f = o.quote, v = o.hashtag;
  return Qf(a, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + fh({
    u: a,
    quote: f,
    hashtag: v
  });
}
var kb = dh("facebook", tS, function(a) {
  return {
    quote: a.quote,
    hashtag: a.hashtag
  };
}, {
  windowWidth: 550,
  windowHeight: 400
}), Hb = sh({
  color: "#007fb1",
  path: "M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
});
function nS(a, o) {
  var f = o.title, v = o.summary, y = o.source;
  return Qf(a, "linkedin.url"), "https://linkedin.com/shareArticle" + fh({ url: a, mini: "true", title: f, summary: v, source: y });
}
var Bb = dh("linkedin", nS, function(a) {
  var o = a.title, f = a.summary, v = a.source;
  return { title: o, summary: f, source: v };
}, {
  windowWidth: 750,
  windowHeight: 600
}), Ub = sh({
  color: "#00aced",
  path: "M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z"
});
function lS(a, o) {
  var f = o.title, v = o.via, y = o.hashtags, p = y === void 0 ? [] : y, w = o.related, _ = w === void 0 ? [] : w;
  return Qf(a, "twitter.url"), Qf(Array.isArray(p), "twitter.hashtags is not an array"), Qf(Array.isArray(_), "twitter.related is not an array"), "https://twitter.com/share" + fh({
    url: a,
    text: f,
    via: v,
    hashtags: p.length > 0 ? p.join(",") : void 0,
    related: _.length > 0 ? _.join(",") : void 0
  });
}
var Fb = dh("twitter", lS, function(a) {
  return {
    hashtags: a.hashtags,
    title: a.title,
    via: a.via,
    related: a.related
  };
}, {
  windowWidth: 550,
  windowHeight: 400
});
function Yg(a) {
  "@babel/helpers - typeof";
  return Yg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Yg(a);
}
var aS;
function Gg() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : aS;
  return o ? a.split(" ").map(function(f) {
    return o[f] || f;
  }).join(" ") : a;
}
var iS = (typeof window > "u" ? "undefined" : Yg(window)) === "object" && window.Element || function() {
};
function rS(a, o, f) {
  if (!(a[o] instanceof iS))
    return new Error("Invalid prop `" + o + "` supplied to `" + f + "`. Expected prop to be an instance of Element. Validation failed.");
}
E.oneOfType([E.string, E.func, rS, E.shape({
  current: E.any
})]);
var Xg = E.oneOfType([E.func, E.string, E.shape({
  $$typeof: E.symbol,
  render: E.func
}), E.arrayOf(E.oneOfType([E.func, E.string, E.shape({
  $$typeof: E.symbol,
  render: E.func
})]))]), uS = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function Ig() {
  return Ig = Object.assign ? Object.assign.bind() : function(a) {
    for (var o = 1; o < arguments.length; o++) {
      var f = arguments[o];
      for (var v in f)
        Object.prototype.hasOwnProperty.call(f, v) && (a[v] = f[v]);
    }
    return a;
  }, Ig.apply(this, arguments);
}
function cS(a, o) {
  if (a == null) return {};
  var f = oS(a, o), v, y;
  if (Object.getOwnPropertySymbols) {
    var p = Object.getOwnPropertySymbols(a);
    for (y = 0; y < p.length; y++)
      v = p[y], !(o.indexOf(v) >= 0) && Object.prototype.propertyIsEnumerable.call(a, v) && (f[v] = a[v]);
  }
  return f;
}
function oS(a, o) {
  if (a == null) return {};
  var f = {}, v = Object.keys(a), y, p;
  for (p = 0; p < v.length; p++)
    y = v[p], !(o.indexOf(y) >= 0) && (f[y] = a[y]);
  return f;
}
var sS = {
  /** Aria label */
  "aria-label": E.string,
  /** Pass children so this component can wrap them */
  children: E.node,
  /** Add custom class */
  className: E.string,
  /** Change existing className with a new className */
  cssModule: E.object,
  /** Add custom class to list tag */
  listClassName: E.string,
  /** Set a custom element for list tag */
  listTag: Xg,
  /** Set a custom element for this component */
  tag: Xg
};
function Ym(a) {
  var o = a.className, f = a.listClassName, v = a.cssModule, y = a.children, p = a.tag, w = p === void 0 ? "nav" : p, _ = a.listTag, C = _ === void 0 ? "ol" : _, z = a["aria-label"], B = z === void 0 ? "breadcrumb" : z, I = cS(a, uS), F = Gg(Mt(o), v), ce = Gg(Mt("breadcrumb", f), v);
  return /* @__PURE__ */ Xt.createElement(w, Ig({}, I, {
    className: F,
    "aria-label": B
  }), /* @__PURE__ */ Xt.createElement(C, {
    className: ce
  }, y));
}
Ym.propTypes = sS;
var fS = ["className", "cssModule", "active", "tag"];
function Zg() {
  return Zg = Object.assign ? Object.assign.bind() : function(a) {
    for (var o = 1; o < arguments.length; o++) {
      var f = arguments[o];
      for (var v in f)
        Object.prototype.hasOwnProperty.call(f, v) && (a[v] = f[v]);
    }
    return a;
  }, Zg.apply(this, arguments);
}
function dS(a, o) {
  if (a == null) return {};
  var f = hS(a, o), v, y;
  if (Object.getOwnPropertySymbols) {
    var p = Object.getOwnPropertySymbols(a);
    for (y = 0; y < p.length; y++)
      v = p[y], !(o.indexOf(v) >= 0) && Object.prototype.propertyIsEnumerable.call(a, v) && (f[v] = a[v]);
  }
  return f;
}
function hS(a, o) {
  if (a == null) return {};
  var f = {}, v = Object.keys(a), y, p;
  for (p = 0; p < v.length; p++)
    y = v[p], !(o.indexOf(y) >= 0) && (f[y] = a[y]);
  return f;
}
var gS = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: E.bool,
  /** Add custom class to the element */
  className: E.string,
  /** Change existing className with a new className */
  cssModule: E.object,
  /** Set a custom element for this component */
  tag: Xg
};
function Vg(a) {
  var o = a.className, f = a.cssModule, v = a.active, y = a.tag, p = y === void 0 ? "li" : y, w = dS(a, fS), _ = Gg(Mt(o, v ? "active" : !1, "breadcrumb-item"), f);
  return /* @__PURE__ */ Xt.createElement(p, Zg({}, w, {
    className: _,
    "aria-current": v ? "page" : void 0
  }));
}
Vg.propTypes = gS;
const vS = gu.div`
  &.news-container h2 {
    font-size: 48px;
  }

  &.event-container h2 {
    font-size: 40px;
  }

  &.news-container img,
  &.event-container img {
    width: 100%;
    max-width: fit-content;
  }

  &.wrapper-container h4 {
    margin-top: 0;
  }

  &.wrapper-container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 10%;
  }

  &.event-container.wrapper-container {
    max-width: 1500px;
  }

  &.news-container {
    background: #fff;
  }

  ol.breadcrumb {
    padding: 0;
    margin: 0;
  }

  ol.breadcrumb > li {
    margin-bottom: 0;
  }

  .article-social-media {
    margin-bottom: 24px;
  }

  .react-share__ShareButton {
    margin-right: 12px;
  }

  i.news-date {
    display: inline-block;
    margin-bottom: 24px;
  }

  .highlight-gold {
    box-shadow:
      -0.15em 0 0 #ffc627,
      0.15em 0 0 #ffc627;
    background: #ffc627;
  }

  .author {
    display: inline-block;
    margin-top: 30px;
    margin-left: -7px;
    padding: 0 6px;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-bg {
    display: inline-block;
    position: relative;
    padding: 1px 3.5px;
    background-color: maroon;
    margin-right: 4px;
    border-radius: 4px;
    color: white;
    font-size: 0.65rem;
  }

  .uds-button {
    margin-top: 17px;
    padding: 0;
  }

  .author-title {
    max-width: 250px;
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 16px;
  }

  .author-contact {
    margin-top: 4px;
    font-size: 14px;
    font-weight: 500;
  }

  ol.breadcrumb a {
    text-decoration: none;
  }

  i.fa-calendar,
  i.fa-map-marker-alt {
    font-size: 1.17rem;
    margin-right: 8px;
  }

  .event-author {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
  }

  .event-author-title {
    margin-top: 4px;
  }

  .event-author-info {
    margin-top: 24px;
  }
`, yS = gu.div`
  border-top: 1px solid black;
  h4 {
    margin-top: 0;
  }
  .react-share__ShareButton {
    margin-right: 24px;
  }
`, Gm = ({
  type: a = "news",
  articleUrl: o,
  publicationDate: f,
  title: v,
  body: y,
  authorEmail: p,
  authorName: w,
  authorPhone: _,
  authorTitle: C,
  breadcrumbs: z,
  calendarUrl: B,
  eventLocation: I,
  eventTime: F,
  headerImageUrl: ce,
  registrationUrl: ae,
  zoomUrl: $
}) => {
  const he = Mt("col", "col-12", {
    "col-lg-8": a === "event" && (ae || $ || B)
  }), ge = () => ae ? /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx(co, { color: "maroon", href: ae, label: "Register" }) }) : /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx(co, { color: "maroon", href: $, label: "Attend on Zoom" }) }), de = () => /* @__PURE__ */ A.jsx("div", { className: "row pb-2", "data-testid": "author-info", children: /* @__PURE__ */ A.jsxs("div", { className: "col col-12", children: [
    /* @__PURE__ */ A.jsx("div", { className: "author highlight-gold", children: w }),
    C && /* @__PURE__ */ A.jsx("div", { className: "author-title", children: C }),
    p && /* @__PURE__ */ A.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ A.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-envelope" }) }),
      /* @__PURE__ */ A.jsx("a", { href: `mailto: ${p}`, children: p })
    ] }),
    _ && /* @__PURE__ */ A.jsxs("div", { className: "author-contact", children: [
      /* @__PURE__ */ A.jsx("span", { className: "icon-bg", children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-phone" }) }),
      /* @__PURE__ */ A.jsx("a", { href: `tel: ${_}`, children: _ })
    ] })
  ] }) }), De = () => /* @__PURE__ */ A.jsxs(
    yS,
    {
      className: "row row-spaced mt-3 pt-6 pb-2 event-info",
      "data-testid": "event-info",
      children: [
        /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ A.jsx("h4", { children: "For more information contact:" }),
          /* @__PURE__ */ A.jsx("div", { className: "event-author", children: w }),
          /* @__PURE__ */ A.jsx("div", { className: "event-author-title", children: C }),
          (p || _) && /* @__PURE__ */ A.jsxs("div", { className: "event-author-info", children: [
            p && /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("a", { href: `mailto: ${p}`, children: p }) }),
            _ && /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("a", { href: `tel: ${_}`, children: _ }) })
          ] })
        ] }),
        /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-12", children: [
          /* @__PURE__ */ A.jsx("h4", { children: "Share this event:" }),
          /* @__PURE__ */ A.jsxs("div", { className: "article-social-media", children: [
            /* @__PURE__ */ A.jsx(kb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              Lb,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(Fb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              Ub,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(qT, { url: p, quote: v, children: /* @__PURE__ */ A.jsx(
              XT,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) }),
            /* @__PURE__ */ A.jsx(Bb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
              Hb,
              {
                size: 28,
                borderRadius: 4,
                bgStyle: { fill: "maroon" },
                iconFillColor: "white"
              }
            ) })
          ] })
        ] })
      ]
    }
  ), Re = () => /* @__PURE__ */ A.jsxs("div", { className: "col col-12 col-lg-4 col-md-6", children: [
    /* @__PURE__ */ A.jsxs("h4", { children: [
      /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }),
      "Location:"
    ] }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: La(I) }),
    ae && $ && /* @__PURE__ */ A.jsx("a", { href: $, children: "Attend on Zoom" })
  ] }), ye = (xe) => /* @__PURE__ */ A.jsx(
    Vg,
    {
      active: xe.active,
      tag: "li",
      className: "breadcrumb-item",
      children: /* @__PURE__ */ A.jsx(Vg, { tag: "a", href: xe.url, children: xe.title })
    },
    xe.title
  );
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    ce && a !== "event" && /* @__PURE__ */ A.jsx(
      "div",
      {
        "data-testid": "uds-hero",
        className: "uds-hero uds-hero-md",
        style: {
          // @ts-ignore
          "--color1": "#19191900",
          "--color2": "#191919c9",
          // moved colors to variable because hex color in linear-gradient breaks react
          backgroundImage: `linear-gradient(180deg, var(--color1) 0%, var(--color2) 100%), url(${ce})`
        }
      }
    ),
    /* @__PURE__ */ A.jsxs(vS, { className: `container ${a}-container wrapper-container`, children: [
      z && /* @__PURE__ */ A.jsx("div", { className: "row pt-4", "data-testid": "breadcrumbs", children: /* @__PURE__ */ A.jsx("div", { className: "col col-12", children: /* @__PURE__ */ A.jsx(Ym, { listClassName: "breadcrumb", children: z.map((xe) => ye(xe)) }) }) }),
      /* @__PURE__ */ A.jsxs("div", { className: "row pb-2 pt-3", children: [
        /* @__PURE__ */ A.jsx("div", { className: he, children: /* @__PURE__ */ A.jsx("h2", { "data-testid": "title", children: v }) }),
        a === "event" && /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-xs-12", children: [
          (ae || $) && ge(),
          B && /* @__PURE__ */ A.jsx("div", { className: "card-button uds-button", children: /* @__PURE__ */ A.jsx(
            co,
            {
              color: "gray",
              size: "small",
              href: B,
              label: "Add to calendar"
            }
          ) })
        ] })
      ] }),
      a === "event" ? /* @__PURE__ */ A.jsxs("div", { className: "row row-spaced pt-3 mb-2", children: [
        F && /* @__PURE__ */ A.jsxs("div", { className: "col col-lg-4 col-md-6 col-sm-12", children: [
          /* @__PURE__ */ A.jsxs("h4", { children: [
            /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }),
            "Date and time:"
          ] }),
          /* @__PURE__ */ A.jsx(
            "div",
            {
              dangerouslySetInnerHTML: La(F)
            }
          )
        ] }),
        (ae && $ || I) && Re()
      ] }) : /* @__PURE__ */ A.jsx("div", { className: "row row-spaced pt-2", children: /* @__PURE__ */ A.jsxs("div", { className: "col col-12", children: [
        /* @__PURE__ */ A.jsxs("div", { className: "article-social-media", children: [
          /* @__PURE__ */ A.jsx(kb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            Lb,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ A.jsx(Fb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            Ub,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) }),
          /* @__PURE__ */ A.jsx(Bb, { url: o, quote: v, children: /* @__PURE__ */ A.jsx(
            Hb,
            {
              size: 28,
              borderRadius: 4,
              bgStyle: { fill: "maroon" },
              iconFillColor: "white"
            }
          ) })
        ] }),
        f && /* @__PURE__ */ A.jsx("i", { className: "news-date", children: f })
      ] }) }),
      /* @__PURE__ */ A.jsx("div", { className: "row", children: /* @__PURE__ */ A.jsx(
        "div",
        {
          className: "col col-12",
          dangerouslySetInnerHTML: La(y),
          "data-testid": "body"
        }
      ) }),
      a === "news" && de(),
      a === "event" && De()
    ] })
  ] });
};
Gm.propTypes = {
  /**
   * Type of article
   */
  type: E.oneOf(["event", "news"]),
  /**
   * This is the relative or absolute url to the full-page article
   */
  articleUrl: E.string.isRequired,
  /**
   * Date for the article
   */
  publicationDate: E.string.isRequired,
  /**
   * Title
   */
  title: E.string.isRequired,
  /**
   * Body content for the article
   */
  body: E.string.isRequired,
  /**
   * Article author email
   */
  authorEmail: E.string,
  /**
   * Article author full name
   */
  authorName: E.string.isRequired,
  /**
   * Article author phone number
   */
  authorPhone: E.string,
  /**
   * Article author title
   */
  authorTitle: E.string,
  /**
   * Breadcrumbs array
   */
  breadcrumbs: E.arrayOf(
    E.shape({
      title: E.string,
      url: E.string,
      active: E.bool
    })
  ),
  /**
   * URL for an "add to calendar" button
   */
  calendarUrl: E.string,
  /**
   * Article image
   */
  headerImageUrl: E.string,
  /**
   * Event location
   */
  eventLocation: E.string,
  /**
   * Event time
   */
  eventTime: E.string,
  /**
   * URL for a registation button
   */
  registrationUrl: E.string,
  /**
   * URL for a Zoom button
   */
  zoomUrl: E.string
};
const bS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, iv = ({
  color: a = "gray",
  icon: o = void 0,
  innerRef: f = void 0,
  onClick: v = void 0,
  size: y = "small",
  cardTitle: p = "",
  className: w,
  gaData: _,
  ...C
}) => {
  const z = () => {
    v == null || v();
  };
  return /* @__PURE__ */ A.jsx(
    Tl,
    {
      gaData: {
        ...bS,
        section: p,
        // @deprecated - remove at some point
        ..._,
        text: `${o == null ? void 0 : o[1]} icon`
      },
      children: /* @__PURE__ */ A.jsx(
        "button",
        {
          type: "button",
          className: `btn btn-circle btn-circle-alt-${a} ${y === "large" && "btn-circle-large"} ${w}`,
          ref: f,
          "aria-label": "Close",
          onClick: z,
          ...C,
          children: /* @__PURE__ */ A.jsx("i", { className: `${o == null ? void 0 : o[0]} fa-${o == null ? void 0 : o[1]}` })
        }
      )
    }
  );
};
iv.propTypes = {
  /**
    Color the button based on the background color
  */
  color: E.oneOf(["white", "gray", "black"]),
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: $g,
  /**
    Button size
  */
  size: E.oneOf(["large", "small"]),
  className: E.string
};
const mS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, rv = ({
  label: a = "",
  cardTitle: o = "",
  gaData: f,
  ariaLabel: v,
  color: y = "gray",
  disabled: p,
  element: w = "button",
  innerRef: _,
  href: C,
  onClick: z,
  ...B
}) => {
  const I = Mt("btn", "btn-tag", {
    "btn-tag-alt-white": y === "white",
    "btn-tag-alt-gray": y === "gray",
    "btn-tag-alt-dark": y === "dark",
    disabled: p
  });
  let F = w;
  return C && w === "button" && (F = "a"), /* @__PURE__ */ A.jsx(
    Tl,
    {
      gaData: {
        ...mS,
        section: o,
        // @deprecated - remove at some point
        ...f,
        text: a
      },
      children: /* @__PURE__ */ A.jsx(
        F,
        {
          type: F === "button" && z ? "button" : void 0,
          ...B,
          className: I,
          href: C,
          ref: _,
          onClick: z,
          "aria-label": v,
          children: a
        }
      )
    }
  );
};
rv.propTypes = {
  /**
    Button tag label
  */
  label: E.string,
  /**
   * @deprecated
   * Card title, use `gaData.section` instead
   */
  cardTitle: E.string,
  /**
   * Google Analytics event data
   */
  gaData: $g,
  /**
    ARIA label for accessibility
  */
  ariaLabel: E.string,
  /**
    Button background color
  */
  color: E.oneOf(["white", "gray", "dark"]),
  /**
    Disable the button?
  */
  disabled: E.bool,
  /**
    Pass in a Component to override default button element.
    For example: react-router Link
  */
  element: E.oneOfType([
    E.func,
    E.string,
    E.shape({ $$typeof: E.symbol, render: E.func }),
    E.arrayOf(
      E.oneOfType([
        E.func,
        E.string,
        E.shape({ $$typeof: E.symbol, render: E.func })
      ])
    )
  ]),
  /**
    Link target url; will cause button to be rendered as `<a>` link
  */
  href: E.string,
  /**
   * ref will only get you a reference to the Button component, use innerRef to
   * get a reference to the DOM element (for things like focus management).
   */
  innerRef: E.oneOfType([
    E.object,
    E.func,
    E.string
  ]),
  /**
    Event handler function for `<button>`
  */
  onClick: E.func
};
const Zo = ({
  src: a,
  alt: o,
  cssClasses: f,
  loading: v = "lazy",
  decoding: y = "async",
  dataTestId: p,
  fetchPriority: w = "auto",
  width: _,
  height: C,
  cardLink: z,
  title: B,
  caption: I,
  captionTitle: F,
  border: ce,
  dropShadow: ae
}) => {
  const $ = {
    src: a,
    alt: o,
    loading: v,
    decoding: y,
    fetchpriority: w,
    // React attribute bug workaround
    ...(f == null ? void 0 : f.length) > 0 && { className: Fd(f) },
    ...p && { "data-testid": p },
    ..._ && { width: _ },
    ...C && { height: C }
  }, he = Mt("uds-img", {
    borderless: !ce,
    "uds-img-drop-shadow": ae
  }), ge = (De) => {
    const Re = De ? `${$.className} ${De}` : $.className;
    return z ? /* @__PURE__ */ A.jsxs("a", { href: z, children: [
      /* @__PURE__ */ A.jsx("img", { ...$, className: Re }),
      /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: B })
    ] }) : /* @__PURE__ */ A.jsx("img", { ...$, className: Re });
  }, de = () => /* @__PURE__ */ A.jsx("div", { className: he, children: /* @__PURE__ */ A.jsxs("figure", { className: "figure uds-figure", children: [
    ge(),
    I && /* @__PURE__ */ A.jsxs("figcaption", { className: "figure-caption uds-figure-caption", children: [
      F && /* @__PURE__ */ A.jsx("h3", { children: F }),
      /* @__PURE__ */ A.jsx(
        "span",
        {
          className: "uds-caption-text",
          dangerouslySetInnerHTML: La(I)
        }
      )
    ] })
  ] }) });
  return /* @__PURE__ */ A.jsx(A.Fragment, { children: I ? de() : ge(he) });
};
Zo.propTypes = {
  /**
   * Image source (We keep the same name as in the whole project)
   */
  src: E.string.isRequired,
  /**
   * Image alt text
   */
  alt: E.string.isRequired,
  /**
   * Array classes for the image
   */
  cssClasses: E.arrayOf(E.string),
  /**
   * Image loading mode
   */
  loading: E.oneOf(["lazy", "eager"]),
  /**
   * Image decoding mode
   */
  decoding: E.oneOf(["sync", "async", "auto"]),
  /**
   * Image fetch priority mode
   */
  fetchPriority: E.oneOf(["auto", "high", "low"]),
  /**
   * Width of the image
   */
  width: E.string,
  /**
   * Height of the image
   */
  height: E.string,
  dataTestId: E.string,
  cardLink: E.string,
  title: E.string,
  caption: E.string,
  captionTitle: E.string,
  border: E.bool,
  dropShadow: E.bool
};
const pS = gu.div`
  &.cards-components a + &.cards-components a {
    margin-left: 5px;
  }
  .card-button {
    column-gap: 1rem;
  }
  .card-button .btn {
    margin: 0;
  }
`, TS = (a) => /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(a), SS = (a) => !a.startsWith("https://") && !a.startsWith("http://") && TS(a) ? `mailto:${a}` : a, Yb = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Xm = (a) => a === "event" || a === "news", tc = ({
  type: a = "default",
  width: o = "100%",
  horizontal: f = !1,
  image: v,
  imageAltText: y,
  title: p,
  icon: w,
  body: _,
  eventFormat: C = "stack",
  eventLocation: z,
  eventTime: B,
  buttons: I,
  linkLabel: F,
  linkUrl: ce,
  tags: ae,
  showBorders: $ = !0,
  cardLink: he
}) => /* @__PURE__ */ A.jsx(
  Im,
  {
    type: a,
    width: o,
    horizontal: f,
    image: v,
    imageAltText: y,
    title: p,
    icon: w,
    body: _,
    eventFormat: C,
    eventLocation: z,
    eventTime: B,
    buttons: I,
    linkLabel: F,
    linkUrl: ce,
    tags: ae,
    showBorders: $,
    cardLink: he
  }
);
tc.propTypes = {
  /**
   * Type of card
   */
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  /**
   * Width of card
   */
  width: E.oneOf(["25%", "50%", "75%", "100%"]),
  /**
   * Enable horizontal mode
   */
  horizontal: E.bool,
  /**
   * Card title
   */
  title: E.string.isRequired,
  /**
    React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  */
  icon: E.arrayOf(E.string),
  /**
   * Card body content
   */
  body: E.string,
  /**
   * Event info format
   */
  eventFormat: E.oneOf(["stack", "inline"]),
  /**
   * Location
   */
  eventLocation: E.string,
  /**
   * Event start time
   */
  eventTime: E.string,
  /**
   * Card header image
   */
  image: E.string,
  /**
   * Card header image alt text
   */
  imageAltText: E.string,
  /**
   * Buttons
   */
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  /**
   * Tags
   */
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  /**
   * Remove card borders
   */
  showBorders: E.bool,
  /**
   * Card link
   */
  cardLink: E.string
};
const Im = ({
  type: a = "default",
  width: o = "100%",
  horizontal: f = !1,
  image: v = "",
  imageAltText: y = "",
  title: p,
  icon: w = void 0,
  body: _ = "",
  eventFormat: C = "stack",
  eventLocation: z = "",
  eventTime: B = "",
  buttons: I = void 0,
  linkLabel: F = void 0,
  linkUrl: ce = void 0,
  tags: ae = void 0,
  showBorders: $ = !0,
  cardLink: he
}) => {
  const ge = Mt("card", "cards-components", {
    "card-degree": a === "degree",
    "card-event": a === "event",
    "card-story": a === "story",
    "card-news": a === "news",
    [`w-${o.replace("%", "")}`]: o !== "100%",
    "card-horizontal": f,
    borderless: !$
  }), de = typeof v == "string" && v.length > 0, De = !Xm(a);
  return /* @__PURE__ */ A.jsxs(pS, { className: ge, "data-testid": "card-container", children: [
    de && /* @__PURE__ */ A.jsx(
      Zo,
      {
        src: v,
        alt: y,
        dataTestId: "card-image",
        cssClasses: ["card-img-top"],
        title: p,
        cardLink: De ? he : void 0
      }
    ),
    !v && w && /* @__PURE__ */ A.jsx(
      "i",
      {
        className: `${w == null ? void 0 : w[0]} fa-${w == null ? void 0 : w[1]} fa-2x card-icon-top`,
        "data-testid": "card-icon"
      }
    ),
    /* @__PURE__ */ A.jsx("div", { className: f ? "card-content-wrapper" : void 0, children: /* @__PURE__ */ A.jsx(
      Zm,
      {
        type: a,
        body: _,
        eventFormat: C,
        eventLocation: z,
        eventTime: B,
        title: p,
        buttons: I,
        linkLabel: F,
        linkUrl: ce,
        tags: ae,
        cardLink: he
      }
    ) })
  ] });
};
Im.propTypes = {
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  width: E.oneOf(["25%", "50%", "75%", "100%"]),
  horizontal: E.bool,
  title: E.string.isRequired,
  icon: E.arrayOf(E.string),
  // React Font Awesome icon prefix and name string to be rendered in button label. Ex: ['fab', 'drupal']
  body: E.string,
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string,
  image: E.string,
  imageAltText: E.string,
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  showBorders: E.bool,
  cardLink: E.string
};
const Zm = ({
  type: a = "default",
  body: o = "",
  eventFormat: f = "stack",
  eventLocation: v = "",
  eventTime: y = "",
  title: p,
  buttons: w = void 0,
  linkLabel: _ = void 0,
  linkUrl: C = void 0,
  tags: z = void 0,
  cardLink: B
}) => {
  const I = Xm(a), F = B && !I, ce = I && B, ae = a === "event" && (y || v);
  return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    p && /* @__PURE__ */ A.jsx("div", { className: "card-header", "data-testid": "card-title", children: /* @__PURE__ */ A.jsx("h3", { className: "card-title", children: F ? /* @__PURE__ */ A.jsx("a", { href: B, children: p }) : p }) }),
    o && /* @__PURE__ */ A.jsx("div", { className: "card-body", "data-testid": "card-body", children: /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: La(o) }) }),
    ae && /* @__PURE__ */ A.jsx(
      Vm,
      {
        eventFormat: f,
        eventTime: y,
        eventLocation: v
      }
    ),
    ce ? /* @__PURE__ */ A.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ A.jsx(
      Tl,
      {
        gaData: {
          ...Yb,
          text: p
        },
        children: /* @__PURE__ */ A.jsx("a", { href: B, className: "card-arrow-link", "aria-label": p, children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-arrow-right", "aria-hidden": "true" }) })
      }
    ) }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      w && /* @__PURE__ */ A.jsx("div", { className: "card-buttons", children: w.map(($) => /* @__PURE__ */ A.jsx(
        "div",
        {
          className: "card-button",
          "data-testid": "card-button",
          children: /* @__PURE__ */ A.jsx(
            co,
            {
              ariaLabel: $.ariaLabel,
              color: $.color,
              icon: $.icon,
              href: $.href,
              label: $.label,
              onClick: $.onClick,
              size: $.size,
              target: $.target,
              cardTitle: p
            }
          )
        },
        `${$.label}-${$.href}`
      )) }),
      C && _ && /* @__PURE__ */ A.jsx("div", { className: "card-link", "data-testid": "card-link", children: /* @__PURE__ */ A.jsx(
        Tl,
        {
          gaData: {
            ...Yb,
            section: p,
            text: _
          },
          children: /* @__PURE__ */ A.jsx("a", { href: SS(C), children: _ })
        }
      ) })
    ] }),
    z && /* @__PURE__ */ A.jsx("div", { className: "card-tags", "data-testid": "card-tags", children: z.map(($) => (
      // @ts-ignore
      /* @__PURE__ */ A.jsx(
        rv,
        {
          ariaLabel: $.ariaLabel,
          color: $.color,
          href: $.href,
          label: $.label,
          onClick: $.onClick,
          cardTitle: p
        },
        `${$.label}-${$.href}`
      )
    )) })
  ] });
};
Zm.propTypes = {
  type: E.oneOf(["default", "degree", "event", "news", "story"]),
  body: E.string,
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string,
  title: E.string.isRequired,
  buttons: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["gold", "maroon", "gray", "dark"]),
      icon: E.arrayOf(E.string),
      href: E.string,
      label: E.string,
      onClick: E.func,
      size: E.oneOf(["default", "small", "xsmall"]),
      target: E.oneOf(["_blank", "_self", "_top", "_parent"])
    })
  ),
  linkLabel: E.string,
  linkUrl: E.string,
  tags: E.arrayOf(
    E.shape({
      ariaLabel: E.string,
      color: E.oneOf(["white", "gray", "dark"]),
      href: E.string,
      label: E.string,
      onClick: E.func
    })
  ),
  cardLink: E.string
};
const Vm = ({
  eventFormat: a = "stack",
  eventLocation: o = "",
  eventTime: f = ""
}) => a === "inline" ? /* @__PURE__ */ A.jsxs("div", { className: "card-event-details", children: [
  f && /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: La(f) })
  ] }),
  o && /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ A.jsx(
      "div",
      {
        dangerouslySetInnerHTML: La(o)
      }
    )
  ] })
] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
  f && /* @__PURE__ */ A.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "far fa-calendar" }) }),
    /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: La(f) })
  ] }) }),
  o && /* @__PURE__ */ A.jsx("div", { className: "card-event-details", children: /* @__PURE__ */ A.jsxs("div", { className: "card-event-icons", children: [
    /* @__PURE__ */ A.jsx("div", { children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-map-marker-alt" }) }),
    /* @__PURE__ */ A.jsx("span", { children: /* @__PURE__ */ A.jsx(
      "div",
      {
        dangerouslySetInnerHTML: La(o)
      }
    ) })
  ] }) })
] });
Vm.propTypes = {
  eventFormat: E.oneOf(["stack", "inline"]),
  eventLocation: E.string,
  eventTime: E.string
};
const Gb = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Xb = {
  OPEN: "open",
  CLOSE: "close"
}, xS = {
  SMALL: "small"
}, Qm = (a) => a === xS.SMALL, Pm = ({ imageSize: a, body: o, heading: f, readMoreLink: v }) => {
  const [y, p] = fa(!1), w = nh(), { isReact: _, isBootstrap: C } = Vo(), z = `info-layer-${w}`, B = Qm(a), I = (F) => {
    (F.type === "click" || F.key === "Enter" || F.key === " ") && p(!y);
  };
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: Mt("info-layer", { show: y }),
      "data-testid": "info-layer",
      id: z,
      children: /* @__PURE__ */ A.jsxs("div", { className: "content", children: [
        /* @__PURE__ */ A.jsxs(
          "div",
          {
            className: Mt("header", {
              closed: B && !y
            }),
            children: [
              B && /* @__PURE__ */ A.jsx("p", { dangerouslySetInnerHTML: La(o) }),
              /* @__PURE__ */ A.jsx(
                Tl,
                {
                  gaData: {
                    ...Gb,
                    text: "Expand ranking",
                    // TODO: for bootstrap can we use aria-expanded value of the button to populate the "action" field
                    action: y ? Xb.OPEN : Xb.CLOSE,
                    section: f
                  },
                  children: /* @__PURE__ */ A.jsxs(
                    "button",
                    {
                      "data-bs-toggle": C && "collapse",
                      "data-bs-target": C && `#${z}`,
                      onClick: _ && I,
                      className: Mt("btn-expand", {
                        btn: B
                      }),
                      type: "button",
                      "aria-expanded": y,
                      "aria-controls": z,
                      children: [
                        B ? /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: f }) : /* @__PURE__ */ A.jsx("h4", { children: f }),
                        /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-up" })
                      ]
                    }
                  )
                }
              )
            ]
          }
        ),
        !B && /* @__PURE__ */ A.jsx("p", { dangerouslySetInnerHTML: La(o) }),
        v && /* @__PURE__ */ A.jsx(
          Tl,
          {
            gaData: {
              ...Gb,
              section: f,
              text: "read more"
            },
            children: /* @__PURE__ */ A.jsxs("a", { href: v, className: "read-more", children: [
              "Read more ",
              /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: f }),
              /* @__PURE__ */ A.jsx(
                "span",
                {
                  className: "fas icon-small fa-arrow-right",
                  "aria-hidden": "true"
                }
              )
            ] })
          }
        )
      ] })
    }
  );
};
Pm.propTypes = {
  imageSize: E.oneOf(["small", "large"]),
  body: E.string.isRequired,
  heading: E.string.isRequired,
  readMoreLink: E.string
};
const uv = ({
  imageSize: a = "large",
  image: o,
  imageAlt: f,
  heading: v,
  body: y,
  readMoreLink: p = "",
  citation: w
}) => {
  const _ = Qm(a);
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Mt("card-ranking", {
        "large-image": !_,
        "small-image": _
      }),
      children: [
        _ ? /* @__PURE__ */ A.jsx("div", { className: "image-wrapper", children: /* @__PURE__ */ A.jsx(Zo, { src: o, alt: f, fetchPriority: "high" }) }) : /* @__PURE__ */ A.jsx(Zo, { src: o, alt: f, fetchPriority: "high" }),
        _ && /* @__PURE__ */ A.jsxs("div", { className: "citation", children: [
          /* @__PURE__ */ A.jsx("h4", { children: v }),
          /* @__PURE__ */ A.jsxs("p", { children: [
            "— ",
            w
          ] })
        ] }),
        /* @__PURE__ */ A.jsx(
          Pm,
          {
            imageSize: a,
            body: y,
            heading: v,
            readMoreLink: p
          }
        )
      ]
    }
  );
};
uv.propTypes = {
  /**
   * Size of ranking card
   */
  imageSize: E.oneOf(["small", "large"]).isRequired,
  /**
   * Ranking card image
   */
  image: E.string.isRequired,
  /**
   * Card header image alt text
   */
  imageAlt: E.string.isRequired,
  /**
   * Ranking card heading
   */
  heading: E.string.isRequired,
  /**
   * Ranking card body content
   */
  body: E.string.isRequired,
  /**
   * Link for read more
   */
  readMoreLink: E.string,
  /**
   * Ranking card citation content (Required for small size only)
   */
  citation: E.string
};
const ES = {
  1: "col-12",
  2: "col-12 col-md-6",
  3: "col-12 col-md-6 col-lg-4",
  4: "col-12 col-md-6 col-lg-4 col-xl-3"
}, Wm = ({ cards: a, cardType: o = "card", columns: f }) => {
  if (!a || a.length === 0)
    return null;
  let v;
  switch (o) {
    case "ranking":
      v = uv;
      break;
    case "image":
      v = Zo;
      break;
    default:
      v = tc;
      break;
  }
  const y = ES[f] || "col-12 col-md-auto";
  return /* @__PURE__ */ A.jsx("div", { className: "row", "data-testid": "card-arrangement", children: a.map((p, w) => /* @__PURE__ */ A.jsx(
    "div",
    {
      "data-testid": "uds-card-arrangement-content-container",
      className: `${p.horizontal ? "col-12 col-md-6" : y} mb-4`,
      children: /* @__PURE__ */ A.jsx(v, { ...p })
    },
    w
  )) });
};
Wm.propTypes = {
  /**
   * Array of card objects to render. Each object should contain props for the
   * Card or RankingCard component. Cards will wrap naturally based on their
   * intrinsic min/max widths.
   */
  cards: E.arrayOf(E.object).isRequired,
  /**
   * Type of card to render - either "card" (default), "ranking", or "image"
   */
  cardType: E.oneOf(["card", "ranking", "image"]),
  /**
   * Number of columns to display.
   */
  columns: E.oneOf([1, 2, 3, 4, "1", "2", "3", "4"])
};
const wS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, Jm = ({
  backgroundImage: a,
  icon: o,
  title: f,
  highlightText: v,
  description: y,
  button: p
}) => {
  const w = () => {
    if (!o) return null;
    let _ = "";
    return Array.isArray(o) ? _ = o.join(" ") : _ = o.includes(" ") ? o : `fas fa-${o}`, /* @__PURE__ */ A.jsx("i", { className: _, "aria-hidden": "true" });
  };
  return /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight", children: [
    /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-image-container", children: /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight-image-wrapper", children: [
      /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-overlay" }),
      /* @__PURE__ */ A.jsx(
        "img",
        {
          src: a,
          alt: "",
          "aria-hidden": "true",
          className: "content-spotlight-image"
        }
      )
    ] }) }),
    /* @__PURE__ */ A.jsxs("div", { className: "content-spotlight-content", children: [
      o && /* @__PURE__ */ A.jsx("div", { className: "content-spotlight-icon", children: w() }),
      /* @__PURE__ */ A.jsxs("h2", { className: "content-spotlight-title", children: [
        f,
        v && /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          f && v && /* @__PURE__ */ A.jsx("br", {}),
          /* @__PURE__ */ A.jsx("span", { className: "highlight", children: v })
        ] })
      ] }),
      y && /* @__PURE__ */ A.jsx(
        "p",
        {
          className: "content-spotlight-description",
          dangerouslySetInnerHTML: La(y)
        }
      ),
      p && /* @__PURE__ */ A.jsx(
        Tl,
        {
          gaData: {
            ...wS,
            text: p.label,
            component: "ContentSpotlight"
          },
          children: /* @__PURE__ */ A.jsx(
            "a",
            {
              href: p.href,
              className: `btn ${p.color ? `btn-${p.color}` : "btn-gold"}`,
              children: p.label
            }
          )
        }
      )
    ] })
  ] });
};
Jm.propTypes = {
  backgroundImage: E.string.isRequired,
  icon: E.oneOfType([
    E.string,
    E.arrayOf(E.string)
  ]),
  title: E.node.isRequired,
  highlightText: E.string,
  description: E.string,
  button: E.shape({
    label: E.string.isRequired,
    href: E.string.isRequired,
    color: E.string
  })
};
var AS = /* @__PURE__ */ ((a) => (a.COPY = "copy", a))(AS || {});
const _S = ({ type: a }) => a == "copy" ? /* @__PURE__ */ A.jsx("hr", { className: "copy-divider" }) : /* @__PURE__ */ A.jsx("hr", {}), OS = gu.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 3px;
    border: 3px solid #1b1b1b;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #1b1b1b transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, CS = () => /* @__PURE__ */ A.jsxs(OS, { children: [
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {}),
  /* @__PURE__ */ A.jsx("div", {})
] }), RS = gu.section``, NS = E1(null), MS = ({
  defaultProps: a,
  dataSource: o,
  noFeedText: f,
  renderHeader: v,
  renderBody: y,
  dataTransformer: p,
  dataFilter: w,
  maxItems: _
}) => {
  const [{ data: C, loading: z, error: B }, I] = M1(), [F, ce] = fa([]), ae = { ...a.dataSource, ...o };
  return Da(() => {
    I(ae == null ? void 0 : ae.url);
  }, [ae == null ? void 0 : ae.url]), Da(() => {
    const $ = C == null ? void 0 : C.nodes.map(p), he = $ == null ? void 0 : $.filter(
      (ge) => w(ge, o == null ? void 0 : o.filters)
    );
    ce(_ ? he == null ? void 0 : he.slice(0, _) : he);
  }, [C]), // Init the context to be used on its childrens
  /* @__PURE__ */ A.jsx(NS.Provider, { value: { feeds: F }, children: /* @__PURE__ */ A.jsxs(RS, { children: [
    v,
    B ? /* @__PURE__ */ A.jsx("span", { children: "Error, try again!" }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      z && !(F != null && F.length) && /* @__PURE__ */ A.jsx("div", { className: "text-center mt-4", children: /* @__PURE__ */ A.jsx(CS, {}) }),
      F != null && F.length ? y : !z && /* @__PURE__ */ A.jsx("p", { className: "text-center", children: f })
    ] })
  ] }) });
};
MS.propTypes = {
  renderHeader: E.element,
  renderBody: E.element,
  maxItems: E.number,
  dataTransformer: E.func,
  dataFilter: E.func,
  noFeedText: E.string
};
const Km = E.shape({
  color: E.oneOf(["white", "dark"]),
  text: E.string
}), jm = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  text: E.string
}), gE = E.shape({
  color: E.oneOf(["gold", "maroon", "gray", "dark"]),
  text: E.string,
  size: E.string
}), zS = E.shape({
  url: E.string,
  filters: E.string
}), DS = E.shape({
  header: Km,
  ctaButton: jm,
  dataSource: zS,
  maxItems: E.number
}), LS = gu.div`
  @media screen and (min-width: 768px) {
    & {
      display: inline-flex;
      justify-content: flex-end;
    }
  }
`, kS = ({
  defaultProps: a,
  header: o,
  ctaButton: f
}) => {
  const v = { ...a.header, ...o }, y = { ...a.ctaButton, ...f }, p = v.tag || "h2", w = p !== "h2", _ = `text-${v.color} ${w ? "h2" : ""}`.trim();
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: "row justify-content-between align-items-center pb-6",
      "data-testid": "feed-header",
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "col-sm-12 col-md-9", children: /* @__PURE__ */ A.jsx(p, { className: _, children: v.text }) }),
        /* @__PURE__ */ A.jsx(LS, { className: "col-sm-12 col-md-3", children: /* @__PURE__ */ A.jsx(
          Tl,
          {
            gaData: {
              event: "link",
              action: "click",
              name: "onclick",
              type: "internal link",
              region: "main content",
              section: v.text,
              text: y.text
            },
            children: /* @__PURE__ */ A.jsx("a", { className: `btn btn-${y.color}`, href: y.url, children: y.text })
          }
        ) })
      ]
    }
  );
};
kS.propTypes = {
  defaultProps: DS,
  header: Km,
  ctaButton: jm
};
const HS = ({ children: a }) => /* @__PURE__ */ A.jsx("div", { className: "row", "data-testid": "feed-body", children: /* @__PURE__ */ A.jsx("div", { className: "col", children: a }) });
HS.propTypes = {
  children: E.element
};
const BS = gu.img`
  width: 100%;
`;
function US({ image: a, title: o, contents: f }) {
  return console.log({ image: a, title: o, contents: f }), /* @__PURE__ */ A.jsx("div", { children: "TODO: to be implemented" });
}
function FS({
  image: a,
  subTitle: o,
  title: f,
  contents: v,
  contentsColor: y
}) {
  const p = {
    small: "uds-hero-sm",
    medium: "uds-hero-md",
    large: "uds-hero-lg",
    undefined: ""
  }, w = {
    gold: "highlight-gold",
    black: "highlight-black",
    white: "highlight-white",
    none: "text-white",
    undefined: ""
  }, _ = {
    black: "text-dark",
    white: "text-white",
    undefined: ""
  };
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Mt("uds-hero", {
        [p[a == null ? void 0 : a.size]]: a == null ? void 0 : a.size
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "hero-overlay" }),
        /* @__PURE__ */ A.jsx(
          BS,
          {
            className: "hero",
            src: a == null ? void 0 : a.url,
            alt: a == null ? void 0 : a.altText,
            "data-testid": "hero-image"
          }
        ),
        o && /* @__PURE__ */ A.jsx("div", { role: "doc-subtitle", "data-testid": "hero-subtitle", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            className: Mt({
              [_[o.color]]: o.color,
              [w[o.highlightColor]]: o.highlightColor
            }),
            children: o.text
          }
        ) }),
        f && /* @__PURE__ */ A.jsx("h1", { style: { maxWidth: f.maxWidth || "" }, "data-testid": "hero-title", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            className: Mt({
              [_[f.color]]: f.color,
              [w[f.highlightColor]]: f.highlightColor
            }),
            children: f.text
          }
        ) }),
        v && /* @__PURE__ */ A.jsx(
          "div",
          {
            "data-testid": "hero-content",
            className: Mt("content", {
              [_[y]]: y
            }),
            children: v.map((C, z) => /* @__PURE__ */ A.jsx("p", { children: C.text }, `content-${z}`))
          }
        )
      ]
    }
  );
}
const qm = (a) => {
  const o = a.type || "heading-hero";
  return {
    "heading-hero": () => FS(a),
    "story-hero": () => US(a),
    undefined: () => (console.error(
      `the type '${o}' is not supported by the 'Hero' component.`
    ), null)
  }[o]();
};
qm.propTypes = {
  type: E.oneOf(["heading-hero", "story-hero"]),
  image: bp,
  title: bg,
  subTitle: bg,
  contents: E.arrayOf(bg),
  contentsColor: E.string
};
const YS = ({
  title: a = "Highly ranked",
  description: o = "",
  ctaText: f = "",
  ctaUrl: v = "",
  ctaButtonColor: y = "dark",
  rankings: p = []
}) => /* @__PURE__ */ A.jsx("section", { className: "highly-ranked-section", children: /* @__PURE__ */ A.jsxs("div", { className: "container", children: [
  /* @__PURE__ */ A.jsx("div", { className: "row", children: /* @__PURE__ */ A.jsxs("div", { className: "col-12 col-lg-8", children: [
    a && /* @__PURE__ */ A.jsx("h2", { className: "highly-ranked-title", children: /* @__PURE__ */ A.jsx("span", { className: "highlight-gold", children: a }) }),
    o && /* @__PURE__ */ A.jsx(
      "p",
      {
        className: "highly-ranked-description",
        dangerouslySetInnerHTML: La(o)
      }
    ),
    f && v && /* @__PURE__ */ A.jsx("div", { className: "highly-ranked-cta", children: /* @__PURE__ */ A.jsx(
      co,
      {
        label: f,
        href: v,
        color: y,
        size: "small",
        classes: []
      }
    ) })
  ] }) }),
  /* @__PURE__ */ A.jsx("div", { className: "row highly-ranked-grid", children: p.map((w, _) => /* @__PURE__ */ A.jsx("div", { className: "col-12 col-lg-6 mb-4", children: /* @__PURE__ */ A.jsxs("div", { className: "highly-ranked-card", children: [
    /* @__PURE__ */ A.jsx("div", { className: "ranking-value-container", children: /* @__PURE__ */ A.jsxs("h3", { className: "ranking-value", children: [
      /* @__PURE__ */ A.jsx(
        "span",
        {
          className: `ranking-value-main${w.headingLevel ? ` ${w.headingLevel}` : " h1"}`,
          children: w.value
        }
      ),
      w.title && /* @__PURE__ */ A.jsx("span", { className: "ranking-value-subsection", children: w.title })
    ] }) }),
    w.description && /* @__PURE__ */ A.jsx("div", { className: "ranking-content", children: /* @__PURE__ */ A.jsx(
      "p",
      {
        className: "ranking-description",
        dangerouslySetInnerHTML: La(
          w.description
        )
      }
    ) })
  ] }) }, _)) })
] }) }), Mr = ({
  dataId: a,
  isClickeable: o = !1,
  disabled: f = !1,
  pageLinkIcon: v = !1,
  selectedPage: y = !1,
  onClick: p = () => {
  },
  ellipses: w,
  ariaLabel: _,
  children: C,
  ariaDisabled: z
}) => /* @__PURE__ */ A.jsx(
  "li",
  {
    className: Mt("page-item", {
      disabled: f,
      active: y,
      elipses: w
    }),
    children: o ? /* @__PURE__ */ A.jsxs(
      "button",
      {
        type: "button",
        "aria-label": _,
        className: Mt("page-link", {
          "page-link-icon": v
        }),
        onClick: p,
        "data-testid": a ? `pagination-${a}` : "page-link",
        "data-id": a,
        "aria-current": y ? "page" : null,
        "aria-disabled": z,
        children: [
          C,
          y && /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "(current)" })
        ]
      }
    ) : /* @__PURE__ */ A.jsx("span", { className: "page-link", "data-testid": "page-link", children: C })
  }
);
Mr.propTypes = {
  isClickeable: E.bool,
  disabled: E.bool,
  pageLinkIcon: E.bool,
  selectedPage: E.bool,
  dataId: E.string,
  onClick: E.func,
  children: E.node,
  ellipses: E.bool,
  ariaLabel: E.string,
  ariaDisabled: E.bool
};
const GS = {
  event: "select",
  action: "click",
  name: "onclick",
  type: "pagination",
  region: "main content"
}, $m = ({
  type: a,
  background: o,
  currentPage: f = 1,
  totalPages: v = 10,
  onChange: y
}) => {
  const [p, w] = fa(null);
  Da(() => {
    w(f);
  }, [f]);
  const _ = (B) => {
    rm({ ...GS, text: `page ${B}` });
  }, C = (B, I) => {
    const ce = {
      first: 1,
      prev: p === 1 ? 1 : p - 1,
      next: p === v ? v : p + 1,
      last: v
    }[I] ?? I;
    w(ce), _(ce), y == null || y(B, ce);
  }, z = () => {
    if (v < 5)
      return /* @__PURE__ */ A.jsx(A.Fragment, { children: Array.from({ length: v }, (he, ge) => {
        const de = ge + 1;
        return /* @__PURE__ */ A.jsx(
          Mr,
          {
            ariaLabel: `Page ${de} of ${v}`,
            isClickeable: !0,
            selectedPage: p === de,
            onClick: (De) => C(De, de),
            children: de
          },
          de
        );
      }) });
    const B = 2, I = Jy(
      p === v - 1,
      1,
      p === v ? 2 : 1
    ), F = Jy(
      p === 1,
      2,
      1
    ), ce = fb(
      p - I,
      p,
      v
    ), ae = fb(
      p,
      p + 1 + F,
      v
    ), $ = [...ce, ...ae];
    return /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      $[0] !== 1 && /* @__PURE__ */ A.jsx(
        Mr,
        {
          ariaLabel: `Page 1 of ${v}`,
          isClickeable: !0,
          selectedPage: p === 1,
          onClick: (he) => C(he, "first"),
          children: "1"
        }
      ),
      p > v - B && /* @__PURE__ */ A.jsx(
        Mr,
        {
          isClickeable: !0,
          ariaLabel: `Page 2 of ${v}`,
          selectedPage: p === 2,
          onClick: (he) => C(he, 2),
          children: "2"
        }
      ),
      $[0] > 2 && /* @__PURE__ */ A.jsx(Mr, { ellipses: !0, children: "..." }),
      $.map((he) => /* @__PURE__ */ A.jsx(
        Mr,
        {
          ariaLabel: `Page ${he} of ${v}`,
          isClickeable: !0,
          selectedPage: p === he,
          onClick: (ge) => C(ge, he),
          children: he
        },
        he
      )),
      $[$.length - 1] < v - 1 && /* @__PURE__ */ A.jsx(Mr, { ellipses: !0, children: "..." }),
      p < B + 1 && /* @__PURE__ */ A.jsx(
        Mr,
        {
          isClickeable: !0,
          ariaLabel: `Page ${v - 1} of ${v}`,
          selectedPage: p === v - 1,
          onClick: (he) => C(he, v - 1),
          children: v - 1
        }
      ),
      $[$.length - 1] !== v && /* @__PURE__ */ A.jsx(
        Mr,
        {
          isClickeable: !0,
          ariaLabel: `Page ${v} of ${v}`,
          selectedPage: p === v,
          onClick: (he) => C(he, "last"),
          children: v
        }
      )
    ] });
  };
  return /* @__PURE__ */ A.jsx("nav", { "aria-label": "Pagination", "data-testid": "pagination", children: /* @__PURE__ */ A.jsxs(
    "ul",
    {
      className: Mt(
        "pagination",
        "justify-content-center",
        "pt-2",
        "pb-2",
        {
          border: a === "bordered",
          "uds-bg-gray1": o === "gray1",
          "uds-bg-gray": o === "gray2",
          "uds-bg-dark": o === "gray7"
        }
      ),
      children: [
        /* @__PURE__ */ A.jsx(
          Mr,
          {
            dataId: "prev",
            isClickeable: !0,
            disabled: p === 1,
            pageLinkIcon: !0,
            onClick: (B) => C(B, "prev"),
            ariaDisabled: p === 1,
            ariaLabel: "Previous Page"
          }
        ),
        z(),
        /* @__PURE__ */ A.jsx(
          Mr,
          {
            dataId: "next",
            isClickeable: !0,
            ariaDisabled: p === v,
            disabled: p === v,
            pageLinkIcon: !0,
            onClick: (B) => C(B, "next"),
            ariaLabel: "Next Page"
          }
        )
      ]
    }
  ) });
};
$m.propTypes = {
  /**
   * Type of pagination
   */
  type: E.oneOf(["default", "bordered"]).isRequired,
  /**
   * Background of pagination
   */
  background: E.oneOf(["white", "gray1", "gray2", "gray7"]).isRequired,
  /**
   * Current page
   */
  currentPage: E.number,
  /**
   * Total number of pages
   */
  totalPages: E.number,
  /**
   * Callback fired when the page is changed
   */
  onChange: E.func.isRequired
};
var XS = /* @__PURE__ */ ((a) => (a.WARNING = "warning", a.INFO = "info", a.SUCCESS = "success", a.ERROR = "error", a))(XS || {});
const IS = ({
  type: a,
  dismissable: o,
  children: f
}) => {
  var z, B, I;
  const { isBootstrap: v, isReact: y } = Vo(), [p, w] = fa(!0), _ = () => w(!1), C = {
    warning: {
      iconTitle: "Warning",
      iconName: "bell",
      alertClass: "warning"
    },
    info: {
      iconTitle: "Information",
      iconName: "info-circle",
      alertClass: "info"
    },
    success: {
      iconTitle: "Success",
      iconName: "check-circle",
      alertClass: "success"
    },
    error: {
      iconTitle: "Error",
      iconName: "exclamation-triangle",
      alertClass: "danger"
    }
  };
  return p && /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Mt("alert", {
        "alert-dismissable": o,
        [`alert-${(z = C[a]) == null ? void 0 : z.alertClass}`]: a
      }),
      role: "alert",
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "alert-icon", children: /* @__PURE__ */ A.jsx(
          "span",
          {
            title: (B = C[a]) == null ? void 0 : B.iconTitle,
            className: `fa fa-icon fa-${(I = C[a]) == null ? void 0 : I.iconName}`
          }
        ) }),
        /* @__PURE__ */ A.jsx("div", { className: "alert-content", children: f }),
        o && /* @__PURE__ */ A.jsx("div", { className: "alert-close", children: /* @__PURE__ */ A.jsx(
          iv,
          {
            icon: ["fas", "times"],
            onClick: y && _,
            "data-bs-dismiss": v && "alert"
          }
        ) })
      ]
    }
  );
}, ZS = gu.div`
  button {
    padding: 16px 0;
    border: none;
    outline: none;
  }
`, e0 = ({ gaData: a, hidePrev: o, hideNext: f, slideNav: v }) => {
  const { isReact: y, isBootstrap: p } = Vo();
  return /* @__PURE__ */ A.jsxs(ZS, { children: [
    (!o || p) && /* @__PURE__ */ A.jsx(Tl, { gaData: { ...a, text: "left chevron" }, children: /* @__PURE__ */ A.jsxs(
      "button",
      {
        className: "scroll-control-prev",
        type: "button",
        onClick: y && (() => v(-1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ A.jsx("span", { className: "carousel-control-prev-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "Previous" })
        ]
      }
    ) }),
    (!f || p) && /* @__PURE__ */ A.jsx(Tl, { gaData: { ...a, text: "right chevron" }, children: /* @__PURE__ */ A.jsxs(
      "button",
      {
        className: "scroll-control-next",
        type: "button",
        onClick: y && (() => v(1)),
        tabIndex: -1,
        children: [
          /* @__PURE__ */ A.jsx("span", { className: "carousel-control-next-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "Next" })
        ]
      }
    ) })
  ] });
};
e0.propTypes = {
  gaData: E.object,
  hidePrev: E.bool,
  hideNext: E.bool,
  slideNav: E.func.isRequired
};
const t0 = function(o) {
  const {
    id: f,
    selected: v,
    title: y,
    selectTab: p,
    leftKeyPressed: w,
    rightKeyPressed: _,
    icon: C,
    gaData: z,
    ref: B
  } = o, { isReact: I, isBootstrap: F } = Vo(), ce = Yo(null);
  w1(B, () => ({
    focus() {
      ce.current.focus();
    },
    scrollIntoView() {
      var ge, de, De, Re, ye, xe, we;
      const $ = ((ge = ce.current) == null ? void 0 : ge.offsetWidth) / 2 + ce.current.offsetLeft, he = ((De = (de = ce.current) == null ? void 0 : de.offsetParent) == null ? void 0 : De.scrollLeft) + ((ye = (Re = ce.current) == null ? void 0 : Re.offsetParent) == null ? void 0 : ye.offsetWidth) / 2;
      (we = (xe = ce.current) == null ? void 0 : xe.offsetParent) == null || we.scrollBy({
        left: $ - he
      });
    }
  }), []);
  const ae = ($) => {
    $.keyCode === 37 ? ($.preventDefault(), w()) : $.keyCode === 39 && ($.preventDefault(), _());
  };
  return /* @__PURE__ */ A.jsx(Tl, { gaData: { ...z, text: y }, children: /* @__PURE__ */ A.jsxs(
    "a",
    {
      ref: ce,
      className: `nav-item nav-link ${v ? "active" : ""}`,
      id: f,
      href: `#nav-${f}`,
      role: "tab",
      "aria-controls": `nav-${f}`,
      "aria-selected": v,
      "data-bs-toggle": F && "tab",
      onClick: I && (($) => p($, f, y)),
      onKeyDown: I && ae,
      tabIndex: v ? "" : "-1",
      children: [
        y,
        " ",
        C && /* @__PURE__ */ A.jsx("i", { className: `${C == null ? void 0 : C[0]} fa-${C == null ? void 0 : C[1]} me-1` })
      ]
    }
  ) });
};
t0.propTypes = {
  gaData: E.object,
  id: E.string.isRequired,
  selected: E.bool.isRequired,
  title: E.string.isRequired,
  selectTab: E.func.isRequired,
  leftKeyPressed: E.func.isRequired,
  rightKeyPressed: E.func.isRequired,
  icon: E.arrayOf(E.string)
};
function VS() {
  const a = Yo({}), o = Ls(
    (f) => (v) => {
      a.current[f] = v;
    },
    []
  );
  return [a, o];
}
const QS = ({ id: a, bgColor: o, selected: f, children: v }) => {
  const { isBootstrap: y } = Vo();
  return f || y ? /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `tab-pane fade show ${f ? "show active" : ""} ${o === "bg-dark" ? "text-white" : ""}`,
      id: `nav-${a}`,
      role: "tabpanel",
      "aria-labelledby": `nav-${a}-tab`,
      children: v
    }
  ) : null;
};
QS.propTypes = {
  id: E.string.isRequired,
  bgColor: E.string,
  selected: E.bool,
  children: E.oneOfType([E.array, E.element])
};
const n0 = ({
  initialTab: a = "",
  children: o,
  bgColor: f = "",
  onTabChange: v = (y) => {
  }
}) => {
  var wt, At;
  const y = Xt.Children.toArray(o), p = Yo(!1), [w, _] = fa(
    a && a !== "null" ? a : ((At = (wt = y[0]) == null ? void 0 : wt.props) == null ? void 0 : At.id) || ""
  ), C = Yo(null), [z, B] = VS(), [I, F] = fa(0), [ce, ae] = fa(), $ = Ls(() => {
    var Ae, Xe;
    ae(
      ((Ae = C.current) == null ? void 0 : Ae.scrollWidth) - ((Xe = C.current) == null ? void 0 : Xe.offsetWidth)
    );
  }, []), he = Ls(() => {
    var Ae;
    F((Ae = C.current) == null ? void 0 : Ae.scrollLeft);
  }, []), ge = Ls(() => {
    Ng(he, 150), Mg(he, 150);
  }, [he]), de = Ls(() => {
    Ng($, 150), Mg($, 150);
  }, [$]);
  if (Da(() => {
    const Ae = C.current;
    return Ae && (Ae.addEventListener("scroll", ge), he()), () => {
      Ae && Ae.removeEventListener("scroll", ge);
    };
  }, [ce, ge, he]), Da(() => (window.addEventListener("resize", de), $(), () => {
    window.removeEventListener("resize", de);
  }), [de, $]), Da(() => {
    z.current[w] && z.current[w].scrollIntoView();
  }, [w, z]), Da(() => {
    p.current && a && a !== "null" && w !== a && _(a);
  }, [a, w]), Da(() => {
    p.current = !0;
  }, []), y.length === 0)
    return null;
  const De = (Ae) => {
    var Xe;
    v(Ae), (Xe = z.current[Ae]) == null || Xe.focus(), _(Ae);
  }, Re = {
    event: "select",
    action: "click",
    name: "onclick",
    type: "carousel",
    region: "main content",
    text: ""
  }, ye = {
    event: "link",
    action: "click",
    name: "onclick",
    type: "internal link",
    text: ""
  }, xe = y.map((Ae) => Xt.cloneElement(Ae, {
    bgColor: f,
    selected: w === Ae.props.id
  })), we = (Ae) => {
    const Xe = C.current, it = Xe.scrollWidth - Xe.clientWidth;
    let P = Xe.scrollLeft + 200 * Ae;
    P = Math.max(0, Math.min(it, P)), Xe.scrollTo({
      left: P,
      behavior: "smooth"
    });
  }, Me = (Ae, Xe, it) => {
    Ae.preventDefault(), De(Xe);
  }, He = (Ae = !0) => {
    const Xe = y.length, it = Ae ? 1 : -1, U = y.findIndex((Se) => Se.props.id === w), P = y[(Xe + U + it) % Xe].props.id;
    De(P);
  };
  let Ot = "uds-tabbed-panels";
  return f === "bg-dark" && (Ot += " uds-tabbed-panels-dark"), /* @__PURE__ */ A.jsxs("div", { className: f, children: [
    /* @__PURE__ */ A.jsxs("nav", { className: Ot, children: [
      /* @__PURE__ */ A.jsx("div", { className: "nav nav-tabs", role: "tablist", ref: C, children: y.map((Ae, Xe) => /* @__PURE__ */ A.jsx(
        t0,
        {
          ref: B(Ae.props.id),
          id: Ae.props.id,
          title: Ae.props.title,
          selected: w === Ae.props.id,
          gaData: ye,
          selectTab: Me,
          leftKeyPressed: () => He(!1),
          rightKeyPressed: () => He(),
          icon: Ae.props.icon,
          index: Xe
        },
        Ae.props.id
      )) }),
      /* @__PURE__ */ A.jsx(
        e0,
        {
          hidePrev: I <= 0,
          hideNext: I >= ce,
          gaData: Re,
          slideNav: we
        }
      )
    ] }),
    /* @__PURE__ */ A.jsx(
      "div",
      {
        className: "tab-content",
        tabIndex: 0,
        role: "tabpanel",
        id: "nav-tabContent",
        children: xe
      }
    )
  ] });
};
n0.propTypes = {
  initialTab: E.string,
  children: E.arrayOf(E.element).isRequired,
  bgColor: E.string,
  onTabChange: E.func
};
const cv = ({ imageSource: a, imageAltText: o, quote: f, itemStyle: v = {} }) => {
  var y, p;
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: `uds-blockquote uds-testimonial ${a ? "with-image" : ""} ${Fd(v.containerCssClass)}`,
      children: [
        a && /* @__PURE__ */ A.jsx(
          Zo,
          {
            src: a,
            alt: o,
            dataTestId: "testimonial-image",
            fetchPriority: "high"
          }
        ),
        /* @__PURE__ */ A.jsx("svg", { role: "presentation", viewBox: "0 0 302.87 245.82", children: /* @__PURE__ */ A.jsx("path", { d: "M113.61,245.82H0V164.56q0-49.34,8.69-77.83T40.84,35.58Q64.29,12.95,100.67,0l22.24,46.9q-34,11.33-48.72,31.54T58.63,132.21h55Zm180,0H180V164.56q0-49.74,8.7-78T221,35.58Q244.65,12.95,280.63,0l22.24,46.9q-34,11.33-48.72,31.54t-15.57,53.77h55Z" }) }),
        /* @__PURE__ */ A.jsxs("blockquote", { style: { paddingLeft: 0 }, children: [
          f.title && /* @__PURE__ */ A.jsx("h3", { className: "text-center", "data-testid": "testimonial-title", children: /* @__PURE__ */ A.jsx("span", { className: Fd(v.titleCssClass), children: f.title }) }),
          f.content && /* @__PURE__ */ A.jsx(
            "p",
            {
              className: Fd(v.contentCssClass),
              "data-testid": "testimonial-content",
              children: f.content
            }
          ),
          (!!((y = f.cite) != null && y.name) || !!((p = f.cite) != null && p.description)) && /* @__PURE__ */ A.jsxs("div", { className: "citation", "data-testid": "testimonial-citation", children: [
            /* @__PURE__ */ A.jsx("cite", { className: "name", children: f.cite.name }),
            f.cite && /* @__PURE__ */ A.jsx("cite", { className: "description", children: f.cite.description })
          ] })
        ] })
      ]
    }
  );
};
cv.propTypes = {
  quote: E.shape({
    title: E.string,
    content: E.string,
    cite: E.shape({
      name: E.string,
      description: E.string
    })
  }).isRequired,
  imageSource: E.string,
  imageAltText: E.string,
  itemStyle: E.shape({
    containerCssClass: E.arrayOf(E.string),
    titleCssClass: E.arrayOf(E.string),
    contentCssClass: E.arrayOf(E.string)
  })
};
const PS = (a) => /* @__PURE__ */ A.jsx("button", { className: "uds-tooltip uds-tooltip-gray", ...a, children: /* @__PURE__ */ A.jsxs("span", { className: "fa-stack", "aria-hidden": "true", children: [
  /* @__PURE__ */ A.jsx("i", { className: "fas fa-circle fa-stack-2x" }),
  /* @__PURE__ */ A.jsx("i", { className: "fas fa-info fa-stack-1x" })
] }) }), WS = ({
  title: a,
  content: o,
  triggerElement: f,
  children: v,
  iconLabel: y
}) => {
  const p = "tooltip-" + nh(), w = () => y || (a ? `Show tooltip: ${a}` : o && typeof o == "string" ? `Show tooltip: ${o.length > 50 ? o.substring(0, 47) + "..." : o}` : "Show more information");
  let _ = v || f || /* @__PURE__ */ A.jsx(PS, { "aria-label": w() });
  return typeof _ == "string" && (_ = /* @__PURE__ */ A.jsx("button", { type: "button", children: _ })), /* @__PURE__ */ A.jsxs("span", { className: "uds-tooltip-container", children: [
    Xt.cloneElement(_, {
      "aria-describedby": p,
      tabIndex: 0
    }),
    /* @__PURE__ */ A.jsxs("div", { role: "tooltip", className: "uds-tooltip-description", id: p, children: [
      a && /* @__PURE__ */ A.jsx("span", { className: "uds-tooltip-heading", children: a }),
      o
    ] })
  ] });
}, JS = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content",
  text: "play button"
}, KS = ({
  url: a = "",
  vttUrl: o,
  caption: f,
  title: v = "",
  className: y,
  controls: p = !0
}) => {
  const w = Yo(null);
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: Mt(`uds-video-container ${y}`, {
        "uds-video-with-caption": f
      }),
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "uds-video-player", children: /* @__PURE__ */ A.jsx(Tl, { gaData: { ...JS, section: v }, children: /* @__PURE__ */ A.jsxs(
          "video",
          {
            ref: w,
            title: v,
            playsInline: !0,
            controls: p || !0,
            children: [
              /* @__PURE__ */ A.jsx("source", { src: a }),
              /* @__PURE__ */ A.jsx(
                "track",
                {
                  src: o,
                  kind: "captions",
                  srcLang: "en",
                  label: "english_captions"
                }
              )
            ]
          }
        ) }) }),
        f && /* @__PURE__ */ A.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ A.jsx("figcaption", { children: f }) })
      ]
    }
  );
}, jS = ({ title: a = "", caption: o, url: f = "", className: v }) => /* @__PURE__ */ A.jsxs(
  "div",
  {
    className: Mt(`uds-video-container ${v}`, {
      "uds-video-with-caption": o
    }),
    children: [
      /* @__PURE__ */ A.jsx("div", { className: "uds-video-player youtube-video", children: /* @__PURE__ */ A.jsx("iframe", { title: a, src: f }) }),
      o && /* @__PURE__ */ A.jsx("figure", { "data-testid": "video-caption", children: /* @__PURE__ */ A.jsx("figcaption", { children: o }) })
    ]
  }
), l0 = (a) => {
  const {
    type: o = "video",
    url: f = "",
    vttUrl: v,
    title: y = "",
    caption: p,
    className: w,
    controls: _ = !0
  } = a;
  return o === "youtube" ? jS({ url: f, title: y, caption: p, className: w }) : KS({
    url: f,
    vttUrl: v,
    title: y,
    caption: p,
    className: w,
    controls: _
  });
};
l0.propTypes = {
  type: E.oneOf(["video", "youtube"]),
  url: E.string,
  vttUrl: E.string,
  title: E.string,
  className: E.string,
  caption: E.string,
  controls: E.bool
};
const qS = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "pagination",
  text: "owl dot"
}, ov = ({ children: a }) => /* @__PURE__ */ A.jsx(
  "div",
  {
    role: "group",
    className: "glide__bullets",
    "data-glide-el": "controls[nav]",
    "data-testid": "bullets-container",
    onClick: (o) => o.stopPropagation(),
    onKeyDown: (o) => o.stopPropagation(),
    children: a
  }
);
ov.propTypes = {
  children: E.oneOfType([
    E.element,
    E.arrayOf(E.element)
  ]).isRequired
};
const a0 = ({ buttonCount: a }) => {
  const o = [];
  for (let f = 0; f < a; f += 1)
    o.push(
      /* @__PURE__ */ A.jsx(Tl, { gaData: qS, children: /* @__PURE__ */ A.jsx(
        "button",
        {
          type: "button",
          className: "glide__bullet",
          "data-glide-dir": `=${f}`,
          "aria-label": `Slide view ${f + 1}`
        }
      ) }, `bullet-${f}`)
    );
  return /* @__PURE__ */ A.jsx(ov, { children: o });
};
a0.propTypes = {
  buttonCount: E.number.isRequired
};
const i0 = ({ imageItems: a, onItemClick: o = () => null }) => {
  const f = (y, p) => {
    const { ariaSelected: w } = y.currentTarget.dataset;
    y.currentTarget.dataset.ariaSelected = String(!w), y.stopPropagation(), o(p);
  }, v = a.map((y, p) => /* @__PURE__ */ A.jsx(
    "button",
    {
      type: "button",
      role: "option",
      className: "bullet-image-container",
      "data-glide-dir": `=${p}`,
      "aria-label": `Slide view ${p + 1}`,
      "aria-selected": "false",
      onClick: (w) => f(w, p),
      onKeyDown: (w) => f(w, p),
      children: /* @__PURE__ */ A.jsx(
        "img",
        {
          src: y,
          alt: `Slide ${p + 1}`,
          className: "glide__bullet bullet-image",
          loading: "lazy",
          decoding: "async",
          fetchpriority: "low"
        }
      )
    },
    `bullet-${p}`
  ));
  return /* @__PURE__ */ A.jsx(ov, { children: v });
};
i0.propTypes = {
  imageItems: E.arrayOf(E.string).isRequired,
  onItemClick: E.func
};
const sv = ({ onClick: a = () => null }) => /* @__PURE__ */ A.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--next",
    "data-glide-dir": ">",
    "aria-label": "Next slide",
    onClick: a,
    children: /* @__PURE__ */ A.jsx("i", { className: "fas fa-chevron-right arrow-icon" })
  }
);
sv.propTypes = {
  onClick: E.func
};
const fv = ({ onClick: a = () => null }) => /* @__PURE__ */ A.jsx(
  "button",
  {
    type: "button",
    className: "glide__arrow glide__arrow--prev",
    "data-glide-dir": "<",
    "aria-label": "Previous slide",
    onClick: a,
    children: /* @__PURE__ */ A.jsx("span", { className: "fas fa-chevron-left arrow-icon" })
  }
);
fv.propTypes = {
  onClick: E.func
};
const Ib = {
  event: "select",
  action: "click",
  name: "onclick",
  region: "main content",
  type: "carousel"
}, dv = ({ children: a = null }) => /* @__PURE__ */ A.jsx(
  "div",
  {
    className: "glide__arrows",
    "data-glide-el": "controls",
    "data-testid": "arrows-container",
    children: a
  }
);
dv.propTypes = {
  children: E.arrayOf(E.element)
};
const r0 = ({ onClick: a = () => null, children: o = null }) => /* @__PURE__ */ A.jsxs(dv, { children: [
  /* @__PURE__ */ A.jsx(Tl, { gaData: { ...Ib, text: "left chevron" }, children: /* @__PURE__ */ A.jsx(fv, { onClick: a }) }),
  o,
  /* @__PURE__ */ A.jsx(Tl, { gaData: { ...Ib, text: "right chevron" }, children: /* @__PURE__ */ A.jsx(sv, { onClick: a }) })
] });
r0.propTypes = {
  children: E.element,
  onClick: E.func
};
const u0 = ({ carouselItems: a }) => {
  const o = a.map((f) => /* @__PURE__ */ A.jsx("li", { className: "glide__slide slider", children: f.item }, f.id.toString()));
  return /* @__PURE__ */ A.jsx("ul", { className: "glide__slides", children: o });
};
u0.propTypes = {
  carouselItems: E.arrayOf(E.object)
};
function Zb(a, o) {
  var f = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var v = Object.getOwnPropertySymbols(a);
    o && (v = v.filter(function(y) {
      return Object.getOwnPropertyDescriptor(a, y).enumerable;
    })), f.push.apply(f, v);
  }
  return f;
}
function Vb(a) {
  for (var o = 1; o < arguments.length; o++) {
    var f = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Zb(Object(f), !0).forEach(function(v) {
      ex(a, v, f[v]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(f)) : Zb(Object(f)).forEach(function(v) {
      Object.defineProperty(a, v, Object.getOwnPropertyDescriptor(f, v));
    });
  }
  return a;
}
function Pd(a) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Pd = function(o) {
    return typeof o;
  } : Pd = function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Pd(a);
}
function hh(a, o) {
  if (!(a instanceof o))
    throw new TypeError("Cannot call a class as a function");
}
function $S(a, o) {
  for (var f = 0; f < o.length; f++) {
    var v = o[f];
    v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(a, v.key, v);
  }
}
function gh(a, o, f) {
  return o && $S(a.prototype, o), a;
}
function ex(a, o, f) {
  return o in a ? Object.defineProperty(a, o, {
    value: f,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[o] = f, a;
}
function tx(a, o) {
  if (typeof o != "function" && o !== null)
    throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(o && o.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), o && Qg(a, o);
}
function Bs(a) {
  return Bs = Object.setPrototypeOf ? Object.getPrototypeOf : function(f) {
    return f.__proto__ || Object.getPrototypeOf(f);
  }, Bs(a);
}
function Qg(a, o) {
  return Qg = Object.setPrototypeOf || function(v, y) {
    return v.__proto__ = y, v;
  }, Qg(a, o);
}
function nx() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function lx(a) {
  if (a === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}
function ax(a, o) {
  if (o && (typeof o == "object" || typeof o == "function"))
    return o;
  if (o !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lx(a);
}
function ix(a) {
  var o = nx();
  return function() {
    var v = Bs(a), y;
    if (o) {
      var p = Bs(this).constructor;
      y = Reflect.construct(v, arguments, p);
    } else
      y = v.apply(this, arguments);
    return ax(this, y);
  };
}
function rx(a, o) {
  for (; !Object.prototype.hasOwnProperty.call(a, o) && (a = Bs(a), a !== null); )
    ;
  return a;
}
function Wd() {
  return typeof Reflect < "u" && Reflect.get ? Wd = Reflect.get : Wd = function(o, f, v) {
    var y = rx(o, f);
    if (y) {
      var p = Object.getOwnPropertyDescriptor(y, f);
      return p.get ? p.get.call(arguments.length < 3 ? o : v) : p.value;
    }
  }, Wd.apply(this, arguments);
}
var ux = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function nc(a) {
  console.error("[Glide warn]: ".concat(a));
}
function sa(a) {
  return parseInt(a);
}
function cx(a) {
  return parseFloat(a);
}
function Pg(a) {
  return typeof a == "string";
}
function Us(a) {
  var o = Pd(a);
  return o === "function" || o === "object" && !!a;
}
function eh(a) {
  return typeof a == "function";
}
function c0(a) {
  return typeof a > "u";
}
function Wg(a) {
  return a.constructor === Array;
}
function ox(a, o, f) {
  var v = {};
  for (var y in o)
    eh(o[y]) ? v[y] = o[y](a, v, f) : nc("Extension must be a function");
  for (var p in v)
    eh(v[p].mount) && v[p].mount();
  return v;
}
function Dn(a, o, f) {
  Object.defineProperty(a, o, f);
}
function sx(a) {
  return Object.keys(a).sort().reduce(function(o, f) {
    return o[f] = a[f], o[f], o;
  }, {});
}
function Jg(a, o) {
  var f = Object.assign({}, a, o);
  if (o.hasOwnProperty("classes")) {
    f.classes = Object.assign({}, a.classes, o.classes);
    var v = ["direction", "type", "slide", "arrow", "nav"];
    v.forEach(function(y) {
      o.classes.hasOwnProperty(y) && (f.classes[y] = Vb(Vb({}, a.classes[y]), o.classes[y]));
    });
  }
  return o.hasOwnProperty("breakpoints") && (f.breakpoints = Object.assign({}, a.breakpoints, o.breakpoints)), f;
}
var fx = /* @__PURE__ */ (function() {
  function a() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    hh(this, a), this.events = o, this.hop = o.hasOwnProperty;
  }
  return gh(a, [{
    key: "on",
    value: function(f, v) {
      if (Wg(f)) {
        for (var y = 0; y < f.length; y++)
          this.on(f[y], v);
        return;
      }
      this.hop.call(this.events, f) || (this.events[f] = []);
      var p = this.events[f].push(v) - 1;
      return {
        remove: function() {
          delete this.events[f][p];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(f, v) {
      if (Wg(f)) {
        for (var y = 0; y < f.length; y++)
          this.emit(f[y], v);
        return;
      }
      this.hop.call(this.events, f) && this.events[f].forEach(function(p) {
        p(v || {});
      });
    }
  }]), a;
})(), dx = /* @__PURE__ */ (function() {
  function a(o) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    hh(this, a), this._c = {}, this._t = [], this._e = new fx(), this.disabled = !1, this.selector = o, this.settings = Jg(ux, f), this.index = this.settings.startAt;
  }
  return gh(a, [{
    key: "mount",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), Us(f) ? this._c = ox(this, f, this._e) : nc("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return Wg(f) ? this._t = f : nc("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = Jg(this.settings, f), f.hasOwnProperty("startAt") && (this.index = f.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(f) {
      return this._c.Run.make(f), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(f) {
      return this._c.Transition.disable(), this._c.Move.make(f), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return f && (this.settings.autoplay = f), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(f, v) {
      return this._e.on(f, v), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(f) {
      return this.settings.type === f;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(f) {
      Us(f) ? this._o = f : nc("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(f) {
      this._i = sa(f);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(f) {
      this._d = !!f;
    }
  }]), a;
})();
function hx(a, o, f) {
  var v = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(z) {
      var B = this;
      a.disabled || (!a.settings.waitForTransition || a.disable(), this.move = z, f.emit("run.before", this.move), this.calculate(), f.emit("run", this.move), o.Transition.after(function() {
        B.isStart() && f.emit("run.start", B.move), B.isEnd() && f.emit("run.end", B.move), B.isOffset() && (B._o = !1, f.emit("run.offset", B.move)), f.emit("run.after", B.move), a.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var z = this.move, B = this.length, I = z.steps, F = z.direction, ce = 1;
      if (F === "=") {
        if (a.settings.bound && sa(I) > B) {
          a.index = B;
          return;
        }
        a.index = I;
        return;
      }
      if (F === ">" && I === ">") {
        a.index = B;
        return;
      }
      if (F === "<" && I === "<") {
        a.index = 0;
        return;
      }
      if (F === "|" && (ce = a.settings.perView || 1), F === ">" || F === "|" && I === ">") {
        var ae = y(ce);
        ae > B && (this._o = !0), a.index = p(ae, ce);
        return;
      }
      if (F === "<" || F === "|" && I === "<") {
        var $ = w(ce);
        $ < 0 && (this._o = !0), a.index = _($, ce);
        return;
      }
      nc("Invalid direction pattern [".concat(F).concat(I, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return a.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return a.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return z ? this._o ? z === "|>" ? this.move.direction === "|" && this.move.steps === ">" : z === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === z : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return a.isType("slider") && a.settings.focusAt !== "center" && a.settings.bound;
    }
  };
  function y(C) {
    var z = a.index;
    return a.isType("carousel") ? z + C : z + (C - z % C);
  }
  function p(C, z) {
    var B = v.length;
    return C <= B ? C : a.isType("carousel") ? C - (B + 1) : a.settings.rewind ? v.isBound() && !v.isEnd() ? B : 0 : v.isBound() ? B : Math.floor(B / z) * z;
  }
  function w(C) {
    var z = a.index;
    if (a.isType("carousel"))
      return z - C;
    var B = Math.ceil(z / C);
    return (B - 1) * C;
  }
  function _(C, z) {
    var B = v.length;
    return C >= 0 ? C : a.isType("carousel") ? C + (B + 1) : a.settings.rewind ? v.isBound() && v.isStart() ? B : Math.floor(B / z) * z : 0;
  }
  return Dn(v, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(z) {
      var B = z.substr(1);
      this._m = {
        direction: z.substr(0, 1),
        steps: B ? sa(B) ? sa(B) : B : 0
      };
    }
  }), Dn(v, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var z = a.settings, B = o.Html.slides.length;
      return this.isBound() ? B - 1 - (sa(z.perView) - 1) + sa(z.focusAt) : B - 1;
    }
  }), Dn(v, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), v;
}
function Qb() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function vh(a, o) {
  var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, v, y, p, w, _ = 0, C = function() {
    _ = f.leading === !1 ? 0 : Qb(), v = null, w = a.apply(y, p), v || (y = p = null);
  }, z = function() {
    var I = Qb();
    !_ && f.leading === !1 && (_ = I);
    var F = o - (I - _);
    return y = this, p = arguments, F <= 0 || F > o ? (v && (clearTimeout(v), v = null), _ = I, w = a.apply(y, p), v || (y = p = null)) : !v && f.trailing !== !1 && (v = setTimeout(C, F)), w;
  };
  return z.cancel = function() {
    clearTimeout(v), _ = 0, v = y = p = null;
  }, z;
}
var Bd = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function gx(a, o, f) {
  var v = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(p) {
      for (var w = 0, _ = p.length; w < _; w++) {
        var C = p[w].style, z = o.Direction.value;
        w !== 0 ? C[Bd[z][0]] = "".concat(this.value / 2, "px") : C[Bd[z][0]] = "", w !== p.length - 1 ? C[Bd[z][1]] = "".concat(this.value / 2, "px") : C[Bd[z][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(p) {
      for (var w = 0, _ = p.length; w < _; w++) {
        var C = p[w].style;
        C.marginLeft = "", C.marginRight = "";
      }
    }
  };
  return Dn(v, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return sa(a.settings.gap);
    }
  }), Dn(v, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return v.value * o.Sizes.length;
    }
  }), Dn(v, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var p = a.settings.perView;
      return v.value * (p - 1) / p;
    }
  }), f.on(["build.after", "update"], vh(function() {
    v.apply(o.Html.wrapper.children);
  }, 30)), f.on("destroy", function() {
    v.remove(o.Html.wrapper.children);
  }), v;
}
function o0(a) {
  if (a && a.parentNode) {
    for (var o = a.parentNode.firstChild, f = []; o; o = o.nextSibling)
      o.nodeType === 1 && o !== a && f.push(o);
    return f;
  }
  return [];
}
function Kg(a) {
  return Array.prototype.slice.call(a);
}
var vx = '[data-glide-el="track"]';
function yx(a, o, f) {
  var v = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = a.selector, this.track = this.root.querySelector(vx), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = Kg(this.wrapper.children).filter(function(p) {
        return !p.classList.contains(a.settings.classes.slide.clone);
      });
    }
  };
  return Dn(v, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return v._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(p) {
      Pg(p) && (p = document.querySelector(p)), p !== null ? v._r = p : nc("Root element must be a existing Html node");
    }
  }), Dn(v, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return v._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(p) {
      v._t = p;
    }
  }), Dn(v, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return v.track.children[0];
    }
  }), f.on("update", function() {
    v.collectSlides();
  }), v;
}
function bx(a, o, f) {
  var v = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = a.settings.peek;
    }
  };
  return Dn(v, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return v._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(p) {
      Us(p) ? (p.before = sa(p.before), p.after = sa(p.after)) : p = sa(p), v._v = p;
    }
  }), Dn(v, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var p = v.value, w = a.settings.perView;
      return Us(p) ? p.before / w + p.after / w : p * 2 / w;
    }
  }), f.on(["resize", "update"], function() {
    v.mount();
  }), v;
}
function mx(a, o, f) {
  var v = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var p = this, w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = w, f.emit("move", {
        movement: this.value
      }), o.Transition.after(function() {
        f.emit("move.after", {
          movement: p.value
        });
      });
    }
  };
  return Dn(v, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return v._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(p) {
      v._o = c0(p) ? 0 : sa(p);
    }
  }), Dn(v, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return o.Sizes.slideWidth * a.index;
    }
  }), Dn(v, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var p = this.offset, w = this.translate;
      return o.Direction.is("rtl") ? w + p : w - p;
    }
  }), f.on(["build.before", "run"], function() {
    v.make();
  }), v;
}
function px(a, o, f) {
  var v = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var p = "".concat(this.slideWidth, "px"), w = o.Html.slides, _ = 0; _ < w.length; _++)
        w[_].style.width = p;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      o.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var p = o.Html.slides, w = 0; w < p.length; w++)
        p[w].style.width = "";
      o.Html.wrapper.style.width = "";
    }
  };
  return Dn(v, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return o.Html.slides.length;
    }
  }), Dn(v, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return o.Html.track.offsetWidth;
    }
  }), Dn(v, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return v.slideWidth * v.length + o.Gaps.grow + o.Clones.grow;
    }
  }), Dn(v, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return v.width / a.settings.perView - o.Peek.reductor - o.Gaps.reductor;
    }
  }), f.on(["build.before", "resize", "update"], function() {
    v.setupSlides(), v.setupWrapper();
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
function Tx(a, o, f) {
  var v = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      f.emit("build.before"), this.typeClass(), this.activeClass(), f.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      o.Html.root.classList.add(a.settings.classes.type[a.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var p = a.settings.classes, w = o.Html.slides[a.index];
      w && (w.classList.add(p.slide.active), o0(w).forEach(function(_) {
        _.classList.remove(p.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var p = a.settings.classes, w = p.type, _ = p.slide;
      o.Html.root.classList.remove(w[a.settings.type]), o.Html.slides.forEach(function(C) {
        C.classList.remove(_.active);
      });
    }
  };
  return f.on(["destroy", "update"], function() {
    v.removeClasses();
  }), f.on(["resize", "update"], function() {
    v.mount();
  }), f.on("move.after", function() {
    v.activeClass();
  }), v;
}
function Sx(a, o, f) {
  var v = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], a.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], w = o.Html.slides, _ = a.settings, C = _.perView, z = _.classes, B = _.cloningRatio;
      if (w.length > 0)
        for (var I = +!!a.settings.peek, F = C + I + Math.round(C / 2), ce = w.slice(0, F).reverse(), ae = w.slice(F * -1), $ = 0; $ < Math.max(B, Math.floor(C / w.length)); $++) {
          for (var he = 0; he < ce.length; he++) {
            var ge = ce[he].cloneNode(!0);
            ge.classList.add(z.slide.clone), p.push(ge);
          }
          for (var de = 0; de < ae.length; de++) {
            var De = ae[de].cloneNode(!0);
            De.classList.add(z.slide.clone), p.unshift(De);
          }
        }
      return p;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var p = this.items, w = o.Html, _ = w.wrapper, C = w.slides, z = Math.floor(p.length / 2), B = p.slice(0, z).reverse(), I = p.slice(z * -1).reverse(), F = "".concat(o.Sizes.slideWidth, "px"), ce = 0; ce < I.length; ce++)
        _.appendChild(I[ce]);
      for (var ae = 0; ae < B.length; ae++)
        _.insertBefore(B[ae], C[0]);
      for (var $ = 0; $ < p.length; $++)
        p[$].style.width = F;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var p = this.items, w = 0; w < p.length; w++)
        o.Html.wrapper.removeChild(p[w]);
    }
  };
  return Dn(v, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (o.Sizes.slideWidth + o.Gaps.value) * v.items.length;
    }
  }), f.on("update", function() {
    v.remove(), v.mount(), v.append();
  }), f.on("build.before", function() {
    a.isType("carousel") && v.append();
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
var oo = /* @__PURE__ */ (function() {
  function a() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    hh(this, a), this.listeners = o;
  }
  return gh(a, [{
    key: "on",
    value: function(f, v, y) {
      var p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      Pg(f) && (f = [f]);
      for (var w = 0; w < f.length; w++)
        this.listeners[f[w]] = y, v.addEventListener(f[w], this.listeners[f[w]], p);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(f, v) {
      var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      Pg(f) && (f = [f]);
      for (var p = 0; p < f.length; p++)
        v.removeEventListener(f[p], this.listeners[f[p]], y);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), a;
})();
function xx(a, o, f) {
  var v = new oo(), y = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("resize", window, vh(function() {
        f.emit("resize");
      }, a.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("resize", window);
    }
  };
  return f.on("destroy", function() {
    y.unbind(), v.destroy();
  }), y;
}
var Ex = ["ltr", "rtl"], wx = {
  ">": "<",
  "<": ">",
  "=": "="
};
function Ax(a, o, f) {
  var v = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = a.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(p) {
      var w = p.slice(0, 1);
      return this.is("rtl") ? p.split(w).join(wx[w]) : p;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(p) {
      return this.value === p;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      o.Html.root.classList.add(a.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      o.Html.root.classList.remove(a.settings.classes.direction[this.value]);
    }
  };
  return Dn(v, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return v._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(p) {
      Ex.indexOf(p) > -1 ? v._v = p : nc("Direction value must be `ltr` or `rtl`");
    }
  }), f.on(["destroy", "update"], function() {
    v.removeClass();
  }), f.on("update", function() {
    v.mount();
  }), f.on(["build.before", "update"], function() {
    v.addClass();
  }), v;
}
function _x(a, o) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      return o.Direction.is("rtl") ? -v : v;
    }
  };
}
function Ox(a, o) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      var y = Math.floor(v / o.Sizes.slideWidth);
      return v + o.Gaps.value * y;
    }
  };
}
function Cx(a, o) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      return v + o.Clones.grow / 2;
    }
  };
}
function Rx(a, o) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      if (a.settings.focusAt >= 0) {
        var y = o.Peek.value;
        return Us(y) ? v - y.before : v - y;
      }
      return v;
    }
  };
}
function Nx(a, o) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(v) {
      var y = o.Gaps.value, p = o.Sizes.width, w = a.settings.focusAt, _ = o.Sizes.slideWidth;
      return w === "center" ? v - (p / 2 - _ / 2) : v - _ * w - y * w;
    }
  };
}
function Mx(a, o, f) {
  var v = [Ox, Cx, Rx, Nx].concat(a._t, [_x]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(p) {
      for (var w = 0; w < v.length; w++) {
        var _ = v[w];
        eh(_) && eh(_().modify) ? p = _(a, o, f).modify(p) : nc("Transformer should be a function that returns an object with `modify()` method");
      }
      return p;
    }
  };
}
function zx(a, o, f) {
  var v = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(p) {
      var w = Mx(a, o).mutate(p), _ = "translate3d(".concat(-1 * w, "px, 0px, 0px)");
      o.Html.wrapper.style.mozTransform = _, o.Html.wrapper.style.webkitTransform = _, o.Html.wrapper.style.transform = _;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      o.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var p = o.Sizes.length, w = a.index, _ = a.settings.perView;
      return o.Run.isOffset(">") || o.Run.isOffset("|>") ? p + (w - _) : (w + _) % p;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var p = o.Sizes.slideWidth * a.settings.perView;
      return o.Run.isOffset(">") || o.Run.isOffset("|>") ? p * -1 : p;
    }
  };
  return f.on("move", function(y) {
    if (!a.isType("carousel") || !o.Run.isOffset())
      return v.set(y.movement);
    o.Transition.after(function() {
      f.emit("translate.jump"), v.set(o.Sizes.slideWidth * a.index);
    });
    var p = o.Sizes.slideWidth * o.Translate.getStartIndex();
    return v.set(p - o.Translate.getTravelDistance());
  }), f.on("destroy", function() {
    v.remove();
  }), v;
}
function Dx(a, o, f) {
  var v = !1, y = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(w) {
      var _ = a.settings;
      return v ? "".concat(w, " 0ms ").concat(_.animationTimingFunc) : "".concat(w, " ").concat(this.duration, "ms ").concat(_.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      o.Html.wrapper.style.transition = this.compose(w);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      o.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(w) {
      setTimeout(function() {
        w();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      v = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      v = !0, this.set();
    }
  };
  return Dn(y, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var w = a.settings;
      return a.isType("slider") && o.Run.offset ? w.rewindDuration : w.animationDuration;
    }
  }), f.on("move", function() {
    y.set();
  }), f.on(["build.before", "resize", "translate.jump"], function() {
    y.disable();
  }), f.on("run", function() {
    y.enable();
  }), f.on("destroy", function() {
    y.remove();
  }), y;
}
var s0 = !1;
try {
  var Pb = Object.defineProperty({}, "passive", {
    get: function() {
      s0 = !0;
    }
  });
  window.addEventListener("testPassive", null, Pb), window.removeEventListener("testPassive", null, Pb);
} catch {
}
var jg = s0, Ud = ["touchstart", "mousedown"], Wb = ["touchmove", "mousemove"], Jb = ["touchend", "touchcancel", "mouseup", "mouseleave"], Kb = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function Lx(a, o, f) {
  var v = new oo(), y = 0, p = 0, w = 0, _ = !1, C = jg ? {
    passive: !0
  } : !1, z = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(I) {
      if (!_ && !a.disabled) {
        this.disable();
        var F = this.touches(I);
        y = null, p = sa(F.pageX), w = sa(F.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), f.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(I) {
      if (!a.disabled) {
        var F = a.settings, ce = F.touchAngle, ae = F.touchRatio, $ = F.classes, he = this.touches(I), ge = sa(he.pageX) - p, de = sa(he.pageY) - w, De = Math.abs(ge << 2), Re = Math.abs(de << 2), ye = Math.sqrt(De + Re), xe = Math.sqrt(Re);
        if (y = Math.asin(xe / ye), y * 180 / Math.PI < ce)
          I.stopPropagation(), o.Move.make(ge * cx(ae)), o.Html.root.classList.add($.dragging), f.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(I) {
      if (!a.disabled) {
        var F = a.settings, ce = F.perSwipe, ae = F.touchAngle, $ = F.classes, he = this.touches(I), ge = this.threshold(I), de = he.pageX - p, De = y * 180 / Math.PI;
        this.enable(), de > ge && De < ae ? o.Run.make(o.Direction.resolve("".concat(ce, "<"))) : de < -ge && De < ae ? o.Run.make(o.Direction.resolve("".concat(ce, ">"))) : o.Move.make(), o.Html.root.classList.remove($.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), f.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var I = this, F = a.settings, ce = F.swipeThreshold, ae = F.dragThreshold;
      ce && v.on(Ud[0], o.Html.wrapper, function($) {
        I.start($);
      }, C), ae && v.on(Ud[1], o.Html.wrapper, function($) {
        I.start($);
      }, C);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      v.off(Ud[0], o.Html.wrapper, C), v.off(Ud[1], o.Html.wrapper, C);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var I = this;
      v.on(Wb, o.Html.wrapper, vh(function(F) {
        I.move(F);
      }, a.settings.throttle), C);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      v.off(Wb, o.Html.wrapper, C);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var I = this;
      v.on(Jb, o.Html.wrapper, function(F) {
        I.end(F);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      v.off(Jb, o.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(I) {
      return Kb.indexOf(I.type) > -1 ? I : I.touches[0] || I.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(I) {
      var F = a.settings;
      return Kb.indexOf(I.type) > -1 ? F.dragThreshold : F.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return _ = !1, o.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return _ = !0, o.Transition.disable(), this;
    }
  };
  return f.on("build.after", function() {
    o.Html.root.classList.add(a.settings.classes.swipeable);
  }), f.on("destroy", function() {
    z.unbindSwipeStart(), z.unbindSwipeMove(), z.unbindSwipeEnd(), v.destroy();
  }), z;
}
function kx(a, o, f) {
  var v = new oo(), y = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("dragstart", o.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("dragstart", o.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(w) {
      w.preventDefault();
    }
  };
  return f.on("destroy", function() {
    y.unbind(), v.destroy();
  }), y;
}
function Hx(a, o, f) {
  var v = new oo(), y = !1, p = !1, w = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = o.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("click", o.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("click", o.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(C) {
      p && (C.stopPropagation(), C.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (p = !0, !y) {
        for (var C = 0; C < this.items.length; C++)
          this.items[C].draggable = !1;
        y = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (p = !1, y) {
        for (var C = 0; C < this.items.length; C++)
          this.items[C].draggable = !0;
        y = !1;
      }
      return this;
    }
  };
  return Dn(w, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return w._a;
    }
  }), f.on("swipe.move", function() {
    w.detach();
  }), f.on("swipe.end", function() {
    o.Transition.after(function() {
      w.attach();
    });
  }), f.on("destroy", function() {
    w.attach(), w.unbind(), v.destroy();
  }), w;
}
var Bx = '[data-glide-el="controls[nav]"]', hv = '[data-glide-el^="controls"]', Ux = "".concat(hv, ' [data-glide-dir*="<"]'), Fx = "".concat(hv, ' [data-glide-dir*=">"]');
function Yx(a, o, f) {
  var v = new oo(), y = jg ? {
    passive: !0
  } : !1, p = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = o.Html.root.querySelectorAll(Bx), this._c = o.Html.root.querySelectorAll(hv), this._arrowControls = {
        previous: o.Html.root.querySelectorAll(Ux),
        next: o.Html.root.querySelectorAll(Fx)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var _ = 0; _ < this._n.length; _++)
        this.addClass(this._n[_].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var _ = 0; _ < this._n.length; _++)
        this.removeClass(this._n[_].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(_) {
      var C = a.settings, z = _[a.index];
      z && (z.classList.add(C.classes.nav.active), o0(z).forEach(function(B) {
        B.classList.remove(C.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(_) {
      var C = _[a.index];
      C == null || C.classList.remove(a.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!a.settings.rewind) {
        var _ = p._arrowControls.next, C = p._arrowControls.previous;
        this.resetArrowState(_, C), a.index === 0 && this.disableArrow(C), a.index === o.Run.length && this.disableArrow(_);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var _ = a.settings, C = arguments.length, z = new Array(C), B = 0; B < C; B++)
        z[B] = arguments[B];
      z.forEach(function(I) {
        Kg(I).forEach(function(F) {
          F.classList.remove(_.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var _ = a.settings, C = arguments.length, z = new Array(C), B = 0; B < C; B++)
        z[B] = arguments[B];
      z.forEach(function(I) {
        Kg(I).forEach(function(F) {
          F.classList.add(_.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var _ = 0; _ < this._c.length; _++)
        this.bind(this._c[_].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var _ = 0; _ < this._c.length; _++)
        this.unbind(this._c[_].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(_) {
      for (var C = 0; C < _.length; C++)
        v.on("click", _[C], this.click), v.on("touchstart", _[C], this.click, y);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(_) {
      for (var C = 0; C < _.length; C++)
        v.off(["click", "touchstart"], _[C]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(_) {
      !jg && _.type === "touchstart" && _.preventDefault();
      var C = _.currentTarget.getAttribute("data-glide-dir");
      o.Run.make(o.Direction.resolve(C));
    }
  };
  return Dn(p, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return p._c;
    }
  }), f.on(["mount.after", "move.after"], function() {
    p.setActive();
  }), f.on(["mount.after", "run"], function() {
    p.setArrowState();
  }), f.on("destroy", function() {
    p.removeBindings(), p.removeActive(), v.destroy();
  }), p;
}
function Gx(a, o, f) {
  var v = new oo(), y = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      a.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      v.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      v.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(w) {
      var _ = a.settings.perSwipe, C = {
        ArrowRight: ">",
        ArrowLeft: "<"
      };
      ["ArrowRight", "ArrowLeft"].includes(w.code) && o.Run.make(o.Direction.resolve("".concat(_).concat(C[w.code])));
    }
  };
  return f.on(["destroy", "update"], function() {
    y.unbind();
  }), f.on("update", function() {
    y.mount();
  }), f.on("destroy", function() {
    v.destroy();
  }), y;
}
function Xx(a, o, f) {
  var v = new oo(), y = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), a.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var w = this;
      this._e && (this.enable(), a.settings.autoplay && c0(this._i) && (this._i = setInterval(function() {
        w.stop(), o.Run.make(">"), w.start(), f.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var w = this;
      v.on("mouseover", o.Html.root, function() {
        w._e && w.stop();
      }), v.on("mouseout", o.Html.root, function() {
        w._e && w.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      v.off(["mouseover", "mouseout"], o.Html.root);
    }
  };
  return Dn(y, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var w = o.Html.slides[a.index].getAttribute("data-glide-autoplay");
      return sa(w || a.settings.autoplay);
    }
  }), f.on(["destroy", "update"], function() {
    y.unbind();
  }), f.on(["run.before", "swipe.start", "update"], function() {
    y.stop();
  }), f.on(["pause", "destroy"], function() {
    y.disable(), y.stop();
  }), f.on(["run.after", "swipe.end"], function() {
    y.start();
  }), f.on(["play"], function() {
    y.enable(), y.start();
  }), f.on("update", function() {
    y.mount();
  }), f.on("destroy", function() {
    v.destroy();
  }), y;
}
function jb(a) {
  return Us(a) ? sx(a) : (nc("Breakpoints option must be an object"), {});
}
function Ix(a, o, f) {
  var v = new oo(), y = a.settings, p = jb(y.breakpoints), w = Object.assign({}, y), _ = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(z) {
      if (typeof window.matchMedia < "u") {
        for (var B in z)
          if (z.hasOwnProperty(B) && window.matchMedia("(max-width: ".concat(B, "px)")).matches)
            return z[B];
      }
      return w;
    }
  };
  return Object.assign(y, _.match(p)), v.on("resize", window, vh(function() {
    a.settings = Jg(y, _.match(p));
  }, a.settings.throttle)), f.on("update", function() {
    p = jb(p), w = Object.assign({}, y);
  }), f.on("destroy", function() {
    v.off("resize", window);
  }), _;
}
var Zx = {
  // Required
  Html: yx,
  Translate: zx,
  Transition: Dx,
  Direction: Ax,
  Peek: bx,
  Sizes: px,
  Gaps: gx,
  Move: mx,
  Clones: Sx,
  Resize: xx,
  Build: Tx,
  Run: hx,
  // Optional
  Swipe: Lx,
  Images: kx,
  Anchors: Hx,
  Controls: Yx,
  Keyboard: Gx,
  Autoplay: Xx,
  Breakpoints: Ix
}, Vx = /* @__PURE__ */ (function(a) {
  tx(f, a);
  var o = ix(f);
  function f() {
    return hh(this, f), o.apply(this, arguments);
  }
  return gh(f, [{
    key: "mount",
    value: function() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return Wd(Bs(f.prototype), "mount", this).call(this, Object.assign({}, Zx, y));
    }
  }]), f;
})(dx);
function Qx(a) {
  let o, f, v;
  switch (a) {
    case 3:
      o = 1, f = 2, v = 3;
      break;
    case 2:
      o = 1, f = 2, v = 2;
      break;
    case 1:
    default:
      o = 1, f = 1, v = 1;
  }
  return {
    perViewSm: o,
    perViewMd: f,
    perViewLg: v
  };
}
function Px(a = 1, o, f = !0, v) {
  const { perViewSm: y, perViewMd: p, perViewLg: w } = Qx(a), _ = f ? 24 : 0, C = f ? { before: 48, after: 48 } : 0, z = f ? { before: 124, after: 124 } : 0;
  return {
    type: "slider",
    // No wrap-around.
    focusAt: 0,
    bound: !0,
    // Only if type slider with focusAt 0
    rewind: !1,
    // Only if type slider
    gap: _,
    // Space between slides... may be impacted by viewport size.
    // `keyboard` Left/Right arrow key support for slides - true is default.
    // Is not fully Accessible, on keydown allcarousels move simultaneously
    // A custome keyboard handler is implemented
    keyboard: !1,
    startAt: 0,
    swipeThreshold: 80,
    // Distance required for swipe to change slide.
    dragThreshold: v ? 120 : !1,
    // Distance for mouse drag to change slide.
    perTouch: 1,
    // Number of slides that can be moved per each swipe/drag.
    perView: w,
    // Can be overwritten at breakpoints
    peek: z,
    // Can be overwritten at breakpoints
    // if isFullWidth = true, then we have only 1 image per view which takes the full width.
    // no need for breakpoints
    breakpoints: o ? null : {
      576: {
        // BS4 sm
        perView: y,
        peek: C
      },
      768: {
        // BS4 md
        perView: p,
        peek: C
      },
      992: {
        // BS4 lg
        perView: w,
        peek: C
      },
      1260: {
        // BS4 xl
        perView: w,
        peek: C
      },
      1400: {
        perView: w,
        peek: z
      },
      1920: {
        perView: w,
        peek: z
      }
    }
  };
}
function Wx(a, o, f) {
  const v = a.querySelector(".glide__arrow--prev"), y = a.querySelector(".glide__arrow--next"), p = a.querySelector(".glide__track"), w = a.querySelector(
    ".image-navigator-images"
  );
  if (!(v || y)) return;
  const _ = ["slider-start", "slider-mid", "slider-end"], C = "glide__arrow--disabled";
  p == null || p.classList.remove(..._), w == null || w.classList.remove(..._), o === 0 ? (p == null || p.classList.add("slider-start"), w == null || w.classList.add("slider-start"), v == null || v.classList.add(C), v == null || v.setAttribute("aria-disabled", "true"), y == null || y.classList.remove(C), y == null || y.setAttribute("aria-disabled", "false")) : o >= f - 1 ? (p == null || p.classList.add("slider-end"), w == null || w.classList.add("slider-end"), v == null || v.classList.remove(C), v == null || v.setAttribute("aria-disabled", "false"), y == null || y.classList.add(C), y == null || y.setAttribute("aria-disabled", "true")) : (p == null || p.classList.add("slider-mid"), w == null || w.classList.add("slider-mid"), v == null || v.classList.remove(C), y == null || y.classList.remove(C), v == null || v.setAttribute("aria-disabled", "false"), y == null || y.setAttribute("aria-disabled", "false"));
}
function Jx(a, o, f) {
  const v = a.querySelectorAll(".glide__slide"), y = o, p = Math.min(
    v.length - 1,
    o + f - 1
  );
  v.forEach((w, _) => {
    _ < y || _ > p ? (w.setAttribute("aria-hidden", "true"), w.setAttribute("tabindex", "-1"), w.setAttribute("inert", "")) : (w.setAttribute("aria-hidden", "false"), w.removeAttribute("tabindex"), w.removeAttribute("inert"));
  });
}
function Kx({
  instanceName: a,
  perView: o,
  buttonCount: f,
  isFullWidth: v = !1,
  onItemClick: y,
  hasPeek: p = !0,
  isDraggable: w
}) {
  const _ = Px(o, v, p, w), C = new Vx(`#${a}`, _);
  let z = document.querySelector(`#${a}`);
  return z.addEventListener("keyup", (B) => {
    const I = B;
    I.keyCode === 39 ? C.go(">") : I.keyCode === 37 ? C.go("<") : I.keyCode === 13 && C.go(document.activeElement.dataset.glideDir);
  }), C.on("build.before", () => {
    z = document.querySelector(`#${a}`), z && z.classList.add("slider-start");
  }), C.on("move", () => {
    if (z = document.querySelector(`#${a}`), !z) return;
    const B = C.index;
    Jx(z, B, o);
    const I = z.querySelector(".navigation-slider"), F = z.querySelector(".image-navigator-images");
    if (I && F) {
      const ce = I.querySelectorAll(
        ".bullet-image-container"
      ), ae = I.clientWidth, $ = 82, he = ce[B], ge = F.getBoundingClientRect().x, de = I.getBoundingClientRect().x - ge, De = he.getBoundingClientRect().x - ge, Re = he.getBoundingClientRect().x + he.getBoundingClientRect().width - ge;
      if (B === 0 || De <= 0 + $)
        I.style.left = `${de - De + $}px`;
      else if (Re >= ae - $) {
        const ye = Re - ae;
        I.style.left = `${de - ye - $}px`;
      }
    }
    Wx(z, B, f), z.setAttribute("data-current-index", B), y && y(B);
  }), C.mount(), C;
}
function jx(a, o) {
  let f;
  const v = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  return f = a, v >= 992 && (o >= 2 && (f = a - 1), o >= 3 && (f = a - 2)), f;
}
const Kf = ({
  perView: a = 1,
  width: o,
  maxWidth: f,
  carouselItems: v,
  cssClass: y = "",
  CustomNavComponent: p,
  role: w,
  ariaLabelledBy: _,
  isFullWidth: C,
  removeSideBackground: z = !1,
  hasNavButtons: B = !0,
  hasPositionIndicators: I = !0,
  imageAutoSize: F = !0,
  onItemClick: ce = () => null,
  hasPeek: ae = !0,
  isDraggable: $ = !0,
  hasShadow: he = !0
}) => {
  const ge = `glide-${Math.ceil(Math.random() * 1e4)}`, de = jx(v.length, a);
  return Da(() => {
    Kx({
      instanceName: ge,
      perView: a,
      buttonCount: de,
      isFullWidth: C,
      onItemClick: ce,
      hasPeek: ae,
      isDraggable: $
    });
  }, [
    ge,
    a,
    de,
    C,
    ce,
    ae,
    $
  ]), /* @__PURE__ */ A.jsxs(
    "div",
    {
      role: w,
      "aria-labelledby": _,
      className: `glide ${y}`,
      id: ge,
      style: { width: o, maxWidth: f },
      "data-remove-side-background": z,
      "data-image-auto-size": F,
      "data-has-shadow": he,
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "glide__track", "data-glide-el": "track", children: /* @__PURE__ */ A.jsx(u0, { carouselItems: v }) }),
        p ? (
          // @ts-ignore
          /* @__PURE__ */ A.jsx(p, { instanceName: ge })
        ) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          I && /* @__PURE__ */ A.jsx(a0, { buttonCount: de }),
          B && /* @__PURE__ */ A.jsx(r0, {})
        ] })
      ]
    }
  );
};
Kf.propTypes = {
  perView: E.number,
  width: E.string,
  maxWidth: E.string,
  carouselItems: E.arrayOf(E.object).isRequired,
  cssClass: E.string,
  CustomNavComponent: E.func,
  role: E.string,
  ariaLabelledBy: E.string,
  onItemClick: E.func,
  isFullWidth: E.bool,
  removeSideBackground: E.bool,
  hasNavButtons: E.bool,
  hasPositionIndicators: E.bool,
  imageAutoSize: E.bool,
  hasPeek: E.bool,
  isDraggable: E.bool,
  hasShadow: E.bool
};
const qx = ({
  id: a,
  imageSource: o,
  imageAltText: f,
  title: v,
  content: y,
  eventLocation: p,
  eventTime: w,
  buttons: _,
  linkLabel: C,
  linkUrl: z,
  tags: B
}, I, F, ce) => {
  var ae, $;
  return {
    // @ts-ignore
    id: a,
    item: /* @__PURE__ */ A.jsx(
      tc,
      {
        type: I,
        horizontal: F,
        image: o,
        imageAltText: f,
        title: v,
        body: y,
        eventFormat: ce,
        eventLocation: p,
        eventTime: w,
        buttons: _,
        linkLabel: C,
        linkUrl: z || ((ae = _ == null ? void 0 : _[0]) == null ? void 0 : ae.href),
        tags: B,
        cardLink: z || (($ = _ == null ? void 0 : _[0]) == null ? void 0 : $.href)
      }
    )
  };
}, f0 = ({
  perView: a = 0,
  cardItems: o = [],
  cardType: f = "default",
  cardEventFormat: v = "stack",
  cardHorizontal: y = !1,
  width: p = void 0,
  maxWidth: w = void 0,
  imageAutoSize: _ = !0
}) => {
  const C = parseInt(`${a}`, 10), [z, B] = fa(C), I = 1024, F = 768;
  Da(() => {
    const $ = () => {
      const he = window.innerWidth;
      let ge;
      switch (C) {
        case 3:
          he > I ? ge = 3 : he > F ? ge = 2 : ge = 1;
          break;
        case 2:
          ge = he < F ? 1 : 2;
          break;
        default:
          ge = 1;
          break;
      }
      B(ge);
    };
    return $(), window.addEventListener("resize", $), () => window.removeEventListener("resize", $);
  }, [C]);
  const ce = o.map(
    ($) => qx($, f, y, v)
  ), ae = o.length > z;
  return /* @__PURE__ */ A.jsx(
    Kf,
    {
      perView: +z,
      maxWidth: w,
      width: p,
      carouselItems: ce,
      cssClass: "aligned-carousel",
      imageAutoSize: _,
      removeSideBackground: o.length <= z,
      hasPositionIndicators: ae,
      hasNavButtons: ae,
      isDraggable: ae,
      hasShadow: !0
    }
  );
};
f0.propTypes = {
  perView: E.string.isRequired,
  cardItems: E.arrayOf(
    E.shape({
      title: E.string.isRequired,
      content: E.string,
      eventLocation: E.string,
      eventTime: E.string,
      image: E.string,
      imageAltText: E.string,
      buttons: tc.propTypes.buttons,
      linkLabel: E.string,
      linkUrl: E.string,
      tags: tc.propTypes.tags
    })
  ).isRequired,
  cardType: tc.propTypes.type,
  cardEventFormat: tc.propTypes.eventFormat,
  cardHorizontal: tc.propTypes.horizontal,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const $x = ({ id: a, imageSource: o, imageAltText: f, title: v, content: y }) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx("div", { className: "uds-img", children: /* @__PURE__ */ A.jsxs("figure", { className: "figure uds-figure", children: [
    /* @__PURE__ */ A.jsx(
      "img",
      {
        src: o,
        className: "uds-img figure-img img-fluid",
        alt: f,
        loading: "lazy",
        decoding: "async"
      }
    ),
    (v || y) && /* @__PURE__ */ A.jsx(
      "figcaption",
      {
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-content-container",
        children: /* @__PURE__ */ A.jsx("div", { className: "uds-caption-text", children: v ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          /* @__PURE__ */ A.jsx("h2", { children: v }),
          /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: y } })
        ] }) : /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: y } }) })
      }
    )
  ] }) })
}), d0 = ({
  perView: a = 0,
  imageItems: o = [],
  width: f = void 0,
  maxWidth: v = void 0,
  imageAutoSize: y = !0
}) => {
  if (!o || o.length === 0)
    return null;
  const p = parseInt(`${a}`, 10), w = o.map($x) || [], _ = o.length > p;
  return /* @__PURE__ */ A.jsx(
    Kf,
    {
      perView: +p,
      maxWidth: v,
      width: f,
      cssClass: "image-carousel aligned-carousel",
      carouselItems: w,
      imageAutoSize: y,
      removeSideBackground: o.length <= p,
      hasPositionIndicators: _,
      hasNavButtons: _,
      isDraggable: _,
      hasShadow: !0
    }
  );
};
d0.propTypes = {
  perView: E.number.isRequired,
  imageItems: E.arrayOf(E.object).isRequired,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const eE = (a, o) => {
  if (!a)
    return 0;
  const f = (a.match(/<br/g) || []).length, v = o / 6;
  return (parseInt(`${a.length / v}`, 10) + f) * 20;
}, th = {
  imageItems: E.arrayOf(
    E.shape({
      id: E.number,
      imageSource: E.string,
      thumbnailSource: E.string,
      imageAltText: E.string,
      content: E.oneOfType([E.string, E.element])
    })
  ),
  hasContent: E.bool
}, tE = ({ id: a, imageSource: o, imageAltText: f }) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx("div", { className: "uds-img", children: /* @__PURE__ */ A.jsx(
    "img",
    {
      src: o,
      className: "uds-img figure-img img-fluid",
      alt: f,
      loading: "lazy",
      decoding: "async"
    }
  ) })
}), h0 = ({ instanceName: a, imageItems: o, hasContent: f }) => {
  var B, I;
  const v = "data-current-index", [y, p] = fa(((B = o == null ? void 0 : o[0]) == null ? void 0 : B.title) || ""), [w, _] = fa(((I = o == null ? void 0 : o[0]) == null ? void 0 : I.content) || ""), C = Ls(
    (F) => {
      const ce = o == null ? void 0 : o[F];
      ce && (p(ce.title), _(ce.content));
    },
    [o]
  );
  if (Da(() => {
    if (!o || o.length === 0)
      return;
    const F = document.querySelector(
      ".image-gallery figcaption .uds-caption-text div"
    );
    if (F) {
      const he = parseInt(
        window.getComputedStyle(F, null).getPropertyValue("width").split("px")[0],
        10
      ), ge = o.reduce((de, De) => {
        const Re = eE(De.content, he);
        return Re > de ? Re : de;
      }, 0);
      F.style.height = `${ge}px`;
    }
    const ce = document.querySelector(`#${a}`);
    if (!ce)
      return;
    function ae(he) {
      for (const ge of he)
        if (ge && ge.attributeName === v) {
          const de = ce.getAttribute(v);
          de !== null && C(+de);
          return;
        }
    }
    const $ = new MutationObserver(ae);
    return $.observe(ce, {
      attributes: !0
    }), () => {
      $.disconnect();
    };
  }, [a, o, C]), !o || o.length === 0)
    return null;
  const z = o.map((F) => F.imageSource);
  return /* @__PURE__ */ A.jsxs("div", { className: "image-gallery-action-area", "data-has-content": f, children: [
    /* @__PURE__ */ A.jsx("div", { className: "image-navigator", children: /* @__PURE__ */ A.jsxs(dv, { children: [
      /* @__PURE__ */ A.jsx(fv, {}),
      /* @__PURE__ */ A.jsx("div", { className: "image-navigator-images", children: /* @__PURE__ */ A.jsx("div", { className: "navigation-slider", children: /* @__PURE__ */ A.jsx(
        i0,
        {
          imageItems: z,
          onItemClick: (F) => C(F)
        }
      ) }) }),
      /* @__PURE__ */ A.jsx(sv, {})
    ] }) }),
    f && (y || w) ? /* @__PURE__ */ A.jsx(
      "figcaption",
      {
        id: "caption",
        className: "figure-caption uds-figure-caption",
        "data-testid": "image-gallery-content-container",
        children: /* @__PURE__ */ A.jsxs("div", { className: "uds-caption-text", children: [
          y ? /* @__PURE__ */ A.jsx("h2", { children: y }) : null,
          /* @__PURE__ */ A.jsx("div", { dangerouslySetInnerHTML: { __html: w } })
        ] })
      }
    ) : null
  ] });
};
h0.propTypes = {
  instanceName: E.string,
  imageItems: th.imageItems,
  hasContent: th.hasContent
};
const g0 = ({
  width: a,
  maxWidth: o,
  imageItems: f = [],
  hasContent: v = !1,
  imageAutoSize: y = !0
}) => {
  const p = f.map(tE), w = f.length > 1;
  return /* @__PURE__ */ A.jsx(
    Kf,
    {
      perView: 1,
      maxWidth: o,
      width: a,
      carouselItems: p,
      cssClass: "image-gallery",
      role: "figure",
      ariaLabelledBy: v ? "caption" : null,
      isFullWidth: !0,
      imageAutoSize: y,
      hasPeek: !1,
      CustomNavComponent: ({ instanceName: _ }) => /* @__PURE__ */ A.jsx(
        h0,
        {
          instanceName: _,
          hasContent: v,
          imageItems: f
        }
      ),
      removeSideBackground: f.length <= 1,
      hasPositionIndicators: w,
      hasNavButtons: w,
      isDraggable: w,
      hasShadow: !0
    }
  );
};
g0.propTypes = {
  imageItems: th.imageItems.isRequired,
  hasContent: th.hasContent,
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool
};
const nE = ({ id: a, imageSource: o, imageAltText: f, quote: v }, y = {}) => ({
  // @ts-ignore
  id: a,
  item: /* @__PURE__ */ A.jsx(
    cv,
    {
      imageSource: o,
      imageAltText: f,
      quote: v,
      itemStyle: y
    }
  )
}), v0 = ({
  width: a,
  maxWidth: o,
  testimonialItems: f = [],
  itemStyle: v = {},
  hasNavButtons: y = !1,
  hasPositionIndicators: p = !1,
  imageAutoSize: w = !0
}) => {
  const _ = f.map(
    (C) => nE(C, v)
  );
  return /* @__PURE__ */ A.jsx(
    Kf,
    {
      perView: 1,
      maxWidth: o,
      width: a,
      carouselItems: _,
      isFullWidth: !0,
      removeSideBackground: !0,
      hasNavButtons: y,
      hasPositionIndicators: p,
      imageAutoSize: w,
      hasPeek: !1,
      hasShadow: !1
    }
  );
};
v0.propTypes = {
  testimonialItems: E.arrayOf(
    E.shape({
      title: E.string,
      content: E.string,
      cite: E.shape({
        name: E.string,
        description: E.string
      })
    })
  ).isRequired,
  itemStyle: E.shape({
    containerCssClass: E.arrayOf(E.string),
    titleCssClass: E.arrayOf(E.string),
    contentCssClass: E.arrayOf(E.string)
  }),
  width: E.string,
  maxWidth: E.string,
  imageAutoSize: E.bool,
  hasNavButtons: E.bool,
  hasPositionIndicators: E.bool
};
var hu = /* @__PURE__ */ ((a) => (a.UNORDERED = "unordered", a.ORDERED = "ordered", a.ICON = "icon", a.STEP = "step", a.DISPLAY = "display", a))(hu || {}), Jd = /* @__PURE__ */ ((a) => (a.UL = "ul", a.OL = "ol", a))(Jd || {}), Ho = /* @__PURE__ */ ((a) => (a.NONE = "none", a.LIGHT = "light", a.MEDIUM = "medium", a.DARK = "dark", a))(Ho || {}), Kd = /* @__PURE__ */ ((a) => (a.DEFAULT = "default", a.PRIMARY = "primary", a.SECONDARY = "secondary", a))(Kd || {});
const y0 = (a) => {
  switch (a) {
    case Jd.OL:
    case hu.ORDERED:
    case hu.STEP:
      return Jd.OL;
    default:
      return Jd.UL;
  }
}, b0 = ({
  listType: a,
  content: o,
  icon: f,
  nestedType: v,
  nestedItems: y
}) => {
  const [p, ...w] = Array.isArray(o) ? o : [o];
  let _ = null;
  if (y != null && y.length) {
    const C = v || a, z = y0(C);
    _ = /* @__PURE__ */ A.jsx(z, { children: y.map((B, I) => /* @__PURE__ */ A.jsx(b0, { listType: C, ...B }, I)) });
  }
  return /* @__PURE__ */ A.jsxs("li", { children: [
    f && /* @__PURE__ */ A.jsx("span", { className: `fa-li ${f == null ? void 0 : f[0]} fa-${f == null ? void 0 : f[1]}` }),
    p,
    " ",
    w.map((C, z) => [/* @__PURE__ */ A.jsx("br", {}, `br-${z}`), /* @__PURE__ */ A.jsx("span", { children: C }, z)]),
    _
  ] });
}, lE = ({
  listType: a = hu.UNORDERED,
  backgroundColor: o = Ho.NONE,
  listItemStyleColor: f = Kd.DEFAULT,
  items: v
}) => {
  const y = y0(a);
  let p = "maroon", w = "maroon";
  o === Ho.DARK && (p = "gold", w = "gold"), a === hu.STEP && (p = "uds-steplist-maroon", w = "uds-steplist-gold", o === Ho.DARK && (p = "uds-steplist-gold"));
  const _ = Mt({
    "uds-list": a === hu.UNORDERED || a === hu.ORDERED,
    "uds-list fa-ul": a === hu.ICON,
    "uds-list uds-steplist": a === hu.STEP,
    "uds-list uds-display-list": a === hu.DISPLAY,
    "light-smokemode": o === Ho.LIGHT,
    smokemode: o === Ho.MEDIUM,
    darkmode: o === Ho.DARK,
    [`${p}`]: f === Kd.PRIMARY,
    // Intentional space ` ${secondaryColor}` for when primary and secondary colors are the same
    [` ${w}`]: f === Kd.SECONDARY
  });
  return /* @__PURE__ */ A.jsx(y, { className: _ || null, children: v.map((C, z) => /* @__PURE__ */ A.jsx(b0, { listType: a, ...C }, z)) });
}, aE = {
  none: "",
  gold: "text-gold",
  white: "text-white"
}, iE = {
  name: "onclick",
  event: "link",
  action: "click",
  type: "internal link",
  region: "main content"
}, rE = ({
  gridLinkItems: a,
  numColumns: o,
  textColor: f,
  children: v
}) => /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
  /* @__PURE__ */ A.jsx(
    "div",
    {
      className: [
        "uds-grid-links",
        o,
        aE[f]
      ].join(" "),
      children: a && a.map((y) => /* @__PURE__ */ A.jsx(
        Tl,
        {
          gaData: {
            ...iE,
            text: y.label,
            section: `grid links ${y.label}`
          },
          children: /* @__PURE__ */ A.jsxs("a", { href: y.href, children: [
            /* @__PURE__ */ A.jsx("span", { className: `fa fa-fw ${y.icon}` }),
            y.label
          ] })
        },
        y.label + y.href
      ))
    }
  ),
  /* @__PURE__ */ A.jsx("div", { children: v })
] });
var Ag = { exports: {} }, Yf = {}, _g = { exports: {} }, Og = {};
var qb;
function uE() {
  return qb || (qb = 1, (function(a) {
    function o(U, P) {
      var Se = U.length;
      U.push(P);
      e: for (; 0 < Se; ) {
        var et = Se - 1 >>> 1, ue = U[et];
        if (0 < y(ue, P))
          U[et] = P, U[Se] = ue, Se = et;
        else break e;
      }
    }
    function f(U) {
      return U.length === 0 ? null : U[0];
    }
    function v(U) {
      if (U.length === 0) return null;
      var P = U[0], Se = U.pop();
      if (Se !== P) {
        U[0] = Se;
        e: for (var et = 0, ue = U.length, Q = ue >>> 1; et < Q; ) {
          var ct = 2 * (et + 1) - 1, tt = U[ct], _e = ct + 1, Ne = U[_e];
          if (0 > y(tt, Se))
            _e < ue && 0 > y(Ne, tt) ? (U[et] = Ne, U[_e] = Se, et = _e) : (U[et] = tt, U[ct] = Se, et = ct);
          else if (_e < ue && 0 > y(Ne, Se))
            U[et] = Ne, U[_e] = Se, et = _e;
          else break e;
        }
      }
      return P;
    }
    function y(U, P) {
      var Se = U.sortIndex - P.sortIndex;
      return Se !== 0 ? Se : U.id - P.id;
    }
    if (a.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var p = performance;
      a.unstable_now = function() {
        return p.now();
      };
    } else {
      var w = Date, _ = w.now();
      a.unstable_now = function() {
        return w.now() - _;
      };
    }
    var C = [], z = [], B = 1, I = null, F = 3, ce = !1, ae = !1, $ = !1, he = !1, ge = typeof setTimeout == "function" ? setTimeout : null, de = typeof clearTimeout == "function" ? clearTimeout : null, De = typeof setImmediate < "u" ? setImmediate : null;
    function Re(U) {
      for (var P = f(z); P !== null; ) {
        if (P.callback === null) v(z);
        else if (P.startTime <= U)
          v(z), P.sortIndex = P.expirationTime, o(C, P);
        else break;
        P = f(z);
      }
    }
    function ye(U) {
      if ($ = !1, Re(U), !ae)
        if (f(C) !== null)
          ae = !0, xe || (xe = !0, At());
        else {
          var P = f(z);
          P !== null && it(ye, P.startTime - U);
        }
    }
    var xe = !1, we = -1, Me = 5, He = -1;
    function Ot() {
      return he ? !0 : !(a.unstable_now() - He < Me);
    }
    function wt() {
      if (he = !1, xe) {
        var U = a.unstable_now();
        He = U;
        var P = !0;
        try {
          e: {
            ae = !1, $ && ($ = !1, de(we), we = -1), ce = !0;
            var Se = F;
            try {
              t: {
                for (Re(U), I = f(C); I !== null && !(I.expirationTime > U && Ot()); ) {
                  var et = I.callback;
                  if (typeof et == "function") {
                    I.callback = null, F = I.priorityLevel;
                    var ue = et(
                      I.expirationTime <= U
                    );
                    if (U = a.unstable_now(), typeof ue == "function") {
                      I.callback = ue, Re(U), P = !0;
                      break t;
                    }
                    I === f(C) && v(C), Re(U);
                  } else v(C);
                  I = f(C);
                }
                if (I !== null) P = !0;
                else {
                  var Q = f(z);
                  Q !== null && it(
                    ye,
                    Q.startTime - U
                  ), P = !1;
                }
              }
              break e;
            } finally {
              I = null, F = Se, ce = !1;
            }
            P = void 0;
          }
        } finally {
          P ? At() : xe = !1;
        }
      }
    }
    var At;
    if (typeof De == "function")
      At = function() {
        De(wt);
      };
    else if (typeof MessageChannel < "u") {
      var Ae = new MessageChannel(), Xe = Ae.port2;
      Ae.port1.onmessage = wt, At = function() {
        Xe.postMessage(null);
      };
    } else
      At = function() {
        ge(wt, 0);
      };
    function it(U, P) {
      we = ge(function() {
        U(a.unstable_now());
      }, P);
    }
    a.unstable_IdlePriority = 5, a.unstable_ImmediatePriority = 1, a.unstable_LowPriority = 4, a.unstable_NormalPriority = 3, a.unstable_Profiling = null, a.unstable_UserBlockingPriority = 2, a.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, a.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Me = 0 < U ? Math.floor(1e3 / U) : 5;
    }, a.unstable_getCurrentPriorityLevel = function() {
      return F;
    }, a.unstable_next = function(U) {
      switch (F) {
        case 1:
        case 2:
        case 3:
          var P = 3;
          break;
        default:
          P = F;
      }
      var Se = F;
      F = P;
      try {
        return U();
      } finally {
        F = Se;
      }
    }, a.unstable_requestPaint = function() {
      he = !0;
    }, a.unstable_runWithPriority = function(U, P) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var Se = F;
      F = U;
      try {
        return P();
      } finally {
        F = Se;
      }
    }, a.unstable_scheduleCallback = function(U, P, Se) {
      var et = a.unstable_now();
      switch (typeof Se == "object" && Se !== null ? (Se = Se.delay, Se = typeof Se == "number" && 0 < Se ? et + Se : et) : Se = et, U) {
        case 1:
          var ue = -1;
          break;
        case 2:
          ue = 250;
          break;
        case 5:
          ue = 1073741823;
          break;
        case 4:
          ue = 1e4;
          break;
        default:
          ue = 5e3;
      }
      return ue = Se + ue, U = {
        id: B++,
        callback: P,
        priorityLevel: U,
        startTime: Se,
        expirationTime: ue,
        sortIndex: -1
      }, Se > et ? (U.sortIndex = Se, o(z, U), f(C) === null && U === f(z) && ($ ? (de(we), we = -1) : $ = !0, it(ye, Se - et))) : (U.sortIndex = ue, o(C, U), ae || ce || (ae = !0, xe || (xe = !0, At()))), U;
    }, a.unstable_shouldYield = Ot, a.unstable_wrapCallback = function(U) {
      var P = F;
      return function() {
        var Se = F;
        F = P;
        try {
          return U.apply(this, arguments);
        } finally {
          F = Se;
        }
      };
    };
  })(Og)), Og;
}
var $b;
function cE() {
  return $b || ($b = 1, _g.exports = uE()), _g.exports;
}
var em;
function oE() {
  if (em) return Yf;
  em = 1;
  var a = { env: { NODE_ENV: "production" } };
  var o = cE(), f = Xt, v = qg;
  function y(e) {
    var t = "https://react.dev/errors/" + e;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        t += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function p(e) {
    return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
  }
  function w(e) {
    var t = e, n = e;
    if (e.alternate) for (; t.return; ) t = t.return;
    else {
      e = t;
      do
        t = e, (t.flags & 4098) !== 0 && (n = t.return), e = t.return;
      while (e);
    }
    return t.tag === 3 ? n : null;
  }
  function _(e) {
    if (e.tag === 13) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function C(e) {
    if (e.tag === 31) {
      var t = e.memoizedState;
      if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function z(e) {
    if (w(e) !== e)
      throw Error(y(188));
  }
  function B(e) {
    var t = e.alternate;
    if (!t) {
      if (t = w(e), t === null) throw Error(y(188));
      return t !== e ? null : e;
    }
    for (var n = e, l = t; ; ) {
      var s = n.return;
      if (s === null) break;
      var d = s.alternate;
      if (d === null) {
        if (l = s.return, l !== null) {
          n = l;
          continue;
        }
        break;
      }
      if (s.child === d.child) {
        for (d = s.child; d; ) {
          if (d === n) return z(s), e;
          if (d === l) return z(s), t;
          d = d.sibling;
        }
        throw Error(y(188));
      }
      if (n.return !== l.return) n = s, l = d;
      else {
        for (var S = !1, R = s.child; R; ) {
          if (R === n) {
            S = !0, n = s, l = d;
            break;
          }
          if (R === l) {
            S = !0, l = s, n = d;
            break;
          }
          R = R.sibling;
        }
        if (!S) {
          for (R = d.child; R; ) {
            if (R === n) {
              S = !0, n = d, l = s;
              break;
            }
            if (R === l) {
              S = !0, l = d, n = s;
              break;
            }
            R = R.sibling;
          }
          if (!S) throw Error(y(189));
        }
      }
      if (n.alternate !== l) throw Error(y(190));
    }
    if (n.tag !== 3) throw Error(y(188));
    return n.stateNode.current === n ? e : t;
  }
  function I(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e;
    for (e = e.child; e !== null; ) {
      if (t = I(e), t !== null) return t;
      e = e.sibling;
    }
    return null;
  }
  var F = Object.assign, ce = Symbol.for("react.element"), ae = Symbol.for("react.transitional.element"), $ = Symbol.for("react.portal"), he = Symbol.for("react.fragment"), ge = Symbol.for("react.strict_mode"), de = Symbol.for("react.profiler"), De = Symbol.for("react.consumer"), Re = Symbol.for("react.context"), ye = Symbol.for("react.forward_ref"), xe = Symbol.for("react.suspense"), we = Symbol.for("react.suspense_list"), Me = Symbol.for("react.memo"), He = Symbol.for("react.lazy"), Ot = Symbol.for("react.activity"), wt = Symbol.for("react.memo_cache_sentinel"), At = Symbol.iterator;
  function Ae(e) {
    return e === null || typeof e != "object" ? null : (e = At && e[At] || e["@@iterator"], typeof e == "function" ? e : null);
  }
  var Xe = Symbol.for("react.client.reference");
  function it(e) {
    if (e == null) return null;
    if (typeof e == "function")
      return e.$$typeof === Xe ? null : e.displayName || e.name || null;
    if (typeof e == "string") return e;
    switch (e) {
      case he:
        return "Fragment";
      case de:
        return "Profiler";
      case ge:
        return "StrictMode";
      case xe:
        return "Suspense";
      case we:
        return "SuspenseList";
      case Ot:
        return "Activity";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case $:
          return "Portal";
        case Re:
          return e.displayName || "Context";
        case De:
          return (e._context.displayName || "Context") + ".Consumer";
        case ye:
          var t = e.render;
          return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
        case Me:
          return t = e.displayName || null, t !== null ? t : it(e.type) || "Memo";
        case He:
          t = e._payload, e = e._init;
          try {
            return it(e(t));
          } catch {
          }
      }
    return null;
  }
  var U = Array.isArray, P = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Se = v.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, et = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, ue = [], Q = -1;
  function ct(e) {
    return { current: e };
  }
  function tt(e) {
    0 > Q || (e.current = ue[Q], ue[Q] = null, Q--);
  }
  function _e(e, t) {
    Q++, ue[Q] = e.current, e.current = t;
  }
  var Ne = ct(null), It = ct(null), en = ct(null), Pl = ct(null);
  function kl(e, t) {
    switch (_e(en, t), _e(It, e), _e(Ne, null), t.nodeType) {
      case 9:
      case 11:
        e = (e = t.documentElement) && (e = e.namespaceURI) ? hy(e) : 0;
        break;
      default:
        if (e = t.tagName, t = t.namespaceURI)
          t = hy(t), e = gy(t, e);
        else
          switch (e) {
            case "svg":
              e = 1;
              break;
            case "math":
              e = 2;
              break;
            default:
              e = 0;
          }
    }
    tt(Ne), _e(Ne, e);
  }
  function Xn() {
    tt(Ne), tt(It), tt(en);
  }
  function $e(e) {
    e.memoizedState !== null && _e(Pl, e);
    var t = Ne.current, n = gy(t, e.type);
    t !== n && (_e(It, e), _e(Ne, n));
  }
  function Ci(e) {
    It.current === e && (tt(Ne), tt(It)), Pl.current === e && (tt(Pl), Nf._currentValue = et);
  }
  var Ce, cr;
  function vt(e) {
    if (Ce === void 0)
      try {
        throw Error();
      } catch (n) {
        var t = n.stack.trim().match(/\n( *(at )?)/);
        Ce = t && t[1] || "", cr = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Ce + e + cr;
  }
  var ka = !1;
  function Ta(e, t) {
    if (!e || ka) return "";
    ka = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var l = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var fe = function() {
                throw Error();
              };
              if (Object.defineProperty(fe.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(fe, []);
                } catch (le) {
                  var q = le;
                }
                Reflect.construct(e, [], fe);
              } else {
                try {
                  fe.call();
                } catch (le) {
                  q = le;
                }
                e.call(fe.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (le) {
                q = le;
              }
              (fe = e()) && typeof fe.catch == "function" && fe.catch(function() {
              });
            }
          } catch (le) {
            if (le && q && typeof le.stack == "string")
              return [le.stack, q.stack];
          }
          return [null, null];
        }
      };
      l.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var s = Object.getOwnPropertyDescriptor(
        l.DetermineComponentFrameRoot,
        "name"
      );
      s && s.configurable && Object.defineProperty(
        l.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var d = l.DetermineComponentFrameRoot(), S = d[0], R = d[1];
      if (S && R) {
        var H = S.split(`
`), j = R.split(`
`);
        for (s = l = 0; l < H.length && !H[l].includes("DetermineComponentFrameRoot"); )
          l++;
        for (; s < j.length && !j[s].includes(
          "DetermineComponentFrameRoot"
        ); )
          s++;
        if (l === H.length || s === j.length)
          for (l = H.length - 1, s = j.length - 1; 1 <= l && 0 <= s && H[l] !== j[s]; )
            s--;
        for (; 1 <= l && 0 <= s; l--, s--)
          if (H[l] !== j[s]) {
            if (l !== 1 || s !== 1)
              do
                if (l--, s--, 0 > s || H[l] !== j[s]) {
                  var re = `
` + H[l].replace(" at new ", " at ");
                  return e.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", e.displayName)), re;
                }
              while (1 <= l && 0 <= s);
            break;
          }
      }
    } finally {
      ka = !1, Error.prepareStackTrace = n;
    }
    return (n = e ? e.displayName || e.name : "") ? vt(n) : "";
  }
  function jn(e, t) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return vt(e.type);
      case 16:
        return vt("Lazy");
      case 13:
        return e.child !== t && t !== null ? vt("Suspense Fallback") : vt("Suspense");
      case 19:
        return vt("SuspenseList");
      case 0:
      case 15:
        return Ta(e.type, !1);
      case 11:
        return Ta(e.type.render, !1);
      case 1:
        return Ta(e.type, !0);
      case 31:
        return vt("Activity");
      default:
        return "";
    }
  }
  function pn(e) {
    try {
      var t = "", n = null;
      do
        t += jn(e, n), n = e, e = e.return;
      while (e);
      return t;
    } catch (l) {
      return `
Error generating stack: ` + l.message + `
` + l.stack;
    }
  }
  var Ri = Object.prototype.hasOwnProperty, ul = o.unstable_scheduleCallback, In = o.unstable_cancelCallback, cl = o.unstable_shouldYield, Ni = o.unstable_requestPaint, Ue = o.unstable_now, qn = o.unstable_getCurrentPriorityLevel, Lr = o.unstable_ImmediatePriority, Mi = o.unstable_UserBlockingPriority, tn = o.unstable_NormalPriority, Ha = o.unstable_LowPriority, ui = o.unstable_IdlePriority, Sa = o.log, or = o.unstable_setDisableYieldValue, Wl = null, Zn = null;
  function Sl(e) {
    if (typeof Sa == "function" && or(e), Zn && typeof Zn.setStrictMode == "function")
      try {
        Zn.setStrictMode(Wl, e);
      } catch {
      }
  }
  var Cn = Math.clz32 ? Math.clz32 : Tn, Ba = Math.log, ft = Math.LN2;
  function Tn(e) {
    return e >>>= 0, e === 0 ? 32 : 31 - (Ba(e) / ft | 0) | 0;
  }
  var ci = 256, Hl = 262144, Ua = 4194304;
  function Jl(e) {
    var t = e & 42;
    if (t !== 0) return t;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e;
    }
  }
  function Kl(e, t, n) {
    var l = e.pendingLanes;
    if (l === 0) return 0;
    var s = 0, d = e.suspendedLanes, S = e.pingedLanes;
    e = e.warmLanes;
    var R = l & 134217727;
    return R !== 0 ? (l = R & ~d, l !== 0 ? s = Jl(l) : (S &= R, S !== 0 ? s = Jl(S) : n || (n = R & ~e, n !== 0 && (s = Jl(n))))) : (R = l & ~d, R !== 0 ? s = Jl(R) : S !== 0 ? s = Jl(S) : n || (n = l & ~e, n !== 0 && (s = Jl(n)))), s === 0 ? 0 : t !== 0 && t !== s && (t & d) === 0 && (d = s & -s, n = t & -t, d >= n || d === 32 && (n & 4194048) !== 0) ? t : s;
  }
  function Rn(e, t) {
    return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
  }
  function jl(e, t) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Fa() {
    var e = Ua;
    return Ua <<= 1, (Ua & 62914560) === 0 && (Ua = 4194304), e;
  }
  function sr(e) {
    for (var t = [], n = 0; 31 > n; n++) t.push(e);
    return t;
  }
  function Ya(e, t) {
    e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
  }
  function fr(e, t, n, l, s, d) {
    var S = e.pendingLanes;
    e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
    var R = e.entanglements, H = e.expirationTimes, j = e.hiddenUpdates;
    for (n = S & ~n; 0 < n; ) {
      var re = 31 - Cn(n), fe = 1 << re;
      R[re] = 0, H[re] = -1;
      var q = j[re];
      if (q !== null)
        for (j[re] = null, re = 0; re < q.length; re++) {
          var le = q[re];
          le !== null && (le.lane &= -536870913);
        }
      n &= ~fe;
    }
    l !== 0 && oi(e, l, 0), d !== 0 && s === 0 && e.tag !== 0 && (e.suspendedLanes |= d & ~(S & ~t));
  }
  function oi(e, t, n) {
    e.pendingLanes |= t, e.suspendedLanes &= ~t;
    var l = 31 - Cn(t);
    e.entangledLanes |= t, e.entanglements[l] = e.entanglements[l] | 1073741824 | n & 261930;
  }
  function fn(e, t) {
    var n = e.entangledLanes |= t;
    for (e = e.entanglements; n; ) {
      var l = 31 - Cn(n), s = 1 << l;
      s & t | e[l] & t && (e[l] |= t), n &= ~s;
    }
  }
  function ol(e, t) {
    var n = t & -t;
    return n = (n & 42) !== 0 ? 1 : zt(n), (n & (e.suspendedLanes | t)) !== 0 ? 0 : n;
  }
  function zt(e) {
    switch (e) {
      case 2:
        e = 1;
        break;
      case 8:
        e = 4;
        break;
      case 32:
        e = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e = 128;
        break;
      case 268435456:
        e = 134217728;
        break;
      default:
        e = 0;
    }
    return e;
  }
  function zi(e) {
    return e &= -e, 2 < e ? 8 < e ? (e & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function Nn() {
    var e = Se.p;
    return e !== 0 ? e : (e = window.event, e === void 0 ? 32 : By(e.type));
  }
  function Zt(e, t) {
    var n = Se.p;
    try {
      return Se.p = e, t();
    } finally {
      Se.p = n;
    }
  }
  var xa = Math.random().toString(36).slice(2), nt = "__reactFiber$" + xa, on = "__reactProps$" + xa, si = "__reactContainer$" + xa, Ga = "__reactEvents$" + xa, kr = "__reactListeners$" + xa, St = "__reactHandles$" + xa, Dt = "__reactResources$" + xa, Ea = "__reactMarker$" + xa;
  function $n(e) {
    delete e[nt], delete e[on], delete e[Ga], delete e[kr], delete e[St];
  }
  function Di(e) {
    var t = e[nt];
    if (t) return t;
    for (var n = e.parentNode; n; ) {
      if (t = n[si] || n[nt]) {
        if (n = t.alternate, t.child !== null || n !== null && n.child !== null)
          for (e = Sy(e); e !== null; ) {
            if (n = e[nt]) return n;
            e = Sy(e);
          }
        return t;
      }
      e = n, n = e.parentNode;
    }
    return null;
  }
  function Xa(e) {
    if (e = e[nt] || e[si]) {
      var t = e.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return e;
    }
    return null;
  }
  function xl(e) {
    var t = e.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
    throw Error(y(33));
  }
  function Ia(e) {
    var t = e[Dt];
    return t || (t = e[Dt] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function Vt(e) {
    e[Ea] = !0;
  }
  var Li = /* @__PURE__ */ new Set(), dn = {};
  function ql(e, t) {
    ga(e, t), ga(e + "Capture", t);
  }
  function ga(e, t) {
    for (dn[e] = t, e = 0; e < t.length; e++)
      Li.add(t[e]);
  }
  var $l = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), fi = {}, dr = {};
  function ki(e) {
    return Ri.call(dr, e) ? !0 : Ri.call(fi, e) ? !1 : $l.test(e) ? dr[e] = !0 : (fi[e] = !0, !1);
  }
  function El(e, t, n) {
    if (ki(t))
      if (n === null) e.removeAttribute(t);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            e.removeAttribute(t);
            return;
          case "boolean":
            var l = t.toLowerCase().slice(0, 5);
            if (l !== "data-" && l !== "aria-") {
              e.removeAttribute(t);
              return;
            }
        }
        e.setAttribute(t, "" + n);
      }
  }
  function el(e, t, n) {
    if (n === null) e.removeAttribute(t);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(t);
          return;
      }
      e.setAttribute(t, "" + n);
    }
  }
  function Bl(e, t, n, l) {
    if (l === null) e.removeAttribute(n);
    else {
      switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e.removeAttribute(n);
          return;
      }
      e.setAttributeNS(t, n, "" + l);
    }
  }
  function Sn(e) {
    switch (typeof e) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return e;
      default:
        return "";
    }
  }
  function hr(e) {
    var t = e.type;
    return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function lc(e, t, n) {
    var l = Object.getOwnPropertyDescriptor(
      e.constructor.prototype,
      t
    );
    if (!e.hasOwnProperty(t) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var s = l.get, d = l.set;
      return Object.defineProperty(e, t, {
        configurable: !0,
        get: function() {
          return s.call(this);
        },
        set: function(S) {
          n = "" + S, d.call(this, S);
        }
      }), Object.defineProperty(e, t, {
        enumerable: l.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(S) {
          n = "" + S;
        },
        stopTracking: function() {
          e._valueTracker = null, delete e[t];
        }
      };
    }
  }
  function di(e) {
    if (!e._valueTracker) {
      var t = hr(e) ? "checked" : "value";
      e._valueTracker = lc(
        e,
        t,
        "" + e[t]
      );
    }
  }
  function nn(e) {
    if (!e) return !1;
    var t = e._valueTracker;
    if (!t) return !0;
    var n = t.getValue(), l = "";
    return e && (l = hr(e) ? e.checked ? "true" : "false" : e.value), e = l, e !== n ? (t.setValue(e), !0) : !1;
  }
  function va(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var Hr = /[\n"\\]/g;
  function tl(e) {
    return e.replace(
      Hr,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function wl(e, t, n, l, s, d, S, R) {
    e.name = "", S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" ? e.type = S : e.removeAttribute("type"), t != null ? S === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Sn(t)) : e.value !== "" + Sn(t) && (e.value = "" + Sn(t)) : S !== "submit" && S !== "reset" || e.removeAttribute("value"), t != null ? be(e, S, Sn(t)) : n != null ? be(e, S, Sn(n)) : l != null && e.removeAttribute("value"), s == null && d != null && (e.defaultChecked = !!d), s != null && (e.checked = s && typeof s != "function" && typeof s != "symbol"), R != null && typeof R != "function" && typeof R != "symbol" && typeof R != "boolean" ? e.name = "" + Sn(R) : e.removeAttribute("name");
  }
  function Hi(e, t, n, l, s, d, S, R) {
    if (d != null && typeof d != "function" && typeof d != "symbol" && typeof d != "boolean" && (e.type = d), t != null || n != null) {
      if (!(d !== "submit" && d !== "reset" || t != null)) {
        di(e);
        return;
      }
      n = n != null ? "" + Sn(n) : "", t = t != null ? "" + Sn(t) : n, R || t === e.value || (e.value = t), e.defaultValue = t;
    }
    l = l ?? s, l = typeof l != "function" && typeof l != "symbol" && !!l, e.checked = R ? e.checked : !!l, e.defaultChecked = !!l, S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" && (e.name = S), di(e);
  }
  function be(e, t, n) {
    t === "number" && va(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
  }
  function D(e, t, n, l) {
    if (e = e.options, t) {
      t = {};
      for (var s = 0; s < n.length; s++)
        t["$" + n[s]] = !0;
      for (n = 0; n < e.length; n++)
        s = t.hasOwnProperty("$" + e[n].value), e[n].selected !== s && (e[n].selected = s), s && l && (e[n].defaultSelected = !0);
    } else {
      for (n = "" + Sn(n), t = null, s = 0; s < e.length; s++) {
        if (e[s].value === n) {
          e[s].selected = !0, l && (e[s].defaultSelected = !0);
          return;
        }
        t !== null || e[s].disabled || (t = e[s]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function W(e, t, n) {
    if (t != null && (t = "" + Sn(t), t !== e.value && (e.value = t), n == null)) {
      e.defaultValue !== t && (e.defaultValue = t);
      return;
    }
    e.defaultValue = n != null ? "" + Sn(n) : "";
  }
  function me(e, t, n, l) {
    if (t == null) {
      if (l != null) {
        if (n != null) throw Error(y(92));
        if (U(l)) {
          if (1 < l.length) throw Error(y(93));
          l = l[0];
        }
        n = l;
      }
      n == null && (n = ""), t = n;
    }
    n = Sn(t), e.defaultValue = n, l = e.textContent, l === n && l !== "" && l !== null && (e.value = l), di(e);
  }
  function Ee(e, t) {
    if (t) {
      var n = e.firstChild;
      if (n && n === e.lastChild && n.nodeType === 3) {
        n.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }
  var We = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function ot(e, t, n) {
    var l = t.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? l ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : l ? e.setProperty(t, n) : typeof n != "number" || n === 0 || We.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
  }
  function xn(e, t, n) {
    if (t != null && typeof t != "object")
      throw Error(y(62));
    if (e = e.style, n != null) {
      for (var l in n)
        !n.hasOwnProperty(l) || t != null && t.hasOwnProperty(l) || (l.indexOf("--") === 0 ? e.setProperty(l, "") : l === "float" ? e.cssFloat = "" : e[l] = "");
      for (var s in t)
        l = t[s], t.hasOwnProperty(s) && n[s] !== l && ot(e, s, l);
    } else
      for (var d in t)
        t.hasOwnProperty(d) && ot(e, d, t[d]);
  }
  function ln(e) {
    if (e.indexOf("-") === -1) return !1;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ht = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Wt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Bi(e) {
    return Wt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
  }
  function Bt() {
  }
  var Br = null;
  function so(e) {
    return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
  }
  var gr = null, Ul = null;
  function ac(e) {
    var t = Xa(e);
    if (t && (e = t.stateNode)) {
      var n = e[on] || null;
      e: switch (e = t.stateNode, t.type) {
        case "input":
          if (wl(
            e,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), t = n.name, n.type === "radio" && t != null) {
            for (n = e; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + tl(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < n.length; t++) {
              var l = n[t];
              if (l !== e && l.form === e.form) {
                var s = l[on] || null;
                if (!s) throw Error(y(90));
                wl(
                  l,
                  s.value,
                  s.defaultValue,
                  s.defaultValue,
                  s.checked,
                  s.defaultChecked,
                  s.type,
                  s.name
                );
              }
            }
            for (t = 0; t < n.length; t++)
              l = n[t], l.form === e.form && nn(l);
          }
          break e;
        case "textarea":
          W(e, n.value, n.defaultValue);
          break e;
        case "select":
          t = n.value, t != null && D(e, !!n.multiple, t, !1);
      }
    }
  }
  var vu = !1;
  function ic(e, t, n) {
    if (vu) return e(t, n);
    vu = !0;
    try {
      var l = e(t);
      return l;
    } finally {
      if (vu = !1, (gr !== null || Ul !== null) && (sd(), gr && (t = gr, e = Ul, Ul = gr = null, ac(t), e)))
        for (t = 0; t < e.length; t++) ac(e[t]);
    }
  }
  function Ui(e, t) {
    var n = e.stateNode;
    if (n === null) return null;
    var l = n[on] || null;
    if (l === null) return null;
    n = l[t];
    e: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (l = !l.disabled) || (e = e.type, l = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !l;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (n && typeof n != "function")
      throw Error(
        y(231, t, typeof n)
      );
    return n;
  }
  var dt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), vr = !1;
  if (dt)
    try {
      var Fi = {};
      Object.defineProperty(Fi, "passive", {
        get: function() {
          vr = !0;
        }
      }), window.addEventListener("test", Fi, Fi), window.removeEventListener("test", Fi, Fi);
    } catch {
      vr = !1;
    }
  var ya = null, yr = null, Yi = null;
  function yu() {
    if (Yi) return Yi;
    var e, t = yr, n = t.length, l, s = "value" in ya ? ya.value : ya.textContent, d = s.length;
    for (e = 0; e < n && t[e] === s[e]; e++) ;
    var S = n - e;
    for (l = 1; l <= S && t[n - l] === s[d - l]; l++) ;
    return Yi = s.slice(e, 1 < l ? 1 - l : void 0);
  }
  function hi(e) {
    var t = e.keyCode;
    return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
  }
  function wa() {
    return !0;
  }
  function bu() {
    return !1;
  }
  function hn(e) {
    function t(n, l, s, d, S) {
      this._reactName = n, this._targetInst = s, this.type = l, this.nativeEvent = d, this.target = S, this.currentTarget = null;
      for (var R in e)
        e.hasOwnProperty(R) && (n = e[R], this[R] = n ? n(d) : d[R]);
      return this.isDefaultPrevented = (d.defaultPrevented != null ? d.defaultPrevented : d.returnValue === !1) ? wa : bu, this.isPropagationStopped = bu, this;
    }
    return F(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = wa);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = wa);
      },
      persist: function() {
      },
      isPersistent: wa
    }), t;
  }
  var Gi = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Ur = hn(Gi), Za = F({}, Gi, { view: 0, detail: 0 }), mu = hn(Za), rc, uc, Fr, cc = F({}, Za, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Xi,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (e !== Fr && (Fr && e.type === "mousemove" ? (rc = e.screenX - Fr.screenX, uc = e.screenY - Fr.screenY) : uc = rc = 0, Fr = e), rc);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : uc;
    }
  }), Qo = hn(cc), Ys = F({}, cc, { dataTransfer: 0 }), Gs = hn(Ys), fo = F({}, Za, { relatedTarget: 0 }), oc = hn(fo), Xs = F({}, Gi, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Po = hn(Xs), sc = F({}, Gi, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), Is = hn(sc), ho = F({}, Gi, { data: 0 }), go = hn(ho), Yr = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, vo = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, fc = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Wo(e) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(e) : (e = fc[e]) ? !!t[e] : !1;
  }
  function Xi() {
    return Wo;
  }
  var Zs = F({}, Za, {
    key: function(e) {
      if (e.key) {
        var t = Yr[e.key] || e.key;
        if (t !== "Unidentified") return t;
      }
      return e.type === "keypress" ? (e = hi(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? vo[e.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Xi,
    charCode: function(e) {
      return e.type === "keypress" ? hi(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? hi(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), Vs = hn(Zs), Qs = F({}, cc, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Vn = hn(Qs), Gr = F({}, Za, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Xi
  }), yo = hn(Gr), dc = F({}, Gi, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Jo = hn(dc), br = F({}, cc, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Ii = hn(br), pu = F({}, Gi, {
    newState: 0,
    oldState: 0
  }), Zi = hn(pu), sl = [9, 13, 27, 32], Vi = dt && "CompositionEvent" in window, Ct = null;
  dt && "documentMode" in document && (Ct = document.documentMode);
  var Va = dt && "TextEvent" in window && !Ct, hc = dt && (!Vi || Ct && 8 < Ct && 11 >= Ct), Xr = " ", bo = !1;
  function gc(e, t) {
    switch (e) {
      case "keyup":
        return sl.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function mo(e) {
    return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
  }
  var gi = !1;
  function vc(e, t) {
    switch (e) {
      case "compositionend":
        return mo(t);
      case "keypress":
        return t.which !== 32 ? null : (bo = !0, Xr);
      case "textInput":
        return e = t.data, e === Xr && bo ? null : e;
      default:
        return null;
    }
  }
  function ba(e, t) {
    if (gi)
      return e === "compositionend" || !Vi && gc(e, t) ? (e = yu(), Yi = yr = ya = null, gi = !1, e) : null;
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return hc && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var po = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Tu(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!po[e.type] : t === "textarea";
  }
  function Ir(e, t, n, l) {
    gr ? Ul ? Ul.push(l) : Ul = [l] : gr = l, t = bd(t, "onChange"), 0 < t.length && (n = new Ur(
      "onChange",
      "change",
      null,
      n,
      l
    ), e.push({ event: n, listeners: t }));
  }
  var Qi = null, Pi = null;
  function yc(e) {
    uy(e, 0);
  }
  function mr(e) {
    var t = xl(e);
    if (nn(t)) return e;
  }
  function Ln(e, t) {
    if (e === "change") return t;
  }
  var Ko = !1;
  if (dt) {
    var vi;
    if (dt) {
      var Su = "oninput" in document;
      if (!Su) {
        var bc = document.createElement("div");
        bc.setAttribute("oninput", "return;"), Su = typeof bc.oninput == "function";
      }
      vi = Su;
    } else vi = !1;
    Ko = vi && (!document.documentMode || 9 < document.documentMode);
  }
  function mc() {
    Qi && (Qi.detachEvent("onpropertychange", xu), Pi = Qi = null);
  }
  function xu(e) {
    if (e.propertyName === "value" && mr(Pi)) {
      var t = [];
      Ir(
        t,
        Pi,
        e,
        so(e)
      ), ic(yc, t);
    }
  }
  function Eu(e, t, n) {
    e === "focusin" ? (mc(), Qi = t, Pi = n, Qi.attachEvent("onpropertychange", xu)) : e === "focusout" && mc();
  }
  function Wi(e) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return mr(Pi);
  }
  function jo(e, t) {
    if (e === "click") return mr(t);
  }
  function pr(e, t) {
    if (e === "input" || e === "change")
      return mr(t);
  }
  function wu(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var kn = typeof Object.is == "function" ? Object.is : wu;
  function Qa(e, t) {
    if (kn(e, t)) return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null)
      return !1;
    var n = Object.keys(e), l = Object.keys(t);
    if (n.length !== l.length) return !1;
    for (l = 0; l < n.length; l++) {
      var s = n[l];
      if (!Ri.call(t, s) || !kn(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  function Ji(e) {
    for (; e && e.firstChild; ) e = e.firstChild;
    return e;
  }
  function Ki(e, t) {
    var n = Ji(e);
    e = 0;
    for (var l; n; ) {
      if (n.nodeType === 3) {
        if (l = e + n.textContent.length, e <= t && l >= t)
          return { node: n, offset: t - e };
        e = l;
      }
      e: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break e;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Ji(n);
    }
  }
  function pc(e, t) {
    return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? pc(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function To(e) {
    e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
    for (var t = va(e.document); t instanceof e.HTMLIFrameElement; ) {
      try {
        var n = typeof t.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) e = t.contentWindow;
      else break;
      t = va(e.document);
    }
    return t;
  }
  function yi(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  var Au = dt && "documentMode" in document && 11 >= document.documentMode, bi = null, mi = null, ji = null, Tc = !1;
  function Aa(e, t, n) {
    var l = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Tc || bi == null || bi !== va(l) || (l = bi, "selectionStart" in l && yi(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection(), l = {
      anchorNode: l.anchorNode,
      anchorOffset: l.anchorOffset,
      focusNode: l.focusNode,
      focusOffset: l.focusOffset
    }), ji && Qa(ji, l) || (ji = l, l = bd(mi, "onSelect"), 0 < l.length && (t = new Ur(
      "onSelect",
      "select",
      null,
      t,
      n
    ), e.push({ event: t, listeners: l }), t.target = bi)));
  }
  function Pa(e, t) {
    var n = {};
    return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
  }
  var qi = {
    animationend: Pa("Animation", "AnimationEnd"),
    animationiteration: Pa("Animation", "AnimationIteration"),
    animationstart: Pa("Animation", "AnimationStart"),
    transitionrun: Pa("Transition", "TransitionRun"),
    transitionstart: Pa("Transition", "TransitionStart"),
    transitioncancel: Pa("Transition", "TransitionCancel"),
    transitionend: Pa("Transition", "TransitionEnd")
  }, r = {}, c = {};
  dt && (c = document.createElement("div").style, "AnimationEvent" in window || (delete qi.animationend.animation, delete qi.animationiteration.animation, delete qi.animationstart.animation), "TransitionEvent" in window || delete qi.transitionend.transition);
  function g(e) {
    if (r[e]) return r[e];
    if (!qi[e]) return e;
    var t = qi[e], n;
    for (n in t)
      if (t.hasOwnProperty(n) && n in c)
        return r[e] = t[n];
    return e;
  }
  var m = g("animationend"), x = g("animationiteration"), N = g("animationstart"), L = g("transitionrun"), ee = g("transitionstart"), Y = g("transitioncancel"), te = g("transitionend"), se = /* @__PURE__ */ new Map(), ie = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  ie.push("scrollEnd");
  function ve(e, t) {
    se.set(e, t), ql(t, [e]);
  }
  var Be = typeof reportError == "function" ? reportError : function(e) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
        error: e
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof a == "object" && typeof a.emit == "function") {
      a.emit("uncaughtException", e);
      return;
    }
    console.error(e);
  }, Ie = [], Ze = 0, je = 0;
  function Qe() {
    for (var e = Ze, t = je = Ze = 0; t < e; ) {
      var n = Ie[t];
      Ie[t++] = null;
      var l = Ie[t];
      Ie[t++] = null;
      var s = Ie[t];
      Ie[t++] = null;
      var d = Ie[t];
      if (Ie[t++] = null, l !== null && s !== null) {
        var S = l.pending;
        S === null ? s.next = s : (s.next = S.next, S.next = s), l.pending = s;
      }
      d !== 0 && ht(n, s, d);
    }
  }
  function qe(e, t, n, l) {
    Ie[Ze++] = e, Ie[Ze++] = t, Ie[Ze++] = n, Ie[Ze++] = l, je |= l, e.lanes |= l, e = e.alternate, e !== null && (e.lanes |= l);
  }
  function Qt(e, t, n, l) {
    return qe(e, t, n, l), gt(e);
  }
  function Lt(e, t) {
    return qe(e, null, null, t), gt(e);
  }
  function ht(e, t, n) {
    e.lanes |= n;
    var l = e.alternate;
    l !== null && (l.lanes |= n);
    for (var s = !1, d = e.return; d !== null; )
      d.childLanes |= n, l = d.alternate, l !== null && (l.childLanes |= n), d.tag === 22 && (e = d.stateNode, e === null || e._visibility & 1 || (s = !0)), e = d, d = d.return;
    return e.tag === 3 ? (d = e.stateNode, s && t !== null && (s = 31 - Cn(n), e = d.hiddenUpdates, l = e[s], l === null ? e[s] = [t] : l.push(t), t.lane = n | 536870912), d) : null;
  }
  function gt(e) {
    if (50 < Ef)
      throw Ef = 0, Nh = null, Error(y(185));
    for (var t = e.return; t !== null; )
      e = t, t = e.return;
    return e.tag === 3 ? e.stateNode : null;
  }
  var lt = {};
  function Fl(e, t, n, l) {
    this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Pe(e, t, n, l) {
    return new Fl(e, t, n, l);
  }
  function Al(e) {
    return e = e.prototype, !(!e || !e.isReactComponent);
  }
  function rt(e, t) {
    var n = e.alternate;
    return n === null ? (n = Pe(
      e.tag,
      t,
      e.key,
      e.mode
    ), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
  }
  function En(e, t) {
    e.flags &= 65011714;
    var n = e.alternate;
    return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), e;
  }
  function gn(e, t, n, l, s, d) {
    var S = 0;
    if (l = e, typeof e == "function") Al(e) && (S = 1);
    else if (typeof e == "string")
      S = c1(
        e,
        n,
        Ne.current
      ) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
    else
      e: switch (e) {
        case Ot:
          return e = Pe(31, n, t, s), e.elementType = Ot, e.lanes = d, e;
        case he:
          return Rt(n.children, s, d, t);
        case ge:
          S = 8, s |= 24;
          break;
        case de:
          return e = Pe(12, n, t, s | 2), e.elementType = de, e.lanes = d, e;
        case xe:
          return e = Pe(13, n, t, s), e.elementType = xe, e.lanes = d, e;
        case we:
          return e = Pe(19, n, t, s), e.elementType = we, e.lanes = d, e;
        default:
          if (typeof e == "object" && e !== null)
            switch (e.$$typeof) {
              case Re:
                S = 10;
                break e;
              case De:
                S = 9;
                break e;
              case ye:
                S = 11;
                break e;
              case Me:
                S = 14;
                break e;
              case He:
                S = 16, l = null;
                break e;
            }
          S = 29, n = Error(
            y(130, e === null ? "null" : typeof e, "")
          ), l = null;
      }
    return t = Pe(S, n, t, s), t.elementType = e, t.type = l, t.lanes = d, t;
  }
  function Rt(e, t, n, l) {
    return e = Pe(7, e, l, t), e.lanes = n, e;
  }
  function nl(e, t, n) {
    return e = Pe(6, e, null, t), e.lanes = n, e;
  }
  function $i(e) {
    var t = Pe(18, null, null, 0);
    return t.stateNode = e, t;
  }
  function _l(e, t, n) {
    return t = Pe(
      4,
      e.children !== null ? e.children : [],
      e.key,
      t
    ), t.lanes = n, t.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, t;
  }
  var Zr = /* @__PURE__ */ new WeakMap();
  function ll(e, t) {
    if (typeof e == "object" && e !== null) {
      var n = Zr.get(e);
      return n !== void 0 ? n : (t = {
        value: e,
        source: t,
        stack: pn(t)
      }, Zr.set(e, t), t);
    }
    return {
      value: e,
      source: t,
      stack: pn(t)
    };
  }
  var wn = [], al = 0, Yl = null, Ol = 0, Mn = [], Hn = 0, Jt = null, fl = 1, Gl = "";
  function _a(e, t) {
    wn[al++] = Ol, wn[al++] = Yl, Yl = e, Ol = t;
  }
  function Sc(e, t, n) {
    Mn[Hn++] = fl, Mn[Hn++] = Gl, Mn[Hn++] = Jt, Jt = e;
    var l = fl;
    e = Gl;
    var s = 32 - Cn(l) - 1;
    l &= ~(1 << s), n += 1;
    var d = 32 - Cn(t) + s;
    if (30 < d) {
      var S = s - s % 5;
      d = (l & (1 << S) - 1).toString(32), l >>= S, s -= S, fl = 1 << 32 - Cn(t) + s | n << s | l, Gl = d + e;
    } else
      fl = 1 << d | n << s | l, Gl = e;
  }
  function xc(e) {
    e.return !== null && (_a(e, 1), Sc(e, 1, 0));
  }
  function _u(e) {
    for (; e === Yl; )
      Yl = wn[--al], wn[al] = null, Ol = wn[--al], wn[al] = null;
    for (; e === Jt; )
      Jt = Mn[--Hn], Mn[Hn] = null, Gl = Mn[--Hn], Mn[Hn] = null, fl = Mn[--Hn], Mn[Hn] = null;
  }
  function Vr(e, t) {
    Mn[Hn++] = fl, Mn[Hn++] = Gl, Mn[Hn++] = Jt, fl = t.id, Gl = t.overflow, Jt = e;
  }
  var Qn = null, _t = null, Je = !1, Xl = null, Cl = !1, Wa = Error(y(519));
  function Ja(e) {
    var t = Error(
      y(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw ta(ll(t, e)), Wa;
  }
  function ea(e) {
    var t = e.stateNode, n = e.type, l = e.memoizedProps;
    switch (t[nt] = e, t[on] = l, n) {
      case "dialog":
        Tt("cancel", t), Tt("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        Tt("load", t);
        break;
      case "video":
      case "audio":
        for (n = 0; n < Af.length; n++)
          Tt(Af[n], t);
        break;
      case "source":
        Tt("error", t);
        break;
      case "img":
      case "image":
      case "link":
        Tt("error", t), Tt("load", t);
        break;
      case "details":
        Tt("toggle", t);
        break;
      case "input":
        Tt("invalid", t), Hi(
          t,
          l.value,
          l.defaultValue,
          l.checked,
          l.defaultChecked,
          l.type,
          l.name,
          !0
        );
        break;
      case "select":
        Tt("invalid", t);
        break;
      case "textarea":
        Tt("invalid", t), me(t, l.value, l.defaultValue, l.children);
    }
    n = l.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || l.suppressHydrationWarning === !0 || fy(t.textContent, n) ? (l.popover != null && (Tt("beforetoggle", t), Tt("toggle", t)), l.onScroll != null && Tt("scroll", t), l.onScrollEnd != null && Tt("scrollend", t), l.onClick != null && (t.onclick = Bt), t = !0) : t = !1, t || Ja(e, !0);
  }
  function Qr(e) {
    for (Qn = e.return; Qn; )
      switch (Qn.tag) {
        case 5:
        case 31:
        case 13:
          Cl = !1;
          return;
        case 27:
        case 3:
          Cl = !0;
          return;
        default:
          Qn = Qn.return;
      }
  }
  function Oa(e) {
    if (e !== Qn) return !1;
    if (!Je) return Qr(e), Je = !0, !1;
    var t = e.tag, n;
    if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Vh(e.type, e.memoizedProps)), n = !n), n && _t && Ja(e), Qr(e), t === 13) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(317));
      _t = Ty(e);
    } else if (t === 31) {
      if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(317));
      _t = Ty(e);
    } else
      t === 27 ? (t = _t, qc(e.type) ? (e = Kh, Kh = null, _t = e) : _t = t) : _t = Qn ? ir(e.stateNode.nextSibling) : null;
    return !0;
  }
  function ma() {
    _t = Qn = null, Je = !1;
  }
  function Tr() {
    var e = Xl;
    return e !== null && (ii === null ? ii = e : ii.push.apply(
      ii,
      e
    ), Xl = null), e;
  }
  function ta(e) {
    Xl === null ? Xl = [e] : Xl.push(e);
  }
  var Ou = ct(null), Kt = null, dl = null;
  function na(e, t, n) {
    _e(Ou, t._currentValue), t._currentValue = n;
  }
  function hl(e) {
    e._currentValue = Ou.current, tt(Ou);
  }
  function Pr(e, t, n) {
    for (; e !== null; ) {
      var l = e.alternate;
      if ((e.childLanes & t) !== t ? (e.childLanes |= t, l !== null && (l.childLanes |= t)) : l !== null && (l.childLanes & t) !== t && (l.childLanes |= t), e === n) break;
      e = e.return;
    }
  }
  function Il(e, t, n, l) {
    var s = e.child;
    for (s !== null && (s.return = e); s !== null; ) {
      var d = s.dependencies;
      if (d !== null) {
        var S = s.child;
        d = d.firstContext;
        e: for (; d !== null; ) {
          var R = d;
          d = s;
          for (var H = 0; H < t.length; H++)
            if (R.context === t[H]) {
              d.lanes |= n, R = d.alternate, R !== null && (R.lanes |= n), Pr(
                d.return,
                n,
                e
              ), l || (S = null);
              break e;
            }
          d = R.next;
        }
      } else if (s.tag === 18) {
        if (S = s.return, S === null) throw Error(y(341));
        S.lanes |= n, d = S.alternate, d !== null && (d.lanes |= n), Pr(S, n, e), S = null;
      } else S = s.child;
      if (S !== null) S.return = s;
      else
        for (S = s; S !== null; ) {
          if (S === e) {
            S = null;
            break;
          }
          if (s = S.sibling, s !== null) {
            s.return = S.return, S = s;
            break;
          }
          S = S.return;
        }
      s = S;
    }
  }
  function la(e, t, n, l) {
    e = null;
    for (var s = t, d = !1; s !== null; ) {
      if (!d) {
        if ((s.flags & 524288) !== 0) d = !0;
        else if ((s.flags & 262144) !== 0) break;
      }
      if (s.tag === 10) {
        var S = s.alternate;
        if (S === null) throw Error(y(387));
        if (S = S.memoizedProps, S !== null) {
          var R = s.type;
          kn(s.pendingProps.value, S.value) || (e !== null ? e.push(R) : e = [R]);
        }
      } else if (s === Pl.current) {
        if (S = s.alternate, S === null) throw Error(y(387));
        S.memoizedState.memoizedState !== s.memoizedState.memoizedState && (e !== null ? e.push(Nf) : e = [Nf]);
      }
      s = s.return;
    }
    e !== null && Il(
      t,
      e,
      n,
      l
    ), t.flags |= 262144;
  }
  function Ka(e) {
    for (e = e.firstContext; e !== null; ) {
      if (!kn(
        e.context._currentValue,
        e.memoizedValue
      ))
        return !0;
      e = e.next;
    }
    return !1;
  }
  function Pn(e) {
    Kt = e, dl = null, e = e.dependencies, e !== null && (e.firstContext = null);
  }
  function yt(e) {
    return il(Kt, e);
  }
  function pi(e, t) {
    return Kt === null && Pn(e), il(e, t);
  }
  function il(e, t) {
    var n = t._currentValue;
    if (t = { context: t, memoizedValue: n, next: null }, dl === null) {
      if (e === null) throw Error(y(308));
      dl = t, e.dependencies = { lanes: 0, firstContext: t }, e.flags |= 524288;
    } else dl = dl.next = t;
    return n;
  }
  var So = typeof AbortController < "u" ? AbortController : function() {
    var e = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(n, l) {
        e.push(l);
      }
    };
    this.abort = function() {
      t.aborted = !0, e.forEach(function(n) {
        return n();
      });
    };
  }, Cu = o.unstable_scheduleCallback, Ru = o.unstable_NormalPriority, An = {
    $$typeof: Re,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Ec() {
    return {
      controller: new So(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function aa(e) {
    e.refCount--, e.refCount === 0 && Cu(Ru, function() {
      e.controller.abort();
    });
  }
  var Ca = null, ja = 0, vn = 0, Ra = null;
  function Wr(e, t) {
    if (Ca === null) {
      var n = Ca = [];
      ja = 0, vn = Hh(), Ra = {
        status: "pending",
        value: void 0,
        then: function(l) {
          n.push(l);
        }
      };
    }
    return ja++, t.then(Nu, Nu), t;
  }
  function Nu() {
    if (--ja === 0 && Ca !== null) {
      Ra !== null && (Ra.status = "fulfilled");
      var e = Ca;
      Ca = null, vn = 0, Ra = null;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
  }
  function wc(e, t) {
    var n = [], l = {
      status: "pending",
      value: null,
      reason: null,
      then: function(s) {
        n.push(s);
      }
    };
    return e.then(
      function() {
        l.status = "fulfilled", l.value = t;
        for (var s = 0; s < n.length; s++) (0, n[s])(t);
      },
      function(s) {
        for (l.status = "rejected", l.reason = s, s = 0; s < n.length; s++)
          (0, n[s])(void 0);
      }
    ), l;
  }
  var Ac = P.S;
  P.S = function(e, t) {
    kv = Ue(), typeof t == "object" && t !== null && typeof t.then == "function" && Wr(e, t), Ac !== null && Ac(e, t);
  };
  var qa = ct(null);
  function Mu() {
    var e = qa.current;
    return e !== null ? e : sn.pooledCache;
  }
  function an(e, t) {
    t === null ? _e(qa, qa.current) : _e(qa, t.pool);
  }
  function zu() {
    var e = Mu();
    return e === null ? null : { parent: An._currentValue, pool: e };
  }
  var Na = Error(y(460)), er = Error(y(474)), tr = Error(y(542)), Sr = { then: function() {
  } };
  function Jr(e) {
    return e = e.status, e === "fulfilled" || e === "rejected";
  }
  function Kr(e, t, n) {
    switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Bt, Bt), t = n), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw e = t.reason, Ti(e), e;
      default:
        if (typeof t.status == "string") t.then(Bt, Bt);
        else {
          if (e = sn, e !== null && 100 < e.shellSuspendCounter)
            throw Error(y(482));
          e = t, e.status = "pending", e.then(
            function(l) {
              if (t.status === "pending") {
                var s = t;
                s.status = "fulfilled", s.value = l;
              }
            },
            function(l) {
              if (t.status === "pending") {
                var s = t;
                s.status = "rejected", s.reason = l;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw e = t.reason, Ti(e), e;
        }
        throw Bn = t, Na;
    }
  }
  function Rl(e) {
    try {
      var t = e._init;
      return t(e._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (Bn = n, Na) : n;
    }
  }
  var Bn = null;
  function _c() {
    if (Bn === null) throw Error(y(459));
    var e = Bn;
    return Bn = null, e;
  }
  function Ti(e) {
    if (e === Na || e === tr)
      throw Error(y(483));
  }
  var nr = null, ia = 0;
  function $a(e) {
    var t = ia;
    return ia += 1, nr === null && (nr = []), Kr(nr, e, t);
  }
  function ra(e, t) {
    t = t.props.ref, e.ref = t !== void 0 ? t : null;
  }
  function Si(e, t) {
    throw t.$$typeof === ce ? Error(y(525)) : (e = Object.prototype.toString.call(t), Error(
      y(
        31,
        e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e
      )
    ));
  }
  function ei(e) {
    function t(V, G) {
      if (e) {
        var K = V.deletions;
        K === null ? (V.deletions = [G], V.flags |= 16) : K.push(G);
      }
    }
    function n(V, G) {
      if (!e) return null;
      for (; G !== null; )
        t(V, G), G = G.sibling;
      return null;
    }
    function l(V) {
      for (var G = /* @__PURE__ */ new Map(); V !== null; )
        V.key !== null ? G.set(V.key, V) : G.set(V.index, V), V = V.sibling;
      return G;
    }
    function s(V, G) {
      return V = rt(V, G), V.index = 0, V.sibling = null, V;
    }
    function d(V, G, K) {
      return V.index = K, e ? (K = V.alternate, K !== null ? (K = K.index, K < G ? (V.flags |= 67108866, G) : K) : (V.flags |= 67108866, G)) : (V.flags |= 1048576, G);
    }
    function S(V) {
      return e && V.alternate === null && (V.flags |= 67108866), V;
    }
    function R(V, G, K, oe) {
      return G === null || G.tag !== 6 ? (G = nl(K, V.mode, oe), G.return = V, G) : (G = s(G, K), G.return = V, G);
    }
    function H(V, G, K, oe) {
      var Fe = K.type;
      return Fe === he ? re(
        V,
        G,
        K.props.children,
        oe,
        K.key
      ) : G !== null && (G.elementType === Fe || typeof Fe == "object" && Fe !== null && Fe.$$typeof === He && Rl(Fe) === G.type) ? (G = s(G, K.props), ra(G, K), G.return = V, G) : (G = gn(
        K.type,
        K.key,
        K.props,
        null,
        V.mode,
        oe
      ), ra(G, K), G.return = V, G);
    }
    function j(V, G, K, oe) {
      return G === null || G.tag !== 4 || G.stateNode.containerInfo !== K.containerInfo || G.stateNode.implementation !== K.implementation ? (G = _l(K, V.mode, oe), G.return = V, G) : (G = s(G, K.children || []), G.return = V, G);
    }
    function re(V, G, K, oe, Fe) {
      return G === null || G.tag !== 7 ? (G = Rt(
        K,
        V.mode,
        oe,
        Fe
      ), G.return = V, G) : (G = s(G, K), G.return = V, G);
    }
    function fe(V, G, K) {
      if (typeof G == "string" && G !== "" || typeof G == "number" || typeof G == "bigint")
        return G = nl(
          "" + G,
          V.mode,
          K
        ), G.return = V, G;
      if (typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case ae:
            return K = gn(
              G.type,
              G.key,
              G.props,
              null,
              V.mode,
              K
            ), ra(K, G), K.return = V, K;
          case $:
            return G = _l(
              G,
              V.mode,
              K
            ), G.return = V, G;
          case He:
            return G = Rl(G), fe(V, G, K);
        }
        if (U(G) || Ae(G))
          return G = Rt(
            G,
            V.mode,
            K,
            null
          ), G.return = V, G;
        if (typeof G.then == "function")
          return fe(V, $a(G), K);
        if (G.$$typeof === Re)
          return fe(
            V,
            pi(V, G),
            K
          );
        Si(V, G);
      }
      return null;
    }
    function q(V, G, K, oe) {
      var Fe = G !== null ? G.key : null;
      if (typeof K == "string" && K !== "" || typeof K == "number" || typeof K == "bigint")
        return Fe !== null ? null : R(V, G, "" + K, oe);
      if (typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case ae:
            return K.key === Fe ? H(V, G, K, oe) : null;
          case $:
            return K.key === Fe ? j(V, G, K, oe) : null;
          case He:
            return K = Rl(K), q(V, G, K, oe);
        }
        if (U(K) || Ae(K))
          return Fe !== null ? null : re(V, G, K, oe, null);
        if (typeof K.then == "function")
          return q(
            V,
            G,
            $a(K),
            oe
          );
        if (K.$$typeof === Re)
          return q(
            V,
            G,
            pi(V, K),
            oe
          );
        Si(V, K);
      }
      return null;
    }
    function le(V, G, K, oe, Fe) {
      if (typeof oe == "string" && oe !== "" || typeof oe == "number" || typeof oe == "bigint")
        return V = V.get(K) || null, R(G, V, "" + oe, Fe);
      if (typeof oe == "object" && oe !== null) {
        switch (oe.$$typeof) {
          case ae:
            return V = V.get(
              oe.key === null ? K : oe.key
            ) || null, H(G, V, oe, Fe);
          case $:
            return V = V.get(
              oe.key === null ? K : oe.key
            ) || null, j(G, V, oe, Fe);
          case He:
            return oe = Rl(oe), le(
              V,
              G,
              K,
              oe,
              Fe
            );
        }
        if (U(oe) || Ae(oe))
          return V = V.get(K) || null, re(G, V, oe, Fe, null);
        if (typeof oe.then == "function")
          return le(
            V,
            G,
            K,
            $a(oe),
            Fe
          );
        if (oe.$$typeof === Re)
          return le(
            V,
            G,
            K,
            pi(G, oe),
            Fe
          );
        Si(G, oe);
      }
      return null;
    }
    function ze(V, G, K, oe) {
      for (var Fe = null, Ut = null, ke = G, ut = G = 0, Et = null; ke !== null && ut < K.length; ut++) {
        ke.index > ut ? (Et = ke, ke = null) : Et = ke.sibling;
        var Ft = q(
          V,
          ke,
          K[ut],
          oe
        );
        if (Ft === null) {
          ke === null && (ke = Et);
          break;
        }
        e && ke && Ft.alternate === null && t(V, ke), G = d(Ft, G, ut), Ut === null ? Fe = Ft : Ut.sibling = Ft, Ut = Ft, ke = Et;
      }
      if (ut === K.length)
        return n(V, ke), Je && _a(V, ut), Fe;
      if (ke === null) {
        for (; ut < K.length; ut++)
          ke = fe(V, K[ut], oe), ke !== null && (G = d(
            ke,
            G,
            ut
          ), Ut === null ? Fe = ke : Ut.sibling = ke, Ut = ke);
        return Je && _a(V, ut), Fe;
      }
      for (ke = l(ke); ut < K.length; ut++)
        Et = le(
          ke,
          V,
          ut,
          K[ut],
          oe
        ), Et !== null && (e && Et.alternate !== null && ke.delete(
          Et.key === null ? ut : Et.key
        ), G = d(
          Et,
          G,
          ut
        ), Ut === null ? Fe = Et : Ut.sibling = Et, Ut = Et);
      return e && ke.forEach(function(lo) {
        return t(V, lo);
      }), Je && _a(V, ut), Fe;
    }
    function Ge(V, G, K, oe) {
      if (K == null) throw Error(y(151));
      for (var Fe = null, Ut = null, ke = G, ut = G = 0, Et = null, Ft = K.next(); ke !== null && !Ft.done; ut++, Ft = K.next()) {
        ke.index > ut ? (Et = ke, ke = null) : Et = ke.sibling;
        var lo = q(V, ke, Ft.value, oe);
        if (lo === null) {
          ke === null && (ke = Et);
          break;
        }
        e && ke && lo.alternate === null && t(V, ke), G = d(lo, G, ut), Ut === null ? Fe = lo : Ut.sibling = lo, Ut = lo, ke = Et;
      }
      if (Ft.done)
        return n(V, ke), Je && _a(V, ut), Fe;
      if (ke === null) {
        for (; !Ft.done; ut++, Ft = K.next())
          Ft = fe(V, Ft.value, oe), Ft !== null && (G = d(Ft, G, ut), Ut === null ? Fe = Ft : Ut.sibling = Ft, Ut = Ft);
        return Je && _a(V, ut), Fe;
      }
      for (ke = l(ke); !Ft.done; ut++, Ft = K.next())
        Ft = le(ke, V, ut, Ft.value, oe), Ft !== null && (e && Ft.alternate !== null && ke.delete(Ft.key === null ? ut : Ft.key), G = d(Ft, G, ut), Ut === null ? Fe = Ft : Ut.sibling = Ft, Ut = Ft);
      return e && ke.forEach(function(p1) {
        return t(V, p1);
      }), Je && _a(V, ut), Fe;
    }
    function un(V, G, K, oe) {
      if (typeof K == "object" && K !== null && K.type === he && K.key === null && (K = K.props.children), typeof K == "object" && K !== null) {
        switch (K.$$typeof) {
          case ae:
            e: {
              for (var Fe = K.key; G !== null; ) {
                if (G.key === Fe) {
                  if (Fe = K.type, Fe === he) {
                    if (G.tag === 7) {
                      n(
                        V,
                        G.sibling
                      ), oe = s(
                        G,
                        K.props.children
                      ), oe.return = V, V = oe;
                      break e;
                    }
                  } else if (G.elementType === Fe || typeof Fe == "object" && Fe !== null && Fe.$$typeof === He && Rl(Fe) === G.type) {
                    n(
                      V,
                      G.sibling
                    ), oe = s(G, K.props), ra(oe, K), oe.return = V, V = oe;
                    break e;
                  }
                  n(V, G);
                  break;
                } else t(V, G);
                G = G.sibling;
              }
              K.type === he ? (oe = Rt(
                K.props.children,
                V.mode,
                oe,
                K.key
              ), oe.return = V, V = oe) : (oe = gn(
                K.type,
                K.key,
                K.props,
                null,
                V.mode,
                oe
              ), ra(oe, K), oe.return = V, V = oe);
            }
            return S(V);
          case $:
            e: {
              for (Fe = K.key; G !== null; ) {
                if (G.key === Fe)
                  if (G.tag === 4 && G.stateNode.containerInfo === K.containerInfo && G.stateNode.implementation === K.implementation) {
                    n(
                      V,
                      G.sibling
                    ), oe = s(G, K.children || []), oe.return = V, V = oe;
                    break e;
                  } else {
                    n(V, G);
                    break;
                  }
                else t(V, G);
                G = G.sibling;
              }
              oe = _l(K, V.mode, oe), oe.return = V, V = oe;
            }
            return S(V);
          case He:
            return K = Rl(K), un(
              V,
              G,
              K,
              oe
            );
        }
        if (U(K))
          return ze(
            V,
            G,
            K,
            oe
          );
        if (Ae(K)) {
          if (Fe = Ae(K), typeof Fe != "function") throw Error(y(150));
          return K = Fe.call(K), Ge(
            V,
            G,
            K,
            oe
          );
        }
        if (typeof K.then == "function")
          return un(
            V,
            G,
            $a(K),
            oe
          );
        if (K.$$typeof === Re)
          return un(
            V,
            G,
            pi(V, K),
            oe
          );
        Si(V, K);
      }
      return typeof K == "string" && K !== "" || typeof K == "number" || typeof K == "bigint" ? (K = "" + K, G !== null && G.tag === 6 ? (n(V, G.sibling), oe = s(G, K), oe.return = V, V = oe) : (n(V, G), oe = nl(K, V.mode, oe), oe.return = V, V = oe), S(V)) : n(V, G);
    }
    return function(V, G, K, oe) {
      try {
        ia = 0;
        var Fe = un(
          V,
          G,
          K,
          oe
        );
        return nr = null, Fe;
      } catch (ke) {
        if (ke === Na || ke === tr) throw ke;
        var Ut = Pe(29, ke, null, V.mode);
        return Ut.lanes = oe, Ut.return = V, Ut;
      } finally {
      }
    };
  }
  var xi = ei(!0), Oc = ei(!1), gl = !1;
  function xr(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Ei(e, t) {
    e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function vl(e) {
    return { lane: e, tag: 0, payload: null, callback: null, next: null };
  }
  function Nl(e, t, n) {
    var l = e.updateQueue;
    if (l === null) return null;
    if (l = l.shared, (Yt & 2) !== 0) {
      var s = l.pending;
      return s === null ? t.next = t : (t.next = s.next, s.next = t), l.pending = t, t = gt(e), ht(e, null, n), t;
    }
    return qe(e, l, t, n), gt(e);
  }
  function yl(e, t, n) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (n & 4194048) !== 0)) {
      var l = t.lanes;
      l &= e.pendingLanes, n |= l, t.lanes = n, fn(e, n);
    }
  }
  function jr(e, t) {
    var n = e.updateQueue, l = e.alternate;
    if (l !== null && (l = l.updateQueue, n === l)) {
      var s = null, d = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var S = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          d === null ? s = d = S : d = d.next = S, n = n.next;
        } while (n !== null);
        d === null ? s = d = t : d = d.next = t;
      } else s = d = t;
      n = {
        baseState: l.baseState,
        firstBaseUpdate: s,
        lastBaseUpdate: d,
        shared: l.shared,
        callbacks: l.callbacks
      }, e.updateQueue = n;
      return;
    }
    e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
  }
  var Du = !1;
  function ti() {
    if (Du) {
      var e = Ra;
      if (e !== null) throw e;
    }
  }
  function i(e, t, n, l) {
    Du = !1;
    var s = e.updateQueue;
    gl = !1;
    var d = s.firstBaseUpdate, S = s.lastBaseUpdate, R = s.shared.pending;
    if (R !== null) {
      s.shared.pending = null;
      var H = R, j = H.next;
      H.next = null, S === null ? d = j : S.next = j, S = H;
      var re = e.alternate;
      re !== null && (re = re.updateQueue, R = re.lastBaseUpdate, R !== S && (R === null ? re.firstBaseUpdate = j : R.next = j, re.lastBaseUpdate = H));
    }
    if (d !== null) {
      var fe = s.baseState;
      S = 0, re = j = H = null, R = d;
      do {
        var q = R.lane & -536870913, le = q !== R.lane;
        if (le ? (xt & q) === q : (l & q) === q) {
          q !== 0 && q === vn && (Du = !0), re !== null && (re = re.next = {
            lane: 0,
            tag: R.tag,
            payload: R.payload,
            callback: null,
            next: null
          });
          e: {
            var ze = e, Ge = R;
            q = t;
            var un = n;
            switch (Ge.tag) {
              case 1:
                if (ze = Ge.payload, typeof ze == "function") {
                  fe = ze.call(un, fe, q);
                  break e;
                }
                fe = ze;
                break e;
              case 3:
                ze.flags = ze.flags & -65537 | 128;
              case 0:
                if (ze = Ge.payload, q = typeof ze == "function" ? ze.call(un, fe, q) : ze, q == null) break e;
                fe = F({}, fe, q);
                break e;
              case 2:
                gl = !0;
            }
          }
          q = R.callback, q !== null && (e.flags |= 64, le && (e.flags |= 8192), le = s.callbacks, le === null ? s.callbacks = [q] : le.push(q));
        } else
          le = {
            lane: q,
            tag: R.tag,
            payload: R.payload,
            callback: R.callback,
            next: null
          }, re === null ? (j = re = le, H = fe) : re = re.next = le, S |= q;
        if (R = R.next, R === null) {
          if (R = s.shared.pending, R === null)
            break;
          le = R, R = le.next, le.next = null, s.lastBaseUpdate = le, s.shared.pending = null;
        }
      } while (!0);
      re === null && (H = fe), s.baseState = H, s.firstBaseUpdate = j, s.lastBaseUpdate = re, d === null && (s.shared.lanes = 0), Pc |= S, e.lanes = S, e.memoizedState = fe;
    }
  }
  function u(e, t) {
    if (typeof e != "function")
      throw Error(y(191, e));
    e.call(t);
  }
  function h(e, t) {
    var n = e.callbacks;
    if (n !== null)
      for (e.callbacks = null, e = 0; e < n.length; e++)
        u(n[e], t);
  }
  var b = ct(null), T = ct(0);
  function O(e, t) {
    e = Ku, _e(T, e), _e(b, t), Ku = e | t.baseLanes;
  }
  function M() {
    _e(T, Ku), _e(b, b.current);
  }
  function Z() {
    Ku = T.current, tt(b), tt(T);
  }
  var k = ct(null), X = null;
  function J(e) {
    var t = e.alternate;
    _e(Le, Le.current & 1), _e(k, e), X === null && (t === null || b.current !== null || t.memoizedState !== null) && (X = e);
  }
  function ne(e) {
    _e(Le, Le.current), _e(k, e), X === null && (X = e);
  }
  function pe(e) {
    e.tag === 22 ? (_e(Le, Le.current), _e(k, e), X === null && (X = e)) : Te();
  }
  function Te() {
    _e(Le, Le.current), _e(k, k.current);
  }
  function Ve(e) {
    tt(k), X === e && (X = null), tt(Le);
  }
  var Le = ct(0);
  function at(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === 13) {
        var n = t.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || Wh(n) || Jh(n)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var bt = 0, Oe = null, Ke = null, mt = null, Ml = !1, Ye = !1, yn = !1, jt = 0, Un = 0, Zl = null, bn = 0;
  function kt() {
    throw Error(y(321));
  }
  function pa(e, t) {
    if (t === null) return !1;
    for (var n = 0; n < t.length && n < e.length; n++)
      if (!kn(e[n], t[n])) return !1;
    return !0;
  }
  function Fn(e, t, n, l, s, d) {
    return bt = d, Oe = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, P.H = e === null || e.memoizedState === null ? Gu : of, yn = !1, d = n(l, s), yn = !1, Ye && (d = qr(
      t,
      n,
      l,
      s
    )), ua(e), d;
  }
  function ua(e) {
    P.H = au;
    var t = Ke !== null && Ke.next !== null;
    if (bt = 0, mt = Ke = Oe = null, Ml = !1, Un = 0, Zl = null, t) throw Error(y(300));
    e === null || Yn || (e = e.dependencies, e !== null && Ka(e) && (Yn = !0));
  }
  function qr(e, t, n, l) {
    Oe = e;
    var s = 0;
    do {
      if (Ye && (Zl = null), Un = 0, Ye = !1, 25 <= s) throw Error(y(301));
      if (s += 1, mt = Ke = null, e.updateQueue != null) {
        var d = e.updateQueue;
        d.lastEffect = null, d.events = null, d.stores = null, d.memoCache != null && (d.memoCache.index = 0);
      }
      P.H = Xu, d = t(n, l);
    } while (Ye);
    return d;
  }
  function Lu() {
    var e = P.H, t = e.useState()[0];
    return t = typeof t.then == "function" ? Hu(t) : t, e = e.useState()[0], (Ke !== null ? Ke.memoizedState : null) !== e && (Oe.flags |= 1024), t;
  }
  function wi() {
    var e = jt !== 0;
    return jt = 0, e;
  }
  function Er(e, t, n) {
    t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
  }
  function ku(e) {
    if (Ml) {
      for (e = e.memoizedState; e !== null; ) {
        var t = e.queue;
        t !== null && (t.pending = null), e = e.next;
      }
      Ml = !1;
    }
    bt = 0, mt = Ke = Oe = null, Ye = !1, Un = jt = 0, Zl = null;
  }
  function mn() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return mt === null ? Oe.memoizedState = mt = e : mt = mt.next = e, mt;
  }
  function Pt() {
    if (Ke === null) {
      var e = Oe.alternate;
      e = e !== null ? e.memoizedState : null;
    } else e = Ke.next;
    var t = mt === null ? Oe.memoizedState : mt.next;
    if (t !== null)
      mt = t, Ke = e;
    else {
      if (e === null)
        throw Oe.alternate === null ? Error(y(467)) : Error(y(310));
      Ke = e, e = {
        memoizedState: Ke.memoizedState,
        baseState: Ke.baseState,
        baseQueue: Ke.baseQueue,
        queue: Ke.queue,
        next: null
      }, mt === null ? Oe.memoizedState = mt = e : mt = mt.next = e;
    }
    return mt;
  }
  function Cc() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Hu(e) {
    var t = Un;
    return Un += 1, Zl === null && (Zl = []), e = Kr(Zl, e, t), t = Oe, (mt === null ? t.memoizedState : mt.next) === null && (t = t.alternate, P.H = t === null || t.memoizedState === null ? Gu : of), e;
  }
  function $r(e) {
    if (e !== null && typeof e == "object") {
      if (typeof e.then == "function") return Hu(e);
      if (e.$$typeof === Re) return yt(e);
    }
    throw Error(y(438, String(e)));
  }
  function Ma(e) {
    var t = null, n = Oe.updateQueue;
    if (n !== null && (t = n.memoCache), t == null) {
      var l = Oe.alternate;
      l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (t = {
        data: l.data.map(function(s) {
          return s.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), n === null && (n = Cc(), Oe.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0)
      for (n = t.data[t.index] = Array(e), l = 0; l < e; l++)
        n[l] = wt;
    return t.index++, n;
  }
  function lr(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function eu(e) {
    var t = Pt();
    return qo(t, Ke, e);
  }
  function qo(e, t, n) {
    var l = e.queue;
    if (l === null) throw Error(y(311));
    l.lastRenderedReducer = n;
    var s = e.baseQueue, d = l.pending;
    if (d !== null) {
      if (s !== null) {
        var S = s.next;
        s.next = d.next, d.next = S;
      }
      t.baseQueue = s = d, l.pending = null;
    }
    if (d = e.baseState, s === null) e.memoizedState = d;
    else {
      t = s.next;
      var R = S = null, H = null, j = t, re = !1;
      do {
        var fe = j.lane & -536870913;
        if (fe !== j.lane ? (xt & fe) === fe : (bt & fe) === fe) {
          var q = j.revertLane;
          if (q === 0)
            H !== null && (H = H.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: j.action,
              hasEagerState: j.hasEagerState,
              eagerState: j.eagerState,
              next: null
            }), fe === vn && (re = !0);
          else if ((bt & q) === q) {
            j = j.next, q === vn && (re = !0);
            continue;
          } else
            fe = {
              lane: 0,
              revertLane: j.revertLane,
              gesture: null,
              action: j.action,
              hasEagerState: j.hasEagerState,
              eagerState: j.eagerState,
              next: null
            }, H === null ? (R = H = fe, S = d) : H = H.next = fe, Oe.lanes |= q, Pc |= q;
          fe = j.action, yn && n(d, fe), d = j.hasEagerState ? j.eagerState : n(d, fe);
        } else
          q = {
            lane: fe,
            revertLane: j.revertLane,
            gesture: j.gesture,
            action: j.action,
            hasEagerState: j.hasEagerState,
            eagerState: j.eagerState,
            next: null
          }, H === null ? (R = H = q, S = d) : H = H.next = q, Oe.lanes |= fe, Pc |= fe;
        j = j.next;
      } while (j !== null && j !== t);
      if (H === null ? S = d : H.next = R, !kn(d, e.memoizedState) && (Yn = !0, re && (n = Ra, n !== null)))
        throw n;
      e.memoizedState = d, e.baseState = S, e.baseQueue = H, l.lastRenderedState = d;
    }
    return s === null && (l.lanes = 0), [e.memoizedState, l.dispatch];
  }
  function $o(e) {
    var t = Pt(), n = t.queue;
    if (n === null) throw Error(y(311));
    n.lastRenderedReducer = e;
    var l = n.dispatch, s = n.pending, d = t.memoizedState;
    if (s !== null) {
      n.pending = null;
      var S = s = s.next;
      do
        d = e(d, S.action), S = S.next;
      while (S !== s);
      kn(d, t.memoizedState) || (Yn = !0), t.memoizedState = d, t.baseQueue === null && (t.baseState = d), n.lastRenderedState = d;
    }
    return [d, l];
  }
  function Ps(e, t, n) {
    var l = Oe, s = Pt(), d = Je;
    if (d) {
      if (n === void 0) throw Error(y(407));
      n = n();
    } else n = t();
    var S = !kn(
      (Ke || s).memoizedState,
      n
    );
    if (S && (s.memoizedState = n, Yn = !0), s = s.queue, Fu(Ks.bind(null, l, s, e), [
      e
    ]), s.getSnapshot !== t || S || mt !== null && mt.memoizedState.tag & 1) {
      if (l.flags |= 2048, Ar(
        9,
        { destroy: void 0 },
        Js.bind(
          null,
          l,
          s,
          n,
          t
        ),
        null
      ), sn === null) throw Error(y(349));
      d || (bt & 127) !== 0 || Ws(l, t, n);
    }
    return n;
  }
  function Ws(e, t, n) {
    e.flags |= 16384, e = { getSnapshot: t, value: n }, t = Oe.updateQueue, t === null ? (t = Cc(), Oe.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
  }
  function Js(e, t, n, l) {
    t.value = n, t.getSnapshot = l, Rc(t) && ar(e);
  }
  function Ks(e, t, n) {
    return n(function() {
      Rc(t) && ar(e);
    });
  }
  function Rc(e) {
    var t = e.getSnapshot;
    e = e.value;
    try {
      var n = t();
      return !kn(e, n);
    } catch {
      return !0;
    }
  }
  function ar(e) {
    var t = Lt(e, 2);
    t !== null && ri(t, e, 2);
  }
  function es(e) {
    var t = mn();
    if (typeof e == "function") {
      var n = e;
      if (e = n(), yn) {
        Sl(!0);
        try {
          n();
        } finally {
          Sl(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = e, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: lr,
      lastRenderedState: e
    }, t;
  }
  function js(e, t, n, l) {
    return e.baseState = n, qo(
      e,
      Ke,
      typeof l == "function" ? l : lr
    );
  }
  function xo(e, t, n, l, s) {
    if (Ao(e)) throw Error(y(485));
    if (e = t.action, e !== null) {
      var d = {
        payload: s,
        action: e,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(S) {
          d.listeners.push(S);
        }
      };
      P.T !== null ? n(!0) : d.isTransition = !1, l(d), n = t.pending, n === null ? (d.next = t.pending = d, qs(t, d)) : (d.next = n.next, t.pending = n.next = d);
    }
  }
  function qs(e, t) {
    var n = t.action, l = t.payload, s = e.state;
    if (t.isTransition) {
      var d = P.T, S = {};
      P.T = S;
      try {
        var R = n(s, l), H = P.S;
        H !== null && H(S, R), tu(e, t, R);
      } catch (j) {
        Bu(e, t, j);
      } finally {
        d !== null && S.types !== null && (d.types = S.types), P.T = d;
      }
    } else
      try {
        d = n(s, l), tu(e, t, d);
      } catch (j) {
        Bu(e, t, j);
      }
  }
  function tu(e, t, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(l) {
        Nc(e, t, l);
      },
      function(l) {
        return Bu(e, t, l);
      }
    ) : Nc(e, t, n);
  }
  function Nc(e, t, n) {
    t.status = "fulfilled", t.value = n, Mc(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, qs(e, n)));
  }
  function Bu(e, t, n) {
    var l = e.pending;
    if (e.pending = null, l !== null) {
      l = l.next;
      do
        t.status = "rejected", t.reason = n, Mc(t), t = t.next;
      while (t !== l);
    }
    e.action = null;
  }
  function Mc(e) {
    e = e.listeners;
    for (var t = 0; t < e.length; t++) (0, e[t])();
  }
  function zc(e, t) {
    return t;
  }
  function wr(e, t) {
    if (Je) {
      var n = sn.formState;
      if (n !== null) {
        e: {
          var l = Oe;
          if (Je) {
            if (_t) {
              t: {
                for (var s = _t, d = Cl; s.nodeType !== 8; ) {
                  if (!d) {
                    s = null;
                    break t;
                  }
                  if (s = ir(
                    s.nextSibling
                  ), s === null) {
                    s = null;
                    break t;
                  }
                }
                d = s.data, s = d === "F!" || d === "F" ? s : null;
              }
              if (s) {
                _t = ir(
                  s.nextSibling
                ), l = s.data === "F!";
                break e;
              }
            }
            Ja(l);
          }
          l = !1;
        }
        l && (t = n[0]);
      }
    }
    return n = mn(), n.memoizedState = n.baseState = t, l = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: zc,
      lastRenderedState: t
    }, n.queue = l, n = uf.bind(
      null,
      Oe,
      l
    ), l.dispatch = n, l = es(!1), d = wo.bind(
      null,
      Oe,
      !1,
      l.queue
    ), l = mn(), s = {
      state: t,
      dispatch: null,
      action: e,
      pending: null
    }, l.queue = s, n = xo.bind(
      null,
      Oe,
      s,
      d,
      n
    ), s.dispatch = n, l.memoizedState = e, [t, n, !1];
  }
  function ts(e) {
    var t = Pt();
    return ns(t, Ke, e);
  }
  function ns(e, t, n) {
    if (t = qo(
      e,
      t,
      zc
    )[0], e = eu(lr)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var l = Hu(t);
      } catch (S) {
        throw S === Na ? tr : S;
      }
    else l = t;
    t = Pt();
    var s = t.queue, d = s.dispatch;
    return n !== t.memoizedState && (Oe.flags |= 2048, Ar(
      9,
      { destroy: void 0 },
      Uu.bind(null, s, n),
      null
    )), [l, d, e];
  }
  function Uu(e, t) {
    e.action = t;
  }
  function $s(e) {
    var t = Pt(), n = Ke;
    if (n !== null)
      return ns(t, n, e);
    Pt(), t = t.memoizedState, n = Pt();
    var l = n.queue.dispatch;
    return n.memoizedState = e, [t, l, !1];
  }
  function Ar(e, t, n, l) {
    return e = { tag: e, create: n, deps: l, inst: t, next: null }, t = Oe.updateQueue, t === null && (t = Cc(), Oe.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (l = n.next, n.next = e, e.next = l, t.lastEffect = e), e;
  }
  function ef() {
    return Pt().memoizedState;
  }
  function nu(e, t, n, l) {
    var s = mn();
    Oe.flags |= e, s.memoizedState = Ar(
      1 | t,
      { destroy: void 0 },
      n,
      l === void 0 ? null : l
    );
  }
  function Eo(e, t, n, l) {
    var s = Pt();
    l = l === void 0 ? null : l;
    var d = s.memoizedState.inst;
    Ke !== null && l !== null && pa(l, Ke.memoizedState.deps) ? s.memoizedState = Ar(t, d, n, l) : (Oe.flags |= e, s.memoizedState = Ar(
      1 | t,
      d,
      n,
      l
    ));
  }
  function Dc(e, t) {
    nu(8390656, 8, e, t);
  }
  function Fu(e, t) {
    Eo(2048, 8, e, t);
  }
  function jf(e) {
    Oe.flags |= 4;
    var t = Oe.updateQueue;
    if (t === null)
      t = Cc(), Oe.updateQueue = t, t.events = [e];
    else {
      var n = t.events;
      n === null ? t.events = [e] : n.push(e);
    }
  }
  function tf(e) {
    var t = Pt().memoizedState;
    return jf({ ref: t, nextImpl: e }), function() {
      if ((Yt & 2) !== 0) throw Error(y(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function qf(e, t) {
    return Eo(4, 2, e, t);
  }
  function $f(e, t) {
    return Eo(4, 4, e, t);
  }
  function ls(e, t) {
    if (typeof t == "function") {
      e = e();
      var n = t(e);
      return function() {
        typeof n == "function" ? n() : t(null);
      };
    }
    if (t != null)
      return e = e(), t.current = e, function() {
        t.current = null;
      };
  }
  function ed(e, t, n) {
    n = n != null ? n.concat([e]) : null, Eo(4, 4, ls.bind(null, t, e), n);
  }
  function nf() {
  }
  function td(e, t) {
    var n = Pt();
    t = t === void 0 ? null : t;
    var l = n.memoizedState;
    return t !== null && pa(t, l[1]) ? l[0] : (n.memoizedState = [e, t], e);
  }
  function _r(e, t) {
    var n = Pt();
    t = t === void 0 ? null : t;
    var l = n.memoizedState;
    if (t !== null && pa(t, l[1]))
      return l[0];
    if (l = e(), yn) {
      Sl(!0);
      try {
        e();
      } finally {
        Sl(!1);
      }
    }
    return n.memoizedState = [l, t], l;
  }
  function Lc(e, t, n) {
    return n === void 0 || (bt & 1073741824) !== 0 && (xt & 261930) === 0 ? e.memoizedState = t : (e.memoizedState = n, e = Bv(), Oe.lanes |= e, Pc |= e, n);
  }
  function kc(e, t, n, l) {
    return kn(n, t) ? n : b.current !== null ? (e = Lc(e, n, l), kn(e, t) || (Yn = !0), e) : (bt & 42) === 0 || (bt & 1073741824) !== 0 && (xt & 261930) === 0 ? (Yn = !0, e.memoizedState = n) : (e = Bv(), Oe.lanes |= e, Pc |= e, t);
  }
  function Yu(e, t, n, l, s) {
    var d = Se.p;
    Se.p = d !== 0 && 8 > d ? d : 8;
    var S = P.T, R = {};
    P.T = R, wo(e, !1, t, n);
    try {
      var H = s(), j = P.S;
      if (j !== null && j(R, H), H !== null && typeof H == "object" && typeof H.then == "function") {
        var re = wc(
          H,
          l
        );
        lu(
          e,
          t,
          re,
          Oi(e)
        );
      } else
        lu(
          e,
          t,
          l,
          Oi(e)
        );
    } catch (fe) {
      lu(
        e,
        t,
        { then: function() {
        }, status: "rejected", reason: fe },
        Oi()
      );
    } finally {
      Se.p = d, S !== null && R.types !== null && (S.types = R.types), P.T = S;
    }
  }
  function as() {
  }
  function Hc(e, t, n, l) {
    if (e.tag !== 5) throw Error(y(476));
    var s = is(e).queue;
    Yu(
      e,
      s,
      t,
      et,
      n === null ? as : function() {
        return lf(e), n(l);
      }
    );
  }
  function is(e) {
    var t = e.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: et,
      baseState: et,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: lr,
        lastRenderedState: et
      },
      next: null
    };
    var n = {};
    return t.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: lr,
        lastRenderedState: n
      },
      next: null
    }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
  }
  function lf(e) {
    var t = is(e);
    t.next === null && (t = e.alternate.memoizedState), lu(
      e,
      t.next.queue,
      {},
      Oi()
    );
  }
  function af() {
    return yt(Nf);
  }
  function rs() {
    return Pt().memoizedState;
  }
  function rf() {
    return Pt().memoizedState;
  }
  function us(e) {
    for (var t = e.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var n = Oi();
          e = vl(n);
          var l = Nl(t, e, n);
          l !== null && (ri(l, t, n), yl(l, t, n)), t = { cache: Ec() }, e.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function cs(e, t, n) {
    var l = Oi();
    n = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Ao(e) ? cf(t, n) : (n = Qt(e, t, n, l), n !== null && (ri(n, e, l), nd(n, t, l)));
  }
  function uf(e, t, n) {
    var l = Oi();
    lu(e, t, n, l);
  }
  function lu(e, t, n, l) {
    var s = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (Ao(e)) cf(t, s);
    else {
      var d = e.alternate;
      if (e.lanes === 0 && (d === null || d.lanes === 0) && (d = t.lastRenderedReducer, d !== null))
        try {
          var S = t.lastRenderedState, R = d(S, n);
          if (s.hasEagerState = !0, s.eagerState = R, kn(R, S))
            return qe(e, t, s, 0), sn === null && Qe(), !1;
        } catch {
        } finally {
        }
      if (n = Qt(e, t, s, l), n !== null)
        return ri(n, e, l), nd(n, t, l), !0;
    }
    return !1;
  }
  function wo(e, t, n, l) {
    if (l = {
      lane: 2,
      revertLane: Hh(),
      gesture: null,
      action: l,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Ao(e)) {
      if (t) throw Error(y(479));
    } else
      t = Qt(
        e,
        n,
        l,
        2
      ), t !== null && ri(t, e, 2);
  }
  function Ao(e) {
    var t = e.alternate;
    return e === Oe || t !== null && t === Oe;
  }
  function cf(e, t) {
    Ye = Ml = !0;
    var n = e.pending;
    n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
  }
  function nd(e, t, n) {
    if ((n & 4194048) !== 0) {
      var l = t.lanes;
      l &= e.pendingLanes, n |= l, t.lanes = n, fn(e, n);
    }
  }
  var au = {
    readContext: yt,
    use: $r,
    useCallback: kt,
    useContext: kt,
    useEffect: kt,
    useImperativeHandle: kt,
    useLayoutEffect: kt,
    useInsertionEffect: kt,
    useMemo: kt,
    useReducer: kt,
    useRef: kt,
    useState: kt,
    useDebugValue: kt,
    useDeferredValue: kt,
    useTransition: kt,
    useSyncExternalStore: kt,
    useId: kt,
    useHostTransitionStatus: kt,
    useFormState: kt,
    useActionState: kt,
    useOptimistic: kt,
    useMemoCache: kt,
    useCacheRefresh: kt
  };
  au.useEffectEvent = kt;
  var Gu = {
    readContext: yt,
    use: $r,
    useCallback: function(e, t) {
      return mn().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    },
    useContext: yt,
    useEffect: Dc,
    useImperativeHandle: function(e, t, n) {
      n = n != null ? n.concat([e]) : null, nu(
        4194308,
        4,
        ls.bind(null, t, e),
        n
      );
    },
    useLayoutEffect: function(e, t) {
      return nu(4194308, 4, e, t);
    },
    useInsertionEffect: function(e, t) {
      nu(4, 2, e, t);
    },
    useMemo: function(e, t) {
      var n = mn();
      t = t === void 0 ? null : t;
      var l = e();
      if (yn) {
        Sl(!0);
        try {
          e();
        } finally {
          Sl(!1);
        }
      }
      return n.memoizedState = [l, t], l;
    },
    useReducer: function(e, t, n) {
      var l = mn();
      if (n !== void 0) {
        var s = n(t);
        if (yn) {
          Sl(!0);
          try {
            n(t);
          } finally {
            Sl(!1);
          }
        }
      } else s = t;
      return l.memoizedState = l.baseState = s, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: s
      }, l.queue = e, e = e.dispatch = cs.bind(
        null,
        Oe,
        e
      ), [l.memoizedState, e];
    },
    useRef: function(e) {
      var t = mn();
      return e = { current: e }, t.memoizedState = e;
    },
    useState: function(e) {
      e = es(e);
      var t = e.queue, n = uf.bind(null, Oe, t);
      return t.dispatch = n, [e.memoizedState, n];
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = mn();
      return Lc(n, e, t);
    },
    useTransition: function() {
      var e = es(!1);
      return e = Yu.bind(
        null,
        Oe,
        e.queue,
        !0,
        !1
      ), mn().memoizedState = e, [!1, e];
    },
    useSyncExternalStore: function(e, t, n) {
      var l = Oe, s = mn();
      if (Je) {
        if (n === void 0)
          throw Error(y(407));
        n = n();
      } else {
        if (n = t(), sn === null)
          throw Error(y(349));
        (xt & 127) !== 0 || Ws(l, t, n);
      }
      s.memoizedState = n;
      var d = { value: n, getSnapshot: t };
      return s.queue = d, Dc(Ks.bind(null, l, d, e), [
        e
      ]), l.flags |= 2048, Ar(
        9,
        { destroy: void 0 },
        Js.bind(
          null,
          l,
          d,
          n,
          t
        ),
        null
      ), n;
    },
    useId: function() {
      var e = mn(), t = sn.identifierPrefix;
      if (Je) {
        var n = Gl, l = fl;
        n = (l & ~(1 << 32 - Cn(l) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = jt++, 0 < n && (t += "H" + n.toString(32)), t += "_";
      } else
        n = bn++, t = "_" + t + "r_" + n.toString(32) + "_";
      return e.memoizedState = t;
    },
    useHostTransitionStatus: af,
    useFormState: wr,
    useActionState: wr,
    useOptimistic: function(e) {
      var t = mn();
      t.memoizedState = t.baseState = e;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = n, t = wo.bind(
        null,
        Oe,
        !0,
        n
      ), n.dispatch = t, [e, t];
    },
    useMemoCache: Ma,
    useCacheRefresh: function() {
      return mn().memoizedState = us.bind(
        null,
        Oe
      );
    },
    useEffectEvent: function(e) {
      var t = mn(), n = { impl: e };
      return t.memoizedState = n, function() {
        if ((Yt & 2) !== 0)
          throw Error(y(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, of = {
    readContext: yt,
    use: $r,
    useCallback: td,
    useContext: yt,
    useEffect: Fu,
    useImperativeHandle: ed,
    useInsertionEffect: qf,
    useLayoutEffect: $f,
    useMemo: _r,
    useReducer: eu,
    useRef: ef,
    useState: function() {
      return eu(lr);
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = Pt();
      return kc(
        n,
        Ke.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = eu(lr)[0], t = Pt().memoizedState;
      return [
        typeof e == "boolean" ? e : Hu(e),
        t
      ];
    },
    useSyncExternalStore: Ps,
    useId: rs,
    useHostTransitionStatus: af,
    useFormState: ts,
    useActionState: ts,
    useOptimistic: function(e, t) {
      var n = Pt();
      return js(n, Ke, e, t);
    },
    useMemoCache: Ma,
    useCacheRefresh: rf
  };
  of.useEffectEvent = tf;
  var Xu = {
    readContext: yt,
    use: $r,
    useCallback: td,
    useContext: yt,
    useEffect: Fu,
    useImperativeHandle: ed,
    useInsertionEffect: qf,
    useLayoutEffect: $f,
    useMemo: _r,
    useReducer: $o,
    useRef: ef,
    useState: function() {
      return $o(lr);
    },
    useDebugValue: nf,
    useDeferredValue: function(e, t) {
      var n = Pt();
      return Ke === null ? Lc(n, e, t) : kc(
        n,
        Ke.memoizedState,
        e,
        t
      );
    },
    useTransition: function() {
      var e = $o(lr)[0], t = Pt().memoizedState;
      return [
        typeof e == "boolean" ? e : Hu(e),
        t
      ];
    },
    useSyncExternalStore: Ps,
    useId: rs,
    useHostTransitionStatus: af,
    useFormState: $s,
    useActionState: $s,
    useOptimistic: function(e, t) {
      var n = Pt();
      return Ke !== null ? js(n, Ke, e, t) : (n.baseState = e, [e, n.queue.dispatch]);
    },
    useMemoCache: Ma,
    useCacheRefresh: rf
  };
  Xu.useEffectEvent = tf;
  function os(e, t, n, l) {
    t = e.memoizedState, n = n(l, t), n = n == null ? t : F({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
  }
  var Iu = {
    enqueueSetState: function(e, t, n) {
      e = e._reactInternals;
      var l = Oi(), s = vl(l);
      s.payload = t, n != null && (s.callback = n), t = Nl(e, s, l), t !== null && (ri(t, e, l), yl(t, e, l));
    },
    enqueueReplaceState: function(e, t, n) {
      e = e._reactInternals;
      var l = Oi(), s = vl(l);
      s.tag = 1, s.payload = t, n != null && (s.callback = n), t = Nl(e, s, l), t !== null && (ri(t, e, l), yl(t, e, l));
    },
    enqueueForceUpdate: function(e, t) {
      e = e._reactInternals;
      var n = Oi(), l = vl(n);
      l.tag = 2, t != null && (l.callback = t), t = Nl(e, l, n), t !== null && (ri(t, e, n), yl(t, e, n));
    }
  };
  function _o(e, t, n, l, s, d, S) {
    return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(l, d, S) : t.prototype && t.prototype.isPureReactComponent ? !Qa(n, l) || !Qa(s, d) : !0;
  }
  function Bc(e, t, n, l) {
    e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, l), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, l), t.state !== e && Iu.enqueueReplaceState(t, t.state, null);
  }
  function iu(e, t) {
    var n = t;
    if ("ref" in t) {
      n = {};
      for (var l in t)
        l !== "ref" && (n[l] = t[l]);
    }
    if (e = e.defaultProps) {
      n === t && (n = F({}, n));
      for (var s in e)
        n[s] === void 0 && (n[s] = e[s]);
    }
    return n;
  }
  function ru(e) {
    Be(e);
  }
  function sf(e) {
    console.error(e);
  }
  function ff(e) {
    Be(e);
  }
  function Or(e, t) {
    try {
      var n = e.onUncaughtError;
      n(t.value, { componentStack: t.stack });
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  function df(e, t, n) {
    try {
      var l = e.onCaughtError;
      l(n.value, {
        componentStack: n.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (s) {
      setTimeout(function() {
        throw s;
      });
    }
  }
  function Uc(e, t, n) {
    return n = vl(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      Or(e, t);
    }, n;
  }
  function ss(e) {
    return e = vl(e), e.tag = 3, e;
  }
  function Fc(e, t, n, l) {
    var s = n.type.getDerivedStateFromError;
    if (typeof s == "function") {
      var d = l.value;
      e.payload = function() {
        return s(d);
      }, e.callback = function() {
        df(t, n, l);
      };
    }
    var S = n.stateNode;
    S !== null && typeof S.componentDidCatch == "function" && (e.callback = function() {
      df(t, n, l), typeof s != "function" && (Wc === null ? Wc = /* @__PURE__ */ new Set([this]) : Wc.add(this));
      var R = l.stack;
      this.componentDidCatch(l.value, {
        componentStack: R !== null ? R : ""
      });
    });
  }
  function bh(e, t, n, l, s) {
    if (n.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
      if (t = n.alternate, t !== null && la(
        t,
        n,
        s,
        !0
      ), n = k.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
            return X === null ? fd() : n.alternate === null && Jn === 0 && (Jn = 3), n.flags &= -257, n.flags |= 65536, n.lanes = s, l === Sr ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = /* @__PURE__ */ new Set([l]) : t.add(l), Dh(e, l, s)), !1;
          case 22:
            return n.flags |= 65536, l === Sr ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([l])
            }, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = /* @__PURE__ */ new Set([l]) : n.add(l)), Dh(e, l, s)), !1;
        }
        throw Error(y(435, n.tag));
      }
      return Dh(e, l, s), fd(), !1;
    }
    if (Je)
      return t = k.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = s, l !== Wa && (e = Error(y(422), { cause: l }), ta(ll(e, n)))) : (l !== Wa && (t = Error(y(423), {
        cause: l
      }), ta(
        ll(t, n)
      )), e = e.current.alternate, e.flags |= 65536, s &= -s, e.lanes |= s, l = ll(l, n), s = Uc(
        e.stateNode,
        l,
        s
      ), jr(e, s), Jn !== 4 && (Jn = 2)), !1;
    var d = Error(y(520), { cause: l });
    if (d = ll(d, n), xf === null ? xf = [d] : xf.push(d), Jn !== 4 && (Jn = 2), t === null) return !0;
    l = ll(l, n), n = t;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, e = s & -s, n.lanes |= e, e = Uc(n.stateNode, l, e), jr(n, e), !1;
        case 1:
          if (t = n.type, d = n.stateNode, (n.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || d !== null && typeof d.componentDidCatch == "function" && (Wc === null || !Wc.has(d))))
            return n.flags |= 65536, s &= -s, n.lanes |= s, s = ss(s), Fc(
              s,
              e,
              n,
              l
            ), jr(n, s), !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var hf = Error(y(461)), Yn = !1;
  function Gn(e, t, n, l) {
    t.child = e === null ? Oc(t, null, n, l) : xi(
      t,
      e.child,
      n,
      l
    );
  }
  function Yc(e, t, n, l, s) {
    n = n.render;
    var d = t.ref;
    if ("ref" in l) {
      var S = {};
      for (var R in l)
        R !== "ref" && (S[R] = l[R]);
    } else S = l;
    return Pn(t), l = Fn(
      e,
      t,
      n,
      S,
      d,
      s
    ), R = wi(), e !== null && !Yn ? (Er(e, t, s), rl(e, t, s)) : (Je && R && xc(t), t.flags |= 1, Gn(e, t, l, s), t.child);
  }
  function Gc(e, t, n, l, s) {
    if (e === null) {
      var d = n.type;
      return typeof d == "function" && !Al(d) && d.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = d, Oo(
        e,
        t,
        d,
        l,
        s
      )) : (e = gn(
        n.type,
        null,
        l,
        t,
        t.mode,
        s
      ), e.ref = t.ref, e.return = t, t.child = e);
    }
    if (d = e.child, !ms(e, s)) {
      var S = d.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Qa, n(S, l) && e.ref === t.ref)
        return rl(e, t, s);
    }
    return t.flags |= 1, e = rt(d, l), e.ref = t.ref, e.return = t, t.child = e;
  }
  function Oo(e, t, n, l, s) {
    if (e !== null) {
      var d = e.memoizedProps;
      if (Qa(d, l) && e.ref === t.ref)
        if (Yn = !1, t.pendingProps = l = d, ms(e, s))
          (e.flags & 131072) !== 0 && (Yn = !0);
        else
          return t.lanes = e.lanes, rl(e, t, s);
    }
    return Cr(
      e,
      t,
      n,
      l,
      s
    );
  }
  function uu(e, t, n, l) {
    var s = l.children, d = e !== null ? e.memoizedState : null;
    if (e === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (d = d !== null ? d.baseLanes | n : n, e !== null) {
          for (l = t.child = e.child, s = 0; l !== null; )
            s = s | l.lanes | l.childLanes, l = l.sibling;
          l = s & ~d;
        } else l = 0, t.child = null;
        return zl(
          e,
          t,
          d,
          n,
          l
        );
      }
      if ((n & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && an(
          t,
          d !== null ? d.cachePool : null
        ), d !== null ? O(t, d) : M(), pe(t);
      else
        return l = t.lanes = 536870912, zl(
          e,
          t,
          d !== null ? d.baseLanes | n : n,
          n,
          l
        );
    } else
      d !== null ? (an(t, d.cachePool), O(t, d), Te(), t.memoizedState = null) : (e !== null && an(t, null), M(), Te());
    return Gn(e, t, s, n), t.child;
  }
  function Co(e, t) {
    return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function zl(e, t, n, l, s) {
    var d = Mu();
    return d = d === null ? null : { parent: An._currentValue, pool: d }, t.memoizedState = {
      baseLanes: n,
      cachePool: d
    }, e !== null && an(t, null), M(), pe(t), e !== null && la(e, t, l, !0), t.childLanes = s, null;
  }
  function Wn(e, t) {
    return t = Zc(
      { mode: t.mode, children: t.children },
      e.mode
    ), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function gf(e, t, n) {
    return xi(t, e.child, null, n), e = Wn(t, t.pendingProps), e.flags |= 2, Ve(t), t.memoizedState = null, e;
  }
  function Xc(e, t, n) {
    var l = t.pendingProps, s = (t.flags & 128) !== 0;
    if (t.flags &= -129, e === null) {
      if (Je) {
        if (l.mode === "hidden")
          return e = Wn(t, l), t.lanes = 536870912, Co(null, e);
        if (ne(t), (e = _t) ? (e = py(
          e,
          Cl
        ), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: Jt !== null ? { id: fl, overflow: Gl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = $i(e), n.return = t, t.child = n, Qn = t, _t = null)) : e = null, e === null) throw Ja(t);
        return t.lanes = 536870912, null;
      }
      return Wn(t, l);
    }
    var d = e.memoizedState;
    if (d !== null) {
      var S = d.dehydrated;
      if (ne(t), s)
        if (t.flags & 256)
          t.flags &= -257, t = gf(
            e,
            t,
            n
          );
        else if (t.memoizedState !== null)
          t.child = e.child, t.flags |= 128, t = null;
        else throw Error(y(558));
      else if (Yn || la(e, t, n, !1), s = (n & e.childLanes) !== 0, Yn || s) {
        if (l = sn, l !== null && (S = ol(l, n), S !== 0 && S !== d.retryLane))
          throw d.retryLane = S, Lt(e, S), ri(l, e, S), hf;
        fd(), t = gf(
          e,
          t,
          n
        );
      } else
        e = d.treeContext, _t = ir(S.nextSibling), Qn = t, Je = !0, Xl = null, Cl = !1, e !== null && Vr(t, e), t = Wn(t, l), t.flags |= 4096;
      return t;
    }
    return e = rt(e.child, {
      mode: l.mode,
      children: l.children
    }), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function Ic(e, t) {
    var n = t.ref;
    if (n === null)
      e !== null && e.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(y(284));
      (e === null || e.ref !== n) && (t.flags |= 4194816);
    }
  }
  function Cr(e, t, n, l, s) {
    return Pn(t), n = Fn(
      e,
      t,
      n,
      l,
      void 0,
      s
    ), l = wi(), e !== null && !Yn ? (Er(e, t, s), rl(e, t, s)) : (Je && l && xc(t), t.flags |= 1, Gn(e, t, n, s), t.child);
  }
  function fs(e, t, n, l, s, d) {
    return Pn(t), t.updateQueue = null, n = qr(
      t,
      l,
      n,
      s
    ), ua(e), l = wi(), e !== null && !Yn ? (Er(e, t, d), rl(e, t, d)) : (Je && l && xc(t), t.flags |= 1, Gn(e, t, n, d), t.child);
  }
  function vf(e, t, n, l, s) {
    if (Pn(t), t.stateNode === null) {
      var d = lt, S = n.contextType;
      typeof S == "object" && S !== null && (d = yt(S)), d = new n(l, d), t.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = Iu, t.stateNode = d, d._reactInternals = t, d = t.stateNode, d.props = l, d.state = t.memoizedState, d.refs = {}, xr(t), S = n.contextType, d.context = typeof S == "object" && S !== null ? yt(S) : lt, d.state = t.memoizedState, S = n.getDerivedStateFromProps, typeof S == "function" && (os(
        t,
        n,
        S,
        l
      ), d.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof d.getSnapshotBeforeUpdate == "function" || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (S = d.state, typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount(), S !== d.state && Iu.enqueueReplaceState(d, d.state, null), i(t, l, d, s), ti(), d.state = t.memoizedState), typeof d.componentDidMount == "function" && (t.flags |= 4194308), l = !0;
    } else if (e === null) {
      d = t.stateNode;
      var R = t.memoizedProps, H = iu(n, R);
      d.props = H;
      var j = d.context, re = n.contextType;
      S = lt, typeof re == "object" && re !== null && (S = yt(re));
      var fe = n.getDerivedStateFromProps;
      re = typeof fe == "function" || typeof d.getSnapshotBeforeUpdate == "function", R = t.pendingProps !== R, re || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (R || j !== S) && Bc(
        t,
        d,
        l,
        S
      ), gl = !1;
      var q = t.memoizedState;
      d.state = q, i(t, l, d, s), ti(), j = t.memoizedState, R || q !== j || gl ? (typeof fe == "function" && (os(
        t,
        n,
        fe,
        l
      ), j = t.memoizedState), (H = gl || _o(
        t,
        n,
        H,
        l,
        q,
        j,
        S
      )) ? (re || typeof d.UNSAFE_componentWillMount != "function" && typeof d.componentWillMount != "function" || (typeof d.componentWillMount == "function" && d.componentWillMount(), typeof d.UNSAFE_componentWillMount == "function" && d.UNSAFE_componentWillMount()), typeof d.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof d.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = l, t.memoizedState = j), d.props = l, d.state = j, d.context = S, l = H) : (typeof d.componentDidMount == "function" && (t.flags |= 4194308), l = !1);
    } else {
      d = t.stateNode, Ei(e, t), S = t.memoizedProps, re = iu(n, S), d.props = re, fe = t.pendingProps, q = d.context, j = n.contextType, H = lt, typeof j == "object" && j !== null && (H = yt(j)), R = n.getDerivedStateFromProps, (j = typeof R == "function" || typeof d.getSnapshotBeforeUpdate == "function") || typeof d.UNSAFE_componentWillReceiveProps != "function" && typeof d.componentWillReceiveProps != "function" || (S !== fe || q !== H) && Bc(
        t,
        d,
        l,
        H
      ), gl = !1, q = t.memoizedState, d.state = q, i(t, l, d, s), ti();
      var le = t.memoizedState;
      S !== fe || q !== le || gl || e !== null && e.dependencies !== null && Ka(e.dependencies) ? (typeof R == "function" && (os(
        t,
        n,
        R,
        l
      ), le = t.memoizedState), (re = gl || _o(
        t,
        n,
        re,
        l,
        q,
        le,
        H
      ) || e !== null && e.dependencies !== null && Ka(e.dependencies)) ? (j || typeof d.UNSAFE_componentWillUpdate != "function" && typeof d.componentWillUpdate != "function" || (typeof d.componentWillUpdate == "function" && d.componentWillUpdate(l, le, H), typeof d.UNSAFE_componentWillUpdate == "function" && d.UNSAFE_componentWillUpdate(
        l,
        le,
        H
      )), typeof d.componentDidUpdate == "function" && (t.flags |= 4), typeof d.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof d.componentDidUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), t.memoizedProps = l, t.memoizedState = le), d.props = l, d.state = le, d.context = H, l = re) : (typeof d.componentDidUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof d.getSnapshotBeforeUpdate != "function" || S === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), l = !1);
    }
    return d = l, Ic(e, t), l = (t.flags & 128) !== 0, d || l ? (d = t.stateNode, n = l && typeof n.getDerivedStateFromError != "function" ? null : d.render(), t.flags |= 1, e !== null && l ? (t.child = xi(
      t,
      e.child,
      null,
      s
    ), t.child = xi(
      t,
      null,
      n,
      s
    )) : Gn(e, t, n, s), t.memoizedState = d.state, e = t.child) : e = rl(
      e,
      t,
      s
    ), e;
  }
  function cu(e, t, n, l) {
    return ma(), t.flags |= 256, Gn(e, t, n, l), t.child;
  }
  var Ro = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function No(e) {
    return { baseLanes: e, cachePool: zu() };
  }
  function ds(e, t, n) {
    return e = e !== null ? e.childLanes & ~n : 0, t && (e |= _i), e;
  }
  function hs(e, t, n) {
    var l = t.pendingProps, s = !1, d = (t.flags & 128) !== 0, S;
    if ((S = d) || (S = e !== null && e.memoizedState === null ? !1 : (Le.current & 2) !== 0), S && (s = !0, t.flags &= -129), S = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
      if (Je) {
        if (s ? J(t) : Te(), (e = _t) ? (e = py(
          e,
          Cl
        ), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
          dehydrated: e,
          treeContext: Jt !== null ? { id: fl, overflow: Gl } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = $i(e), n.return = t, t.child = n, Qn = t, _t = null)) : e = null, e === null) throw Ja(t);
        return Jh(e) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var R = l.children;
      return l = l.fallback, s ? (Te(), s = t.mode, R = Zc(
        { mode: "hidden", children: R },
        s
      ), l = Rt(
        l,
        s,
        n,
        null
      ), R.return = t, l.return = t, R.sibling = l, t.child = R, l = t.child, l.memoizedState = No(n), l.childLanes = ds(
        e,
        S,
        n
      ), t.memoizedState = Ro, Co(null, l)) : (J(t), gs(t, R));
    }
    var H = e.memoizedState;
    if (H !== null && (R = H.dehydrated, R !== null)) {
      if (d)
        t.flags & 256 ? (J(t), t.flags &= -257, t = vs(
          e,
          t,
          n
        )) : t.memoizedState !== null ? (Te(), t.child = e.child, t.flags |= 128, t = null) : (Te(), R = l.fallback, s = t.mode, l = Zc(
          { mode: "visible", children: l.children },
          s
        ), R = Rt(
          R,
          s,
          n,
          null
        ), R.flags |= 2, l.return = t, R.return = t, l.sibling = R, t.child = l, xi(
          t,
          e.child,
          null,
          n
        ), l = t.child, l.memoizedState = No(n), l.childLanes = ds(
          e,
          S,
          n
        ), t.memoizedState = Ro, t = Co(null, l));
      else if (J(t), Jh(R)) {
        if (S = R.nextSibling && R.nextSibling.dataset, S) var j = S.dgst;
        S = j, l = Error(y(419)), l.stack = "", l.digest = S, ta({ value: l, source: null, stack: null }), t = vs(
          e,
          t,
          n
        );
      } else if (Yn || la(e, t, n, !1), S = (n & e.childLanes) !== 0, Yn || S) {
        if (S = sn, S !== null && (l = ol(S, n), l !== 0 && l !== H.retryLane))
          throw H.retryLane = l, Lt(e, l), ri(S, e, l), hf;
        Wh(R) || fd(), t = vs(
          e,
          t,
          n
        );
      } else
        Wh(R) ? (t.flags |= 192, t.child = e.child, t = null) : (e = H.treeContext, _t = ir(
          R.nextSibling
        ), Qn = t, Je = !0, Xl = null, Cl = !1, e !== null && Vr(t, e), t = gs(
          t,
          l.children
        ), t.flags |= 4096);
      return t;
    }
    return s ? (Te(), R = l.fallback, s = t.mode, H = e.child, j = H.sibling, l = rt(H, {
      mode: "hidden",
      children: l.children
    }), l.subtreeFlags = H.subtreeFlags & 65011712, j !== null ? R = rt(
      j,
      R
    ) : (R = Rt(
      R,
      s,
      n,
      null
    ), R.flags |= 2), R.return = t, l.return = t, l.sibling = R, t.child = l, Co(null, l), l = t.child, R = e.child.memoizedState, R === null ? R = No(n) : (s = R.cachePool, s !== null ? (H = An._currentValue, s = s.parent !== H ? { parent: H, pool: H } : s) : s = zu(), R = {
      baseLanes: R.baseLanes | n,
      cachePool: s
    }), l.memoizedState = R, l.childLanes = ds(
      e,
      S,
      n
    ), t.memoizedState = Ro, Co(e.child, l)) : (J(t), n = e.child, e = n.sibling, n = rt(n, {
      mode: "visible",
      children: l.children
    }), n.return = t, n.sibling = null, e !== null && (S = t.deletions, S === null ? (t.deletions = [e], t.flags |= 16) : S.push(e)), t.child = n, t.memoizedState = null, n);
  }
  function gs(e, t) {
    return t = Zc(
      { mode: "visible", children: t },
      e.mode
    ), t.return = e, e.child = t;
  }
  function Zc(e, t) {
    return e = Pe(22, e, null, t), e.lanes = 0, e;
  }
  function vs(e, t, n) {
    return xi(t, e.child, null, n), e = gs(
      t,
      t.pendingProps.children
    ), e.flags |= 2, t.memoizedState = null, e;
  }
  function ys(e, t, n) {
    e.lanes |= t;
    var l = e.alternate;
    l !== null && (l.lanes |= t), Pr(e.return, t, n);
  }
  function bs(e, t, n, l, s, d) {
    var S = e.memoizedState;
    S === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: l,
      tail: n,
      tailMode: s,
      treeForkCount: d
    } : (S.isBackwards = t, S.rendering = null, S.renderingStartTime = 0, S.last = l, S.tail = n, S.tailMode = s, S.treeForkCount = d);
  }
  function Zu(e, t, n) {
    var l = t.pendingProps, s = l.revealOrder, d = l.tail;
    l = l.children;
    var S = Le.current, R = (S & 2) !== 0;
    if (R ? (S = S & 1 | 2, t.flags |= 128) : S &= 1, _e(Le, S), Gn(e, t, l, n), l = Je ? Ol : 0, !R && e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13)
          e.memoizedState !== null && ys(e, n, t);
        else if (e.tag === 19)
          ys(e, n, t);
        else if (e.child !== null) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t)
            break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    switch (s) {
      case "forwards":
        for (n = t.child, s = null; n !== null; )
          e = n.alternate, e !== null && at(e) === null && (s = n), n = n.sibling;
        n = s, n === null ? (s = t.child, t.child = null) : (s = n.sibling, n.sibling = null), bs(
          t,
          !1,
          s,
          n,
          d,
          l
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n = null, s = t.child, t.child = null; s !== null; ) {
          if (e = s.alternate, e !== null && at(e) === null) {
            t.child = s;
            break;
          }
          e = s.sibling, s.sibling = n, n = s, s = e;
        }
        bs(
          t,
          !0,
          n,
          null,
          d,
          l
        );
        break;
      case "together":
        bs(
          t,
          !1,
          null,
          null,
          void 0,
          l
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function rl(e, t, n) {
    if (e !== null && (t.dependencies = e.dependencies), Pc |= t.lanes, (n & t.childLanes) === 0)
      if (e !== null) {
        if (la(
          e,
          t,
          n,
          !1
        ), (n & t.childLanes) === 0)
          return null;
      } else return null;
    if (e !== null && t.child !== e.child)
      throw Error(y(153));
    if (t.child !== null) {
      for (e = t.child, n = rt(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
        e = e.sibling, n = n.sibling = rt(e, e.pendingProps), n.return = t;
      n.sibling = null;
    }
    return t.child;
  }
  function ms(e, t) {
    return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && Ka(e)));
  }
  function p0(e, t, n) {
    switch (t.tag) {
      case 3:
        kl(t, t.stateNode.containerInfo), na(t, An, e.memoizedState.cache), ma();
        break;
      case 27:
      case 5:
        $e(t);
        break;
      case 4:
        kl(t, t.stateNode.containerInfo);
        break;
      case 10:
        na(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, ne(t), null;
        break;
      case 13:
        var l = t.memoizedState;
        if (l !== null)
          return l.dehydrated !== null ? (J(t), t.flags |= 128, null) : (n & t.child.childLanes) !== 0 ? hs(e, t, n) : (J(t), e = rl(
            e,
            t,
            n
          ), e !== null ? e.sibling : null);
        J(t);
        break;
      case 19:
        var s = (e.flags & 128) !== 0;
        if (l = (n & t.childLanes) !== 0, l || (la(
          e,
          t,
          n,
          !1
        ), l = (n & t.childLanes) !== 0), s) {
          if (l)
            return Zu(
              e,
              t,
              n
            );
          t.flags |= 128;
        }
        if (s = t.memoizedState, s !== null && (s.rendering = null, s.tail = null, s.lastEffect = null), _e(Le, Le.current), l) break;
        return null;
      case 22:
        return t.lanes = 0, uu(
          e,
          t,
          n,
          t.pendingProps
        );
      case 24:
        na(t, An, e.memoizedState.cache);
    }
    return rl(e, t, n);
  }
  function gv(e, t, n) {
    if (e !== null)
      if (e.memoizedProps !== t.pendingProps)
        Yn = !0;
      else {
        if (!ms(e, n) && (t.flags & 128) === 0)
          return Yn = !1, p0(
            e,
            t,
            n
          );
        Yn = (e.flags & 131072) !== 0;
      }
    else
      Yn = !1, Je && (t.flags & 1048576) !== 0 && Sc(t, Ol, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        e: {
          var l = t.pendingProps;
          if (e = Rl(t.elementType), t.type = e, typeof e == "function")
            Al(e) ? (l = iu(e, l), t.tag = 1, t = vf(
              null,
              t,
              e,
              l,
              n
            )) : (t.tag = 0, t = Cr(
              null,
              t,
              e,
              l,
              n
            ));
          else {
            if (e != null) {
              var s = e.$$typeof;
              if (s === ye) {
                t.tag = 11, t = Yc(
                  null,
                  t,
                  e,
                  l,
                  n
                );
                break e;
              } else if (s === Me) {
                t.tag = 14, t = Gc(
                  null,
                  t,
                  e,
                  l,
                  n
                );
                break e;
              }
            }
            throw t = it(e) || e, Error(y(306, t, ""));
          }
        }
        return t;
      case 0:
        return Cr(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 1:
        return l = t.type, s = iu(
          l,
          t.pendingProps
        ), vf(
          e,
          t,
          l,
          s,
          n
        );
      case 3:
        e: {
          if (kl(
            t,
            t.stateNode.containerInfo
          ), e === null) throw Error(y(387));
          l = t.pendingProps;
          var d = t.memoizedState;
          s = d.element, Ei(e, t), i(t, l, null, n);
          var S = t.memoizedState;
          if (l = S.cache, na(t, An, l), l !== d.cache && Il(
            t,
            [An],
            n,
            !0
          ), ti(), l = S.element, d.isDehydrated)
            if (d = {
              element: l,
              isDehydrated: !1,
              cache: S.cache
            }, t.updateQueue.baseState = d, t.memoizedState = d, t.flags & 256) {
              t = cu(
                e,
                t,
                l,
                n
              );
              break e;
            } else if (l !== s) {
              s = ll(
                Error(y(424)),
                t
              ), ta(s), t = cu(
                e,
                t,
                l,
                n
              );
              break e;
            } else {
              switch (e = t.stateNode.containerInfo, e.nodeType) {
                case 9:
                  e = e.body;
                  break;
                default:
                  e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
              }
              for (_t = ir(e.firstChild), Qn = t, Je = !0, Xl = null, Cl = !0, n = Oc(
                t,
                null,
                l,
                n
              ), t.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (ma(), l === s) {
              t = rl(
                e,
                t,
                n
              );
              break e;
            }
            Gn(e, t, l, n);
          }
          t = t.child;
        }
        return t;
      case 26:
        return Ic(e, t), e === null ? (n = Ay(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = n : Je || (n = t.type, e = t.pendingProps, l = md(
          en.current
        ).createElement(n), l[nt] = t, l[on] = e, ca(l, n, e), Vt(l), t.stateNode = l) : t.memoizedState = Ay(
          t.type,
          e.memoizedProps,
          t.pendingProps,
          e.memoizedState
        ), null;
      case 27:
        return $e(t), e === null && Je && (l = t.stateNode = xy(
          t.type,
          t.pendingProps,
          en.current
        ), Qn = t, Cl = !0, s = _t, qc(t.type) ? (Kh = s, _t = ir(l.firstChild)) : _t = s), Gn(
          e,
          t,
          t.pendingProps.children,
          n
        ), Ic(e, t), e === null && (t.flags |= 4194304), t.child;
      case 5:
        return e === null && Je && ((s = l = _t) && (l = J0(
          l,
          t.type,
          t.pendingProps,
          Cl
        ), l !== null ? (t.stateNode = l, Qn = t, _t = ir(l.firstChild), Cl = !1, s = !0) : s = !1), s || Ja(t)), $e(t), s = t.type, d = t.pendingProps, S = e !== null ? e.memoizedProps : null, l = d.children, Vh(s, d) ? l = null : S !== null && Vh(s, S) && (t.flags |= 32), t.memoizedState !== null && (s = Fn(
          e,
          t,
          Lu,
          null,
          null,
          n
        ), Nf._currentValue = s), Ic(e, t), Gn(e, t, l, n), t.child;
      case 6:
        return e === null && Je && ((e = n = _t) && (n = K0(
          n,
          t.pendingProps,
          Cl
        ), n !== null ? (t.stateNode = n, Qn = t, _t = null, e = !0) : e = !1), e || Ja(t)), null;
      case 13:
        return hs(e, t, n);
      case 4:
        return kl(
          t,
          t.stateNode.containerInfo
        ), l = t.pendingProps, e === null ? t.child = xi(
          t,
          null,
          l,
          n
        ) : Gn(e, t, l, n), t.child;
      case 11:
        return Yc(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 7:
        return Gn(
          e,
          t,
          t.pendingProps,
          n
        ), t.child;
      case 8:
        return Gn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 12:
        return Gn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 10:
        return l = t.pendingProps, na(t, t.type, l.value), Gn(e, t, l.children, n), t.child;
      case 9:
        return s = t.type._context, l = t.pendingProps.children, Pn(t), s = yt(s), l = l(s), t.flags |= 1, Gn(e, t, l, n), t.child;
      case 14:
        return Gc(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 15:
        return Oo(
          e,
          t,
          t.type,
          t.pendingProps,
          n
        );
      case 19:
        return Zu(e, t, n);
      case 31:
        return Xc(e, t, n);
      case 22:
        return uu(
          e,
          t,
          n,
          t.pendingProps
        );
      case 24:
        return Pn(t), l = yt(An), e === null ? (s = Mu(), s === null && (s = sn, d = Ec(), s.pooledCache = d, d.refCount++, d !== null && (s.pooledCacheLanes |= n), s = d), t.memoizedState = { parent: l, cache: s }, xr(t), na(t, An, s)) : ((e.lanes & n) !== 0 && (Ei(e, t), i(t, null, null, n), ti()), s = e.memoizedState, d = t.memoizedState, s.parent !== l ? (s = { parent: l, cache: l }, t.memoizedState = s, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = s), na(t, An, l)) : (l = d.cache, na(t, An, l), l !== s.cache && Il(
          t,
          [An],
          n,
          !0
        ))), Gn(
          e,
          t,
          t.pendingProps.children,
          n
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(y(156, t.tag));
  }
  function Vu(e) {
    e.flags |= 4;
  }
  function mh(e, t, n, l, s) {
    if ((t = (e.mode & 32) !== 0) && (t = !1), t) {
      if (e.flags |= 16777216, (s & 335544128) === s)
        if (e.stateNode.complete) e.flags |= 8192;
        else if (Gv()) e.flags |= 8192;
        else
          throw Bn = Sr, er;
    } else e.flags &= -16777217;
  }
  function vv(e, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      e.flags &= -16777217;
    else if (e.flags |= 16777216, !Ny(t))
      if (Gv()) e.flags |= 8192;
      else
        throw Bn = Sr, er;
  }
  function ld(e, t) {
    t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? Fa() : 536870912, e.lanes |= t, xs |= t);
  }
  function yf(e, t) {
    if (!Je)
      switch (e.tailMode) {
        case "hidden":
          t = e.tail;
          for (var n = null; t !== null; )
            t.alternate !== null && (n = t), t = t.sibling;
          n === null ? e.tail = null : n.sibling = null;
          break;
        case "collapsed":
          n = e.tail;
          for (var l = null; n !== null; )
            n.alternate !== null && (l = n), n = n.sibling;
          l === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : l.sibling = null;
      }
  }
  function _n(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, n = 0, l = 0;
    if (t)
      for (var s = e.child; s !== null; )
        n |= s.lanes | s.childLanes, l |= s.subtreeFlags & 65011712, l |= s.flags & 65011712, s.return = e, s = s.sibling;
    else
      for (s = e.child; s !== null; )
        n |= s.lanes | s.childLanes, l |= s.subtreeFlags, l |= s.flags, s.return = e, s = s.sibling;
    return e.subtreeFlags |= l, e.childLanes = n, t;
  }
  function T0(e, t, n) {
    var l = t.pendingProps;
    switch (_u(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return _n(t), null;
      case 1:
        return _n(t), null;
      case 3:
        return n = t.stateNode, l = null, e !== null && (l = e.memoizedState.cache), t.memoizedState.cache !== l && (t.flags |= 2048), hl(An), Xn(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Oa(t) ? Vu(t) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Tr())), _n(t), null;
      case 26:
        var s = t.type, d = t.memoizedState;
        return e === null ? (Vu(t), d !== null ? (_n(t), vv(t, d)) : (_n(t), mh(
          t,
          s,
          null,
          l,
          n
        ))) : d ? d !== e.memoizedState ? (Vu(t), _n(t), vv(t, d)) : (_n(t), t.flags &= -16777217) : (e = e.memoizedProps, e !== l && Vu(t), _n(t), mh(
          t,
          s,
          e,
          l,
          n
        )), null;
      case 27:
        if (Ci(t), n = en.current, s = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== l && Vu(t);
        else {
          if (!l) {
            if (t.stateNode === null)
              throw Error(y(166));
            return _n(t), null;
          }
          e = Ne.current, Oa(t) ? ea(t) : (e = xy(s, l, n), t.stateNode = e, Vu(t));
        }
        return _n(t), null;
      case 5:
        if (Ci(t), s = t.type, e !== null && t.stateNode != null)
          e.memoizedProps !== l && Vu(t);
        else {
          if (!l) {
            if (t.stateNode === null)
              throw Error(y(166));
            return _n(t), null;
          }
          if (d = Ne.current, Oa(t))
            ea(t);
          else {
            var S = md(
              en.current
            );
            switch (d) {
              case 1:
                d = S.createElementNS(
                  "http://www.w3.org/2000/svg",
                  s
                );
                break;
              case 2:
                d = S.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  s
                );
                break;
              default:
                switch (s) {
                  case "svg":
                    d = S.createElementNS(
                      "http://www.w3.org/2000/svg",
                      s
                    );
                    break;
                  case "math":
                    d = S.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      s
                    );
                    break;
                  case "script":
                    d = S.createElement("div"), d.innerHTML = "<script><\/script>", d = d.removeChild(
                      d.firstChild
                    );
                    break;
                  case "select":
                    d = typeof l.is == "string" ? S.createElement("select", {
                      is: l.is
                    }) : S.createElement("select"), l.multiple ? d.multiple = !0 : l.size && (d.size = l.size);
                    break;
                  default:
                    d = typeof l.is == "string" ? S.createElement(s, { is: l.is }) : S.createElement(s);
                }
            }
            d[nt] = t, d[on] = l;
            e: for (S = t.child; S !== null; ) {
              if (S.tag === 5 || S.tag === 6)
                d.appendChild(S.stateNode);
              else if (S.tag !== 4 && S.tag !== 27 && S.child !== null) {
                S.child.return = S, S = S.child;
                continue;
              }
              if (S === t) break e;
              for (; S.sibling === null; ) {
                if (S.return === null || S.return === t)
                  break e;
                S = S.return;
              }
              S.sibling.return = S.return, S = S.sibling;
            }
            t.stateNode = d;
            e: switch (ca(d, s, l), s) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                l = !!l.autoFocus;
                break e;
              case "img":
                l = !0;
                break e;
              default:
                l = !1;
            }
            l && Vu(t);
          }
        }
        return _n(t), mh(
          t,
          t.type,
          e === null ? null : e.memoizedProps,
          t.pendingProps,
          n
        ), null;
      case 6:
        if (e && t.stateNode != null)
          e.memoizedProps !== l && Vu(t);
        else {
          if (typeof l != "string" && t.stateNode === null)
            throw Error(y(166));
          if (e = en.current, Oa(t)) {
            if (e = t.stateNode, n = t.memoizedProps, l = null, s = Qn, s !== null)
              switch (s.tag) {
                case 27:
                case 5:
                  l = s.memoizedProps;
              }
            e[nt] = t, e = !!(e.nodeValue === n || l !== null && l.suppressHydrationWarning === !0 || fy(e.nodeValue, n)), e || Ja(t, !0);
          } else
            e = md(e).createTextNode(
              l
            ), e[nt] = t, t.stateNode = e;
        }
        return _n(t), null;
      case 31:
        if (n = t.memoizedState, e === null || e.memoizedState !== null) {
          if (l = Oa(t), n !== null) {
            if (e === null) {
              if (!l) throw Error(y(318));
              if (e = t.memoizedState, e = e !== null ? e.dehydrated : null, !e) throw Error(y(557));
              e[nt] = t;
            } else
              ma(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            _n(t), e = !1;
          } else
            n = Tr(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
          if (!e)
            return t.flags & 256 ? (Ve(t), t) : (Ve(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(y(558));
        }
        return _n(t), null;
      case 13:
        if (l = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          if (s = Oa(t), l !== null && l.dehydrated !== null) {
            if (e === null) {
              if (!s) throw Error(y(318));
              if (s = t.memoizedState, s = s !== null ? s.dehydrated : null, !s) throw Error(y(317));
              s[nt] = t;
            } else
              ma(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            _n(t), s = !1;
          } else
            s = Tr(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = s), s = !0;
          if (!s)
            return t.flags & 256 ? (Ve(t), t) : (Ve(t), null);
        }
        return Ve(t), (t.flags & 128) !== 0 ? (t.lanes = n, t) : (n = l !== null, e = e !== null && e.memoizedState !== null, n && (l = t.child, s = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (s = l.alternate.memoizedState.cachePool.pool), d = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (d = l.memoizedState.cachePool.pool), d !== s && (l.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), ld(t, t.updateQueue), _n(t), null);
      case 4:
        return Xn(), e === null && Yh(t.stateNode.containerInfo), _n(t), null;
      case 10:
        return hl(t.type), _n(t), null;
      case 19:
        if (tt(Le), l = t.memoizedState, l === null) return _n(t), null;
        if (s = (t.flags & 128) !== 0, d = l.rendering, d === null)
          if (s) yf(l, !1);
          else {
            if (Jn !== 0 || e !== null && (e.flags & 128) !== 0)
              for (e = t.child; e !== null; ) {
                if (d = at(e), d !== null) {
                  for (t.flags |= 128, yf(l, !1), e = d.updateQueue, t.updateQueue = e, ld(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null; )
                    En(n, e), n = n.sibling;
                  return _e(
                    Le,
                    Le.current & 1 | 2
                  ), Je && _a(t, l.treeForkCount), t.child;
                }
                e = e.sibling;
              }
            l.tail !== null && Ue() > cd && (t.flags |= 128, s = !0, yf(l, !1), t.lanes = 4194304);
          }
        else {
          if (!s)
            if (e = at(d), e !== null) {
              if (t.flags |= 128, s = !0, e = e.updateQueue, t.updateQueue = e, ld(t, e), yf(l, !0), l.tail === null && l.tailMode === "hidden" && !d.alternate && !Je)
                return _n(t), null;
            } else
              2 * Ue() - l.renderingStartTime > cd && n !== 536870912 && (t.flags |= 128, s = !0, yf(l, !1), t.lanes = 4194304);
          l.isBackwards ? (d.sibling = t.child, t.child = d) : (e = l.last, e !== null ? e.sibling = d : t.child = d, l.last = d);
        }
        return l.tail !== null ? (e = l.tail, l.rendering = e, l.tail = e.sibling, l.renderingStartTime = Ue(), e.sibling = null, n = Le.current, _e(
          Le,
          s ? n & 1 | 2 : n & 1
        ), Je && _a(t, l.treeForkCount), e) : (_n(t), null);
      case 22:
      case 23:
        return Ve(t), Z(), l = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== l && (t.flags |= 8192) : l && (t.flags |= 8192), l ? (n & 536870912) !== 0 && (t.flags & 128) === 0 && (_n(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : _n(t), n = t.updateQueue, n !== null && ld(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== n && (t.flags |= 2048), e !== null && tt(qa), null;
      case 24:
        return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), hl(An), _n(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(y(156, t.tag));
  }
  function S0(e, t) {
    switch (_u(t), t.tag) {
      case 1:
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 3:
        return hl(An), Xn(), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return Ci(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (Ve(t), t.alternate === null)
            throw Error(y(340));
          ma();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 13:
        if (Ve(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(y(340));
          ma();
        }
        return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 19:
        return tt(Le), null;
      case 4:
        return Xn(), null;
      case 10:
        return hl(t.type), null;
      case 22:
      case 23:
        return Ve(t), Z(), e !== null && tt(qa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
      case 24:
        return hl(An), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function yv(e, t) {
    switch (_u(t), t.tag) {
      case 3:
        hl(An), Xn();
        break;
      case 26:
      case 27:
      case 5:
        Ci(t);
        break;
      case 4:
        Xn();
        break;
      case 31:
        t.memoizedState !== null && Ve(t);
        break;
      case 13:
        Ve(t);
        break;
      case 19:
        tt(Le);
        break;
      case 10:
        hl(t.type);
        break;
      case 22:
      case 23:
        Ve(t), Z(), e !== null && tt(qa);
        break;
      case 24:
        hl(An);
    }
  }
  function bf(e, t) {
    try {
      var n = t.updateQueue, l = n !== null ? n.lastEffect : null;
      if (l !== null) {
        var s = l.next;
        n = s;
        do {
          if ((n.tag & e) === e) {
            l = void 0;
            var d = n.create, S = n.inst;
            l = d(), S.destroy = l;
          }
          n = n.next;
        } while (n !== s);
      }
    } catch (R) {
      $t(t, t.return, R);
    }
  }
  function Vc(e, t, n) {
    try {
      var l = t.updateQueue, s = l !== null ? l.lastEffect : null;
      if (s !== null) {
        var d = s.next;
        l = d;
        do {
          if ((l.tag & e) === e) {
            var S = l.inst, R = S.destroy;
            if (R !== void 0) {
              S.destroy = void 0, s = t;
              var H = n, j = R;
              try {
                j();
              } catch (re) {
                $t(
                  s,
                  H,
                  re
                );
              }
            }
          }
          l = l.next;
        } while (l !== d);
      }
    } catch (re) {
      $t(t, t.return, re);
    }
  }
  function bv(e) {
    var t = e.updateQueue;
    if (t !== null) {
      var n = e.stateNode;
      try {
        h(t, n);
      } catch (l) {
        $t(e, e.return, l);
      }
    }
  }
  function mv(e, t, n) {
    n.props = iu(
      e.type,
      e.memoizedProps
    ), n.state = e.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (l) {
      $t(e, t, l);
    }
  }
  function mf(e, t) {
    try {
      var n = e.ref;
      if (n !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var l = e.stateNode;
            break;
          case 30:
            l = e.stateNode;
            break;
          default:
            l = e.stateNode;
        }
        typeof n == "function" ? e.refCleanup = n(l) : n.current = l;
      }
    } catch (s) {
      $t(e, t, s);
    }
  }
  function ou(e, t) {
    var n = e.ref, l = e.refCleanup;
    if (n !== null)
      if (typeof l == "function")
        try {
          l();
        } catch (s) {
          $t(e, t, s);
        } finally {
          e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (s) {
          $t(e, t, s);
        }
      else n.current = null;
  }
  function pv(e) {
    var t = e.type, n = e.memoizedProps, l = e.stateNode;
    try {
      e: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && l.focus();
          break e;
        case "img":
          n.src ? l.src = n.src : n.srcSet && (l.srcset = n.srcSet);
      }
    } catch (s) {
      $t(e, e.return, s);
    }
  }
  function ph(e, t, n) {
    try {
      var l = e.stateNode;
      I0(l, e.type, n, t), l[on] = t;
    } catch (s) {
      $t(e, e.return, s);
    }
  }
  function Tv(e) {
    return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && qc(e.type) || e.tag === 4;
  }
  function Th(e) {
    e: for (; ; ) {
      for (; e.sibling === null; ) {
        if (e.return === null || Tv(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
        if (e.tag === 27 && qc(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(e.flags & 2)) return e.stateNode;
    }
  }
  function Sh(e, t, n) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Bt));
    else if (l !== 4 && (l === 27 && qc(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null))
      for (Sh(e, t, n), e = e.sibling; e !== null; )
        Sh(e, t, n), e = e.sibling;
  }
  function ad(e, t, n) {
    var l = e.tag;
    if (l === 5 || l === 6)
      e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
    else if (l !== 4 && (l === 27 && qc(e.type) && (n = e.stateNode), e = e.child, e !== null))
      for (ad(e, t, n), e = e.sibling; e !== null; )
        ad(e, t, n), e = e.sibling;
  }
  function Sv(e) {
    var t = e.stateNode, n = e.memoizedProps;
    try {
      for (var l = e.type, s = t.attributes; s.length; )
        t.removeAttributeNode(s[0]);
      ca(t, l, n), t[nt] = e, t[on] = n;
    } catch (d) {
      $t(e, e.return, d);
    }
  }
  var Qu = !1, bl = !1, xh = !1, xv = typeof WeakSet == "function" ? WeakSet : Set, Vl = null;
  function x0(e, t) {
    if (e = e.containerInfo, Ih = Ad, e = To(e), yi(e)) {
      if ("selectionStart" in e)
        var n = {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      else
        e: {
          n = (n = e.ownerDocument) && n.defaultView || window;
          var l = n.getSelection && n.getSelection();
          if (l && l.rangeCount !== 0) {
            n = l.anchorNode;
            var s = l.anchorOffset, d = l.focusNode;
            l = l.focusOffset;
            try {
              n.nodeType, d.nodeType;
            } catch {
              n = null;
              break e;
            }
            var S = 0, R = -1, H = -1, j = 0, re = 0, fe = e, q = null;
            t: for (; ; ) {
              for (var le; fe !== n || s !== 0 && fe.nodeType !== 3 || (R = S + s), fe !== d || l !== 0 && fe.nodeType !== 3 || (H = S + l), fe.nodeType === 3 && (S += fe.nodeValue.length), (le = fe.firstChild) !== null; )
                q = fe, fe = le;
              for (; ; ) {
                if (fe === e) break t;
                if (q === n && ++j === s && (R = S), q === d && ++re === l && (H = S), (le = fe.nextSibling) !== null) break;
                fe = q, q = fe.parentNode;
              }
              fe = le;
            }
            n = R === -1 || H === -1 ? null : { start: R, end: H };
          } else n = null;
        }
      n = n || { start: 0, end: 0 };
    } else n = null;
    for (Zh = { focusedElem: e, selectionRange: n }, Ad = !1, Vl = t; Vl !== null; )
      if (t = Vl, e = t.child, (t.subtreeFlags & 1028) !== 0 && e !== null)
        e.return = t, Vl = e;
      else
        for (; Vl !== null; ) {
          switch (t = Vl, d = t.alternate, e = t.flags, t.tag) {
            case 0:
              if ((e & 4) !== 0 && (e = t.updateQueue, e = e !== null ? e.events : null, e !== null))
                for (n = 0; n < e.length; n++)
                  s = e[n], s.ref.impl = s.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((e & 1024) !== 0 && d !== null) {
                e = void 0, n = t, s = d.memoizedProps, d = d.memoizedState, l = n.stateNode;
                try {
                  var ze = iu(
                    n.type,
                    s
                  );
                  e = l.getSnapshotBeforeUpdate(
                    ze,
                    d
                  ), l.__reactInternalSnapshotBeforeUpdate = e;
                } catch (Ge) {
                  $t(
                    n,
                    n.return,
                    Ge
                  );
                }
              }
              break;
            case 3:
              if ((e & 1024) !== 0) {
                if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9)
                  Ph(e);
                else if (n === 1)
                  switch (e.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      Ph(e);
                      break;
                    default:
                      e.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((e & 1024) !== 0) throw Error(y(163));
          }
          if (e = t.sibling, e !== null) {
            e.return = t.return, Vl = e;
            break;
          }
          Vl = t.return;
        }
  }
  function Ev(e, t, n) {
    var l = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        Wu(e, n), l & 4 && bf(5, n);
        break;
      case 1:
        if (Wu(e, n), l & 4)
          if (e = n.stateNode, t === null)
            try {
              e.componentDidMount();
            } catch (S) {
              $t(n, n.return, S);
            }
          else {
            var s = iu(
              n.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              e.componentDidUpdate(
                s,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            } catch (S) {
              $t(
                n,
                n.return,
                S
              );
            }
          }
        l & 64 && bv(n), l & 512 && mf(n, n.return);
        break;
      case 3:
        if (Wu(e, n), l & 64 && (e = n.updateQueue, e !== null)) {
          if (t = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                t = n.child.stateNode;
                break;
              case 1:
                t = n.child.stateNode;
            }
          try {
            h(e, t);
          } catch (S) {
            $t(n, n.return, S);
          }
        }
        break;
      case 27:
        t === null && l & 4 && Sv(n);
      case 26:
      case 5:
        Wu(e, n), t === null && l & 4 && pv(n), l & 512 && mf(n, n.return);
        break;
      case 12:
        Wu(e, n);
        break;
      case 31:
        Wu(e, n), l & 4 && _v(e, n);
        break;
      case 13:
        Wu(e, n), l & 4 && Ov(e, n), l & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = M0.bind(
          null,
          n
        ), j0(e, n))));
        break;
      case 22:
        if (l = n.memoizedState !== null || Qu, !l) {
          t = t !== null && t.memoizedState !== null || bl, s = Qu;
          var d = bl;
          Qu = l, (bl = t) && !d ? Ju(
            e,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : Wu(e, n), Qu = s, bl = d;
        }
        break;
      case 30:
        break;
      default:
        Wu(e, n);
    }
  }
  function wv(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, wv(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && $n(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  var zn = null, ni = !1;
  function Pu(e, t, n) {
    for (n = n.child; n !== null; )
      Av(e, t, n), n = n.sibling;
  }
  function Av(e, t, n) {
    if (Zn && typeof Zn.onCommitFiberUnmount == "function")
      try {
        Zn.onCommitFiberUnmount(Wl, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        bl || ou(n, t), Pu(
          e,
          t,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        bl || ou(n, t);
        var l = zn, s = ni;
        qc(n.type) && (zn = n.stateNode, ni = !1), Pu(
          e,
          t,
          n
        ), Of(n.stateNode), zn = l, ni = s;
        break;
      case 5:
        bl || ou(n, t);
      case 6:
        if (l = zn, s = ni, zn = null, Pu(
          e,
          t,
          n
        ), zn = l, ni = s, zn !== null)
          if (ni)
            try {
              (zn.nodeType === 9 ? zn.body : zn.nodeName === "HTML" ? zn.ownerDocument.body : zn).removeChild(n.stateNode);
            } catch (d) {
              $t(
                n,
                t,
                d
              );
            }
          else
            try {
              zn.removeChild(n.stateNode);
            } catch (d) {
              $t(
                n,
                t,
                d
              );
            }
        break;
      case 18:
        zn !== null && (ni ? (e = zn, by(
          e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
          n.stateNode
        ), Ns(e)) : by(zn, n.stateNode));
        break;
      case 4:
        l = zn, s = ni, zn = n.stateNode.containerInfo, ni = !0, Pu(
          e,
          t,
          n
        ), zn = l, ni = s;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Vc(2, n, t), bl || Vc(4, n, t), Pu(
          e,
          t,
          n
        );
        break;
      case 1:
        bl || (ou(n, t), l = n.stateNode, typeof l.componentWillUnmount == "function" && mv(
          n,
          t,
          l
        )), Pu(
          e,
          t,
          n
        );
        break;
      case 21:
        Pu(
          e,
          t,
          n
        );
        break;
      case 22:
        bl = (l = bl) || n.memoizedState !== null, Pu(
          e,
          t,
          n
        ), bl = l;
        break;
      default:
        Pu(
          e,
          t,
          n
        );
    }
  }
  function _v(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
      e = e.dehydrated;
      try {
        Ns(e);
      } catch (n) {
        $t(t, t.return, n);
      }
    }
  }
  function Ov(e, t) {
    if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
      try {
        Ns(e);
      } catch (n) {
        $t(t, t.return, n);
      }
  }
  function E0(e) {
    switch (e.tag) {
      case 31:
      case 13:
      case 19:
        var t = e.stateNode;
        return t === null && (t = e.stateNode = new xv()), t;
      case 22:
        return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new xv()), t;
      default:
        throw Error(y(435, e.tag));
    }
  }
  function id(e, t) {
    var n = E0(e);
    t.forEach(function(l) {
      if (!n.has(l)) {
        n.add(l);
        var s = z0.bind(null, e, l);
        l.then(s, s);
      }
    });
  }
  function li(e, t) {
    var n = t.deletions;
    if (n !== null)
      for (var l = 0; l < n.length; l++) {
        var s = n[l], d = e, S = t, R = S;
        e: for (; R !== null; ) {
          switch (R.tag) {
            case 27:
              if (qc(R.type)) {
                zn = R.stateNode, ni = !1;
                break e;
              }
              break;
            case 5:
              zn = R.stateNode, ni = !1;
              break e;
            case 3:
            case 4:
              zn = R.stateNode.containerInfo, ni = !0;
              break e;
          }
          R = R.return;
        }
        if (zn === null) throw Error(y(160));
        Av(d, S, s), zn = null, ni = !1, d = s.alternate, d !== null && (d.return = null), s.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        Cv(t, e), t = t.sibling;
  }
  var Rr = null;
  function Cv(e, t) {
    var n = e.alternate, l = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        li(t, e), ai(e), l & 4 && (Vc(3, e, e.return), bf(3, e), Vc(5, e, e.return));
        break;
      case 1:
        li(t, e), ai(e), l & 512 && (bl || n === null || ou(n, n.return)), l & 64 && Qu && (e = e.updateQueue, e !== null && (l = e.callbacks, l !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? l : n.concat(l))));
        break;
      case 26:
        var s = Rr;
        if (li(t, e), ai(e), l & 512 && (bl || n === null || ou(n, n.return)), l & 4) {
          var d = n !== null ? n.memoizedState : null;
          if (l = e.memoizedState, n === null)
            if (l === null)
              if (e.stateNode === null) {
                e: {
                  l = e.type, n = e.memoizedProps, s = s.ownerDocument || s;
                  t: switch (l) {
                    case "title":
                      d = s.getElementsByTagName("title")[0], (!d || d[Ea] || d[nt] || d.namespaceURI === "http://www.w3.org/2000/svg" || d.hasAttribute("itemprop")) && (d = s.createElement(l), s.head.insertBefore(
                        d,
                        s.querySelector("head > title")
                      )), ca(d, l, n), d[nt] = e, Vt(d), l = d;
                      break e;
                    case "link":
                      var S = Cy(
                        "link",
                        "href",
                        s
                      ).get(l + (n.href || ""));
                      if (S) {
                        for (var R = 0; R < S.length; R++)
                          if (d = S[R], d.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && d.getAttribute("rel") === (n.rel == null ? null : n.rel) && d.getAttribute("title") === (n.title == null ? null : n.title) && d.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
                            S.splice(R, 1);
                            break t;
                          }
                      }
                      d = s.createElement(l), ca(d, l, n), s.head.appendChild(d);
                      break;
                    case "meta":
                      if (S = Cy(
                        "meta",
                        "content",
                        s
                      ).get(l + (n.content || ""))) {
                        for (R = 0; R < S.length; R++)
                          if (d = S[R], d.getAttribute("content") === (n.content == null ? null : "" + n.content) && d.getAttribute("name") === (n.name == null ? null : n.name) && d.getAttribute("property") === (n.property == null ? null : n.property) && d.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && d.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
                            S.splice(R, 1);
                            break t;
                          }
                      }
                      d = s.createElement(l), ca(d, l, n), s.head.appendChild(d);
                      break;
                    default:
                      throw Error(y(468, l));
                  }
                  d[nt] = e, Vt(d), l = d;
                }
                e.stateNode = l;
              } else
                Ry(
                  s,
                  e.type,
                  e.stateNode
                );
            else
              e.stateNode = Oy(
                s,
                l,
                e.memoizedProps
              );
          else
            d !== l ? (d === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : d.count--, l === null ? Ry(
              s,
              e.type,
              e.stateNode
            ) : Oy(
              s,
              l,
              e.memoizedProps
            )) : l === null && e.stateNode !== null && ph(
              e,
              e.memoizedProps,
              n.memoizedProps
            );
        }
        break;
      case 27:
        li(t, e), ai(e), l & 512 && (bl || n === null || ou(n, n.return)), n !== null && l & 4 && ph(
          e,
          e.memoizedProps,
          n.memoizedProps
        );
        break;
      case 5:
        if (li(t, e), ai(e), l & 512 && (bl || n === null || ou(n, n.return)), e.flags & 32) {
          s = e.stateNode;
          try {
            Ee(s, "");
          } catch (ze) {
            $t(e, e.return, ze);
          }
        }
        l & 4 && e.stateNode != null && (s = e.memoizedProps, ph(
          e,
          s,
          n !== null ? n.memoizedProps : s
        )), l & 1024 && (xh = !0);
        break;
      case 6:
        if (li(t, e), ai(e), l & 4) {
          if (e.stateNode === null)
            throw Error(y(162));
          l = e.memoizedProps, n = e.stateNode;
          try {
            n.nodeValue = l;
          } catch (ze) {
            $t(e, e.return, ze);
          }
        }
        break;
      case 3:
        if (Sd = null, s = Rr, Rr = pd(t.containerInfo), li(t, e), Rr = s, ai(e), l & 4 && n !== null && n.memoizedState.isDehydrated)
          try {
            Ns(t.containerInfo);
          } catch (ze) {
            $t(e, e.return, ze);
          }
        xh && (xh = !1, Rv(e));
        break;
      case 4:
        l = Rr, Rr = pd(
          e.stateNode.containerInfo
        ), li(t, e), ai(e), Rr = l;
        break;
      case 12:
        li(t, e), ai(e);
        break;
      case 31:
        li(t, e), ai(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, id(e, l)));
        break;
      case 13:
        li(t, e), ai(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (ud = Ue()), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, id(e, l)));
        break;
      case 22:
        s = e.memoizedState !== null;
        var H = n !== null && n.memoizedState !== null, j = Qu, re = bl;
        if (Qu = j || s, bl = re || H, li(t, e), bl = re, Qu = j, ai(e), l & 8192)
          e: for (t = e.stateNode, t._visibility = s ? t._visibility & -2 : t._visibility | 1, s && (n === null || H || Qu || bl || Mo(e)), n = null, t = e; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (n === null) {
                H = n = t;
                try {
                  if (d = H.stateNode, s)
                    S = d.style, typeof S.setProperty == "function" ? S.setProperty("display", "none", "important") : S.display = "none";
                  else {
                    R = H.stateNode;
                    var fe = H.memoizedProps.style, q = fe != null && fe.hasOwnProperty("display") ? fe.display : null;
                    R.style.display = q == null || typeof q == "boolean" ? "" : ("" + q).trim();
                  }
                } catch (ze) {
                  $t(H, H.return, ze);
                }
              }
            } else if (t.tag === 6) {
              if (n === null) {
                H = t;
                try {
                  H.stateNode.nodeValue = s ? "" : H.memoizedProps;
                } catch (ze) {
                  $t(H, H.return, ze);
                }
              }
            } else if (t.tag === 18) {
              if (n === null) {
                H = t;
                try {
                  var le = H.stateNode;
                  s ? my(le, !0) : my(H.stateNode, !1);
                } catch (ze) {
                  $t(H, H.return, ze);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break e;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === e) break e;
              n === t && (n = null), t = t.return;
            }
            n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
          }
        l & 4 && (l = e.updateQueue, l !== null && (n = l.retryQueue, n !== null && (l.retryQueue = null, id(e, n))));
        break;
      case 19:
        li(t, e), ai(e), l & 4 && (l = e.updateQueue, l !== null && (e.updateQueue = null, id(e, l)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        li(t, e), ai(e);
    }
  }
  function ai(e) {
    var t = e.flags;
    if (t & 2) {
      try {
        for (var n, l = e.return; l !== null; ) {
          if (Tv(l)) {
            n = l;
            break;
          }
          l = l.return;
        }
        if (n == null) throw Error(y(160));
        switch (n.tag) {
          case 27:
            var s = n.stateNode, d = Th(e);
            ad(e, d, s);
            break;
          case 5:
            var S = n.stateNode;
            n.flags & 32 && (Ee(S, ""), n.flags &= -33);
            var R = Th(e);
            ad(e, R, S);
            break;
          case 3:
          case 4:
            var H = n.stateNode.containerInfo, j = Th(e);
            Sh(
              e,
              j,
              H
            );
            break;
          default:
            throw Error(y(161));
        }
      } catch (re) {
        $t(e, e.return, re);
      }
      e.flags &= -3;
    }
    t & 4096 && (e.flags &= -4097);
  }
  function Rv(e) {
    if (e.subtreeFlags & 1024)
      for (e = e.child; e !== null; ) {
        var t = e;
        Rv(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
      }
  }
  function Wu(e, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        Ev(e, t.alternate, t), t = t.sibling;
  }
  function Mo(e) {
    for (e = e.child; e !== null; ) {
      var t = e;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Vc(4, t, t.return), Mo(t);
          break;
        case 1:
          ou(t, t.return);
          var n = t.stateNode;
          typeof n.componentWillUnmount == "function" && mv(
            t,
            t.return,
            n
          ), Mo(t);
          break;
        case 27:
          Of(t.stateNode);
        case 26:
        case 5:
          ou(t, t.return), Mo(t);
          break;
        case 22:
          t.memoizedState === null && Mo(t);
          break;
        case 30:
          Mo(t);
          break;
        default:
          Mo(t);
      }
      e = e.sibling;
    }
  }
  function Ju(e, t, n) {
    for (n = n && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var l = t.alternate, s = e, d = t, S = d.flags;
      switch (d.tag) {
        case 0:
        case 11:
        case 15:
          Ju(
            s,
            d,
            n
          ), bf(4, d);
          break;
        case 1:
          if (Ju(
            s,
            d,
            n
          ), l = d, s = l.stateNode, typeof s.componentDidMount == "function")
            try {
              s.componentDidMount();
            } catch (j) {
              $t(l, l.return, j);
            }
          if (l = d, s = l.updateQueue, s !== null) {
            var R = l.stateNode;
            try {
              var H = s.shared.hiddenCallbacks;
              if (H !== null)
                for (s.shared.hiddenCallbacks = null, s = 0; s < H.length; s++)
                  u(H[s], R);
            } catch (j) {
              $t(l, l.return, j);
            }
          }
          n && S & 64 && bv(d), mf(d, d.return);
          break;
        case 27:
          Sv(d);
        case 26:
        case 5:
          Ju(
            s,
            d,
            n
          ), n && l === null && S & 4 && pv(d), mf(d, d.return);
          break;
        case 12:
          Ju(
            s,
            d,
            n
          );
          break;
        case 31:
          Ju(
            s,
            d,
            n
          ), n && S & 4 && _v(s, d);
          break;
        case 13:
          Ju(
            s,
            d,
            n
          ), n && S & 4 && Ov(s, d);
          break;
        case 22:
          d.memoizedState === null && Ju(
            s,
            d,
            n
          ), mf(d, d.return);
          break;
        case 30:
          break;
        default:
          Ju(
            s,
            d,
            n
          );
      }
      t = t.sibling;
    }
  }
  function Eh(e, t) {
    var n = null;
    e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && aa(n));
  }
  function wh(e, t) {
    e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && aa(e));
  }
  function Nr(e, t, n, l) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        Nv(
          e,
          t,
          n,
          l
        ), t = t.sibling;
  }
  function Nv(e, t, n, l) {
    var s = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Nr(
          e,
          t,
          n,
          l
        ), s & 2048 && bf(9, t);
        break;
      case 1:
        Nr(
          e,
          t,
          n,
          l
        );
        break;
      case 3:
        Nr(
          e,
          t,
          n,
          l
        ), s & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && aa(e)));
        break;
      case 12:
        if (s & 2048) {
          Nr(
            e,
            t,
            n,
            l
          ), e = t.stateNode;
          try {
            var d = t.memoizedProps, S = d.id, R = d.onPostCommit;
            typeof R == "function" && R(
              S,
              t.alternate === null ? "mount" : "update",
              e.passiveEffectDuration,
              -0
            );
          } catch (H) {
            $t(t, t.return, H);
          }
        } else
          Nr(
            e,
            t,
            n,
            l
          );
        break;
      case 31:
        Nr(
          e,
          t,
          n,
          l
        );
        break;
      case 13:
        Nr(
          e,
          t,
          n,
          l
        );
        break;
      case 23:
        break;
      case 22:
        d = t.stateNode, S = t.alternate, t.memoizedState !== null ? d._visibility & 2 ? Nr(
          e,
          t,
          n,
          l
        ) : pf(e, t) : d._visibility & 2 ? Nr(
          e,
          t,
          n,
          l
        ) : (d._visibility |= 2, ps(
          e,
          t,
          n,
          l,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), s & 2048 && Eh(S, t);
        break;
      case 24:
        Nr(
          e,
          t,
          n,
          l
        ), s & 2048 && wh(t.alternate, t);
        break;
      default:
        Nr(
          e,
          t,
          n,
          l
        );
    }
  }
  function ps(e, t, n, l, s) {
    for (s = s && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var d = e, S = t, R = n, H = l, j = S.flags;
      switch (S.tag) {
        case 0:
        case 11:
        case 15:
          ps(
            d,
            S,
            R,
            H,
            s
          ), bf(8, S);
          break;
        case 23:
          break;
        case 22:
          var re = S.stateNode;
          S.memoizedState !== null ? re._visibility & 2 ? ps(
            d,
            S,
            R,
            H,
            s
          ) : pf(
            d,
            S
          ) : (re._visibility |= 2, ps(
            d,
            S,
            R,
            H,
            s
          )), s && j & 2048 && Eh(
            S.alternate,
            S
          );
          break;
        case 24:
          ps(
            d,
            S,
            R,
            H,
            s
          ), s && j & 2048 && wh(S.alternate, S);
          break;
        default:
          ps(
            d,
            S,
            R,
            H,
            s
          );
      }
      t = t.sibling;
    }
  }
  function pf(e, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var n = e, l = t, s = l.flags;
        switch (l.tag) {
          case 22:
            pf(n, l), s & 2048 && Eh(
              l.alternate,
              l
            );
            break;
          case 24:
            pf(n, l), s & 2048 && wh(l.alternate, l);
            break;
          default:
            pf(n, l);
        }
        t = t.sibling;
      }
  }
  var Tf = 8192;
  function Ts(e, t, n) {
    if (e.subtreeFlags & Tf)
      for (e = e.child; e !== null; )
        Mv(
          e,
          t,
          n
        ), e = e.sibling;
  }
  function Mv(e, t, n) {
    switch (e.tag) {
      case 26:
        Ts(
          e,
          t,
          n
        ), e.flags & Tf && e.memoizedState !== null && o1(
          n,
          Rr,
          e.memoizedState,
          e.memoizedProps
        );
        break;
      case 5:
        Ts(
          e,
          t,
          n
        );
        break;
      case 3:
      case 4:
        var l = Rr;
        Rr = pd(e.stateNode.containerInfo), Ts(
          e,
          t,
          n
        ), Rr = l;
        break;
      case 22:
        e.memoizedState === null && (l = e.alternate, l !== null && l.memoizedState !== null ? (l = Tf, Tf = 16777216, Ts(
          e,
          t,
          n
        ), Tf = l) : Ts(
          e,
          t,
          n
        ));
        break;
      default:
        Ts(
          e,
          t,
          n
        );
    }
  }
  function zv(e) {
    var t = e.alternate;
    if (t !== null && (e = t.child, e !== null)) {
      t.child = null;
      do
        t = e.sibling, e.sibling = null, e = t;
      while (e !== null);
    }
  }
  function Sf(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var n = 0; n < t.length; n++) {
          var l = t[n];
          Vl = l, Lv(
            l,
            e
          );
        }
      zv(e);
    }
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; )
        Dv(e), e = e.sibling;
  }
  function Dv(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Sf(e), e.flags & 2048 && Vc(9, e, e.return);
        break;
      case 3:
        Sf(e);
        break;
      case 12:
        Sf(e);
        break;
      case 22:
        var t = e.stateNode;
        e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, rd(e)) : Sf(e);
        break;
      default:
        Sf(e);
    }
  }
  function rd(e) {
    var t = e.deletions;
    if ((e.flags & 16) !== 0) {
      if (t !== null)
        for (var n = 0; n < t.length; n++) {
          var l = t[n];
          Vl = l, Lv(
            l,
            e
          );
        }
      zv(e);
    }
    for (e = e.child; e !== null; ) {
      switch (t = e, t.tag) {
        case 0:
        case 11:
        case 15:
          Vc(8, t, t.return), rd(t);
          break;
        case 22:
          n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, rd(t));
          break;
        default:
          rd(t);
      }
      e = e.sibling;
    }
  }
  function Lv(e, t) {
    for (; Vl !== null; ) {
      var n = Vl;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Vc(8, n, t);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var l = n.memoizedState.cachePool.pool;
            l != null && l.refCount++;
          }
          break;
        case 24:
          aa(n.memoizedState.cache);
      }
      if (l = n.child, l !== null) l.return = n, Vl = l;
      else
        e: for (n = e; Vl !== null; ) {
          l = Vl;
          var s = l.sibling, d = l.return;
          if (wv(l), l === n) {
            Vl = null;
            break e;
          }
          if (s !== null) {
            s.return = d, Vl = s;
            break e;
          }
          Vl = d;
        }
    }
  }
  var w0 = {
    getCacheForType: function(e) {
      var t = yt(An), n = t.data.get(e);
      return n === void 0 && (n = e(), t.data.set(e, n)), n;
    },
    cacheSignal: function() {
      return yt(An).controller.signal;
    }
  }, A0 = typeof WeakMap == "function" ? WeakMap : Map, Yt = 0, sn = null, pt = null, xt = 0, qt = 0, Ai = null, Qc = !1, Ss = !1, Ah = !1, Ku = 0, Jn = 0, Pc = 0, zo = 0, _h = 0, _i = 0, xs = 0, xf = null, ii = null, Oh = !1, ud = 0, kv = 0, cd = 1 / 0, od = null, Wc = null, Dl = 0, Jc = null, Es = null, ju = 0, Ch = 0, Rh = null, Hv = null, Ef = 0, Nh = null;
  function Oi() {
    return (Yt & 2) !== 0 && xt !== 0 ? xt & -xt : P.T !== null ? Hh() : Nn();
  }
  function Bv() {
    if (_i === 0)
      if ((xt & 536870912) === 0 || Je) {
        var e = Hl;
        Hl <<= 1, (Hl & 3932160) === 0 && (Hl = 262144), _i = e;
      } else _i = 536870912;
    return e = k.current, e !== null && (e.flags |= 32), _i;
  }
  function ri(e, t, n) {
    (e === sn && (qt === 2 || qt === 9) || e.cancelPendingCommit !== null) && (ws(e, 0), Kc(
      e,
      xt,
      _i,
      !1
    )), Ya(e, n), ((Yt & 2) === 0 || e !== sn) && (e === sn && ((Yt & 2) === 0 && (zo |= n), Jn === 4 && Kc(
      e,
      xt,
      _i,
      !1
    )), su(e));
  }
  function Uv(e, t, n) {
    if ((Yt & 6) !== 0) throw Error(y(327));
    var l = !n && (t & 127) === 0 && (t & e.expiredLanes) === 0 || Rn(e, t), s = l ? C0(e, t) : zh(e, t, !0), d = l;
    do {
      if (s === 0) {
        Ss && !l && Kc(e, t, 0, !1);
        break;
      } else {
        if (n = e.current.alternate, d && !_0(n)) {
          s = zh(e, t, !1), d = !1;
          continue;
        }
        if (s === 2) {
          if (d = t, e.errorRecoveryDisabledLanes & d)
            var S = 0;
          else
            S = e.pendingLanes & -536870913, S = S !== 0 ? S : S & 536870912 ? 536870912 : 0;
          if (S !== 0) {
            t = S;
            e: {
              var R = e;
              s = xf;
              var H = R.current.memoizedState.isDehydrated;
              if (H && (ws(R, S).flags |= 256), S = zh(
                R,
                S,
                !1
              ), S !== 2) {
                if (Ah && !H) {
                  R.errorRecoveryDisabledLanes |= d, zo |= d, s = 4;
                  break e;
                }
                d = ii, ii = s, d !== null && (ii === null ? ii = d : ii.push.apply(
                  ii,
                  d
                ));
              }
              s = S;
            }
            if (d = !1, s !== 2) continue;
          }
        }
        if (s === 1) {
          ws(e, 0), Kc(e, t, 0, !0);
          break;
        }
        e: {
          switch (l = e, d = s, d) {
            case 0:
            case 1:
              throw Error(y(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              Kc(
                l,
                t,
                _i,
                !Qc
              );
              break e;
            case 2:
              ii = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(y(329));
          }
          if ((t & 62914560) === t && (s = ud + 300 - Ue(), 10 < s)) {
            if (Kc(
              l,
              t,
              _i,
              !Qc
            ), Kl(l, 0, !0) !== 0) break e;
            ju = t, l.timeoutHandle = vy(
              Fv.bind(
                null,
                l,
                n,
                ii,
                od,
                Oh,
                t,
                _i,
                zo,
                xs,
                Qc,
                d,
                "Throttled",
                -0,
                0
              ),
              s
            );
            break e;
          }
          Fv(
            l,
            n,
            ii,
            od,
            Oh,
            t,
            _i,
            zo,
            xs,
            Qc,
            d,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    su(e);
  }
  function Fv(e, t, n, l, s, d, S, R, H, j, re, fe, q, le) {
    if (e.timeoutHandle = -1, fe = t.subtreeFlags, fe & 8192 || (fe & 16785408) === 16785408) {
      fe = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Bt
      }, Mv(
        t,
        d,
        fe
      );
      var ze = (d & 62914560) === d ? ud - Ue() : (d & 4194048) === d ? kv - Ue() : 0;
      if (ze = s1(
        fe,
        ze
      ), ze !== null) {
        ju = d, e.cancelPendingCommit = ze(
          Pv.bind(
            null,
            e,
            t,
            d,
            n,
            l,
            s,
            S,
            R,
            H,
            re,
            fe,
            null,
            q,
            le
          )
        ), Kc(e, d, S, !j);
        return;
      }
    }
    Pv(
      e,
      t,
      d,
      n,
      l,
      s,
      S,
      R,
      H
    );
  }
  function _0(e) {
    for (var t = e; ; ) {
      var n = t.tag;
      if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var l = 0; l < n.length; l++) {
          var s = n[l], d = s.getSnapshot;
          s = s.value;
          try {
            if (!kn(d(), s)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = t.child, t.subtreeFlags & 16384 && n !== null)
        n.return = t, t = n;
      else {
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function Kc(e, t, n, l) {
    t &= ~_h, t &= ~zo, e.suspendedLanes |= t, e.pingedLanes &= ~t, l && (e.warmLanes |= t), l = e.expirationTimes;
    for (var s = t; 0 < s; ) {
      var d = 31 - Cn(s), S = 1 << d;
      l[d] = -1, s &= ~S;
    }
    n !== 0 && oi(e, n, t);
  }
  function sd() {
    return (Yt & 6) === 0 ? (wf(0), !1) : !0;
  }
  function Mh() {
    if (pt !== null) {
      if (qt === 0)
        var e = pt.return;
      else
        e = pt, dl = Kt = null, ku(e), nr = null, ia = 0, e = pt;
      for (; e !== null; )
        yv(e.alternate, e), e = e.return;
      pt = null;
    }
  }
  function ws(e, t) {
    var n = e.timeoutHandle;
    n !== -1 && (e.timeoutHandle = -1, Q0(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), ju = 0, Mh(), sn = e, pt = n = rt(e.current, null), xt = t, qt = 0, Ai = null, Qc = !1, Ss = Rn(e, t), Ah = !1, xs = _i = _h = zo = Pc = Jn = 0, ii = xf = null, Oh = !1, (t & 8) !== 0 && (t |= t & 32);
    var l = e.entangledLanes;
    if (l !== 0)
      for (e = e.entanglements, l &= t; 0 < l; ) {
        var s = 31 - Cn(l), d = 1 << s;
        t |= e[s], l &= ~d;
      }
    return Ku = t, Qe(), n;
  }
  function Yv(e, t) {
    Oe = null, P.H = au, t === Na || t === tr ? (t = _c(), qt = 3) : t === er ? (t = _c(), qt = 4) : qt = t === hf ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, Ai = t, pt === null && (Jn = 1, Or(
      e,
      ll(t, e.current)
    ));
  }
  function Gv() {
    var e = k.current;
    return e === null ? !0 : (xt & 4194048) === xt ? X === null : (xt & 62914560) === xt || (xt & 536870912) !== 0 ? e === X : !1;
  }
  function Xv() {
    var e = P.H;
    return P.H = au, e === null ? au : e;
  }
  function Iv() {
    var e = P.A;
    return P.A = w0, e;
  }
  function fd() {
    Jn = 4, Qc || (xt & 4194048) !== xt && k.current !== null || (Ss = !0), (Pc & 134217727) === 0 && (zo & 134217727) === 0 || sn === null || Kc(
      sn,
      xt,
      _i,
      !1
    );
  }
  function zh(e, t, n) {
    var l = Yt;
    Yt |= 2;
    var s = Xv(), d = Iv();
    (sn !== e || xt !== t) && (od = null, ws(e, t)), t = !1;
    var S = Jn;
    e: do
      try {
        if (qt !== 0 && pt !== null) {
          var R = pt, H = Ai;
          switch (qt) {
            case 8:
              Mh(), S = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              k.current === null && (t = !0);
              var j = qt;
              if (qt = 0, Ai = null, As(e, R, H, j), n && Ss) {
                S = 0;
                break e;
              }
              break;
            default:
              j = qt, qt = 0, Ai = null, As(e, R, H, j);
          }
        }
        O0(), S = Jn;
        break;
      } catch (re) {
        Yv(e, re);
      }
    while (!0);
    return t && e.shellSuspendCounter++, dl = Kt = null, Yt = l, P.H = s, P.A = d, pt === null && (sn = null, xt = 0, Qe()), S;
  }
  function O0() {
    for (; pt !== null; ) Zv(pt);
  }
  function C0(e, t) {
    var n = Yt;
    Yt |= 2;
    var l = Xv(), s = Iv();
    sn !== e || xt !== t ? (od = null, cd = Ue() + 500, ws(e, t)) : Ss = Rn(
      e,
      t
    );
    e: do
      try {
        if (qt !== 0 && pt !== null) {
          t = pt;
          var d = Ai;
          t: switch (qt) {
            case 1:
              qt = 0, Ai = null, As(e, t, d, 1);
              break;
            case 2:
            case 9:
              if (Jr(d)) {
                qt = 0, Ai = null, Vv(t);
                break;
              }
              t = function() {
                qt !== 2 && qt !== 9 || sn !== e || (qt = 7), su(e);
              }, d.then(t, t);
              break e;
            case 3:
              qt = 7;
              break e;
            case 4:
              qt = 5;
              break e;
            case 7:
              Jr(d) ? (qt = 0, Ai = null, Vv(t)) : (qt = 0, Ai = null, As(e, t, d, 7));
              break;
            case 5:
              var S = null;
              switch (pt.tag) {
                case 26:
                  S = pt.memoizedState;
                case 5:
                case 27:
                  var R = pt;
                  if (S ? Ny(S) : R.stateNode.complete) {
                    qt = 0, Ai = null;
                    var H = R.sibling;
                    if (H !== null) pt = H;
                    else {
                      var j = R.return;
                      j !== null ? (pt = j, dd(j)) : pt = null;
                    }
                    break t;
                  }
              }
              qt = 0, Ai = null, As(e, t, d, 5);
              break;
            case 6:
              qt = 0, Ai = null, As(e, t, d, 6);
              break;
            case 8:
              Mh(), Jn = 6;
              break e;
            default:
              throw Error(y(462));
          }
        }
        R0();
        break;
      } catch (re) {
        Yv(e, re);
      }
    while (!0);
    return dl = Kt = null, P.H = l, P.A = s, Yt = n, pt !== null ? 0 : (sn = null, xt = 0, Qe(), Jn);
  }
  function R0() {
    for (; pt !== null && !cl(); )
      Zv(pt);
  }
  function Zv(e) {
    var t = gv(e.alternate, e, Ku);
    e.memoizedProps = e.pendingProps, t === null ? dd(e) : pt = t;
  }
  function Vv(e) {
    var t = e, n = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = fs(
          n,
          t,
          t.pendingProps,
          t.type,
          void 0,
          xt
        );
        break;
      case 11:
        t = fs(
          n,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          xt
        );
        break;
      case 5:
        ku(t);
      default:
        yv(n, t), t = pt = En(t, Ku), t = gv(n, t, Ku);
    }
    e.memoizedProps = e.pendingProps, t === null ? dd(e) : pt = t;
  }
  function As(e, t, n, l) {
    dl = Kt = null, ku(t), nr = null, ia = 0;
    var s = t.return;
    try {
      if (bh(
        e,
        s,
        t,
        n,
        xt
      )) {
        Jn = 1, Or(
          e,
          ll(n, e.current)
        ), pt = null;
        return;
      }
    } catch (d) {
      if (s !== null) throw pt = s, d;
      Jn = 1, Or(
        e,
        ll(n, e.current)
      ), pt = null;
      return;
    }
    t.flags & 32768 ? (Je || l === 1 ? e = !0 : Ss || (xt & 536870912) !== 0 ? e = !1 : (Qc = e = !0, (l === 2 || l === 9 || l === 3 || l === 6) && (l = k.current, l !== null && l.tag === 13 && (l.flags |= 16384))), Qv(t, e)) : dd(t);
  }
  function dd(e) {
    var t = e;
    do {
      if ((t.flags & 32768) !== 0) {
        Qv(
          t,
          Qc
        );
        return;
      }
      e = t.return;
      var n = T0(
        t.alternate,
        t,
        Ku
      );
      if (n !== null) {
        pt = n;
        return;
      }
      if (t = t.sibling, t !== null) {
        pt = t;
        return;
      }
      pt = t = e;
    } while (t !== null);
    Jn === 0 && (Jn = 5);
  }
  function Qv(e, t) {
    do {
      var n = S0(e.alternate, e);
      if (n !== null) {
        n.flags &= 32767, pt = n;
        return;
      }
      if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
        pt = e;
        return;
      }
      pt = e = n;
    } while (e !== null);
    Jn = 6, pt = null;
  }
  function Pv(e, t, n, l, s, d, S, R, H) {
    e.cancelPendingCommit = null;
    do
      hd();
    while (Dl !== 0);
    if ((Yt & 6) !== 0) throw Error(y(327));
    if (t !== null) {
      if (t === e.current) throw Error(y(177));
      if (d = t.lanes | t.childLanes, d |= je, fr(
        e,
        n,
        d,
        S,
        R,
        H
      ), e === sn && (pt = sn = null, xt = 0), Es = t, Jc = e, ju = n, Ch = d, Rh = s, Hv = l, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, D0(tn, function() {
        return qv(), null;
      })) : (e.callbackNode = null, e.callbackPriority = 0), l = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || l) {
        l = P.T, P.T = null, s = Se.p, Se.p = 2, S = Yt, Yt |= 4;
        try {
          x0(e, t, n);
        } finally {
          Yt = S, Se.p = s, P.T = l;
        }
      }
      Dl = 1, Wv(), Jv(), Kv();
    }
  }
  function Wv() {
    if (Dl === 1) {
      Dl = 0;
      var e = Jc, t = Es, n = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || n) {
        n = P.T, P.T = null;
        var l = Se.p;
        Se.p = 2;
        var s = Yt;
        Yt |= 4;
        try {
          Cv(t, e);
          var d = Zh, S = To(e.containerInfo), R = d.focusedElem, H = d.selectionRange;
          if (S !== R && R && R.ownerDocument && pc(
            R.ownerDocument.documentElement,
            R
          )) {
            if (H !== null && yi(R)) {
              var j = H.start, re = H.end;
              if (re === void 0 && (re = j), "selectionStart" in R)
                R.selectionStart = j, R.selectionEnd = Math.min(
                  re,
                  R.value.length
                );
              else {
                var fe = R.ownerDocument || document, q = fe && fe.defaultView || window;
                if (q.getSelection) {
                  var le = q.getSelection(), ze = R.textContent.length, Ge = Math.min(H.start, ze), un = H.end === void 0 ? Ge : Math.min(H.end, ze);
                  !le.extend && Ge > un && (S = un, un = Ge, Ge = S);
                  var V = Ki(
                    R,
                    Ge
                  ), G = Ki(
                    R,
                    un
                  );
                  if (V && G && (le.rangeCount !== 1 || le.anchorNode !== V.node || le.anchorOffset !== V.offset || le.focusNode !== G.node || le.focusOffset !== G.offset)) {
                    var K = fe.createRange();
                    K.setStart(V.node, V.offset), le.removeAllRanges(), Ge > un ? (le.addRange(K), le.extend(G.node, G.offset)) : (K.setEnd(G.node, G.offset), le.addRange(K));
                  }
                }
              }
            }
            for (fe = [], le = R; le = le.parentNode; )
              le.nodeType === 1 && fe.push({
                element: le,
                left: le.scrollLeft,
                top: le.scrollTop
              });
            for (typeof R.focus == "function" && R.focus(), R = 0; R < fe.length; R++) {
              var oe = fe[R];
              oe.element.scrollLeft = oe.left, oe.element.scrollTop = oe.top;
            }
          }
          Ad = !!Ih, Zh = Ih = null;
        } finally {
          Yt = s, Se.p = l, P.T = n;
        }
      }
      e.current = t, Dl = 2;
    }
  }
  function Jv() {
    if (Dl === 2) {
      Dl = 0;
      var e = Jc, t = Es, n = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || n) {
        n = P.T, P.T = null;
        var l = Se.p;
        Se.p = 2;
        var s = Yt;
        Yt |= 4;
        try {
          Ev(e, t.alternate, t);
        } finally {
          Yt = s, Se.p = l, P.T = n;
        }
      }
      Dl = 3;
    }
  }
  function Kv() {
    if (Dl === 4 || Dl === 3) {
      Dl = 0, Ni();
      var e = Jc, t = Es, n = ju, l = Hv;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Dl = 5 : (Dl = 0, Es = Jc = null, jv(e, e.pendingLanes));
      var s = e.pendingLanes;
      if (s === 0 && (Wc = null), zi(n), t = t.stateNode, Zn && typeof Zn.onCommitFiberRoot == "function")
        try {
          Zn.onCommitFiberRoot(
            Wl,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (l !== null) {
        t = P.T, s = Se.p, Se.p = 2, P.T = null;
        try {
          for (var d = e.onRecoverableError, S = 0; S < l.length; S++) {
            var R = l[S];
            d(R.value, {
              componentStack: R.stack
            });
          }
        } finally {
          P.T = t, Se.p = s;
        }
      }
      (ju & 3) !== 0 && hd(), su(e), s = e.pendingLanes, (n & 261930) !== 0 && (s & 42) !== 0 ? e === Nh ? Ef++ : (Ef = 0, Nh = e) : Ef = 0, wf(0);
    }
  }
  function jv(e, t) {
    (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, aa(t)));
  }
  function hd() {
    return Wv(), Jv(), Kv(), qv();
  }
  function qv() {
    if (Dl !== 5) return !1;
    var e = Jc, t = Ch;
    Ch = 0;
    var n = zi(ju), l = P.T, s = Se.p;
    try {
      Se.p = 32 > n ? 32 : n, P.T = null, n = Rh, Rh = null;
      var d = Jc, S = ju;
      if (Dl = 0, Es = Jc = null, ju = 0, (Yt & 6) !== 0) throw Error(y(331));
      var R = Yt;
      if (Yt |= 4, Dv(d.current), Nv(
        d,
        d.current,
        S,
        n
      ), Yt = R, wf(0, !1), Zn && typeof Zn.onPostCommitFiberRoot == "function")
        try {
          Zn.onPostCommitFiberRoot(Wl, d);
        } catch {
        }
      return !0;
    } finally {
      Se.p = s, P.T = l, jv(e, t);
    }
  }
  function $v(e, t, n) {
    t = ll(n, t), t = Uc(e.stateNode, t, 2), e = Nl(e, t, 2), e !== null && (Ya(e, 2), su(e));
  }
  function $t(e, t, n) {
    if (e.tag === 3)
      $v(e, e, n);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          $v(
            t,
            e,
            n
          );
          break;
        } else if (t.tag === 1) {
          var l = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (Wc === null || !Wc.has(l))) {
            e = ll(n, e), n = ss(2), l = Nl(t, n, 2), l !== null && (Fc(
              n,
              l,
              t,
              e
            ), Ya(l, 2), su(l));
            break;
          }
        }
        t = t.return;
      }
  }
  function Dh(e, t, n) {
    var l = e.pingCache;
    if (l === null) {
      l = e.pingCache = new A0();
      var s = /* @__PURE__ */ new Set();
      l.set(t, s);
    } else
      s = l.get(t), s === void 0 && (s = /* @__PURE__ */ new Set(), l.set(t, s));
    s.has(n) || (Ah = !0, s.add(n), e = N0.bind(null, e, t, n), t.then(e, e));
  }
  function N0(e, t, n) {
    var l = e.pingCache;
    l !== null && l.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, sn === e && (xt & n) === n && (Jn === 4 || Jn === 3 && (xt & 62914560) === xt && 300 > Ue() - ud ? (Yt & 2) === 0 && ws(e, 0) : _h |= n, xs === xt && (xs = 0)), su(e);
  }
  function ey(e, t) {
    t === 0 && (t = Fa()), e = Lt(e, t), e !== null && (Ya(e, t), su(e));
  }
  function M0(e) {
    var t = e.memoizedState, n = 0;
    t !== null && (n = t.retryLane), ey(e, n);
  }
  function z0(e, t) {
    var n = 0;
    switch (e.tag) {
      case 31:
      case 13:
        var l = e.stateNode, s = e.memoizedState;
        s !== null && (n = s.retryLane);
        break;
      case 19:
        l = e.stateNode;
        break;
      case 22:
        l = e.stateNode._retryCache;
        break;
      default:
        throw Error(y(314));
    }
    l !== null && l.delete(t), ey(e, n);
  }
  function D0(e, t) {
    return ul(e, t);
  }
  var gd = null, _s = null, Lh = !1, vd = !1, kh = !1, jc = 0;
  function su(e) {
    e !== _s && e.next === null && (_s === null ? gd = _s = e : _s = _s.next = e), vd = !0, Lh || (Lh = !0, k0());
  }
  function wf(e, t) {
    if (!kh && vd) {
      kh = !0;
      do
        for (var n = !1, l = gd; l !== null; ) {
          if (e !== 0) {
            var s = l.pendingLanes;
            if (s === 0) var d = 0;
            else {
              var S = l.suspendedLanes, R = l.pingedLanes;
              d = (1 << 31 - Cn(42 | e) + 1) - 1, d &= s & ~(S & ~R), d = d & 201326741 ? d & 201326741 | 1 : d ? d | 2 : 0;
            }
            d !== 0 && (n = !0, ay(l, d));
          } else
            d = xt, d = Kl(
              l,
              l === sn ? d : 0,
              l.cancelPendingCommit !== null || l.timeoutHandle !== -1
            ), (d & 3) === 0 || Rn(l, d) || (n = !0, ay(l, d));
          l = l.next;
        }
      while (n);
      kh = !1;
    }
  }
  function L0() {
    ty();
  }
  function ty() {
    vd = Lh = !1;
    var e = 0;
    jc !== 0 && V0() && (e = jc);
    for (var t = Ue(), n = null, l = gd; l !== null; ) {
      var s = l.next, d = ny(l, t);
      d === 0 ? (l.next = null, n === null ? gd = s : n.next = s, s === null && (_s = n)) : (n = l, (e !== 0 || (d & 3) !== 0) && (vd = !0)), l = s;
    }
    Dl !== 0 && Dl !== 5 || wf(e), jc !== 0 && (jc = 0);
  }
  function ny(e, t) {
    for (var n = e.suspendedLanes, l = e.pingedLanes, s = e.expirationTimes, d = e.pendingLanes & -62914561; 0 < d; ) {
      var S = 31 - Cn(d), R = 1 << S, H = s[S];
      H === -1 ? ((R & n) === 0 || (R & l) !== 0) && (s[S] = jl(R, t)) : H <= t && (e.expiredLanes |= R), d &= ~R;
    }
    if (t = sn, n = xt, n = Kl(
      e,
      e === t ? n : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l = e.callbackNode, n === 0 || e === t && (qt === 2 || qt === 9) || e.cancelPendingCommit !== null)
      return l !== null && l !== null && In(l), e.callbackNode = null, e.callbackPriority = 0;
    if ((n & 3) === 0 || Rn(e, n)) {
      if (t = n & -n, t === e.callbackPriority) return t;
      switch (l !== null && In(l), zi(n)) {
        case 2:
        case 8:
          n = Mi;
          break;
        case 32:
          n = tn;
          break;
        case 268435456:
          n = ui;
          break;
        default:
          n = tn;
      }
      return l = ly.bind(null, e), n = ul(n, l), e.callbackPriority = t, e.callbackNode = n, t;
    }
    return l !== null && l !== null && In(l), e.callbackPriority = 2, e.callbackNode = null, 2;
  }
  function ly(e, t) {
    if (Dl !== 0 && Dl !== 5)
      return e.callbackNode = null, e.callbackPriority = 0, null;
    var n = e.callbackNode;
    if (hd() && e.callbackNode !== n)
      return null;
    var l = xt;
    return l = Kl(
      e,
      e === sn ? l : 0,
      e.cancelPendingCommit !== null || e.timeoutHandle !== -1
    ), l === 0 ? null : (Uv(e, l, t), ny(e, Ue()), e.callbackNode != null && e.callbackNode === n ? ly.bind(null, e) : null);
  }
  function ay(e, t) {
    if (hd()) return null;
    Uv(e, t, !0);
  }
  function k0() {
    P0(function() {
      (Yt & 6) !== 0 ? ul(
        Lr,
        L0
      ) : ty();
    });
  }
  function Hh() {
    if (jc === 0) {
      var e = vn;
      e === 0 && (e = ci, ci <<= 1, (ci & 261888) === 0 && (ci = 256)), jc = e;
    }
    return jc;
  }
  function iy(e) {
    return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Bi("" + e);
  }
  function ry(e, t) {
    var n = t.ownerDocument.createElement("input");
    return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
  }
  function H0(e, t, n, l, s) {
    if (t === "submit" && n && n.stateNode === s) {
      var d = iy(
        (s[on] || null).action
      ), S = l.submitter;
      S && (t = (t = S[on] || null) ? iy(t.formAction) : S.getAttribute("formAction"), t !== null && (d = t, S = null));
      var R = new Ur(
        "action",
        "action",
        null,
        l,
        s
      );
      e.push({
        event: R,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (l.defaultPrevented) {
                if (jc !== 0) {
                  var H = S ? ry(s, S) : new FormData(s);
                  Hc(
                    n,
                    {
                      pending: !0,
                      data: H,
                      method: s.method,
                      action: d
                    },
                    null,
                    H
                  );
                }
              } else
                typeof d == "function" && (R.preventDefault(), H = S ? ry(s, S) : new FormData(s), Hc(
                  n,
                  {
                    pending: !0,
                    data: H,
                    method: s.method,
                    action: d
                  },
                  d,
                  H
                ));
            },
            currentTarget: s
          }
        ]
      });
    }
  }
  for (var Bh = 0; Bh < ie.length; Bh++) {
    var Uh = ie[Bh], B0 = Uh.toLowerCase(), U0 = Uh[0].toUpperCase() + Uh.slice(1);
    ve(
      B0,
      "on" + U0
    );
  }
  ve(m, "onAnimationEnd"), ve(x, "onAnimationIteration"), ve(N, "onAnimationStart"), ve("dblclick", "onDoubleClick"), ve("focusin", "onFocus"), ve("focusout", "onBlur"), ve(L, "onTransitionRun"), ve(ee, "onTransitionStart"), ve(Y, "onTransitionCancel"), ve(te, "onTransitionEnd"), ga("onMouseEnter", ["mouseout", "mouseover"]), ga("onMouseLeave", ["mouseout", "mouseover"]), ga("onPointerEnter", ["pointerout", "pointerover"]), ga("onPointerLeave", ["pointerout", "pointerover"]), ql(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), ql(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), ql("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), ql(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), ql(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), ql(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var Af = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), F0 = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(Af)
  );
  function uy(e, t) {
    t = (t & 4) !== 0;
    for (var n = 0; n < e.length; n++) {
      var l = e[n], s = l.event;
      l = l.listeners;
      e: {
        var d = void 0;
        if (t)
          for (var S = l.length - 1; 0 <= S; S--) {
            var R = l[S], H = R.instance, j = R.currentTarget;
            if (R = R.listener, H !== d && s.isPropagationStopped())
              break e;
            d = R, s.currentTarget = j;
            try {
              d(s);
            } catch (re) {
              Be(re);
            }
            s.currentTarget = null, d = H;
          }
        else
          for (S = 0; S < l.length; S++) {
            if (R = l[S], H = R.instance, j = R.currentTarget, R = R.listener, H !== d && s.isPropagationStopped())
              break e;
            d = R, s.currentTarget = j;
            try {
              d(s);
            } catch (re) {
              Be(re);
            }
            s.currentTarget = null, d = H;
          }
      }
    }
  }
  function Tt(e, t) {
    var n = t[Ga];
    n === void 0 && (n = t[Ga] = /* @__PURE__ */ new Set());
    var l = e + "__bubble";
    n.has(l) || (cy(t, e, 2, !1), n.add(l));
  }
  function Fh(e, t, n) {
    var l = 0;
    t && (l |= 4), cy(
      n,
      e,
      l,
      t
    );
  }
  var yd = "_reactListening" + Math.random().toString(36).slice(2);
  function Yh(e) {
    if (!e[yd]) {
      e[yd] = !0, Li.forEach(function(n) {
        n !== "selectionchange" && (F0.has(n) || Fh(n, !1, e), Fh(n, !0, e));
      });
      var t = e.nodeType === 9 ? e : e.ownerDocument;
      t === null || t[yd] || (t[yd] = !0, Fh("selectionchange", !1, t));
    }
  }
  function cy(e, t, n, l) {
    switch (By(t)) {
      case 2:
        var s = h1;
        break;
      case 8:
        s = g1;
        break;
      default:
        s = tg;
    }
    n = s.bind(
      null,
      t,
      n,
      e
    ), s = void 0, !vr || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (s = !0), l ? s !== void 0 ? e.addEventListener(t, n, {
      capture: !0,
      passive: s
    }) : e.addEventListener(t, n, !0) : s !== void 0 ? e.addEventListener(t, n, {
      passive: s
    }) : e.addEventListener(t, n, !1);
  }
  function Gh(e, t, n, l, s) {
    var d = l;
    if ((t & 1) === 0 && (t & 2) === 0 && l !== null)
      e: for (; ; ) {
        if (l === null) return;
        var S = l.tag;
        if (S === 3 || S === 4) {
          var R = l.stateNode.containerInfo;
          if (R === s) break;
          if (S === 4)
            for (S = l.return; S !== null; ) {
              var H = S.tag;
              if ((H === 3 || H === 4) && S.stateNode.containerInfo === s)
                return;
              S = S.return;
            }
          for (; R !== null; ) {
            if (S = Di(R), S === null) return;
            if (H = S.tag, H === 5 || H === 6 || H === 26 || H === 27) {
              l = d = S;
              continue e;
            }
            R = R.parentNode;
          }
        }
        l = l.return;
      }
    ic(function() {
      var j = d, re = so(n), fe = [];
      e: {
        var q = se.get(e);
        if (q !== void 0) {
          var le = Ur, ze = e;
          switch (e) {
            case "keypress":
              if (hi(n) === 0) break e;
            case "keydown":
            case "keyup":
              le = Vs;
              break;
            case "focusin":
              ze = "focus", le = oc;
              break;
            case "focusout":
              ze = "blur", le = oc;
              break;
            case "beforeblur":
            case "afterblur":
              le = oc;
              break;
            case "click":
              if (n.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              le = Qo;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              le = Gs;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              le = yo;
              break;
            case m:
            case x:
            case N:
              le = Po;
              break;
            case te:
              le = Jo;
              break;
            case "scroll":
            case "scrollend":
              le = mu;
              break;
            case "wheel":
              le = Ii;
              break;
            case "copy":
            case "cut":
            case "paste":
              le = Is;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              le = Vn;
              break;
            case "toggle":
            case "beforetoggle":
              le = Zi;
          }
          var Ge = (t & 4) !== 0, un = !Ge && (e === "scroll" || e === "scrollend"), V = Ge ? q !== null ? q + "Capture" : null : q;
          Ge = [];
          for (var G = j, K; G !== null; ) {
            var oe = G;
            if (K = oe.stateNode, oe = oe.tag, oe !== 5 && oe !== 26 && oe !== 27 || K === null || V === null || (oe = Ui(G, V), oe != null && Ge.push(
              _f(G, oe, K)
            )), un) break;
            G = G.return;
          }
          0 < Ge.length && (q = new le(
            q,
            ze,
            null,
            n,
            re
          ), fe.push({ event: q, listeners: Ge }));
        }
      }
      if ((t & 7) === 0) {
        e: {
          if (q = e === "mouseover" || e === "pointerover", le = e === "mouseout" || e === "pointerout", q && n !== Br && (ze = n.relatedTarget || n.fromElement) && (Di(ze) || ze[si]))
            break e;
          if ((le || q) && (q = re.window === re ? re : (q = re.ownerDocument) ? q.defaultView || q.parentWindow : window, le ? (ze = n.relatedTarget || n.toElement, le = j, ze = ze ? Di(ze) : null, ze !== null && (un = w(ze), Ge = ze.tag, ze !== un || Ge !== 5 && Ge !== 27 && Ge !== 6) && (ze = null)) : (le = null, ze = j), le !== ze)) {
            if (Ge = Qo, oe = "onMouseLeave", V = "onMouseEnter", G = "mouse", (e === "pointerout" || e === "pointerover") && (Ge = Vn, oe = "onPointerLeave", V = "onPointerEnter", G = "pointer"), un = le == null ? q : xl(le), K = ze == null ? q : xl(ze), q = new Ge(
              oe,
              G + "leave",
              le,
              n,
              re
            ), q.target = un, q.relatedTarget = K, oe = null, Di(re) === j && (Ge = new Ge(
              V,
              G + "enter",
              ze,
              n,
              re
            ), Ge.target = K, Ge.relatedTarget = un, oe = Ge), un = oe, le && ze)
              t: {
                for (Ge = Y0, V = le, G = ze, K = 0, oe = V; oe; oe = Ge(oe))
                  K++;
                oe = 0;
                for (var Fe = G; Fe; Fe = Ge(Fe))
                  oe++;
                for (; 0 < K - oe; )
                  V = Ge(V), K--;
                for (; 0 < oe - K; )
                  G = Ge(G), oe--;
                for (; K--; ) {
                  if (V === G || G !== null && V === G.alternate) {
                    Ge = V;
                    break t;
                  }
                  V = Ge(V), G = Ge(G);
                }
                Ge = null;
              }
            else Ge = null;
            le !== null && oy(
              fe,
              q,
              le,
              Ge,
              !1
            ), ze !== null && un !== null && oy(
              fe,
              un,
              ze,
              Ge,
              !0
            );
          }
        }
        e: {
          if (q = j ? xl(j) : window, le = q.nodeName && q.nodeName.toLowerCase(), le === "select" || le === "input" && q.type === "file")
            var Ut = Ln;
          else if (Tu(q))
            if (Ko)
              Ut = pr;
            else {
              Ut = Wi;
              var ke = Eu;
            }
          else
            le = q.nodeName, !le || le.toLowerCase() !== "input" || q.type !== "checkbox" && q.type !== "radio" ? j && ln(j.elementType) && (Ut = Ln) : Ut = jo;
          if (Ut && (Ut = Ut(e, j))) {
            Ir(
              fe,
              Ut,
              n,
              re
            );
            break e;
          }
          ke && ke(e, q, j), e === "focusout" && j && q.type === "number" && j.memoizedProps.value != null && be(q, "number", q.value);
        }
        switch (ke = j ? xl(j) : window, e) {
          case "focusin":
            (Tu(ke) || ke.contentEditable === "true") && (bi = ke, mi = j, ji = null);
            break;
          case "focusout":
            ji = mi = bi = null;
            break;
          case "mousedown":
            Tc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Tc = !1, Aa(fe, n, re);
            break;
          case "selectionchange":
            if (Au) break;
          case "keydown":
          case "keyup":
            Aa(fe, n, re);
        }
        var ut;
        if (Vi)
          e: {
            switch (e) {
              case "compositionstart":
                var Et = "onCompositionStart";
                break e;
              case "compositionend":
                Et = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Et = "onCompositionUpdate";
                break e;
            }
            Et = void 0;
          }
        else
          gi ? gc(e, n) && (Et = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (Et = "onCompositionStart");
        Et && (hc && n.locale !== "ko" && (gi || Et !== "onCompositionStart" ? Et === "onCompositionEnd" && gi && (ut = yu()) : (ya = re, yr = "value" in ya ? ya.value : ya.textContent, gi = !0)), ke = bd(j, Et), 0 < ke.length && (Et = new go(
          Et,
          e,
          null,
          n,
          re
        ), fe.push({ event: Et, listeners: ke }), ut ? Et.data = ut : (ut = mo(n), ut !== null && (Et.data = ut)))), (ut = Va ? vc(e, n) : ba(e, n)) && (Et = bd(j, "onBeforeInput"), 0 < Et.length && (ke = new go(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          re
        ), fe.push({
          event: ke,
          listeners: Et
        }), ke.data = ut)), H0(
          fe,
          e,
          j,
          n,
          re
        );
      }
      uy(fe, t);
    });
  }
  function _f(e, t, n) {
    return {
      instance: e,
      listener: t,
      currentTarget: n
    };
  }
  function bd(e, t) {
    for (var n = t + "Capture", l = []; e !== null; ) {
      var s = e, d = s.stateNode;
      if (s = s.tag, s !== 5 && s !== 26 && s !== 27 || d === null || (s = Ui(e, n), s != null && l.unshift(
        _f(e, s, d)
      ), s = Ui(e, t), s != null && l.push(
        _f(e, s, d)
      )), e.tag === 3) return l;
      e = e.return;
    }
    return [];
  }
  function Y0(e) {
    if (e === null) return null;
    do
      e = e.return;
    while (e && e.tag !== 5 && e.tag !== 27);
    return e || null;
  }
  function oy(e, t, n, l, s) {
    for (var d = t._reactName, S = []; n !== null && n !== l; ) {
      var R = n, H = R.alternate, j = R.stateNode;
      if (R = R.tag, H !== null && H === l) break;
      R !== 5 && R !== 26 && R !== 27 || j === null || (H = j, s ? (j = Ui(n, d), j != null && S.unshift(
        _f(n, j, H)
      )) : s || (j = Ui(n, d), j != null && S.push(
        _f(n, j, H)
      ))), n = n.return;
    }
    S.length !== 0 && e.push({ event: t, listeners: S });
  }
  var G0 = /\r\n?/g, X0 = /\u0000|\uFFFD/g;
  function sy(e) {
    return (typeof e == "string" ? e : "" + e).replace(G0, `
`).replace(X0, "");
  }
  function fy(e, t) {
    return t = sy(t), sy(e) === t;
  }
  function rn(e, t, n, l, s, d) {
    switch (n) {
      case "children":
        typeof l == "string" ? t === "body" || t === "textarea" && l === "" || Ee(e, l) : (typeof l == "number" || typeof l == "bigint") && t !== "body" && Ee(e, "" + l);
        break;
      case "className":
        el(e, "class", l);
        break;
      case "tabIndex":
        el(e, "tabindex", l);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        el(e, n, l);
        break;
      case "style":
        xn(e, l, d);
        break;
      case "data":
        if (t !== "object") {
          el(e, "data", l);
          break;
        }
      case "src":
      case "href":
        if (l === "" && (t !== "a" || n !== "href")) {
          e.removeAttribute(n);
          break;
        }
        if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(n);
          break;
        }
        l = Bi("" + l), e.setAttribute(n, l);
        break;
      case "action":
      case "formAction":
        if (typeof l == "function") {
          e.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof d == "function" && (n === "formAction" ? (t !== "input" && rn(e, t, "name", s.name, s, null), rn(
            e,
            t,
            "formEncType",
            s.formEncType,
            s,
            null
          ), rn(
            e,
            t,
            "formMethod",
            s.formMethod,
            s,
            null
          ), rn(
            e,
            t,
            "formTarget",
            s.formTarget,
            s,
            null
          )) : (rn(e, t, "encType", s.encType, s, null), rn(e, t, "method", s.method, s, null), rn(e, t, "target", s.target, s, null)));
        if (l == null || typeof l == "symbol" || typeof l == "boolean") {
          e.removeAttribute(n);
          break;
        }
        l = Bi("" + l), e.setAttribute(n, l);
        break;
      case "onClick":
        l != null && (e.onclick = Bt);
        break;
      case "onScroll":
        l != null && Tt("scroll", e);
        break;
      case "onScrollEnd":
        l != null && Tt("scrollend", e);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(y(61));
          if (n = l.__html, n != null) {
            if (s.children != null) throw Error(y(60));
            e.innerHTML = n;
          }
        }
        break;
      case "multiple":
        e.multiple = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "muted":
        e.muted = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
          e.removeAttribute("xlink:href");
          break;
        }
        n = Bi("" + l), e.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, "" + l) : e.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        l && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
        break;
      case "capture":
      case "download":
        l === !0 ? e.setAttribute(n, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? e.setAttribute(n, l) : e.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? e.setAttribute(n, l) : e.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? e.removeAttribute(n) : e.setAttribute(n, l);
        break;
      case "popover":
        Tt("beforetoggle", e), Tt("toggle", e), El(e, "popover", l);
        break;
      case "xlinkActuate":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          l
        );
        break;
      case "xlinkArcrole":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          l
        );
        break;
      case "xlinkRole":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          l
        );
        break;
      case "xlinkShow":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          l
        );
        break;
      case "xlinkTitle":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          l
        );
        break;
      case "xlinkType":
        Bl(
          e,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          l
        );
        break;
      case "xmlBase":
        Bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          l
        );
        break;
      case "xmlLang":
        Bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          l
        );
        break;
      case "xmlSpace":
        Bl(
          e,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          l
        );
        break;
      case "is":
        El(e, "is", l);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Ht.get(n) || n, El(e, n, l));
    }
  }
  function Xh(e, t, n, l, s, d) {
    switch (n) {
      case "style":
        xn(e, l, d);
        break;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(y(61));
          if (n = l.__html, n != null) {
            if (s.children != null) throw Error(y(60));
            e.innerHTML = n;
          }
        }
        break;
      case "children":
        typeof l == "string" ? Ee(e, l) : (typeof l == "number" || typeof l == "bigint") && Ee(e, "" + l);
        break;
      case "onScroll":
        l != null && Tt("scroll", e);
        break;
      case "onScrollEnd":
        l != null && Tt("scrollend", e);
        break;
      case "onClick":
        l != null && (e.onclick = Bt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!dn.hasOwnProperty(n))
          e: {
            if (n[0] === "o" && n[1] === "n" && (s = n.endsWith("Capture"), t = n.slice(2, s ? n.length - 7 : void 0), d = e[on] || null, d = d != null ? d[n] : null, typeof d == "function" && e.removeEventListener(t, d, s), typeof l == "function")) {
              typeof d != "function" && d !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, l, s);
              break e;
            }
            n in e ? e[n] = l : l === !0 ? e.setAttribute(n, "") : El(e, n, l);
          }
    }
  }
  function ca(e, t, n) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Tt("error", e), Tt("load", e);
        var l = !1, s = !1, d;
        for (d in n)
          if (n.hasOwnProperty(d)) {
            var S = n[d];
            if (S != null)
              switch (d) {
                case "src":
                  l = !0;
                  break;
                case "srcSet":
                  s = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(y(137, t));
                default:
                  rn(e, t, d, S, n, null);
              }
          }
        s && rn(e, t, "srcSet", n.srcSet, n, null), l && rn(e, t, "src", n.src, n, null);
        return;
      case "input":
        Tt("invalid", e);
        var R = d = S = s = null, H = null, j = null;
        for (l in n)
          if (n.hasOwnProperty(l)) {
            var re = n[l];
            if (re != null)
              switch (l) {
                case "name":
                  s = re;
                  break;
                case "type":
                  S = re;
                  break;
                case "checked":
                  H = re;
                  break;
                case "defaultChecked":
                  j = re;
                  break;
                case "value":
                  d = re;
                  break;
                case "defaultValue":
                  R = re;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (re != null)
                    throw Error(y(137, t));
                  break;
                default:
                  rn(e, t, l, re, n, null);
              }
          }
        Hi(
          e,
          d,
          R,
          H,
          j,
          S,
          s,
          !1
        );
        return;
      case "select":
        Tt("invalid", e), l = S = d = null;
        for (s in n)
          if (n.hasOwnProperty(s) && (R = n[s], R != null))
            switch (s) {
              case "value":
                d = R;
                break;
              case "defaultValue":
                S = R;
                break;
              case "multiple":
                l = R;
              default:
                rn(e, t, s, R, n, null);
            }
        t = d, n = S, e.multiple = !!l, t != null ? D(e, !!l, t, !1) : n != null && D(e, !!l, n, !0);
        return;
      case "textarea":
        Tt("invalid", e), d = s = l = null;
        for (S in n)
          if (n.hasOwnProperty(S) && (R = n[S], R != null))
            switch (S) {
              case "value":
                l = R;
                break;
              case "defaultValue":
                s = R;
                break;
              case "children":
                d = R;
                break;
              case "dangerouslySetInnerHTML":
                if (R != null) throw Error(y(91));
                break;
              default:
                rn(e, t, S, R, n, null);
            }
        me(e, l, s, d);
        return;
      case "option":
        for (H in n)
          if (n.hasOwnProperty(H) && (l = n[H], l != null))
            switch (H) {
              case "selected":
                e.selected = l && typeof l != "function" && typeof l != "symbol";
                break;
              default:
                rn(e, t, H, l, n, null);
            }
        return;
      case "dialog":
        Tt("beforetoggle", e), Tt("toggle", e), Tt("cancel", e), Tt("close", e);
        break;
      case "iframe":
      case "object":
        Tt("load", e);
        break;
      case "video":
      case "audio":
        for (l = 0; l < Af.length; l++)
          Tt(Af[l], e);
        break;
      case "image":
        Tt("error", e), Tt("load", e);
        break;
      case "details":
        Tt("toggle", e);
        break;
      case "embed":
      case "source":
      case "link":
        Tt("error", e), Tt("load", e);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (j in n)
          if (n.hasOwnProperty(j) && (l = n[j], l != null))
            switch (j) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(y(137, t));
              default:
                rn(e, t, j, l, n, null);
            }
        return;
      default:
        if (ln(t)) {
          for (re in n)
            n.hasOwnProperty(re) && (l = n[re], l !== void 0 && Xh(
              e,
              t,
              re,
              l,
              n,
              void 0
            ));
          return;
        }
    }
    for (R in n)
      n.hasOwnProperty(R) && (l = n[R], l != null && rn(e, t, R, l, n, null));
  }
  function I0(e, t, n, l) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var s = null, d = null, S = null, R = null, H = null, j = null, re = null;
        for (le in n) {
          var fe = n[le];
          if (n.hasOwnProperty(le) && fe != null)
            switch (le) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                H = fe;
              default:
                l.hasOwnProperty(le) || rn(e, t, le, null, l, fe);
            }
        }
        for (var q in l) {
          var le = l[q];
          if (fe = n[q], l.hasOwnProperty(q) && (le != null || fe != null))
            switch (q) {
              case "type":
                d = le;
                break;
              case "name":
                s = le;
                break;
              case "checked":
                j = le;
                break;
              case "defaultChecked":
                re = le;
                break;
              case "value":
                S = le;
                break;
              case "defaultValue":
                R = le;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (le != null)
                  throw Error(y(137, t));
                break;
              default:
                le !== fe && rn(
                  e,
                  t,
                  q,
                  le,
                  l,
                  fe
                );
            }
        }
        wl(
          e,
          S,
          R,
          H,
          j,
          re,
          d,
          s
        );
        return;
      case "select":
        le = S = R = q = null;
        for (d in n)
          if (H = n[d], n.hasOwnProperty(d) && H != null)
            switch (d) {
              case "value":
                break;
              case "multiple":
                le = H;
              default:
                l.hasOwnProperty(d) || rn(
                  e,
                  t,
                  d,
                  null,
                  l,
                  H
                );
            }
        for (s in l)
          if (d = l[s], H = n[s], l.hasOwnProperty(s) && (d != null || H != null))
            switch (s) {
              case "value":
                q = d;
                break;
              case "defaultValue":
                R = d;
                break;
              case "multiple":
                S = d;
              default:
                d !== H && rn(
                  e,
                  t,
                  s,
                  d,
                  l,
                  H
                );
            }
        t = R, n = S, l = le, q != null ? D(e, !!n, q, !1) : !!l != !!n && (t != null ? D(e, !!n, t, !0) : D(e, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        le = q = null;
        for (R in n)
          if (s = n[R], n.hasOwnProperty(R) && s != null && !l.hasOwnProperty(R))
            switch (R) {
              case "value":
                break;
              case "children":
                break;
              default:
                rn(e, t, R, null, l, s);
            }
        for (S in l)
          if (s = l[S], d = n[S], l.hasOwnProperty(S) && (s != null || d != null))
            switch (S) {
              case "value":
                q = s;
                break;
              case "defaultValue":
                le = s;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (s != null) throw Error(y(91));
                break;
              default:
                s !== d && rn(e, t, S, s, l, d);
            }
        W(e, q, le);
        return;
      case "option":
        for (var ze in n)
          if (q = n[ze], n.hasOwnProperty(ze) && q != null && !l.hasOwnProperty(ze))
            switch (ze) {
              case "selected":
                e.selected = !1;
                break;
              default:
                rn(
                  e,
                  t,
                  ze,
                  null,
                  l,
                  q
                );
            }
        for (H in l)
          if (q = l[H], le = n[H], l.hasOwnProperty(H) && q !== le && (q != null || le != null))
            switch (H) {
              case "selected":
                e.selected = q && typeof q != "function" && typeof q != "symbol";
                break;
              default:
                rn(
                  e,
                  t,
                  H,
                  q,
                  l,
                  le
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var Ge in n)
          q = n[Ge], n.hasOwnProperty(Ge) && q != null && !l.hasOwnProperty(Ge) && rn(e, t, Ge, null, l, q);
        for (j in l)
          if (q = l[j], le = n[j], l.hasOwnProperty(j) && q !== le && (q != null || le != null))
            switch (j) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (q != null)
                  throw Error(y(137, t));
                break;
              default:
                rn(
                  e,
                  t,
                  j,
                  q,
                  l,
                  le
                );
            }
        return;
      default:
        if (ln(t)) {
          for (var un in n)
            q = n[un], n.hasOwnProperty(un) && q !== void 0 && !l.hasOwnProperty(un) && Xh(
              e,
              t,
              un,
              void 0,
              l,
              q
            );
          for (re in l)
            q = l[re], le = n[re], !l.hasOwnProperty(re) || q === le || q === void 0 && le === void 0 || Xh(
              e,
              t,
              re,
              q,
              l,
              le
            );
          return;
        }
    }
    for (var V in n)
      q = n[V], n.hasOwnProperty(V) && q != null && !l.hasOwnProperty(V) && rn(e, t, V, null, l, q);
    for (fe in l)
      q = l[fe], le = n[fe], !l.hasOwnProperty(fe) || q === le || q == null && le == null || rn(e, t, fe, q, l, le);
  }
  function dy(e) {
    switch (e) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Z0() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), l = 0; l < n.length; l++) {
        var s = n[l], d = s.transferSize, S = s.initiatorType, R = s.duration;
        if (d && R && dy(S)) {
          for (S = 0, R = s.responseEnd, l += 1; l < n.length; l++) {
            var H = n[l], j = H.startTime;
            if (j > R) break;
            var re = H.transferSize, fe = H.initiatorType;
            re && dy(fe) && (H = H.responseEnd, S += re * (H < R ? 1 : (R - j) / (H - j)));
          }
          if (--l, t += 8 * (d + S) / (s.duration / 1e3), e++, 10 < e) break;
        }
      }
      if (0 < e) return t / e / 1e6;
    }
    return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
  }
  var Ih = null, Zh = null;
  function md(e) {
    return e.nodeType === 9 ? e : e.ownerDocument;
  }
  function hy(e) {
    switch (e) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function gy(e, t) {
    if (e === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return e === 1 && t === "foreignObject" ? 0 : e;
  }
  function Vh(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var Qh = null;
  function V0() {
    var e = window.event;
    return e && e.type === "popstate" ? e === Qh ? !1 : (Qh = e, !0) : (Qh = null, !1);
  }
  var vy = typeof setTimeout == "function" ? setTimeout : void 0, Q0 = typeof clearTimeout == "function" ? clearTimeout : void 0, yy = typeof Promise == "function" ? Promise : void 0, P0 = typeof queueMicrotask == "function" ? queueMicrotask : typeof yy < "u" ? function(e) {
    return yy.resolve(null).then(e).catch(W0);
  } : vy;
  function W0(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function qc(e) {
    return e === "head";
  }
  function by(e, t) {
    var n = t, l = 0;
    do {
      var s = n.nextSibling;
      if (e.removeChild(n), s && s.nodeType === 8)
        if (n = s.data, n === "/$" || n === "/&") {
          if (l === 0) {
            e.removeChild(s), Ns(t);
            return;
          }
          l--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          l++;
        else if (n === "html")
          Of(e.ownerDocument.documentElement);
        else if (n === "head") {
          n = e.ownerDocument.head, Of(n);
          for (var d = n.firstChild; d; ) {
            var S = d.nextSibling, R = d.nodeName;
            d[Ea] || R === "SCRIPT" || R === "STYLE" || R === "LINK" && d.rel.toLowerCase() === "stylesheet" || n.removeChild(d), d = S;
          }
        } else
          n === "body" && Of(e.ownerDocument.body);
      n = s;
    } while (n);
    Ns(t);
  }
  function my(e, t) {
    var n = e;
    e = 0;
    do {
      var l = n.nextSibling;
      if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), l && l.nodeType === 8)
        if (n = l.data, n === "/$") {
          if (e === 0) break;
          e--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
      n = l;
    } while (n);
  }
  function Ph(e) {
    var t = e.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var n = t;
      switch (t = t.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Ph(n), $n(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      e.removeChild(n);
    }
  }
  function J0(e, t, n, l) {
    for (; e.nodeType === 1; ) {
      var s = n;
      if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!l && (e.nodeName !== "INPUT" || e.type !== "hidden"))
          break;
      } else if (l) {
        if (!e[Ea])
          switch (t) {
            case "meta":
              if (!e.hasAttribute("itemprop")) break;
              return e;
            case "link":
              if (d = e.getAttribute("rel"), d === "stylesheet" && e.hasAttribute("data-precedence"))
                break;
              if (d !== s.rel || e.getAttribute("href") !== (s.href == null || s.href === "" ? null : s.href) || e.getAttribute("crossorigin") !== (s.crossOrigin == null ? null : s.crossOrigin) || e.getAttribute("title") !== (s.title == null ? null : s.title))
                break;
              return e;
            case "style":
              if (e.hasAttribute("data-precedence")) break;
              return e;
            case "script":
              if (d = e.getAttribute("src"), (d !== (s.src == null ? null : s.src) || e.getAttribute("type") !== (s.type == null ? null : s.type) || e.getAttribute("crossorigin") !== (s.crossOrigin == null ? null : s.crossOrigin)) && d && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                break;
              return e;
            default:
              return e;
          }
      } else if (t === "input" && e.type === "hidden") {
        var d = s.name == null ? null : "" + s.name;
        if (s.type === "hidden" && e.getAttribute("name") === d)
          return e;
      } else return e;
      if (e = ir(e.nextSibling), e === null) break;
    }
    return null;
  }
  function K0(e, t, n) {
    if (t === "") return null;
    for (; e.nodeType !== 3; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = ir(e.nextSibling), e === null)) return null;
    return e;
  }
  function py(e, t) {
    for (; e.nodeType !== 8; )
      if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = ir(e.nextSibling), e === null)) return null;
    return e;
  }
  function Wh(e) {
    return e.data === "$?" || e.data === "$~";
  }
  function Jh(e) {
    return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
  }
  function j0(e, t) {
    var n = e.ownerDocument;
    if (e.data === "$~") e._reactRetry = t;
    else if (e.data !== "$?" || n.readyState !== "loading")
      t();
    else {
      var l = function() {
        t(), n.removeEventListener("DOMContentLoaded", l);
      };
      n.addEventListener("DOMContentLoaded", l), e._reactRetry = l;
    }
  }
  function ir(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return e;
  }
  var Kh = null;
  function Ty(e) {
    e = e.nextSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "/$" || n === "/&") {
          if (t === 0)
            return ir(e.nextSibling);
          t--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
      }
      e = e.nextSibling;
    }
    return null;
  }
  function Sy(e) {
    e = e.previousSibling;
    for (var t = 0; e; ) {
      if (e.nodeType === 8) {
        var n = e.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (t === 0) return e;
          t--;
        } else n !== "/$" && n !== "/&" || t++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function xy(e, t, n) {
    switch (t = md(n), e) {
      case "html":
        if (e = t.documentElement, !e) throw Error(y(452));
        return e;
      case "head":
        if (e = t.head, !e) throw Error(y(453));
        return e;
      case "body":
        if (e = t.body, !e) throw Error(y(454));
        return e;
      default:
        throw Error(y(451));
    }
  }
  function Of(e) {
    for (var t = e.attributes; t.length; )
      e.removeAttributeNode(t[0]);
    $n(e);
  }
  var rr = /* @__PURE__ */ new Map(), Ey = /* @__PURE__ */ new Set();
  function pd(e) {
    return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
  }
  var qu = Se.d;
  Se.d = {
    f: q0,
    r: $0,
    D: e1,
    C: t1,
    L: n1,
    m: l1,
    X: i1,
    S: a1,
    M: r1
  };
  function q0() {
    var e = qu.f(), t = sd();
    return e || t;
  }
  function $0(e) {
    var t = Xa(e);
    t !== null && t.tag === 5 && t.type === "form" ? lf(t) : qu.r(e);
  }
  var Os = typeof document > "u" ? null : document;
  function wy(e, t, n) {
    var l = Os;
    if (l && typeof t == "string" && t) {
      var s = tl(t);
      s = 'link[rel="' + e + '"][href="' + s + '"]', typeof n == "string" && (s += '[crossorigin="' + n + '"]'), Ey.has(s) || (Ey.add(s), e = { rel: e, crossOrigin: n, href: t }, l.querySelector(s) === null && (t = l.createElement("link"), ca(t, "link", e), Vt(t), l.head.appendChild(t)));
    }
  }
  function e1(e) {
    qu.D(e), wy("dns-prefetch", e, null);
  }
  function t1(e, t) {
    qu.C(e, t), wy("preconnect", e, t);
  }
  function n1(e, t, n) {
    qu.L(e, t, n);
    var l = Os;
    if (l && e && t) {
      var s = 'link[rel="preload"][as="' + tl(t) + '"]';
      t === "image" && n && n.imageSrcSet ? (s += '[imagesrcset="' + tl(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (s += '[imagesizes="' + tl(
        n.imageSizes
      ) + '"]')) : s += '[href="' + tl(e) + '"]';
      var d = s;
      switch (t) {
        case "style":
          d = Cs(e);
          break;
        case "script":
          d = Rs(e);
      }
      rr.has(d) || (e = F(
        {
          rel: "preload",
          href: t === "image" && n && n.imageSrcSet ? void 0 : e,
          as: t
        },
        n
      ), rr.set(d, e), l.querySelector(s) !== null || t === "style" && l.querySelector(Cf(d)) || t === "script" && l.querySelector(Rf(d)) || (t = l.createElement("link"), ca(t, "link", e), Vt(t), l.head.appendChild(t)));
    }
  }
  function l1(e, t) {
    qu.m(e, t);
    var n = Os;
    if (n && e) {
      var l = t && typeof t.as == "string" ? t.as : "script", s = 'link[rel="modulepreload"][as="' + tl(l) + '"][href="' + tl(e) + '"]', d = s;
      switch (l) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          d = Rs(e);
      }
      if (!rr.has(d) && (e = F({ rel: "modulepreload", href: e }, t), rr.set(d, e), n.querySelector(s) === null)) {
        switch (l) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(Rf(d)))
              return;
        }
        l = n.createElement("link"), ca(l, "link", e), Vt(l), n.head.appendChild(l);
      }
    }
  }
  function a1(e, t, n) {
    qu.S(e, t, n);
    var l = Os;
    if (l && e) {
      var s = Ia(l).hoistableStyles, d = Cs(e);
      t = t || "default";
      var S = s.get(d);
      if (!S) {
        var R = { loading: 0, preload: null };
        if (S = l.querySelector(
          Cf(d)
        ))
          R.loading = 5;
        else {
          e = F(
            { rel: "stylesheet", href: e, "data-precedence": t },
            n
          ), (n = rr.get(d)) && jh(e, n);
          var H = S = l.createElement("link");
          Vt(H), ca(H, "link", e), H._p = new Promise(function(j, re) {
            H.onload = j, H.onerror = re;
          }), H.addEventListener("load", function() {
            R.loading |= 1;
          }), H.addEventListener("error", function() {
            R.loading |= 2;
          }), R.loading |= 4, Td(S, t, l);
        }
        S = {
          type: "stylesheet",
          instance: S,
          count: 1,
          state: R
        }, s.set(d, S);
      }
    }
  }
  function i1(e, t) {
    qu.X(e, t);
    var n = Os;
    if (n && e) {
      var l = Ia(n).hoistableScripts, s = Rs(e), d = l.get(s);
      d || (d = n.querySelector(Rf(s)), d || (e = F({ src: e, async: !0 }, t), (t = rr.get(s)) && qh(e, t), d = n.createElement("script"), Vt(d), ca(d, "link", e), n.head.appendChild(d)), d = {
        type: "script",
        instance: d,
        count: 1,
        state: null
      }, l.set(s, d));
    }
  }
  function r1(e, t) {
    qu.M(e, t);
    var n = Os;
    if (n && e) {
      var l = Ia(n).hoistableScripts, s = Rs(e), d = l.get(s);
      d || (d = n.querySelector(Rf(s)), d || (e = F({ src: e, async: !0, type: "module" }, t), (t = rr.get(s)) && qh(e, t), d = n.createElement("script"), Vt(d), ca(d, "link", e), n.head.appendChild(d)), d = {
        type: "script",
        instance: d,
        count: 1,
        state: null
      }, l.set(s, d));
    }
  }
  function Ay(e, t, n, l) {
    var s = (s = en.current) ? pd(s) : null;
    if (!s) throw Error(y(446));
    switch (e) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Cs(n.href), n = Ia(
          s
        ).hoistableStyles, l = n.get(t), l || (l = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(t, l)), l) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          e = Cs(n.href);
          var d = Ia(
            s
          ).hoistableStyles, S = d.get(e);
          if (S || (s = s.ownerDocument || s, S = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, d.set(e, S), (d = s.querySelector(
            Cf(e)
          )) && !d._p && (S.instance = d, S.state.loading = 5), rr.has(e) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, rr.set(e, n), d || u1(
            s,
            e,
            n,
            S.state
          ))), t && l === null)
            throw Error(y(528, ""));
          return S;
        }
        if (t && l !== null)
          throw Error(y(529, ""));
        return null;
      case "script":
        return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Rs(n), n = Ia(
          s
        ).hoistableScripts, l = n.get(t), l || (l = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(t, l)), l) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(y(444, e));
    }
  }
  function Cs(e) {
    return 'href="' + tl(e) + '"';
  }
  function Cf(e) {
    return 'link[rel="stylesheet"][' + e + "]";
  }
  function _y(e) {
    return F({}, e, {
      "data-precedence": e.precedence,
      precedence: null
    });
  }
  function u1(e, t, n, l) {
    e.querySelector('link[rel="preload"][as="style"][' + t + "]") ? l.loading = 1 : (t = e.createElement("link"), l.preload = t, t.addEventListener("load", function() {
      return l.loading |= 1;
    }), t.addEventListener("error", function() {
      return l.loading |= 2;
    }), ca(t, "link", n), Vt(t), e.head.appendChild(t));
  }
  function Rs(e) {
    return '[src="' + tl(e) + '"]';
  }
  function Rf(e) {
    return "script[async]" + e;
  }
  function Oy(e, t, n) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var l = e.querySelector(
            'style[data-href~="' + tl(n.href) + '"]'
          );
          if (l)
            return t.instance = l, Vt(l), l;
          var s = F({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return l = (e.ownerDocument || e).createElement(
            "style"
          ), Vt(l), ca(l, "style", s), Td(l, n.precedence, e), t.instance = l;
        case "stylesheet":
          s = Cs(n.href);
          var d = e.querySelector(
            Cf(s)
          );
          if (d)
            return t.state.loading |= 4, t.instance = d, Vt(d), d;
          l = _y(n), (s = rr.get(s)) && jh(l, s), d = (e.ownerDocument || e).createElement("link"), Vt(d);
          var S = d;
          return S._p = new Promise(function(R, H) {
            S.onload = R, S.onerror = H;
          }), ca(d, "link", l), t.state.loading |= 4, Td(d, n.precedence, e), t.instance = d;
        case "script":
          return d = Rs(n.src), (s = e.querySelector(
            Rf(d)
          )) ? (t.instance = s, Vt(s), s) : (l = n, (s = rr.get(d)) && (l = F({}, n), qh(l, s)), e = e.ownerDocument || e, s = e.createElement("script"), Vt(s), ca(s, "link", l), e.head.appendChild(s), t.instance = s);
        case "void":
          return null;
        default:
          throw Error(y(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (l = t.instance, t.state.loading |= 4, Td(l, n.precedence, e));
    return t.instance;
  }
  function Td(e, t, n) {
    for (var l = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), s = l.length ? l[l.length - 1] : null, d = s, S = 0; S < l.length; S++) {
      var R = l[S];
      if (R.dataset.precedence === t) d = R;
      else if (d !== s) break;
    }
    d ? d.parentNode.insertBefore(e, d.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
  }
  function jh(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
  }
  function qh(e, t) {
    e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
  }
  var Sd = null;
  function Cy(e, t, n) {
    if (Sd === null) {
      var l = /* @__PURE__ */ new Map(), s = Sd = /* @__PURE__ */ new Map();
      s.set(n, l);
    } else
      s = Sd, l = s.get(n), l || (l = /* @__PURE__ */ new Map(), s.set(n, l));
    if (l.has(e)) return l;
    for (l.set(e, null), n = n.getElementsByTagName(e), s = 0; s < n.length; s++) {
      var d = n[s];
      if (!(d[Ea] || d[nt] || e === "link" && d.getAttribute("rel") === "stylesheet") && d.namespaceURI !== "http://www.w3.org/2000/svg") {
        var S = d.getAttribute(t) || "";
        S = e + S;
        var R = l.get(S);
        R ? R.push(d) : l.set(S, [d]);
      }
    }
    return l;
  }
  function Ry(e, t, n) {
    e = e.ownerDocument || e, e.head.insertBefore(
      n,
      t === "title" ? e.querySelector("head > title") : null
    );
  }
  function c1(e, t, n) {
    if (n === 1 || t.itemProp != null) return !1;
    switch (e) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        switch (t.rel) {
          case "stylesheet":
            return e = t.disabled, typeof t.precedence == "string" && e == null;
          default:
            return !0;
        }
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function Ny(e) {
    return !(e.type === "stylesheet" && (e.state.loading & 3) === 0);
  }
  function o1(e, t, n, l) {
    if (n.type === "stylesheet" && (typeof l.media != "string" || matchMedia(l.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var s = Cs(l.href), d = t.querySelector(
          Cf(s)
        );
        if (d) {
          t = d._p, t !== null && typeof t == "object" && typeof t.then == "function" && (e.count++, e = xd.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = d, Vt(d);
          return;
        }
        d = t.ownerDocument || t, l = _y(l), (s = rr.get(s)) && jh(l, s), d = d.createElement("link"), Vt(d);
        var S = d;
        S._p = new Promise(function(R, H) {
          S.onload = R, S.onerror = H;
        }), ca(d, "link", l), n.instance = d;
      }
      e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && (n.state.loading & 3) === 0 && (e.count++, n = xd.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
    }
  }
  var $h = 0;
  function s1(e, t) {
    return e.stylesheets && e.count === 0 && wd(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
      var l = setTimeout(function() {
        if (e.stylesheets && wd(e, e.stylesheets), e.unsuspend) {
          var d = e.unsuspend;
          e.unsuspend = null, d();
        }
      }, 6e4 + t);
      0 < e.imgBytes && $h === 0 && ($h = 62500 * Z0());
      var s = setTimeout(
        function() {
          if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && wd(e, e.stylesheets), e.unsuspend)) {
            var d = e.unsuspend;
            e.unsuspend = null, d();
          }
        },
        (e.imgBytes > $h ? 50 : 800) + t
      );
      return e.unsuspend = n, function() {
        e.unsuspend = null, clearTimeout(l), clearTimeout(s);
      };
    } : null;
  }
  function xd() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) wd(this, this.stylesheets);
      else if (this.unsuspend) {
        var e = this.unsuspend;
        this.unsuspend = null, e();
      }
    }
  }
  var Ed = null;
  function wd(e, t) {
    e.stylesheets = null, e.unsuspend !== null && (e.count++, Ed = /* @__PURE__ */ new Map(), t.forEach(f1, e), Ed = null, xd.call(e));
  }
  function f1(e, t) {
    if (!(t.state.loading & 4)) {
      var n = Ed.get(e);
      if (n) var l = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), Ed.set(e, n);
        for (var s = e.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), d = 0; d < s.length; d++) {
          var S = s[d];
          (S.nodeName === "LINK" || S.getAttribute("media") !== "not all") && (n.set(S.dataset.precedence, S), l = S);
        }
        l && n.set(null, l);
      }
      s = t.instance, S = s.getAttribute("data-precedence"), d = n.get(S) || l, d === l && n.set(null, s), n.set(S, s), this.count++, l = xd.bind(this), s.addEventListener("load", l), s.addEventListener("error", l), d ? d.parentNode.insertBefore(s, d.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(s, e.firstChild)), t.state.loading |= 4;
    }
  }
  var Nf = {
    $$typeof: Re,
    Provider: null,
    Consumer: null,
    _currentValue: et,
    _currentValue2: et,
    _threadCount: 0
  };
  function d1(e, t, n, l, s, d, S, R, H) {
    this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = sr(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = sr(0), this.hiddenUpdates = sr(null), this.identifierPrefix = l, this.onUncaughtError = s, this.onCaughtError = d, this.onRecoverableError = S, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = H, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function My(e, t, n, l, s, d, S, R, H, j, re, fe) {
    return e = new d1(
      e,
      t,
      n,
      S,
      H,
      j,
      re,
      fe,
      R
    ), t = 1, d === !0 && (t |= 24), d = Pe(3, null, null, t), e.current = d, d.stateNode = e, t = Ec(), t.refCount++, e.pooledCache = t, t.refCount++, d.memoizedState = {
      element: l,
      isDehydrated: n,
      cache: t
    }, xr(d), e;
  }
  function zy(e) {
    return e ? (e = lt, e) : lt;
  }
  function Dy(e, t, n, l, s, d) {
    s = zy(s), l.context === null ? l.context = s : l.pendingContext = s, l = vl(t), l.payload = { element: n }, d = d === void 0 ? null : d, d !== null && (l.callback = d), n = Nl(e, l, t), n !== null && (ri(n, e, t), yl(n, e, t));
  }
  function Ly(e, t) {
    if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
      var n = e.retryLane;
      e.retryLane = n !== 0 && n < t ? n : t;
    }
  }
  function eg(e, t) {
    Ly(e, t), (e = e.alternate) && Ly(e, t);
  }
  function ky(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Lt(e, 67108864);
      t !== null && ri(t, e, 67108864), eg(e, 67108864);
    }
  }
  function Hy(e) {
    if (e.tag === 13 || e.tag === 31) {
      var t = Oi();
      t = zt(t);
      var n = Lt(e, t);
      n !== null && ri(n, e, t), eg(e, t);
    }
  }
  var Ad = !0;
  function h1(e, t, n, l) {
    var s = P.T;
    P.T = null;
    var d = Se.p;
    try {
      Se.p = 2, tg(e, t, n, l);
    } finally {
      Se.p = d, P.T = s;
    }
  }
  function g1(e, t, n, l) {
    var s = P.T;
    P.T = null;
    var d = Se.p;
    try {
      Se.p = 8, tg(e, t, n, l);
    } finally {
      Se.p = d, P.T = s;
    }
  }
  function tg(e, t, n, l) {
    if (Ad) {
      var s = ng(l);
      if (s === null)
        Gh(
          e,
          t,
          l,
          _d,
          n
        ), Uy(e, l);
      else if (y1(
        s,
        e,
        t,
        n,
        l
      ))
        l.stopPropagation();
      else if (Uy(e, l), t & 4 && -1 < v1.indexOf(e)) {
        for (; s !== null; ) {
          var d = Xa(s);
          if (d !== null)
            switch (d.tag) {
              case 3:
                if (d = d.stateNode, d.current.memoizedState.isDehydrated) {
                  var S = Jl(d.pendingLanes);
                  if (S !== 0) {
                    var R = d;
                    for (R.pendingLanes |= 2, R.entangledLanes |= 2; S; ) {
                      var H = 1 << 31 - Cn(S);
                      R.entanglements[1] |= H, S &= ~H;
                    }
                    su(d), (Yt & 6) === 0 && (cd = Ue() + 500, wf(0));
                  }
                }
                break;
              case 31:
              case 13:
                R = Lt(d, 2), R !== null && ri(R, d, 2), sd(), eg(d, 2);
            }
          if (d = ng(l), d === null && Gh(
            e,
            t,
            l,
            _d,
            n
          ), d === s) break;
          s = d;
        }
        s !== null && l.stopPropagation();
      } else
        Gh(
          e,
          t,
          l,
          null,
          n
        );
    }
  }
  function ng(e) {
    return e = so(e), lg(e);
  }
  var _d = null;
  function lg(e) {
    if (_d = null, e = Di(e), e !== null) {
      var t = w(e);
      if (t === null) e = null;
      else {
        var n = t.tag;
        if (n === 13) {
          if (e = _(t), e !== null) return e;
          e = null;
        } else if (n === 31) {
          if (e = C(t), e !== null) return e;
          e = null;
        } else if (n === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          e = null;
        } else t !== e && (e = null);
      }
    }
    return _d = e, null;
  }
  function By(e) {
    switch (e) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (qn()) {
          case Lr:
            return 2;
          case Mi:
            return 8;
          case tn:
          case Ha:
            return 32;
          case ui:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var ag = !1, $c = null, eo = null, to = null, Mf = /* @__PURE__ */ new Map(), zf = /* @__PURE__ */ new Map(), no = [], v1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Uy(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        $c = null;
        break;
      case "dragenter":
      case "dragleave":
        eo = null;
        break;
      case "mouseover":
      case "mouseout":
        to = null;
        break;
      case "pointerover":
      case "pointerout":
        Mf.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        zf.delete(t.pointerId);
    }
  }
  function Df(e, t, n, l, s, d) {
    return e === null || e.nativeEvent !== d ? (e = {
      blockedOn: t,
      domEventName: n,
      eventSystemFlags: l,
      nativeEvent: d,
      targetContainers: [s]
    }, t !== null && (t = Xa(t), t !== null && ky(t)), e) : (e.eventSystemFlags |= l, t = e.targetContainers, s !== null && t.indexOf(s) === -1 && t.push(s), e);
  }
  function y1(e, t, n, l, s) {
    switch (t) {
      case "focusin":
        return $c = Df(
          $c,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "dragenter":
        return eo = Df(
          eo,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "mouseover":
        return to = Df(
          to,
          e,
          t,
          n,
          l,
          s
        ), !0;
      case "pointerover":
        var d = s.pointerId;
        return Mf.set(
          d,
          Df(
            Mf.get(d) || null,
            e,
            t,
            n,
            l,
            s
          )
        ), !0;
      case "gotpointercapture":
        return d = s.pointerId, zf.set(
          d,
          Df(
            zf.get(d) || null,
            e,
            t,
            n,
            l,
            s
          )
        ), !0;
    }
    return !1;
  }
  function Fy(e) {
    var t = Di(e.target);
    if (t !== null) {
      var n = w(t);
      if (n !== null) {
        if (t = n.tag, t === 13) {
          if (t = _(n), t !== null) {
            e.blockedOn = t, Zt(e.priority, function() {
              Hy(n);
            });
            return;
          }
        } else if (t === 31) {
          if (t = C(n), t !== null) {
            e.blockedOn = t, Zt(e.priority, function() {
              Hy(n);
            });
            return;
          }
        } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e.blockedOn = null;
  }
  function Od(e) {
    if (e.blockedOn !== null) return !1;
    for (var t = e.targetContainers; 0 < t.length; ) {
      var n = ng(e.nativeEvent);
      if (n === null) {
        n = e.nativeEvent;
        var l = new n.constructor(
          n.type,
          n
        );
        Br = l, n.target.dispatchEvent(l), Br = null;
      } else
        return t = Xa(n), t !== null && ky(t), e.blockedOn = n, !1;
      t.shift();
    }
    return !0;
  }
  function Yy(e, t, n) {
    Od(e) && n.delete(t);
  }
  function b1() {
    ag = !1, $c !== null && Od($c) && ($c = null), eo !== null && Od(eo) && (eo = null), to !== null && Od(to) && (to = null), Mf.forEach(Yy), zf.forEach(Yy);
  }
  function Cd(e, t) {
    e.blockedOn === t && (e.blockedOn = null, ag || (ag = !0, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      b1
    )));
  }
  var Rd = null;
  function Gy(e) {
    Rd !== e && (Rd = e, o.unstable_scheduleCallback(
      o.unstable_NormalPriority,
      function() {
        Rd === e && (Rd = null);
        for (var t = 0; t < e.length; t += 3) {
          var n = e[t], l = e[t + 1], s = e[t + 2];
          if (typeof l != "function") {
            if (lg(l || n) === null)
              continue;
            break;
          }
          var d = Xa(n);
          d !== null && (e.splice(t, 3), t -= 3, Hc(
            d,
            {
              pending: !0,
              data: s,
              method: n.method,
              action: l
            },
            l,
            s
          ));
        }
      }
    ));
  }
  function Ns(e) {
    function t(H) {
      return Cd(H, e);
    }
    $c !== null && Cd($c, e), eo !== null && Cd(eo, e), to !== null && Cd(to, e), Mf.forEach(t), zf.forEach(t);
    for (var n = 0; n < no.length; n++) {
      var l = no[n];
      l.blockedOn === e && (l.blockedOn = null);
    }
    for (; 0 < no.length && (n = no[0], n.blockedOn === null); )
      Fy(n), n.blockedOn === null && no.shift();
    if (n = (e.ownerDocument || e).$$reactFormReplay, n != null)
      for (l = 0; l < n.length; l += 3) {
        var s = n[l], d = n[l + 1], S = s[on] || null;
        if (typeof d == "function")
          S || Gy(n);
        else if (S) {
          var R = null;
          if (d && d.hasAttribute("formAction")) {
            if (s = d, S = d[on] || null)
              R = S.formAction;
            else if (lg(s) !== null) continue;
          } else R = S.action;
          typeof R == "function" ? n[l + 1] = R : (n.splice(l, 3), l -= 3), Gy(n);
        }
      }
  }
  function Xy() {
    function e(d) {
      d.canIntercept && d.info === "react-transition" && d.intercept({
        handler: function() {
          return new Promise(function(S) {
            return s = S;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      s !== null && (s(), s = null), l || setTimeout(n, 20);
    }
    function n() {
      if (!l && !navigation.transition) {
        var d = navigation.currentEntry;
        d && d.url != null && navigation.navigate(d.url, {
          state: d.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var l = !1, s = null;
      return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
        l = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), s !== null && (s(), s = null);
      };
    }
  }
  function ig(e) {
    this._internalRoot = e;
  }
  Nd.prototype.render = ig.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null) throw Error(y(409));
    var n = t.current, l = Oi();
    Dy(n, l, e, t, null, null);
  }, Nd.prototype.unmount = ig.prototype.unmount = function() {
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      Dy(e.current, 2, null, e, null, null), sd(), t[si] = null;
    }
  };
  function Nd(e) {
    this._internalRoot = e;
  }
  Nd.prototype.unstable_scheduleHydration = function(e) {
    if (e) {
      var t = Nn();
      e = { blockedOn: null, target: e, priority: t };
      for (var n = 0; n < no.length && t !== 0 && t < no[n].priority; n++) ;
      no.splice(n, 0, e), n === 0 && Fy(e);
    }
  };
  var Iy = f.version;
  if (Iy !== "19.2.6")
    throw Error(
      y(
        527,
        Iy,
        "19.2.6"
      )
    );
  Se.findDOMNode = function(e) {
    var t = e._reactInternals;
    if (t === void 0)
      throw typeof e.render == "function" ? Error(y(188)) : (e = Object.keys(e).join(","), Error(y(268, e)));
    return e = B(t), e = e !== null ? I(e) : null, e = e === null ? null : e.stateNode, e;
  };
  var m1 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: P,
    reconcilerVersion: "19.2.6"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Md = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Md.isDisabled && Md.supportsFiber)
      try {
        Wl = Md.inject(
          m1
        ), Zn = Md;
      } catch {
      }
  }
  return Yf.createRoot = function(e, t) {
    if (!p(e)) throw Error(y(299));
    var n = !1, l = "", s = ru, d = sf, S = ff;
    return t != null && (t.unstable_strictMode === !0 && (n = !0), t.identifierPrefix !== void 0 && (l = t.identifierPrefix), t.onUncaughtError !== void 0 && (s = t.onUncaughtError), t.onCaughtError !== void 0 && (d = t.onCaughtError), t.onRecoverableError !== void 0 && (S = t.onRecoverableError)), t = My(
      e,
      1,
      !1,
      null,
      null,
      n,
      l,
      null,
      s,
      d,
      S,
      Xy
    ), e[si] = t.current, Yh(e), new ig(t);
  }, Yf.hydrateRoot = function(e, t, n) {
    if (!p(e)) throw Error(y(299));
    var l = !1, s = "", d = ru, S = sf, R = ff, H = null;
    return n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (s = n.identifierPrefix), n.onUncaughtError !== void 0 && (d = n.onUncaughtError), n.onCaughtError !== void 0 && (S = n.onCaughtError), n.onRecoverableError !== void 0 && (R = n.onRecoverableError), n.formState !== void 0 && (H = n.formState)), t = My(
      e,
      1,
      !0,
      t,
      n ?? null,
      l,
      s,
      H,
      d,
      S,
      R,
      Xy
    ), t.context = zy(null), n = t.current, l = Oi(), l = zt(l), s = vl(l), s.callback = null, Nl(n, s, l), n = l, t.current.lanes = n, Ya(t, n), su(t), e[si] = t.current, Yh(e), new Nd(t);
  }, Yf.version = "19.2.6", Yf;
}
var tm;
function sE() {
  if (tm) return Ag.exports;
  tm = 1;
  function a() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(a);
      } catch (o) {
        console.error(o);
      }
  }
  return a(), Ag.exports = oE(), Ag.exports;
}
var m0 = sE();
const fE = (a, o, f) => {
  m0.createRoot(f).render(Xt.createElement(a, o));
}, yh = ({ typeCarousel: a, targetSelector: o, props: f }) => {
  const y = {
    card: f0,
    testimonial: v0,
    image: d0,
    "image-gallery": g0
  }[a];
  y && fE(y, f, document.querySelector(o));
}, vE = ({ targetSelector: a, props: o }) => yh({
  typeCarousel: "card",
  targetSelector: a,
  props: o
}), yE = ({ targetSelector: a, props: o }) => {
  yh({
    typeCarousel: "testimonial",
    targetSelector: a,
    props: o
  });
}, bE = ({ targetSelector: a, props: o }) => {
  yh({ typeCarousel: "image", targetSelector: a, props: o });
}, mE = ({ targetSelector: a, props: o }) => {
  yh({
    typeCarousel: "image-gallery",
    targetSelector: a,
    props: o
  });
}, Kn = (a, o, f) => {
  m0.createRoot(f).render(Xt.createElement(a, o));
}, pE = ({ targetSelector: a, props: o }) => Kn(sm, o, document.querySelector(a)), TE = ({ targetSelector: a, props: o }) => Kn(Um, o, document.querySelector(a)), SE = ({ targetSelector: a, props: o }) => Kn(Gm, o, document.querySelector(a)), xE = ({ targetSelector: a, props: o }) => Kn(co, o, document.querySelector(a)), EE = ({ targetSelector: a, props: o }) => Kn(iv, o, document.querySelector(a)), wE = ({ targetSelector: a, props: o }) => Kn(rv, o, document.querySelector(a)), AE = ({ targetSelector: a, props: o }) => Kn(tc, o, document.querySelector(a)), _E = ({ targetSelector: a, props: o }) => Kn(Wm, o, document.querySelector(a)), OE = ({ targetSelector: a, props: o }) => Kn(Jm, o, document.querySelector(a)), CE = ({ targetSelector: a, props: o }) => Kn(rE, o, document.querySelector(a)), RE = ({ targetSelector: a, props: o }) => Kn(qm, o, document.querySelector(a)), NE = ({ targetSelector: a, props: o }) => Kn(Zo, o, document.querySelector(a)), ME = ({ targetSelector: a, props: o }) => Kn($m, o, document.querySelector(a)), zE = ({ targetSelector: a, props: o }) => Kn(uv, o, document.querySelector(a)), DE = ({ targetSelector: a, props: o }) => Kn(n0, o, document.querySelector(a)), LE = ({ targetSelector: a, props: o }) => Kn(cv, o, document.querySelector(a)), kE = ({ targetSelector: a, props: o }) => Kn(l0, o, document.querySelector(a)), HE = ({ targetSelector: a, props: o }) => Kn(IS, o, document.querySelector(a)), BE = ({ targetSelector: a, props: o }) => Kn(_S, o, document.querySelector(a)), UE = ({ targetSelector: a, props: o }) => Kn(WS, o, document.querySelector(a)), FE = ({ targetSelector: a, props: o }) => Kn(lE, o, document.querySelector(a)), YE = ({ targetSelector: a, props: o }) => Kn(YS, o, document.querySelector(a));
export {
  sm as Accordion,
  Um as AnchorMenu,
  Gm as Article,
  co as Button,
  iv as ButtonIconOnly,
  rv as ButtonTag,
  tc as Card,
  Wm as CardArrangement,
  f0 as CardCarousel,
  Jm as ContentSpotlight,
  _S as Divider,
  AS as DividerType,
  HS as FeedBody,
  MS as FeedContainerProvider,
  NS as FeedContext,
  kS as FeedHeader,
  rE as GridLinks,
  qm as Hero,
  YS as HighlyRanked,
  Zo as Image,
  d0 as ImageCarousel,
  g0 as ImageGalleryCarousel,
  lE as List,
  e0 as NavControls,
  $m as Pagination,
  uv as RankingCard,
  IS as SystemAlert,
  XS as SystemAlertType,
  QS as Tab,
  t0 as TabHeader,
  n0 as TabbedPanels,
  cv as Testimonial,
  v0 as TestimonialCarousel,
  WS as Tooltip,
  l0 as Video,
  gE as feedCardButtonShape,
  DS as feedComponentShape,
  jm as feedCtaButtonShape,
  zS as feedDataSourceShape,
  Km as feedHeaderShape,
  pE as initAccordion,
  TE as initAnchorMenu,
  SE as initArticle,
  xE as initButton,
  EE as initButtonIconOnly,
  wE as initButtonTag,
  AE as initCard,
  _E as initCardArrangement,
  vE as initCardCarousel,
  OE as initContentSpotlight,
  BE as initDivider,
  CE as initGridLinks,
  RE as initHero,
  YE as initHighlyRanked,
  NE as initImage,
  bE as initImageCarousel,
  mE as initImageGalleryCarousel,
  FE as initList,
  ME as initPagination,
  zE as initRankingCard,
  HE as initSystemAlert,
  DE as initTabbedPanels,
  LE as initTestimonial,
  yE as initTestimonialCarousel,
  UE as initTooltip,
  kE as initVideo
};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*! @license DOMPurify 3.4.11 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.11/LICENSE */
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function() {
                var css = `@charset "UTF-8";.glide{position:relative;width:100%;box-sizing:border-box}.glide *{box-sizing:inherit}.glide__track{overflow:hidden}.glide__slides{position:relative;width:100%;list-style:none;backface-visibility:hidden;transform-style:preserve-3d;touch-action:pan-Y;overflow:hidden;margin:0;padding:0;white-space:nowrap;display:flex;flex-wrap:nowrap;will-change:transform}.glide__slides--dragging{-webkit-user-select:none;user-select:none}.glide__slide{width:100%;height:100%;flex-shrink:0;white-space:normal;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent}.glide__slide a{-webkit-user-select:none;user-select:none;-webkit-user-drag:none;-moz-user-select:none;-ms-user-select:none}.glide__arrows,.glide__bullets{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.glide--rtl{direction:rtl}@media only screen and (min-width:1260px){.container .aligned-carousel{margin-left:-124px!important}}.glide{display:flex;flex-direction:column;gap:32px;position:relative}[data-image-auto-size=true] .glide__slides .glide__slide{height:auto;position:relative;display:inline-flex;justify-content:center}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img{display:flex;width:100%;max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img{flex-grow:1;object-fit:cover}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img img.uds-img{max-width:100%}[data-image-auto-size=true] .glide__slides .glide__slide>div.uds-img figure.uds-figure{display:flex;justify-content:space-between;flex-direction:column}.glide .glide__track{position:relative}.glide .glide__track .glide__slides{margin-bottom:0;touch-action:auto}.glide .glide__track .glide__slides .glide__slide .card{width:100%}@media only screen and (min-width:576px){.glide[data-has-shadow=true] .glide__track.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide[data-has-shadow=true] .glide__track.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}}.glide__arrows{z-index:2;align-self:center}.glide__arrows .glide__arrow{color:#191919;width:4rem;height:4rem;margin:0 .5rem;background-color:#e8e8e8;border:1px solid #d0d0d0;border-radius:50%;font-size:1.3rem;text-shadow:0 .25em .5em rgba(0,0,0,.1);opacity:1;cursor:pointer;transition:opacity .15s ease,border .3s ease-in-out;line-height:1}.glide__arrows .glide__arrow.glide__arrow--disabled{color:#e8e8e8;background-color:#fafafa;border:1px solid #e8e8e8;opacity:1}.glide__arrows .glide__arrow:focus{outline:none}.glide__arrows .glide__arrow:hover{border-color:#fff}.glide__arrows .glide__arrow--left{left:2em}.glide__arrows .glide__arrow--right{right:2em}.glide__arrows .glide__arrow--disabled{opacity:.33}.glide__bullets{z-index:2;list-style:none;max-width:100%;display:flex;justify-content:center}.glide__bullet{transition:all .3s ease-in-out;background-color:#d0d0d0;width:1rem;height:1rem;padding:0;border-radius:50%;border:2px solid transparent;cursor:pointer;line-height:0;margin:.375rem}.glide__bullet:focus{outline:none}.glide__bullet:hover,.glide__bullet:focus{border:1px solid #d0d0d0;background-color:#191919}.glide__bullet--active{background-color:#191919}.glide.aligned-carousel{width:1448px;margin:auto}.glide.image-gallery{gap:0;overflow:hidden}.glide.image-gallery .glide__track{border:1px solid #d0d0d0}.glide.image-gallery .glide__track:after{content:none}.glide.image-gallery .glide__track .glide__slides li.glide__slide{display:list-item}.glide.image-gallery .glide__track .glide__slides{margin-bottom:0;height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img{height:100%}.glide.image-gallery .glide__track .glide__slides .glide__slide>div.uds-img img{object-fit:cover;border:none}.glide.image-gallery .image-gallery-action-area{border:1px solid #d0d0d0;border-top:0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .image-navigator{border-bottom:1px solid #d0d0d0}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text{padding:1rem 0;display:inline-block}.glide.image-gallery .image-gallery-action-area[data-has-content=true] .uds-caption-text>div{height:auto!important}.glide.image-gallery figcaption{padding:0 .75rem;font-size:.75rem}.glide.image-gallery figcaption h2{font-size:1.5rem;line-height:1.75rem;letter-spacing:-.0525rem}.glide.image-gallery .image-navigator{position:relative}.glide.image-gallery .image-navigator .image-navigator-images{min-height:64px;padding-top:1rem;padding-bottom:1rem;width:100%;margin:auto;overflow:hidden}.glide.image-gallery .image-navigator .image-navigator-images.slider-start:after{background:linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-mid:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px),linear-gradient(to left,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images.slider-end:after{background:linear-gradient(to right,#19191933,48px,#fff0 96px);content:" ";height:100%;position:absolute;pointer-events:none;width:100%;top:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider{position:relative;left:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets{position:relative}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container{position:relative;margin:0 .5rem;height:48px;border:0;padding:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:first-child{margin-left:16rem}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container .bullet-image{flex-basis:auto;width:88px;height:100%;border-radius:0;border:0;z-index:2;object-fit:cover;margin:0}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .bullet-image-container:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery .image-navigator .image-navigator-images .navigation-slider .glide__bullets .glide__bullet--active{background-color:transparent;border:5px solid #ffc627}.glide.image-gallery .image-navigator .glide__arrows{width:100%;display:flex;justify-content:space-between;align-items:center}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow{width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;z-index:3;position:absolute;background-color:#fff}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow:hover{border-color:#d0d0d0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow .arrow-icon{font-size:1rem}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--prev{left:0}.glide.image-gallery .image-navigator .glide__arrows .glide__arrow.glide__arrow--next{right:0}@media only screen and (max-width:576px){.glide{gap:21px}.glide:not(.glide.image-gallery) .glide__bullets{display:none}.glide.image-gallery{width:100%;margin:auto!important}.glide.image-gallery .image-navigator .image-navigator-images .glide__arrows .glide__arrow{display:none}}@media only screen and (max-width:1260px){.glide.aligned-carousel{width:100%}}.glide--swipeable{cursor:grab;cursor:-moz-grab;cursor:-webkit-grab}.glide--dragging{cursor:grabbing;cursor:-moz-grabbing;cursor:-webkit-grabbing}.glide[data-remove-side-background=true]:after,.glide[data-remove-side-background=true]:before{content:none}.glide button:focus,.glide a:focus,.glide input:focus,.glide textarea:focus,.glide select:focus{outline:none!important;box-shadow:0 0 0 2px #fff,0 0 0 4px #191919!important}.glide.image-gallery,.glide.image-carousel{margin:auto}.glide.image-gallery[role=figure],.glide.image-gallery figure.uds-figure,.glide.image-carousel[role=figure],.glide.image-carousel figure.uds-figure{margin:0}.glide.image-gallery[role=figure] figcaption *,.glide.image-gallery[role=figure] .uds-caption-text,.glide.image-gallery figure.uds-figure figcaption *,.glide.image-gallery figure.uds-figure .uds-caption-text,.glide.image-carousel[role=figure] figcaption *,.glide.image-carousel[role=figure] .uds-caption-text,.glide.image-carousel figure.uds-figure figcaption *,.glide.image-carousel figure.uds-figure .uds-caption-text{color:#191919;max-width:100%}
`;
                var style = document.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                  style.styleSheet.cssText = css;
                } else {
                  style.appendChild(document.createTextNode(css));
                }
                document.head.appendChild(style);
              })();